import * as React from "react";
import wrapIcon from "../utils/wrapIcon";
const AccessColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 12v4c0 1.1-2.69 2-6 2s-6-.9-6-2v-4h12z",
    fill: "url(#paint0_linear_79311_35767)"
  }), React.createElement("path", {
    d: "M17 12v4c0 1.1-2.69 2-6 2s-6-.9-6-2v-4h12z",
    fill: "url(#paint1_linear_79311_35767)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M17 8v4c0 1.1-2.69 2-6 2s-6-.9-6-2V8h12z",
    fill: "url(#paint2_linear_79311_35767)"
  }), React.createElement("path", {
    d: "M17 8v4c0 1.1-2.69 2-6 2s-6-.9-6-2V8h12z",
    fill: "url(#paint3_linear_79311_35767)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M17 4v4c0 1.1-2.69 2-6 2s-6-.9-6-2V4h12z",
    fill: "url(#paint4_linear_79311_35767)"
  }), React.createElement("path", {
    d: "M17 4v4c0 1.1-2.69 2-6 2s-6-.9-6-2V4h12z",
    fill: "url(#paint5_radial_79311_35767)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M11 6c-3.31 0-6-.9-6-2s2.69-2 6-2 6 .9 6 2-2.69 2-6 2z",
    fill: "url(#paint6_linear_79311_35767)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint7_radial_79311_35767)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint8_radial_79311_35767)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M4.07 14l1.78-5H7.2l1.74 5H7.75l-.34-1H5.58l-.34 1H4.07zm1.76-1.92h1.3l-.52-1.75a8.98 8.98 0 00-.1-.35h-.03a3.64 3.64 0 01-.1.35l-.55 1.75z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_79311_35767",
    x1: 17,
    y1: 15.27,
    x2: 5,
    y2: 15.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9C0D55"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A61727"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8A1421"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_79311_35767",
    x1: 9.8,
    y1: 11.8,
    x2: 11,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#560B14"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#560B14",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint2_linear_79311_35767",
    x1: 17,
    y1: 11.27,
    x2: 5,
    y2: 11.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E82C41"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2134"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79311_35767",
    x1: 9.2,
    y1: 7.6,
    x2: 10.4,
    y2: 14.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#560B14"
  }), React.createElement("stop", {
    offset: 0.75,
    stopColor: "#560B14",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79311_35767",
    x1: 17,
    y1: 7.27,
    x2: 5,
    y2: 7.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F97DBD"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FB5B6C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F83F54"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_79311_35767",
    x1: 9.92,
    y1: 0.98,
    x2: 8.4,
    y2: 6.66,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F97DBD"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF9FB2"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79311_35767",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6 -15.491 0 11 4)"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF9FB2"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9FB2",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint7_radial_79311_35767",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    stopColor: "#E82C58"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#AA1D2D"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_79311_35767",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90.01 -2.82 9.32) scale(6.55714)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5778",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FF9FB2"
  }))));
};
export const AccessColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/AccessColorIcon({}), 'AccessColor');
const AccessFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16c0 1.1-2.69 2-6 2-2.22 0-4.16-.4-5.2-1H9a3 3 0 002.83-2.02c1.42-.06 2.71-.28 3.73-.62.53-.17 1.03-.4 1.44-.69V16zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zm-4.93 7h1.17l.34-1H7.4l.34 1h1.18L7.2 9H5.85l-1.78 5zM17 12c0 1-2.16 1.81-5 1.97v-3c1.35-.07 2.58-.28 3.56-.6.53-.18 1.03-.41 1.44-.7V12zM6.55 10.16l.06.17.53 1.75h-1.3l.54-1.75a7.01 7.01 0 00.1-.35h.02l.05.18zM17 8c0 1-2.16 1.81-5 1.97V9c0-.77-.3-1.47-.77-2 1.64-.02 3.17-.25 4.33-.64A5.6 5.6 0 0017 5.67V8zm-6-6c3.31 0 6 .9 6 2s-2.69 2-6 2-6-.9-6-2 2.69-2 6-2z",
    fill: primaryFill
  }));
};
export const AccessFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/AccessFilledIcon({}), 'AccessFilled');
const AccessRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 2c3.31 0 6 1.12 6 2.5v11c0 1.38-2.69 2.5-6 2.5-2.9 0-5.32-.86-5.88-2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h1V4.5C5 3.12 7.69 2 11 2zM4.07 14h1.17l.34-1H7.4l.34 1h1.18L7.2 9H5.85l-1.78 5zM16 9.38c-1.07.67-2.91 1.12-5 1.12v3c1.56 0 2.92-.27 3.86-.66.47-.2.78-.4.97-.58a.77.77 0 00.15-.2A.15.15 0 0016 12V9.38zm-9.45.78l.06.17.53 1.75h-1.3l.54-1.75a7.01 7.01 0 00.1-.35h.02l.05.18zM11 3c-1.56 0-2.92.26-3.86.66-.47.2-.78.4-.97.58a.77.77 0 00-.15.2.14.14 0 00-.02.06l.02.06c.02.05.06.11.15.2.19.18.5.39.97.58.94.4 2.3.66 3.86.66s2.92-.26 3.86-.66c.47-.2.78-.4.97-.58a.77.77 0 00.15-.2.14.14 0 00.02-.06l-.02-.06a.77.77 0 00-.15-.2 3.1 3.1 0 00-.97-.58C13.92 3.26 12.56 3 11 3zM6.48 16c.17.11.4.23.66.34.94.4 2.3.66 3.86.66s2.92-.27 3.86-.66c.47-.2.78-.4.97-.58a.77.77 0 00.15-.2.15.15 0 00.02-.06v-2.12c-1.07.67-2.91 1.12-5 1.12h-.07A2 2 0 019 16H6.48zM9 7a2 2 0 012 2v.5c1.56 0 2.92-.26 3.86-.66.47-.2.78-.4.97-.58a.77.77 0 00.15-.2A.14.14 0 0016 8V5.88C14.93 6.55 13.09 7 11 7s-3.93-.45-5-1.12V7h3z",
    fill: primaryFill
  }));
};
export const AccessRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/AccessRegularIcon({}), 'AccessRegular');
const Agent365ColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.1 6c-.03-1.17-.04-1.76.13-2.23.26-.73.82-1.31 1.55-1.6C12.24 2 12.83 2 14 2c1.19 0 2.21 2.09 2.9 4.99.32 1.33.48 2 .08 2.5-.4.51-1.13.51-2.58.51h-1.57c-1.55 0-2.3.34-2.56 2.33L10.1 6z",
    fill: "url(#paint0_linear_79278_8056)"
  }), React.createElement("path", {
    d: "M10.1 6c-.03-1.17-.04-1.76.13-2.23.26-.73.82-1.31 1.55-1.6C12.24 2 12.83 2 14 2c1.19 0 2.21 2.09 2.9 4.99.32 1.33.48 2 .08 2.5-.4.51-1.13.51-2.58.51h-1.57c-1.55 0-2.3.34-2.56 2.33L10.1 6z",
    fill: "url(#paint1_radial_79278_8056)"
  }), React.createElement("path", {
    d: "M12 15a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "url(#paint2_linear_79278_8056)"
  }), React.createElement("path", {
    d: "M12 15a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "url(#paint3_radial_79278_8056)"
  }), React.createElement("path", {
    d: "M10 2C6.22 2 3.15 7.29 2.26 14.01c-.23 1.75-.35 2.63.25 3.3.6.69 1.56.69 3.49.69 1.86 0 2.78 0 3.36-.54.58-.54.64-1.51.78-3.46.44-6.46 1.92-12 3.86-12h-4z",
    fill: "url(#paint4_linear_79278_8056)"
  }), React.createElement("path", {
    d: "M10 2C6.22 2 3.15 7.29 2.26 14.01c-.23 1.75-.35 2.63.25 3.3.6.69 1.56.69 3.49.69 1.86 0 2.78 0 3.36-.54.58-.54.64-1.51.78-3.46.44-6.46 1.92-12 3.86-12h-4z",
    fill: "url(#paint5_linear_79278_8056)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_79278_8056",
    x1: 12.33,
    y1: 2.92,
    x2: 16.5,
    y2: 12.75,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#1B44B1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_79278_8056",
    x1: 18.09,
    y1: 18,
    x2: 18.11,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#367AF2"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#BABAFF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79278_8056",
    x1: 11.5,
    y1: 2,
    x2: 11.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BABAFF"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4894FE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_79278_8056",
    x1: 10.5,
    y1: 7.58,
    x2: 10.5,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BABAFF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FECBE6"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_79278_8056",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-92.02 14.39 -.53) scale(11.8407 5.32173)"
  }, React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2052CB",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#163697"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_79278_8056",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-74.27 18.79 -.58) scale(6.14693 5.30931)"
  }, React.createElement("stop", {
    offset: 0.51,
    stopColor: "#BABAFF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FECBE6"
  }))));
};
export const Agent365Color = /*#__PURE__*/wrapIcon( /*#__PURE__*/Agent365ColorIcon({}), 'Agent365Color');
const Agent365FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.75 2c.12 0 .23.01.33.04-.42.18-.8.52-1.12.94a9.4 9.4 0 00-1.3 2.62 36.24 36.24 0 00-1.55 8.79v.15c-.06.71-.1 1.3-.18 1.75-.09.46-.24.87-.57 1.17-.32.3-.73.43-1.18.49-.44.05-1 .05-1.68.05H5.45c-.7 0-1.29 0-1.75-.07-.48-.07-.9-.23-1.23-.6a1.9 1.9 0 01-.46-1.24c-.03-.44.03-.99.1-1.64a21.8 21.8 0 012.65-8.7C6.1 3.52 7.9 2 10 2h3.75zM15 12a3 3 0 110 6 3 3 0 010-6zm-.25-9.1c.27 0 .55.16.85.54.07.08.12.17.18.26.43.85.8 1.98 1.14 3.27.13.53.25.98.29 1.34.04.39 0 .77-.26 1.1-.26.35-.63.48-1.02.54-.37.05-.85.05-1.4.05h-1.37c-.6 0-.99.2-1.29.58-.2.25-.35.59-.48 1.02.3-2.26.71-4.2 1.22-5.68a8.45 8.45 0 011.14-2.33c.4-.52.74-.69 1-.69z",
    fill: primaryFill
  }));
};
export const Agent365Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Agent365FilledIcon({}), 'Agent365Filled');
const Agent365RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.75 2c.88 0 1.5.7 1.95 1.53.47.86.86 2.06 1.22 3.44.13.53.25.98.29 1.34.04.39 0 .77-.26 1.1-.26.35-.63.48-1.02.54-.37.05-.85.05-1.4.05h-2.37c-.6 0-1 .2-1.29.58-.18.23-.33.54-.45.94-.14.97-.24 1.98-.32 3.02-.05.71-.09 1.3-.17 1.75-.09.46-.24.87-.57 1.17-.32.3-.73.43-1.18.49-.44.05-1 .05-1.68.05H5.45c-.7 0-1.29 0-1.75-.07-.48-.07-.9-.23-1.23-.6A1.9 1.9 0 012 16.1c-.02-.45.04-1 .1-1.65a21.9 21.9 0 012.63-8.7C6.05 3.52 7.9 2 10 2h3.75zM15 12a3 3 0 110 6 3 3 0 010-6zm-5-9C8.42 3 6.84 4.15 5.6 6.26a20.92 20.92 0 00-2.49 8.3c-.07.68-.11 1.14-.1 1.48.02.32.09.5.21.63s.29.22.64.27c.37.06.86.06 1.6.06H6.5c.71 0 1.2 0 1.56-.05.35-.04.51-.12.62-.22.1-.1.2-.26.27-.63.07-.38.1-.89.16-1.63a36 36 0 011.53-8.52A11 11 0 0112.07 3H10zm5 10a2 2 0 100 4 2 2 0 000-4zM13.71 3c-.21 0-.55.17-.96.77-.4.57-.8 1.42-1.16 2.5-.3.9-.57 1.94-.8 3.08.39-.23.85-.35 1.37-.35h2.36c.6 0 .98 0 1.27-.04.26-.04.33-.1.37-.15.04-.06.08-.14.06-.4a9.3 9.3 0 00-.27-1.2 15.05 15.05 0 00-1.13-3.2c-.43-.78-.8-1.01-1.07-1.01h-.04z",
    fill: primaryFill
  }));
};
export const Agent365Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Agent365RegularIcon({}), 'Agent365Regular');
const AppsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h4c.83 0 1.5.67 1.5 1.5V10H3V4.5z",
    fill: "url(#paint0_linear_73293_123)"
  }), React.createElement("path", {
    d: "M3 10h7v7H4.5A1.5 1.5 0 013 15.5V10z",
    fill: "url(#paint1_linear_73293_123)"
  }), React.createElement("path", {
    d: "M3 10h7v7H4.5A1.5 1.5 0 013 15.5V10z",
    fill: "url(#paint2_linear_73293_123)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M10 10h5.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5H10v-7z",
    fill: "url(#paint3_linear_73293_123)"
  }), React.createElement("path", {
    d: "M10 10h5.5c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5H10v-7z",
    fill: "url(#paint4_linear_73293_123)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M12.73 2.44a1.5 1.5 0 012.12 0l2.7 2.7a1.5 1.5 0 010 2.11l-2.7 2.7a1.5 1.5 0 01-2.12 0l-2.69-2.7a1.5 1.5 0 010-2.12l2.7-2.69z",
    fill: "url(#paint5_linear_73293_123)"
  }), React.createElement("path", {
    d: "M12.73 2.44a1.5 1.5 0 012.12 0l2.7 2.7a1.5 1.5 0 010 2.11l-2.7 2.7a1.5 1.5 0 01-2.12 0l-2.69-2.7a1.5 1.5 0 010-2.12l2.7-2.69z",
    fill: "url(#paint6_linear_73293_123)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_73293_123",
    x1: 3.37,
    y1: 2.61,
    x2: 19.15,
    y2: 22.79,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C354FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_73293_123",
    x1: 2.63,
    y1: 4.11,
    x2: 16.18,
    y2: 16.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C354FF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_73293_123",
    x1: 6.5,
    y1: 18.12,
    x2: 6.5,
    y2: 9.03,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FEA567",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CA2134"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_73293_123",
    x1: 2.61,
    y1: 3.74,
    x2: 17.33,
    y2: 16.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CF40CA"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B339F0"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_73293_123",
    x1: 21.57,
    y1: 13.5,
    x2: 10,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A931D8",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#82027A"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_73293_123",
    x1: 10.01,
    y1: 2.55,
    x2: 18.65,
    y2: 10.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6D37CD"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_73293_123",
    x1: 14.22,
    y1: 3.86,
    x2: 5.31,
    y2: 3.86,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F24A9D",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F24A9D"
  }))));
};
export const AppsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/AppsColorIcon({}), 'AppsColor');
const BingColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 1.75c0-.6.66-.95 1.16-.62L8.1 2.4A2 2 0 019 4.08V16H6.5L5 13.75v-12z",
    fill: "url(#paint0_linear_1_57)"
  }), React.createElement("path", {
    d: "M5 1.75c0-.6.66-.95 1.16-.62L8.1 2.4A2 2 0 019 4.08V16H6.5L5 13.75v-12z",
    fill: "url(#paint1_linear_1_57)"
  }), React.createElement("path", {
    d: "M6.58 14.93l-.04-.01A2.94 2.94 0 015 13.5 4.5 4.5 0 009.5 18h.06c.94 0 1.85-.29 2.62-.82l2.98-2.1c.53-.36.84-.96.84-1.6v-.81a1.17 1.17 0 00-1.78-1L9.3 14.7c-.83.5-1.84.59-2.73.23z",
    fill: "url(#paint2_linear_1_57)"
  }), React.createElement("path", {
    d: "M6.58 14.93l-.04-.01A2.94 2.94 0 015 13.5 4.5 4.5 0 009.5 18h.06c.94 0 1.85-.29 2.62-.82l2.98-2.1c.53-.36.84-.96.84-1.6v-.81a1.17 1.17 0 00-1.78-1L9.3 14.7c-.83.5-1.84.59-2.73.23z",
    fill: "url(#paint3_linear_1_57)"
  }), React.createElement("path", {
    d: "M10.72 9.59l-.68-2.26a.8.8 0 011.16-.92l3.62 2.11a3.93 3.93 0 01.6 6.36l-.06.06-.36.26a1.98 1.98 0 00-.54-3.4l-2.56-.96c-.57-.22-1-.68-1.18-1.25z",
    fill: "url(#paint4_linear_1_57)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_1_57",
    x1: 11.99,
    y1: 16.16,
    x2: 11.99,
    y2: 1.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#1B48EF"
  }), React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1C51F0"
  }), React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1E69F5"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2190FB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#26B8F4"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_1_57",
    x1: 11.99,
    y1: 0.99,
    x2: 11.99,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "paint2_linear_1_57",
    x1: 5,
    y1: 14.74,
    x2: 16,
    y2: 14.74,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#39D2FF"
  }), React.createElement("stop", {
    offset: 0.15,
    stopColor: "#38CEFE"
  }), React.createElement("stop", {
    offset: 0.29,
    stopColor: "#35C3FA"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2FB0F3"
  }), React.createElement("stop", {
    offset: 0.55,
    stopColor: "#299AEB"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2692EC"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1A6CF1"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1355F4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#104CF5"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_1_57",
    x1: 6.27,
    y1: 16.98,
    x2: 14.24,
    y2: 11.55,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), React.createElement("linearGradient", {
    id: "paint4_linear_1_57",
    x1: 9.06,
    y1: 8.11,
    x2: 16.77,
    y2: 12.58,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#37BDFF"
  }), React.createElement("stop", {
    offset: 0.18,
    stopColor: "#33BFFD"
  }), React.createElement("stop", {
    offset: 0.36,
    stopColor: "#28C5F5"
  }), React.createElement("stop", {
    offset: 0.53,
    stopColor: "#15D0E9"
  }), React.createElement("stop", {
    offset: 0.55,
    stopColor: "#12D1E7"
  }), React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1CD2E5"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#42D8DC"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#59DBD6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#62DCD4"
  }))));
};
export const BingColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BingColorIcon({}), 'BingColor');
const BingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 1.75c0-.6.66-.95 1.16-.62L8.1 2.4A2 2 0 019 4.08v9.63l-.6.36A2.25 2.25 0 015 12.2V1.75zm5.54 12.2l-1.2.73-.11.06-.3.19a3.24 3.24 0 01-3.8-.32A4.5 4.5 0 009.5 18h.06c.87 0 1.71-.25 2.44-.7l2.25-1.58c1.16-.82.93-2.6-.4-3.08l-.75-.28-2.46 1.51a.5.5 0 01-.1.08zm3.64-2.25h.01a2.73 2.73 0 011.8 2.52 3.9 3.9 0 00-1.16-5.69l-3.62-2.12a.77.77 0 00-1.13.88l.65 2.28c.17.58.6 1.06 1.18 1.27l2.27.85z",
    fill: primaryFill
  }));
};
export const BingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BingFilledIcon({}), 'BingFilled');
const BingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2.25V12.8a2.25 2.25 0 003 2.06V4.2a.75.75 0 00-.33-.62L5.39 2.04a.25.25 0 00-.39.21zm-1 0c0-1 1.12-1.6 1.95-1.03l2.28 1.53c.48.33.77.87.77 1.45v10.11l3.55-2.14-.73-.26a1.25 1.25 0 01-.77-.83l-1-3.48a1.25 1.25 0 011.83-1.43l1.33.77a.5.5 0 01.04.02l1.07.62a5.36 5.36 0 01.5 8.96l-.03.02-.07.05-.97.68-.98.69A5.57 5.57 0 014 13.42v-.61V10.34a.5.5 0 010-.04V2.25zm10.43 13.33a1.75 1.75 0 00-.6-2.94l-.07-.03-4.83 2.91c-1.15.7-2.47.58-3.46-.06a4.58 4.58 0 006.72 1.7l.08-.05.02-.02 1.92-1.34.22-.17zm1.42-2.2a4.36 4.36 0 00-1.97-4.9l-2.5-1.44a.25.25 0 00-.37.28l1 3.48c.02.08.08.14.15.17h.03a.5.5 0 01.07.03l1.93.7c.84.3 1.4.94 1.66 1.68z",
    fill: primaryFill
  }));
};
export const BingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BingRegularIcon({}), 'BingRegular');
const BookColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16 14H5v3a1 1 0 001 1h8a2 2 0 002-2v-2z",
    fill: "#929292"
  }), React.createElement("path", {
    d: "M16 14H5v3a1 1 0 001 1h8a2 2 0 002-2v-2z",
    fill: "url(#paint0_linear_73819_12118)"
  }), React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2a1 1 0 110-2h8a2 2 0 002-2V4a2 2 0 00-2-2H6z",
    fill: "#CACACA"
  }), React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2a1 1 0 110-2h8a2 2 0 002-2V4a2 2 0 00-2-2H6z",
    fill: "url(#paint1_linear_73819_12118)"
  }), React.createElement("path", {
    d: "M6 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2a1 1 0 110-2h8a2 2 0 002-2V4a2 2 0 00-2-2H6z",
    fill: "url(#paint2_radial_73819_12118)"
  }), React.createElement("path", {
    d: "M6 5a1 1 0 011-1h6a1 1 0 011 1v1a1 1 0 01-1 1H7a1 1 0 01-1-1V5z",
    fill: "url(#paint3_linear_73819_12118)",
    fillOpacity: 0.95
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_73819_12118",
    x1: 5.73,
    y1: 15,
    x2: 28.47,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#5029CE"
  }), React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9550F3"
  }), React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C16DFA"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_73819_12118",
    x1: -5.84,
    y1: 36.99,
    x2: 26.91,
    y2: 8.36,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BD4AF9"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4B8AFF"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#41E2B5"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_73819_12118",
    x1: 10.74,
    y1: 6.94,
    x2: 9.94,
    y2: 3.51,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFC8D7"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_73819_12118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-15.27267 -38.39999 30.51588 -12.13696 20.36 24.4)"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C354FF"
  }))));
};
export const BookColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BookColorIcon({}), 'BookColor');
const BookingsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2H5.87a.95.95 0 00-.6.2.76.76 0 00-.2.25.69.69 0 00-.07.29v14.53c0 .2.1.39.26.52.16.14.38.21.6.21H9V2z",
    fill: "#057093"
  }), React.createElement("path", {
    d: "M12 2H8.87a.95.95 0 00-.6.2.76.76 0 00-.2.25.69.69 0 00-.07.29v14.53c0 .1.03.2.07.29a.86.86 0 00.47.4c.1.03.21.04.32.04H12V2z",
    fill: "#1098B6"
  }), React.createElement("path", {
    d: "M18 2.74a.8.8 0 00-.19-.52.6.6 0 00-.46-.22h-5.7a.6.6 0 00-.46.22.8.8 0 00-.19.52v14.53c0 .1.02.2.05.28.03.09.08.17.14.24.06.06.13.12.2.15.08.04.16.06.25.06h5.72a.64.64 0 00.45-.21.82.82 0 00.19-.52V2.74z",
    fill: "#30CCD7"
  }), React.createElement("path", {
    d: "M18 7h-7v6h7V7z",
    fill: "#70ECEE"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M11.94 6H5v10h6.73c.32 0 .62-.11.85-.29.23-.17.38-.42.42-.68v-8.2a.72.72 0 00-.08-.33.85.85 0 00-.23-.27c-.1-.08-.22-.14-.35-.18a1.18 1.18 0 00-.4-.05z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11.17 5H2.83a.83.83 0 00-.83.83v8.34c0 .46.37.83.83.83h8.34c.46 0 .83-.37.83-.83V5.83a.83.83 0 00-.83-.83z",
    fill: "#057093"
  }), React.createElement("path", {
    d: "M8.67 7.17c.3.1.57.26.78.49.17.2.27.46.27.73 0 .31-.11.62-.34.87-.24.26-.57.44-.94.52.29.03.57.11.82.25.23.12.42.3.55.5a1.52 1.52 0 01-.11 1.63c-.22.27-.52.49-.87.62-.4.15-.84.23-1.28.22H5V7h2.5c.4 0 .8.05 1.17.17zm-1.5 2.3c.3.01.6-.07.84-.23.1-.08.18-.17.23-.28.05-.1.08-.22.07-.34 0-.48-.38-.72-1.14-.72h-.84v1.56h.84zm-.84 2.64h1.04c.33.03.67-.05.94-.23.1-.08.19-.18.25-.3a.75.75 0 00.08-.36.66.66 0 00-.08-.35.76.76 0 00-.26-.28c-.28-.16-.6-.24-.94-.22H6.33v1.74z",
    fill: "#fff"
  }));
};
export const BookingsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/BookingsColorIcon({}), 'BookingsColor');
const BookingsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8 9.24c-.23.16-.53.24-.83.22h-.84V7.9h.84c.76 0 1.14.24 1.14.72 0 .12-.02.23-.07.34-.05.1-.13.2-.23.28z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.37 12.11H6.33v-1.74h1.03c.33-.02.66.06.94.22.11.08.2.17.26.28.06.11.08.23.08.35 0 .13-.03.25-.08.36a.85.85 0 01-.25.3c-.27.18-.6.26-.94.23z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M5 3a1 1 0 011-1h11a1 1 0 011 1v14a1 1 0 01-1 1H6a1 1 0 01-1-1v-2H2.83a.83.83 0 01-.83-.83V5.83c0-.46.37-.83.83-.83H5V3zm1 14h2v-2H6v2zm3 0h2v-2H9v2zM9 5h2V3H9v2zm3 1h5V3h-5v3zm0 7h5V7h-5v6zm0 1v3h5v-3h-5zM6 5h2V3H6v2zm3.45 2.66c-.2-.23-.48-.4-.78-.5A3.7 3.7 0 007.5 7H5v6h2.55c.44 0 .88-.07 1.28-.22.35-.13.65-.35.87-.62a1.52 1.52 0 00.11-1.62c-.13-.21-.32-.39-.55-.51a2.05 2.05 0 00-.82-.25c.37-.08.7-.26.94-.52.23-.25.35-.56.34-.87 0-.27-.1-.52-.27-.73z",
    fill: "#242424"
  }));
};
export const BookingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BookingsRegularIcon({}), 'BookingsRegular');
const CalendarAgendaLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M15 10c.71 0 1.39.15 2 .41V5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17H10v-2c0-.34.04-.68.1-1H6.41a.5.5 0 010-1h4.01a5.02 5.02 0 012.4-2.5H6.41a.5.5 0 010-1h7.18a.5.5 0 01.4.6c.33-.06.67-.1 1.01-.1zm-1-3.5a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09a.5.5 0 01.5.5z",
    fill: primaryFill
  }));
};
export const CalendarAgendaLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgendaLoopFilledIcon({}), 'CalendarAgendaLoopFilled');
const CalendarTaskbarColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 14a2 2 0 002-2V3.33C15 2.6 14.4 2 13.67 2H5.5C4.67 2 4 2.67 4 3.5V12c0 1.1.9 2 2 2h7z",
    fill: "url(#paint0_linear_74711_27032)"
  }), React.createElement("path", {
    d: "M13 14a2 2 0 002-2V3.33C15 2.6 14.4 2 13.67 2H5.5C4.67 2 4 2.67 4 3.5V12c0 1.1.9 2 2 2h7z",
    fill: "url(#paint1_linear_74711_27032)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M16.5 16c.83 0 1.5-.67 1.5-1.5V6.54c0-.83-.67-1.5-1.5-1.5L5.5 5A1.5 1.5 0 014 3.5V14c0 1.1.9 2 2 2h10.5z",
    fill: "url(#paint2_linear_74711_27032)"
  }), React.createElement("path", {
    d: "M16.5 16c.83 0 1.5-.67 1.5-1.5V6.54c0-.83-.67-1.5-1.5-1.5L5.5 5A1.5 1.5 0 014 3.5V14c0 1.1.9 2 2 2h10.5z",
    fill: "url(#paint3_radial_74711_27032)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M7 11.33a1 1 0 110 2 1 1 0 010-2zm4-.33a1 1 0 110 2 1 1 0 010-2zM7 7a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2z",
    fill: "#B8F0FF"
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.37l1.5 1.5-.47.46-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "#7A41DC"
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.37l1.5 1.5-.47.46-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "url(#paint4_radial_74711_27032)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M7.34 13.33a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "url(#paint5_linear_74711_27032)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_74711_27032",
    x1: 16,
    y1: 8,
    x2: 4,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#7A41DC"
  }), React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5542CB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1B44B1"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_74711_27032",
    x1: 9.85,
    y1: 2,
    x2: 9.85,
    y2: 5.58,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0E45D8",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1B44B1"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_74711_27032",
    x1: 4,
    y1: 10,
    x2: 18.33,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6CE0FF"
  }), React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0FAFFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0094F0"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_74711_27032",
    x1: 3.83,
    y1: 12.08,
    x2: 6.59,
    y2: 14.84,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9DEAFF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_74711_27032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.60578 -7.73514 6.39312 16.20424 .67 15.33)"
  }, React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F4A7F7",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A7F7"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_74711_27032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.65 -9.3 7.12) scale(8.22533 6.01255)"
  }, React.createElement("stop", {
    stopColor: "#66C0FF"
  }), React.createElement("stop", {
    offset: 0.74,
    stopColor: "#66C0FF",
    stopOpacity: 0
  }))));
};
export const CalendarTaskbarColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTaskbarColorIcon({}), 'CalendarTaskbarColor');
const CalendarTaskbarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 9.5a3.53 3.53 0 011.75.47 3.5 3.5 0 01.82 5.4l1.78 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.3 16a3.5 3.5 0 01-4.62-5.08l.06-.06a3.51 3.51 0 011.18-.98l.07-.04A3.48 3.48 0 015.5 9.5zM12.9 2c1.16 0 2.1.94 2.1 2.1V5h.9c1.16 0 2.1.94 2.1 2.1v6.8a2.1 2.1 0 01-2.1 2.1h-5.78l-.73-.73.14-.27h6.37c.6 0 1.1-.5 1.1-1.1V7.1c0-.6-.5-1.1-1.1-1.1H6c-.36 0-.7-.1-1-.27v2.8c-.35.04-.68.11-1 .23V4c0-1.1.9-2 2-2h6.9zm-7.4 8.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM11 12a1 1 0 110 2 1 1 0 010-2zm0-4a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM7 8a1 1 0 01.97 1.24 4.47 4.47 0 00-1.86-.7A1 1 0 017 8z",
    fill: primaryFill
  }));
};
export const CalendarTaskbarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTaskbarFilledIcon({}), 'CalendarTaskbarFilled');
const CalendarTaskbarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 9.5A3.48 3.48 0 019 13a3.5 3.5 0 01-.93 2.37l1.78 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.29 16a3.5 3.5 0 11-1.8-6.5zM12.9 2c1.16 0 2.1.94 2.1 2.1V5h.9c1.16 0 2.1.94 2.1 2.1v6.8a2.1 2.1 0 01-2.1 2.1h-5.78l-.73-.73.14-.27h6.37c.6 0 1.1-.5 1.1-1.1V7.1c0-.6-.5-1.1-1.1-1.1H6c-.36 0-.7-.1-1-.27v2.8c-.35.04-.68.11-1 .23V4c0-1.1.9-2 2-2h6.9zm-7.4 8.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM11 12a1 1 0 110 2 1 1 0 010-2zm0-4a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zM7 8a1 1 0 01.97 1.24 4.47 4.47 0 00-1.86-.7A1 1 0 017 8zM6 3a1 1 0 00-1 1v.1A1 1 0 006 5h8v-.9c0-.6-.5-1.1-1.1-1.1H6z",
    fill: primaryFill
  }));
};
export const CalendarTaskbarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTaskbarRegularIcon({}), 'CalendarTaskbarRegular');
const CalendarTodoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 7v1.59a2 2 0 00-1.48.58l-3.88 3.9-.36-.36a2 2 0 00-2.83 0L7.4 13.77a2 2 0 000 2.83l.4.4H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM8.1 14.48a1 1 0 000 1.41l2.83 2.83a1 1 0 001.41 0l6.37-6.36a1 1 0 000-1.42l-1.06-1.06a1 1 0 00-1.42 0l-4.6 4.6-1.06-1.06a1 1 0 00-1.4 0L8.1 14.48zM11.64 18l-1.07-1.06 6.37-6.36L18 11.65 11.64 18zm-.71-2.83l-1.06 1.06-1.06-1.06 1.06-1.06 1.06 1.06z",
    fill: primaryFill
  }));
};
export const CalendarTodoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTodoFilledIcon({}), 'CalendarTodoFilled');
const CalendarTodoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v3.09a2 2 0 00-1 .23V7H4v7.5c0 .83.67 1.5 1.5 1.5h1.48a2 2 0 00.41.6l.4.4H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM8.1 15.9a1 1 0 010-1.42l1.06-1.06a1 1 0 011.41 0l1.07 1.06 4.6-4.6a1 1 0 011.4 0l1.07 1.06a1 1 0 010 1.42l-6.37 6.36a1 1 0 01-1.41 0L8.1 15.89zm2.47 1.05l1.07 1.06L18 11.65l-1.06-1.06-6.37 6.36zm-1.76-1.77l1.06 1.06 1.06-1.06-1.06-1.06-1.06 1.06z",
    fill: primaryFill
  }));
};
export const CalendarTodoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarTodoRegularIcon({}), 'CalendarTodoRegular');
const ChatEmptyColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10z",
    fill: "url(#paint0_radial_73293_98)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_73293_98",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(60.46 3.29 2.94) scale(26.1389 32.1109)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB152"
  }))));
};
export const ChatEmptyColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatEmptyColorIcon({}), 'ChatEmptyColor');
const ChatHistoryColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10z",
    fill: "#424242"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10z",
    fill: "url(#paint0_radial_73293_100)"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 10-16 0v.35l.03.38c.1 1.01.38 1.99.83 2.89l.06.12-.9 3.64-.02.08v.08c.03.3.31.52.62.45l3.65-.91.12.06A8 8 0 0018 10z",
    fill: "url(#paint1_radial_73293_100)"
  }), React.createElement("path", {
    d: "M17.5 12.8A8 8 0 003.86 4.86l-1.02-1A.5.5 0 002 4.2V8.5c0 .28.22.5.5.5h4.3a.5.5 0 00.35-.85L6.08 7.08A6.4 6.4 0 0110.75 5c3.73 0 6.75 3.36 6.75 7.5v.3z",
    fill: "url(#paint2_radial_73293_100)"
  }), React.createElement("path", {
    d: "M17.5 12.8A8 8 0 003.86 4.86l-1.02-1A.5.5 0 002 4.2V8.5c0 .28.22.5.5.5h4.3a.5.5 0 00.35-.85L6.08 7.08A6.4 6.4 0 0110.75 5c3.73 0 6.75 3.36 6.75 7.5v.3z",
    fill: "url(#paint3_radial_73293_100)"
  }), React.createElement("path", {
    d: "M10 7.5a.5.5 0 00-1 0v4c0 .28.22.5.5.5h3a.5.5 0 000-1H10V7.5z",
    fill: "#424242"
  }), React.createElement("path", {
    d: "M10 7.5a.5.5 0 00-1 0v4c0 .28.22.5.5.5h3a.5.5 0 000-1H10V7.5z",
    fill: "url(#paint4_linear_73293_100)",
    fillOpacity: 0.95
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_73293_100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-6.76195 21.89302 -29.73251 -9.18328 15.23 -2.11)"
  }, React.createElement("stop", {
    stopColor: "#C354FF"
  }), React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC470"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_73293_100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(130.73 1.02 9.47) scale(30.3401 26.8382)"
  }, React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A411BC",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A411BC"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_73293_100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-163.86 6.28 4.72) scale(19.78)"
  }, React.createElement("stop", {
    stopColor: "#CDA5E0"
  }), React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D279FE"
  }), React.createElement("stop", {
    offset: 0.42,
    stopColor: "#7439EC"
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3220AF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_73293_100",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-7.5 .49999 -.46697 -7.00466 2.5 9)"
  }, React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4B27CB"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4B27CB",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_73293_100",
    x1: 11.37,
    y1: 14.34,
    x2: 6.91,
    y2: 10.52,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFC8D7"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff"
  }))));
};
export const ChatHistoryColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ChatHistoryColorIcon({}), 'ChatHistoryColor');
const CheckmarkCircleLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 10-8 8v-3a5 5 0 017.94-4.04c.04-.32.06-.64.06-.96zm-5.28-2.41a.5.5 0 01.7.7l-.06.06-4 4-.08.07a.5.5 0 01-.56 0l-.07-.06-2-2-.06-.07a.5.5 0 01.7-.7l.06.06L9 11.3l3.65-3.65.07-.06z",
    fill: primaryFill
  }));
};
export const CheckmarkCircleLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CheckmarkCircleLoopFilledIcon({}), 'CheckmarkCircleLoopFilled');
const CircleMultipleHintCheckmarkColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.51 2.8c.18.19.47.2.69.06a4.97 4.97 0 011.85-.77.54.54 0 00.45-.52c0-.3-.25-.53-.54-.48-.88.15-1.7.5-2.4 1-.24.16-.26.5-.05.72z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M3.51 2.8c.18.19.47.2.69.06a4.97 4.97 0 011.85-.77.54.54 0 00.45-.52c0-.3-.25-.53-.54-.48-.88.15-1.7.5-2.4 1-.24.16-.26.5-.05.72z",
    fill: "url(#paint0_linear_73293_119)"
  }), React.createElement("path", {
    d: "M8.04 1.09c-.29-.05-.54.18-.54.48 0 .26.2.47.45.52.67.13 1.3.4 1.85.77.21.14.5.13.68-.05.21-.21.2-.56-.04-.73-.7-.49-1.52-.84-2.4-.99z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M8.04 1.09c-.29-.05-.54.18-.54.48 0 .26.2.47.45.52.67.13 1.3.4 1.85.77.21.14.5.13.68-.05.21-.21.2-.56-.04-.73-.7-.49-1.52-.84-2.4-.99z",
    fill: "url(#paint1_linear_73293_119)"
  }), React.createElement("path", {
    d: "M12.9 5.96l.01.04c-.34 0-.67.03-1 .08v-.03c-.13-.68-.4-1.3-.77-1.85a.54.54 0 01.05-.69c.21-.2.55-.2.72.05.5.7.84 1.52 1 2.4z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M12.9 5.96l.01.04c-.34 0-.67.03-1 .08v-.03c-.13-.68-.4-1.3-.77-1.85a.54.54 0 01.05-.69c.21-.2.55-.2.72.05.5.7.84 1.52 1 2.4z",
    fill: "url(#paint2_linear_73293_119)"
  }), React.createElement("path", {
    d: "M5.96 12.91H6c0-.33.03-.67.08-1h-.03c-.68-.13-1.3-.4-1.85-.77a.54.54 0 00-.69.05c-.2.21-.2.56.05.73.7.49 1.52.84 2.4.99z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M5.96 12.91H6c0-.33.03-.67.08-1h-.03c-.68-.13-1.3-.4-1.85-.77a.54.54 0 00-.69.05c-.2.21-.2.56.05.73.7.49 1.52.84 2.4.99z",
    fill: "url(#paint3_linear_73293_119)"
  }), React.createElement("path", {
    d: "M2.8 3.51c.19.19.2.48.05.7a4.97 4.97 0 00-.76 1.84.54.54 0 01-.52.45c-.3 0-.53-.25-.48-.54.15-.88.5-1.7 1-2.4.16-.24.5-.25.71-.05z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M2.8 3.51c.19.19.2.48.05.7a4.97 4.97 0 00-.76 1.84.54.54 0 01-.52.45c-.3 0-.53-.25-.48-.54.15-.88.5-1.7 1-2.4.16-.24.5-.25.71-.05z",
    fill: "url(#paint4_linear_73293_119)"
  }), React.createElement("path", {
    d: "M2.8 10.49c.19-.19.2-.48.05-.7a4.97 4.97 0 01-.76-1.84.54.54 0 00-.52-.45c-.3 0-.53.25-.48.54.15.88.5 1.7 1 2.4.16.24.5.25.71.05z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M2.8 10.49c.19-.19.2-.48.05-.7a4.97 4.97 0 01-.76-1.84.54.54 0 00-.52-.45c-.3 0-.53.25-.48.54.15.88.5 1.7 1 2.4.16.24.5.25.71.05z",
    fill: "url(#paint5_linear_73293_119)"
  }), React.createElement("path", {
    d: "M6.3 10.94a7.02 7.02 0 014.64-4.63 4 4 0 10-4.63 4.63z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M6.3 10.94a7.02 7.02 0 014.64-4.63 4 4 0 10-4.63 4.63z",
    fill: "url(#paint6_linear_73293_119)"
  }), React.createElement("path", {
    d: "M13 19a6 6 0 100-12 6 6 0 000 12zm2.85-7.15l-3 3a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7l1.15 1.14 2.65-2.64a.5.5 0 01.7.7z",
    fill: "#424242"
  }), React.createElement("path", {
    d: "M13 19a6 6 0 100-12 6 6 0 000 12zm2.85-7.15l-3 3a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7l1.15 1.14 2.65-2.64a.5.5 0 01.7.7z",
    fill: "url(#paint7_radial_73293_119)"
  }), React.createElement("path", {
    d: "M15.85 11.85l-3 3a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 01.7-.7l1.15 1.14 2.65-2.64a.5.5 0 01.7.7z",
    fill: "url(#paint8_linear_73293_119)",
    fillOpacity: 0.95
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_73293_119",
    x1: 2.67,
    y1: 5.21,
    x2: 12.6,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_73293_119",
    x1: 2.67,
    y1: 5.21,
    x2: 12.6,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_73293_119",
    x1: 2.67,
    y1: 5.21,
    x2: 12.6,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_73293_119",
    x1: 2.67,
    y1: 5.21,
    x2: 12.6,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_73293_119",
    x1: 2.67,
    y1: 5.21,
    x2: 12.6,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_73293_119",
    x1: 2.67,
    y1: 5.21,
    x2: 12.6,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_73293_119",
    x1: 2.67,
    y1: 5.21,
    x2: 12.6,
    y2: 9.97,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.86,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_73293_119",
    x1: 13.76,
    y1: 16.88,
    x2: 10.4,
    y2: 11.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFC8D7"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_73293_119",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(40.38 -6.62 13.24) scale(15.754 13.2203)"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C354FF"
  }))));
};
export const CircleMultipleHintCheckmarkColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CircleMultipleHintCheckmarkColorIcon({}), 'CircleMultipleHintCheckmarkColor');
const ClipboardTextLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.6a5.03 5.03 0 00-5.9 3.9H6.5a.5.5 0 000 1H10v3H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zm4.91.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zM13.5 8h-7a.5.5 0 000 1h7a.5.5 0 000-1zM10 11.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};
export const ClipboardTextLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLoopFilledIcon({}), 'ClipboardTextLoopFilled');
const ClipboardTextLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.6a5.03 5.03 0 00-5.9 3.9H6.5a.5.5 0 000 1H10v3H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3h1.59zm4.91.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5zM13.5 8h-7a.5.5 0 000 1h7a.5.5 0 000-1zM10 11.5a.5.5 0 00-.5-.5h-3a.5.5 0 000 1h3a.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};
export const ClipboardTextLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLtrLoopFilledIcon({}), 'ClipboardTextLtrLoopFilled');
const ClipchampColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.15 7.42a1.4 1.4 0 001.62 1.1L15.6 6.5a1.47 1.47 0 001.18-1.74l-.1-.5a1.53 1.53 0 00-1.77-1.2l-10.72 2c-.81.15-1.34.93-1.18 1.74l.13.62z",
    fill: "url(#paint0_radial_79311_35734)"
  }), React.createElement("path", {
    d: "M3.15 7.42a1.4 1.4 0 001.62 1.1L15.6 6.5a1.47 1.47 0 001.18-1.74l-.1-.5a1.53 1.53 0 00-1.77-1.2l-10.72 2c-.81.15-1.34.93-1.18 1.74l.13.62z",
    fill: "url(#paint1_radial_79311_35734)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M3.15 7.42a1.4 1.4 0 001.62 1.1L15.6 6.5a1.47 1.47 0 001.18-1.74l-.1-.5a1.53 1.53 0 00-1.77-1.2l-10.72 2c-.81.15-1.34.93-1.18 1.74l.13.62z",
    fill: "url(#paint2_radial_79311_35734)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M3 15c0 1.1.9 2 2 2h10.34c.92 0 1.66-.74 1.66-1.66v-.04c0-.92-.74-1.67-1.66-1.67H5.46A2.47 2.47 0 013 11.16V15z",
    fill: "#7611F0"
  }), React.createElement("path", {
    d: "M3 15c0 1.1.9 2 2 2h10.34c.92 0 1.66-.74 1.66-1.66v-.04c0-.92-.74-1.67-1.66-1.67H5.46A2.47 2.47 0 013 11.16V15z",
    fill: "#A966FF",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M3 15c0 1.1.9 2 2 2h10.34c.92 0 1.66-.74 1.66-1.66v-.04c0-.92-.74-1.67-1.66-1.67H5.46A2.47 2.47 0 013 11.16V15z",
    fill: "url(#paint3_linear_79311_35734)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M3 15c0 1.1.9 2 2 2h10.34c.92 0 1.66-.74 1.66-1.66v-.04c0-.92-.74-1.67-1.66-1.67H5.46A2.47 2.47 0 013 11.16V15z",
    fill: "url(#paint4_linear_79311_35734)",
    fillOpacity: 0.15
  }), React.createElement("path", {
    d: "M3 15c0 1.1.9 2 2 2h10.34c.92 0 1.66-.74 1.66-1.66v-.04c0-.92-.74-1.67-1.66-1.67H5.46A2.47 2.47 0 013 11.16V15z",
    fill: "url(#paint5_linear_79311_35734)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M3 15c0 1.1.9 2 2 2h10.34c.92 0 1.66-.74 1.66-1.66v-.04c0-.92-.74-1.67-1.66-1.67H5.46A2.47 2.47 0 013 11.16V15z",
    fill: "url(#paint6_linear_79311_35734)",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M3 9.8c0 .85.68 1.54 1.53 1.54h10.64c1.01 0 1.83.82 1.83 1.83v.7-4.2c0-.92-.74-1.66-1.66-1.66H4.66C3.74 8 3 7.26 3 6.34v-.67 4.14z",
    fill: "#BC7FFF"
  }), React.createElement("path", {
    d: "M3 9.8c0 .85.68 1.54 1.53 1.54h10.64c1.01 0 1.83.82 1.83 1.83v.7-4.2c0-.92-.74-1.66-1.66-1.66H4.66C3.74 8 3 7.26 3 6.34v-.67 4.14z",
    fill: "url(#paint7_linear_79311_35734)"
  }), React.createElement("path", {
    d: "M3 9.8c0 .85.68 1.54 1.53 1.54h10.64c1.01 0 1.83.82 1.83 1.83v.7-4.2c0-.92-.74-1.66-1.66-1.66H4.66C3.74 8 3 7.26 3 6.34v-.67 4.14z",
    fill: "url(#paint8_linear_79311_35734)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M3 9.8c0 .85.68 1.54 1.53 1.54h10.64c1.01 0 1.83.82 1.83 1.83v.7-4.2c0-.92-.74-1.66-1.66-1.66H4.66C3.74 8 3 7.26 3 6.34v-.67 4.14z",
    fill: "url(#paint9_radial_79311_35734)"
  }), React.createElement("path", {
    d: "M3 12.14c0 1.01.82 1.83 1.83 1.83h10.5c.93 0 1.67.75 1.67 1.67v-2.99c0-.92-.74-1.67-1.66-1.67H4.83A1.83 1.83 0 013 9.15v-.98 3.97z",
    fill: "#974CFF"
  }), React.createElement("path", {
    d: "M3 12.14c0 1.01.82 1.83 1.83 1.83h10.5c.93 0 1.67.75 1.67 1.67v-2.99c0-.92-.74-1.67-1.66-1.67H4.83A1.83 1.83 0 013 9.15v-.98 3.97z",
    fill: "#A966FF",
    fillOpacity: 0.35
  }), React.createElement("path", {
    d: "M3 12.14c0 1.01.82 1.83 1.83 1.83h10.5c.93 0 1.67.75 1.67 1.67v-2.99c0-.92-.74-1.67-1.66-1.67H4.83A1.83 1.83 0 013 9.15v-.98 3.97z",
    fill: "url(#paint10_linear_79311_35734)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M3 12.14c0 1.01.82 1.83 1.83 1.83h10.5c.93 0 1.67.75 1.67 1.67v-2.99c0-.92-.74-1.67-1.66-1.67H4.83A1.83 1.83 0 013 9.15v-.98 3.97z",
    fill: "url(#paint11_linear_79311_35734)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M3 12.14c0 1.01.82 1.83 1.83 1.83h10.5c.93 0 1.67.75 1.67 1.67v-2.99c0-.92-.74-1.67-1.66-1.67H4.83A1.83 1.83 0 013 9.15v-.98 3.97z",
    fill: "url(#paint12_linear_79311_35734)",
    fillOpacity: 0.6
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint3_linear_79311_35734",
    x1: 11.98,
    y1: 14.59,
    x2: 11.51,
    y2: 17.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#330072"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7611F0",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79311_35734",
    x1: 6.14,
    y1: 14.59,
    x2: 6.14,
    y2: 18.42,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_79311_35734",
    x1: 6.82,
    y1: 14.34,
    x2: 3,
    y2: 14.37,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_79311_35734",
    x1: 12.79,
    y1: 14.38,
    x2: 18.88,
    y2: 19.03,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_79311_35734",
    x1: 6.82,
    y1: 9.52,
    x2: 3,
    y2: 9.52,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BC80FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_79311_35734",
    x1: 12.36,
    y1: 9.52,
    x2: 17,
    y2: 9.52,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BC7FFF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_79311_35734",
    x1: 11.32,
    y1: 8.17,
    x2: 11.11,
    y2: 12.85,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6200D5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3E008D",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint11_linear_79311_35734",
    x1: 13.18,
    y1: 11.93,
    x2: 17,
    y2: 11.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9B54FD",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_79311_35734",
    x1: 6.82,
    y1: 11.93,
    x2: 3,
    y2: 11.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#944EF6",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("radialGradient", {
    id: "paint0_radial_79311_35734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(148 5.99 -.82) scale(16.5182)"
  }, React.createElement("stop", {
    offset: 0.62,
    stopColor: "#974CFF"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5000B0"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_79311_35734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(159.23 8.29 2.96) scale(13.4612)"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DE91FF"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D373FC",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79311_35734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(146.31 7.46 3.05) scale(9.79479)"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint9_radial_79311_35734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.57116 7.68199 9.22906 18.144 14.57 -.29)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  }))));
};
export const ClipchampColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipchampColorIcon({}), 'ClipchampColor');
const ClipchampFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 14c.42.31.94.5 1.5.5h11.25a1.25 1.25 0 010 2.5H5a2 2 0 01-2-2v-1zm0-3.5c.42.31.94.5 1.5.5h11.25c.69 0 1.25.56 1.25 1.25v1.63a2.24 2.24 0 00-1.25-.38H4.5A1.5 1.5 0 013 12v-1.5zM3 7c.2.15.44.28.69.36l.04.02c.24.08.5.12.77.12h11.25c.69 0 1.25.56 1.25 1.25v1.63a2.24 2.24 0 00-1.25-.38H4.5A1.5 1.5 0 013 8.5V7zm11.92-4.43c.81-.15 1.6.38 1.77 1.2l.1.49c.17.8-.36 1.59-1.18 1.74l-2.7.5H4.5a1.5 1.5 0 01-1.42-1c.18-.48.59-.85 1.12-.95l10.72-1.98z",
    fill: primaryFill
  }));
};
export const ClipchampFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipchampFilledIcon({}), 'ClipchampFilled');
const ClipchampRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.07 2.55c.71-.06 1.37.39 1.58 1.06l.04.15.1.5c.16.76-.3 1.49-1.03 1.7l-.15.04-5.39 1H15a2 2 0 012 2v6l-.01.2A2 2 0 0115 17H5a2 2 0 01-2-2V6.1A1.47 1.47 0 014.05 4.6l.15-.04 10.72-1.98.15-.02zM4 15a1 1 0 001 1h10a1 1 0 100-2H5c-.36 0-.7-.1-1-.27V15zm0-3a1 1 0 001 1h10c.36 0 .7.1 1 .27V12a1 1 0 00-1-1H5c-.36 0-.7-.1-1-.27V12zm0-3a1 1 0 001 1h10c.36 0 .7.1 1 .27V9a1 1 0 00-1-1H5c-.36 0-.7-.1-1-.27V9zm11.12-5.45L4.69 5.48a.75.75 0 00.07 1.49h.17l10.49-1.95a.5.5 0 00.39-.58l-.1-.5a.51.51 0 00-.6-.4z",
    fill: primaryFill
  }));
};
export const ClipchampRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipchampRegularIcon({}), 'ClipchampRegular');
const ComponentLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v7a3 3 0 003 3h4v-2.5a5.5 5.5 0 019-4.24V7a3 3 0 00-3-3H5zm9 3a1 1 0 11-2 0 1 1 0 012 0zm-4 1a1 1 0 110-2 1 1 0 010 2zM8 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};
export const ComponentLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComponentLoopFilledIcon({}), 'ComponentLoopFilled');
const ComponentLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v3.26a5.5 5.5 0 00-1-.66V7a2 2 0 00-2-2H5a2 2 0 00-2 2v7c0 1.1.9 2 2 2h4v1H5a3 3 0 01-3-3V7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10 8a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 7a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};
export const ComponentLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComponentLoopRegularIcon({}), 'ComponentLoopRegular');
const CopilotColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 3.35A1.88 1.88 0 0012.34 2h-.6c-.9 0-1.66.63-1.84 1.51L8.85 8.85l.3-.96c.24-.78.97-1.32 1.8-1.32h3.29l1.4 1.17 1.24-1.17h-.39c-.83 0-1.57-.55-1.8-1.35l-.55-1.87z",
    fill: "url(#paint0_radial_79345_26935)"
  }), React.createElement("path", {
    d: "M6.05 16.64c.23.8.97 1.36 1.8 1.36h1.22c1.01 0 1.84-.8 1.88-1.8l.18-5.06-.29.96c-.24.79-.97 1.33-1.8 1.33h-3.3l-1.39-.89-1.02.89h.38c.84 0 1.57.55 1.8 1.36l.54 1.85z",
    fill: "url(#paint1_radial_79345_26935)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint2_radial_79345_26935)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint3_linear_79345_26935)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint4_linear_79345_26935)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint5_radial_79345_26935)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint6_linear_79345_26935)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_79345_26935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.54964 -5.59008 -4.91213 4.68878 15.71 8.9)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00AEFF"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_79345_26935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(4.0792 5.17125 4.81539 -4.22088 4.74 13.4)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFB657"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF5F3D"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C02B3C"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79345_26935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.56254 -14.1518 14.6248 -.54326 6.06 15.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFC800"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#52B471"
  }), React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0D91E1"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79345_26935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.18438 14.3365 -14.8202 -5.01518 17.09 5.45)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79345_26935",
    x1: 6.11,
    y1: 2,
    x2: 6.59,
    y2: 13.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79345_26935",
    x1: 5.5,
    y1: 15.06,
    x2: 5.5,
    y2: 9.08,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC800"
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#9DBD42",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint6_linear_79345_26935",
    x1: 17.6,
    y1: 5.87,
    x2: 17.6,
    y2: 8.99,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8ADFA"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A86EDD",
    stopOpacity: 0
  }))));
};
export const CopilotColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotColorIcon({}), 'CopilotColor');
const CopilotFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.93 2h6.2c1.06 0 1.99.7 2.29 1.7l.47 1.6c.16.55.64.93 1.2.98h.28c.9 0 1.58.25 2.03.77.44.5.6 1.17.6 1.84.02 1.32-.5 2.96-.9 4.27a12.57 12.57 0 01-1.45 3.22c-.61.9-1.45 1.62-2.58 1.62H7.86c-1.05 0-1.98-.7-2.28-1.7l-.47-1.6a1.38 1.38 0 00-1.2-.98h-.29c-.88 0-1.57-.25-2.02-.77a2.78 2.78 0 01-.6-1.84c-.02-1.32.5-2.96.9-4.26.37-1.14.83-2.32 1.44-3.23C3.96 2.72 4.8 2 5.93 2zm-.2 11.72c.15.2.27.44.34.7l.47 1.6c.17.58.71.98 1.32.98h.03c.36 0 .6-.17.75-.38a4 4 0 00.47-.95c.15-.4.29-.83.44-1.33l.03-.1.2-.64c-.24.07-.49.11-.74.11H6.4l-.16.01h-.52zm2.46-1h.85c.55 0 1.04-.34 1.26-.84l1.17-3.9c.07-.25.19-.49.34-.7h-.85c-.55 0-1.04.34-1.26.83l-1.17 3.91c-.08.25-.19.49-.34.7zm2.03-6.32c.24-.07.49-.11.74-.11h3.3c-.14-.22-.26-.45-.33-.7l-.47-1.6c-.17-.59-.71-.99-1.32-.99h-.02a.92.92 0 00-.76.38 4 4 0 00-.48.96c-.14.38-.28.82-.43 1.32l-.03.1-.2.64z",
    fill: primaryFill
  }));
};
export const CopilotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotFilledIcon({}), 'CopilotFilled');
const CopilotRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.93 2h6.2c1.06 0 1.99.7 2.29 1.7l.47 1.6c.16.55.64.93 1.2.98h.28c.9 0 1.58.25 2.03.77.44.5.6 1.17.6 1.84.02 1.32-.5 2.96-.9 4.27a12.57 12.57 0 01-1.45 3.22c-.61.9-1.45 1.62-2.58 1.62H7.86c-1.05 0-1.98-.7-2.28-1.7l-.47-1.6a1.38 1.38 0 00-1.2-.98h-.29c-.88 0-1.57-.25-2.02-.77a2.78 2.78 0 01-.6-1.84c-.02-1.32.5-2.96.9-4.26.37-1.14.83-2.32 1.44-3.23C3.96 2.72 4.8 2 5.93 2zM2.86 7.15C2.43 8.5 1.98 9.97 2 11.1c0 .55.13.94.35 1.2.2.23.57.42 1.27.42h2.63c.61 0 1.15-.4 1.32-.98.47-1.58 1.27-4.24 1.9-6.28l.03-.1c.15-.5.3-.96.45-1.38.13-.35.28-.69.46-.98H5.93c-.65 0-1.22.4-1.76 1.19-.53.78-.96 1.84-1.3 2.96zm2.87 6.57c.15.2.27.44.34.7l.47 1.6c.17.58.71.98 1.32.98h.03c.36 0 .6-.17.75-.38a4 4 0 00.47-.95c.15-.4.29-.83.44-1.33l.03-.1.2-.64c-.24.07-.49.11-.74.11H6.4l-.16.01h-.52zm2.46-1h.85c.55 0 1.04-.34 1.26-.84l1.17-3.9c.07-.25.19-.49.34-.7h-.85c-.55 0-1.04.34-1.26.83l-1.17 3.91c-.08.25-.19.49-.34.7zm2.03-6.32c.24-.07.49-.11.74-.11h3.31c-.15-.22-.27-.45-.34-.7l-.47-1.6c-.17-.59-.71-.99-1.32-.99h-.02a.92.92 0 00-.76.38 4 4 0 00-.48.96c-.14.38-.28.82-.43 1.32l-.03.1-.2.64zm6.92 6.45c.42-1.35.88-2.82.86-3.95 0-.55-.13-.94-.35-1.2-.2-.23-.57-.42-1.28-.42h-2.62c-.61 0-1.15.4-1.32.99-.47 1.57-1.27 4.23-1.9 6.27l-.03.1c-.15.5-.3.96-.45 1.38-.13.35-.28.69-.46.98h4.48c.65 0 1.22-.4 1.76-1.19.53-.78.96-1.84 1.3-2.96z",
    fill: primaryFill
  }));
};
export const CopilotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotRegularIcon({}), 'CopilotRegular');
const CopilotForSalesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.5 18h6.48a2.9 2.9 0 002.05-4.97L13 12.5 10.5 10H10l-6.26 2.74A2.9 2.9 0 002 15.4v.1A2.5 2.5 0 004.5 18z",
    fill: "url(#paint0_linear_60212_297)"
  }), React.createElement("path", {
    d: "M15.5 2H9.02c-2.4 0-3.7 2.7-2.4 4.56.2.28.36.6.38.94L9.5 10h.5l6.26-2.74A2.9 2.9 0 0018 4.6v-.1A2.5 2.5 0 0015.5 2z",
    fill: "url(#paint1_linear_60212_297)"
  }), React.createElement("path", {
    d: "M12.5 7h3.05C16.9 7 18 5.9 18 4.55v6.43a2.9 2.9 0 01-4.97 2.05L10 10v.5A2.5 2.5 0 017.5 13H4.45A2.45 2.45 0 002 15.45V9.02a2.9 2.9 0 014.97-2.05L10 10v-.5A2.5 2.5 0 0112.5 7z",
    fill: "url(#paint2_linear_60212_297)"
  }), React.createElement("g", {
    opacity: 0.25,
    fill: "#000"
  }, React.createElement("path", {
    d: "M7.5 14h-3a2.5 2.5 0 00-2.45 2 2.5 2.5 0 01-.05-.45v-.1A2.5 2.5 0 014.5 13h3a2.5 2.5 0 002.5-2.49v.99A2.5 2.5 0 017.5 14z"
  }), React.createElement("path", {
    d: "M10 10.49A2.5 2.5 0 0112.5 8h3a2.5 2.5 0 002.45-3 2.5 2.5 0 01-2.45 2h-3A2.5 2.5 0 0010 9.5v.99z"
  })), React.createElement("path", {
    opacity: 0.25,
    d: "M2.2 16.5c.3-.5.84-1.5 2.3-1.5h3a3.5 3.5 0 003.5-3.5v-1c0-.83.67-1.5 1.5-1.5h3c.98 0 1.86-.4 2.5-1.05V4.5A2.5 2.5 0 0115.5 7h-3A2.5 2.5 0 0010 9.5v1A2.5 2.5 0 017.5 13h-3a2.5 2.5 0 00-2.3 3.5z",
    fill: "#000",
    fillOpacity: 0.5
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_60212_297",
    x1: 1.73,
    y1: 17.82,
    x2: 10.69,
    y2: 8.73,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#122882"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1A43BC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0BA0C5"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_60212_297",
    x1: 16.42,
    y1: 2,
    x2: 9.42,
    y2: 10.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9BF3AF"
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3DD9EB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3DCBFF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_60212_297",
    x1: 2,
    y1: 10.98,
    x2: 18.85,
    y2: 10.98,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2764E7"
  }), React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0099F8"
  }), React.createElement("stop", {
    offset: 0.73,
    stopColor: "#16BFDF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3EE5C9"
  }))));
};
export const CopilotForSalesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotForSalesColorIcon({}), 'CopilotForSalesColor');
const CopilotForSalesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 10.25l2.9 2.9a2.4 2.4 0 004.1-1.7V6.25c-.53.47-1.23.76-2 .76h-3.5c-.83 0-1.5.67-1.5 1.5v1.75zm7-6.28v.06A2 2 0 0116 6h-3.5A2.5 2.5 0 0010 8.5v.75L6.85 6.1A2.4 2.4 0 018.55 2H16a2 2 0 012 1.97zM11.46 18H4a2 2 0 010-4h3.5a2.5 2.5 0 002.5-2.5v-.75l3.15 3.15a2.4 2.4 0 01-1.7 4.1zM2 8.54v5.22A2.99 2.99 0 014 13h3.5c.83 0 1.5-.67 1.5-1.5V9.75l-2.9-2.9A2.4 2.4 0 002 8.55z",
    fill: primaryFill
  }));
};
export const CopilotForSalesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotForSalesFilledIcon({}), 'CopilotForSalesFilled');
const CopilotForSalesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 15a3 3 0 003 3h5.86c2.23 0 3.6-2.07 3.18-3.96A3.26 3.26 0 0018 10.86V5a3 3 0 00-3-3H9.14a3.26 3.26 0 00-3.18 3.96A3.26 3.26 0 002 9.14V15zm4.84-7.46L9 9.71v.62C9 11.25 8.25 12 7.33 12H5c-.77 0-1.47.29-2 .76V9.14c0-2 2.42-3 3.84-1.6zM3 15C3 13.9 3.9 13 5 13h2.33c1.36 0 2.48-1 2.65-2.32l2.48 2.48a2.25 2.25 0 01-1.6 3.84H5a2 2 0 01-2-2zm10.16-2.53L11 10.29v-.62c0-.92.75-1.67 1.67-1.67H15c.77 0 1.47-.29 2-.76v3.62c0 2-2.42 3-3.84 1.6zM12.66 7c-1.35 0-2.47 1-2.64 2.32L7.54 6.84A2.25 2.25 0 019.14 3H15a2 2 0 110 4h-2.33z",
    fill: primaryFill
  }));
};
export const CopilotForSalesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopilotForSalesRegularIcon({}), 'CopilotForSalesRegular');
const CortanaColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10a8.01 8.01 0 0016 0 8.01 8.01 0 00-16 0zm2 0a6 6 0 1112 0 6 6 0 01-12 0z",
    fill: "#1C9FE7"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10a6 6 0 1012.01-.01A6 6 0 004 10zm1 0a5 5 0 1110 0 5 5 0 01-10 0z",
    fill: "#1C9FE7"
  }));
};
export const CortanaColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/CortanaColorIcon({}), 'CortanaColor');
const DefenderColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 10.25v-5c-7.1 2.78-9.7 4.9-8.99 11.58.03.33.23.62.53.76.56.26 1.07.4 1.46.4 2 0 7-3.73 7-7.74z",
    fill: "url(#paint0_linear_79311_35708)"
  }), React.createElement("path", {
    d: "M17 10.25v-5c-7.1 2.78-9.7 4.9-8.99 11.58.03.33.23.62.53.76.56.26 1.07.4 1.46.4 2 0 7-3.73 7-7.74z",
    fill: "url(#paint1_radial_79311_35708)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M10 2.24c1.35 0 4.05.68 5.68 1.13l.42.12c.54.15.9.65.9 1.21v.83c-.16 3.69-1.34 4.76-4.64 7.42-.43.38-.88.74-1.33 1.11-.64.53-1.3 1.07-1.97 1.7a1.3 1.3 0 00.45 2.18 3.86 3.86 0 01-.38-.11c-1.21-.4-2.84-1.5-4.11-2.97-1-6.26.96-9.33 4.98-12.62z",
    fill: "url(#paint2_radial_79311_35708)"
  }), React.createElement("path", {
    d: "M10 2.24c1.35 0 4.05.68 5.68 1.13l.42.12c.54.15.9.65.9 1.21v.83c-.16 3.69-1.34 4.76-4.64 7.42-.43.38-.88.74-1.33 1.11-.64.53-1.3 1.07-1.97 1.7a1.3 1.3 0 00.45 2.18 3.86 3.86 0 01-.38-.11c-1.21-.4-2.84-1.5-4.11-2.97-1-6.26.96-9.33 4.98-12.62z",
    fill: "url(#paint3_radial_79311_35708)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M10 2.24c1.35 0 4.05.68 5.68 1.13l.42.12c.54.15.9.65.9 1.21v.83c-.16 3.69-1.34 4.76-4.64 7.42-.43.38-.88.74-1.33 1.11-.64.53-1.3 1.07-1.97 1.7a1.3 1.3 0 00.45 2.18 3.86 3.86 0 01-.38-.11c-1.21-.4-2.84-1.5-4.11-2.97-1-6.26.96-9.33 4.98-12.62z",
    fill: "url(#paint4_radial_79311_35708)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M10 2.24c1.35 0 4.05.68 5.68 1.13l.42.12c.54.15.9.65.9 1.21v.83c-.16 3.69-1.34 4.76-4.64 7.42-.43.38-.88.74-1.33 1.11-.64.53-1.3 1.07-1.97 1.7a1.3 1.3 0 00.45 2.18 3.86 3.86 0 01-.38-.11c-1.21-.4-2.84-1.5-4.11-2.97-1-6.26.96-9.33 4.98-12.62z",
    fill: "url(#paint5_radial_79311_35708)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M3.94 3.47c1.54-.43 4.6-1.23 6.06-1.23l.34.01a2.63 2.63 0 012 3.98C11.83 7.25 11 8.05 9.72 9.1l-1.2.96-1.14.91a6.25 6.25 0 00-1.64 1.64 2.62 2.62 0 00.45 3.4 1.98 1.98 0 00.06.07l-.5-.45C4.25 14.19 3 12.26 3 10.25V4.72c0-.58.38-1.1.94-1.25z",
    fill: "url(#paint6_radial_79311_35708)"
  }), React.createElement("path", {
    d: "M3.94 3.47c1.54-.43 4.6-1.23 6.06-1.23l.34.01a2.63 2.63 0 012 3.98C11.83 7.25 11 8.05 9.72 9.1l-1.2.96-1.14.91a6.25 6.25 0 00-1.64 1.64 2.62 2.62 0 00.45 3.4 1.98 1.98 0 00.06.07l-.5-.45C4.25 14.19 3 12.26 3 10.25V4.72c0-.58.38-1.1.94-1.25z",
    fill: "url(#paint7_linear_79311_35708)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M3.94 3.47c1.54-.43 4.6-1.23 6.06-1.23l.34.01a2.63 2.63 0 012 3.98C11.83 7.25 11 8.05 9.72 9.1l-1.2.96-1.14.91a6.25 6.25 0 00-1.64 1.64 2.62 2.62 0 00.45 3.4 1.98 1.98 0 00.06.07l-.5-.45C4.25 14.19 3 12.26 3 10.25V4.72c0-.58.38-1.1.94-1.25z",
    fill: "url(#paint8_radial_79311_35708)",
    fillOpacity: 0.5
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_79311_35708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 2.2 -6.63) scale(26.6479)"
  }, React.createElement("stop", {
    offset: 0.86,
    stopColor: "#003375"
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#003375",
    stopOpacity: 0.1
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79311_35708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(126.33 9.5 5.22) scale(25.2287)"
  }, React.createElement("stop", {
    offset: 0.17,
    stopColor: "#23C0FE"
  }), React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1C91FF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_79311_35708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(93.54 -2.78 -6.76) scale(35.7169)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1B44B1"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#045ED1",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_79311_35708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(91.89 -3.37 -7.27) scale(35.4088)"
  }, React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1B44B1"
  }), React.createElement("stop", {
    offset: 0.72,
    stopColor: "#045ED1",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79311_35708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-111.1 8.01 -.63) scale(16.0939 12.3019)"
  }, React.createElement("stop", {
    offset: 0.64,
    stopColor: "#11A7FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6AB3FF"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_79311_35708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(126.61 5.98 3.94) scale(19.3192)"
  }, React.createElement("stop", {
    stopColor: "#92EEFE"
  }), React.createElement("stop", {
    offset: 0.21,
    stopColor: "#35DDFF"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#15BDFB"
  }), React.createElement("stop", {
    offset: 0.8,
    stopColor: "#08B1F9"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_79311_35708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 7.14 -2.99) scale(14.3892)"
  }, React.createElement("stop", {
    offset: 0.66,
    stopColor: "#92DEFF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#92DEFF"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_79311_35708",
    x1: 16.28,
    y1: 9.83,
    x2: 6.98,
    y2: 17.28,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.72,
    stopColor: "#143DE0"
  }), React.createElement("stop", {
    offset: 0.98,
    stopColor: "#003375"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_79311_35708",
    x1: 8.24,
    y1: 7.74,
    x2: 3,
    y2: 7.74,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22CBFD",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#92DEFF"
  }))));
};
export const DefenderColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/DefenderColorIcon({}), 'DefenderColor');
const DefenderFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 10.5c0 .87-.32 1.77-.8 2.6a11.98 11.98 0 01-4.08 4.15c-.73.44-1.48.75-2.12.75h-.13a1.25 1.25 0 01-1.12-1.25c0-.63.41-1.2 1.25-1.86.42-.33.9-.65 1.45-1 .53-.34 1.12-.7 1.7-1.1 1.43-.96 2.9-2.15 3.85-3.83v1.54zm-4.17-8.06a47 47 0 012.79.76l.15.05c.74.3 1.22 1.01 1.23 1.8-.02 3.46-2.14 5.38-4.4 6.91-.58.39-1.14.74-1.7 1.1-.54.34-1.06.68-1.51 1.04-.9.7-1.64 1.53-1.64 2.65 0 .15.02.3.05.45-.66-.4-1.34-.94-1.98-1.55l-.13-.14c-.32-.39-.5-.88-.5-1.42 0-.79.4-1.45 1.13-2.1.73-.66 1.72-1.24 2.78-1.9a14.65 14.65 0 002.96-2.21A4.78 4.78 0 0013.5 4.5c0-.77-.25-1.49-.68-2.07h.01zM10 2a2.5 2.5 0 012.5 2.5c0 1.08-.45 1.93-1.16 2.69-.73.77-1.72 1.41-2.76 2.05-1.02.63-2.1 1.27-2.93 2a3.93 3.93 0 00-1.45 2.5 9.34 9.34 0 01-.4-.63A5.41 5.41 0 013 10.5V5.08c0-.86.55-1.63 1.38-1.88.73-.23 1.76-.52 2.79-.76C8.18 2.2 9.24 2 10 2z",
    fill: primaryFill
  }));
};
export const DefenderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DefenderFilledIcon({}), 'DefenderFilled');
const DefenderRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2h.17c.74.03 1.72.21 2.66.44a47 47 0 012.79.76l.15.05c.7.28 1.17.94 1.22 1.7L17 5v5.5c0 .87-.32 1.77-.8 2.6a11.98 11.98 0 01-4.08 4.15c-.73.44-1.48.75-2.12.75h-.18l-.01-.01a4.81 4.81 0 01-1.93-.73c-.66-.4-1.35-.94-2-1.55l-.23-.23A11.45 11.45 0 013.8 13.1 5.41 5.41 0 013 10.5V5.08c0-.86.55-1.63 1.38-1.88.73-.23 1.76-.52 2.79-.76C8.18 2.2 9.24 2 10 2zm6 7.44l-.29.5a10.21 10.21 0 01-2.8 2.87c-.49.36-.98.68-1.43.98-.46.3-.86.57-1.2.85-.7.55-1.03 1.03-1.03 1.61 0 .39.29.7.66.74L10 17c.36 0 .92-.2 1.6-.6a10.99 10.99 0 003.73-3.79c.43-.75.67-1.48.67-2.11V9.44zm-3.47-6.05c.3.47.47 1.02.47 1.61 0 2.48-2 3.97-3.71 5.16-.9.62-1.73 1.17-2.35 1.77-.6.6-.94 1.17-.94 1.82 0 .4.18.78.45 1.1l.1.12a11 11 0 001.7 1.34v-.06c0-1.05.64-1.78 1.4-2.4.38-.3.82-.6 1.28-.9.46-.3.93-.6 1.4-.95a9.23 9.23 0 002.53-2.59A8.11 8.11 0 0016 5.07c0-.38-.21-.7-.53-.86l-.14-.06a46 46 0 00-2.73-.74l-.07-.02zM10 3c-.64 0-1.6.17-2.6.4a46 46 0 00-2.73.75c-.4.13-.67.5-.67.93v5.42c0 .63.24 1.36.67 2.11.11.2.24.4.38.6.15-.78.62-1.44 1.2-2 .69-.67 1.6-1.28 2.46-1.87C10.51 8.1 12 6.89 12 5a2 2 0 00-2-2z",
    fill: primaryFill
  }));
};
export const DefenderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DefenderRegularIcon({}), 'DefenderRegular');
const DesignIdeasColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 10c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2h-5a2 2 0 01-2-2v-5z",
    fill: "red"
  }), React.createElement("path", {
    d: "M9 10c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2h-5a2 2 0 01-2-2v-5z",
    fill: "url(#paint0_radial_73293_112)"
  }), React.createElement("path", {
    d: "M14 8A5 5 0 114 8a5 5 0 0110 0z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M14 8A5 5 0 114 8a5 5 0 0110 0z",
    fill: "url(#paint1_radial_73293_112)"
  }), React.createElement("path", {
    d: "M14 8A5 5 0 114 8a5 5 0 0110 0z",
    fill: "url(#paint2_radial_73293_112)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M14 8A5 5 0 114 8a5 5 0 0110 0z",
    fill: "url(#paint3_radial_73293_112)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M9 13a5 5 0 005-5h-3a2 2 0 00-2 2v3z",
    fill: "url(#paint4_linear_73293_112)"
  }), React.createElement("path", {
    d: "M9 13a5 5 0 005-5h-3a2 2 0 00-2 2v3z",
    fill: "url(#paint5_linear_73293_112)"
  }), React.createElement("path", {
    d: "M4 6.86c.5 0 1.02.44 1.19.67l.06.07c.29.34.45.79.55 1.23.2.87.2 1.92.2 2.64v.03c0 2.79-.38 4.37-.8 5.27-.2.46-.43.75-.62.93a1.48 1.48 0 01-.4.26S4.09 18 4 18c-.07 0-.19-.04-.19-.04a.67.67 0 01-.13-.06c-.07-.05-.16-.1-.26-.2-.2-.18-.41-.47-.62-.93-.42-.9-.8-2.48-.8-5.27v-.03c0-.72 0-1.77.2-2.64a3.02 3.02 0 01.6-1.3h.01c.15-.23.6-.67 1.19-.67z",
    fill: "url(#paint6_radial_73293_112)"
  }), React.createElement("path", {
    d: "M2.08 9.54c.03-.24.07-.48.12-.71a3.02 3.02 0 01.6-1.3h.01c.15-.23.6-.67 1.19-.67.5 0 1.02.44 1.19.67l.06.07c.29.34.45.79.55 1.23.05.23.1.47.12.7-.52.3-1.19.47-1.92.47s-1.4-.17-1.92-.46z",
    fill: "#fff",
    fillOpacity: 0.24
  }), React.createElement("path", {
    d: "M4.7 2.71a.5.5 0 00-.73-.63l-.01.01-.03.02a4.31 4.31 0 00-.43.35c-.25.22-.58.54-.81.93A4.73 4.73 0 002 5.5c0 .85.32 1.58.8 2.03.21.22.71.56 1.24.56.51 0 .98-.36 1.16-.55v-.01c.48-.45.8-1.18.8-2.03 0-.7-.14-1.18-.4-1.56a2.75 2.75 0 00-.56-.61l-.19-.18C4.7 3 4.7 2.88 4.7 2.8a.33.33 0 01.01-.1z",
    fill: "#424242"
  }), React.createElement("path", {
    d: "M4.7 2.71a.5.5 0 00-.73-.63l-.01.01-.03.02a4.31 4.31 0 00-.43.35c-.25.22-.58.54-.81.93A4.73 4.73 0 002 5.5c0 .85.32 1.58.8 2.03.21.22.71.56 1.24.56.51 0 .98-.36 1.16-.55v-.01c.48-.45.8-1.18.8-2.03 0-.7-.14-1.18-.4-1.56a2.75 2.75 0 00-.56-.61l-.19-.18C4.7 3 4.7 2.88 4.7 2.8a.33.33 0 01.01-.1z",
    fill: "url(#paint7_radial_73293_112)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_73293_112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.8504 7.18406 -9.7579 10.66296 10.15 8.64)"
  }, React.createElement("stop", {
    stopColor: "#C354FF"
  }), React.createElement("stop", {
    offset: 0.16,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC470"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_73293_112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-78.38 11.94 4.7) scale(13.528 13.5279)"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4E46E2"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#625DF6"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E37DFF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_73293_112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-17.28 36.3 -3.53) scale(5.46112 7.14855)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#251FBA"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5E51E4",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint3_radial_73293_112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.9714 .72166 -.73767 5.08176 2.31 6.92)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#251FBA"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5E51E4",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_73293_112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.0909 .2034 -.50164 -12.55538 2.45 11.87)"
  }, React.createElement("stop", {
    offset: 0.03,
    stopColor: "#F34E99"
  }), React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C61EBB"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_73293_112",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(112.91 1.36 3.58) scale(5.95419 4.17416)"
  }, React.createElement("stop", {
    stopColor: "#FEAD54"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF835C"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_73293_112",
    x1: 13.51,
    y1: 12.93,
    x2: 9.77,
    y2: 7.43,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EA71EF"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_73293_112",
    x1: 14.3,
    y1: 14.22,
    x2: 8.34,
    y2: 5.89,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.19,
    stopColor: "#7631FF"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#E63080"
  }))));
};
export const DesignIdeasColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignIdeasColorIcon({}), 'DesignIdeasColor');
const DesignerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.25 15a7.99 7.99 0 01-6.24 3H4a1 1 0 01-1-1v-1a6 6 0 016-6v-.25h6.25v5.24z",
    fill: "url(#paint0_radial_218573_1549)"
  }), React.createElement("path", {
    d: "M15.25 15a7.99 7.99 0 01-6.24 3H4a1 1 0 01-1-1v-1a6 6 0 016-6v-.25h6.25v5.24z",
    fill: "url(#paint1_radial_218573_1549)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M9 2H4a1 1 0 00-1 1v1a6 6 0 006 6h2.25a4 4 0 013.8 5.22A8 8 0 009 2z",
    fill: "url(#paint2_radial_218573_1549)"
  }), React.createElement("path", {
    d: "M9 2H4a1 1 0 00-1 1v1a6 6 0 006 6h2.25a4 4 0 013.8 5.22A8 8 0 009 2z",
    fill: "url(#paint3_radial_218573_1549)",
    fillOpacity: 0.5
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.12487 -8.2499 10.11492 12.41375 3 18.58)"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD7DFF"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6864F6"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5750E2"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3E36B1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#261D82"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-160.3 9.73 7.43) scale(15.0593)"
  }, React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AC80FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BD96FF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.99976 11.01763 -9.10449 11.56878 3 2.48)"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C354FF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_218573_1549",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-11.41642 -7.95828 7.55741 -10.84136 8.74 13.46)"
  }, React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFB357",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB357"
  }))));
};
export const DesignerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignerColorIcon({}), 'DesignerColor');
const DesignerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.5 9.5h4a4.23 4.23 0 014.24 3.91A8 8 0 009.5 2H5a2 2 0 00-2 2 5.5 5.5 0 005.5 5.5zm6.56 6.25a3.25 3.25 0 00-2.56-5.25h-4A5.5 5.5 0 003 16c0 1.1.9 2 2 2h4.5c2.16 0 4.12-.86 5.56-2.25z",
    fill: primaryFill
  }));
};
export const DesignerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignerFilledIcon({}), 'DesignerFilled');
const DesignerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2 6.5 6.5 0 004 6 6.5 6.5 0 00-4 5.99V16c0 1.1.9 2 2 2h4.5a8 8 0 000-16H5zm11.5 8.01c0 1-.22 1.96-.6 2.83a4.25 4.25 0 00-4.15-3.34H9.5A5.5 5.5 0 014 4a1 1 0 011-1h4.5a7 7 0 017 7.01zm-1.57 4.4A6.99 6.99 0 019.5 17H5a1 1 0 01-1-1 5.5 5.5 0 015.5-5.5h2.25a3.25 3.25 0 013.18 3.92z",
    fill: primaryFill
  }));
};
export const DesignerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignerRegularIcon({}), 'DesignerRegular');
const DocumentOnePageLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v5.7a5.5 5.5 0 00-3.8.3H7.42a.5.5 0 00.09 1h3.23A5.5 5.5 0 009.2 13H7.4a.5.5 0 00.09 1h1.52l-.02.5V18H5.5A1.5 1.5 0 014 16.5v-13zM12.5 7h.09a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h5z",
    fill: primaryFill
  }));
};
export const DocumentOnePageLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageLoopFilledIcon({}), 'DocumentOnePageLoopFilled');
const DocumentOnePageLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M14 2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h3v-1H6a1 1 0 01-1-1V4a1 1 0 011-1h8a1 1 0 011 1v5.02c.34.03.68.1 1 .19V4a2 2 0 00-2-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.2 9.5H7.42a.5.5 0 00.09 1h3.23c.43-.4.93-.75 1.48-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.2 13H7.42a.5.5 0 00.09 1h1.52c.03-.34.1-.68.19-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.59 7a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h5.09z",
    fill: primaryFill
  }));
};
export const DocumentOnePageLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageLoopRegularIcon({}), 'DocumentOnePageLoopRegular');
const DocumentOnePageMultipleSparkleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.35 1.07a.42.42 0 01-.8 0l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-1.07-.35a.42.42 0 010-.8l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0z",
    fill: "url(#paint0_linear_70965_84915)"
  }), React.createElement("path", {
    d: "M19.78 8.21l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 000 .57l.77.25a1.58 1.58 0 011 1l.24.77a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02z",
    fill: "url(#paint1_linear_70965_84915)"
  }), React.createElement("path", {
    d: "M6 2h5.43l-.48.15A1.43 1.43 0 0010 3.5a1.41 1.41 0 00.97 1.35l.46.15H7.41a.5.5 0 00.09 1h4.09a.5.5 0 00.25-.86l.2.06c.14.05.28.13.46.29.11.11.2.24.3.47l.35 1.1c.1.24.25.47.52.68.14.1.3.17.45.21a1.3 1.3 0 00.77 1.79l.11.03V14a2 2 0 01-2 2H6a2 2 0 01-2-2V4l.01-.2A2 2 0 016 2zm5.59 7.5a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h4.09zm0 3.5a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h4.09z",
    fill: "url(#paint2_linear_70965_84915)"
  }), React.createElement("path", {
    d: "M16 14v-3.7l.02.05.26.8c.1.25.26.46.48.62.07.05.15.1.24.13v2.16A3.94 3.94 0 0113.06 18H7a1 1 0 01-1-1h7a3 3 0 003-3z",
    fill: "url(#paint3_linear_70965_84915)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_70965_84915",
    x1: 18.15,
    y1: 18.03,
    x2: 18.15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_70965_84915",
    x1: 18.15,
    y1: 18.03,
    x2: 18.15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_70965_84915",
    x1: 18.15,
    y1: 18.03,
    x2: 18.15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_70965_84915",
    x1: 18.15,
    y1: 18.03,
    x2: 18.15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  }))));
};
export const DocumentOnePageMultipleSparkleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageMultipleSparkleFilledIcon({}), 'DocumentOnePageMultipleSparkleFilled');
const DocumentOnePageMultipleSparkleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.35 1.07a.42.42 0 01-.8 0l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-1.07-.35a.42.42 0 010-.8l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M19.78 8.21l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 000 .57l.77.25a1.58 1.58 0 011 1l.24.77a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M11.43 2H6a2 2 0 00-2 2v10c0 1.1.9 2 2 2h7a2 2 0 002-2V9.77l-.1-.03c-.28-.1-.5-.26-.66-.48A1.27 1.27 0 0114 8.5V14a1 1 0 01-1 1H6a1 1 0 01-1-1V4v-.11A1 1 0 016 3h4.09a1.42 1.42 0 01.86-.85l.48-.15z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M11.43 5H7.41a.5.5 0 00.09 1h4.09a.5.5 0 00.25-.86L11.43 5z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M16 10.3V14a3 3 0 01-3 3H6a1 1 0 001 1h6.06A3.94 3.94 0 0017 14.06V11.9a1.32 1.32 0 01-.24-.13 1.4 1.4 0 01-.48-.62l-.26-.8a.98.98 0 00-.02-.04z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M12 9a.5.5 0 01-.41.5H7.5a.5.5 0 01-.09-1h4.09c.28 0 .5.22.5.5z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M12 12.5a.5.5 0 01-.41.5H7.5a.5.5 0 01-.09-1h4.09c.28 0 .5.22.5.5z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M15.23 1.35L14.88.28a.42.42 0 00-.8 0l-.35 1.07a2.2 2.2 0 01-1.38 1.4l-1.07.35a.42.42 0 000 .8l1.07.34a2.2 2.2 0 011.4 1.4l.35 1.08a.42.42 0 00.8 0l.35-1.07a2.2 2.2 0 011.4-1.4l1.07-.35a.42.42 0 000-.8h-.02l-1.08-.35a2.2 2.2 0 01-1.4-1.4z",
    fill: "url(#paint0_linear_70965_84912)"
  }), React.createElement("path", {
    d: "M19.02 7.96l.76.25h.02a.3.3 0 010 .58l-.77.25a1.58 1.58 0 00-1 1l-.24.76a.3.3 0 01-.58 0l-.24-.77a1.58 1.58 0 00-1-1l-.77-.25a.3.3 0 010-.57l.77-.25a1.58 1.58 0 00.98-1l.25-.76a.3.3 0 01.57 0l.25.77a1.57 1.57 0 001 1z",
    fill: "url(#paint1_linear_70965_84912)"
  }), React.createElement("path", {
    d: "M11.43 5H7.41a.5.5 0 00.09 1h4.09a.5.5 0 00.25-.86L11.43 5z",
    fill: "url(#paint2_linear_70965_84912)"
  }), React.createElement("path", {
    d: "M12 9a.5.5 0 01-.41.5H7.5a.5.5 0 01-.09-1h4.09c.28 0 .5.22.5.5z",
    fill: "url(#paint3_linear_70965_84912)"
  }), React.createElement("path", {
    d: "M11.59 13a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h4.09z",
    fill: "url(#paint4_linear_70965_84912)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_70965_84912",
    x1: 14.67,
    y1: 13.01,
    x2: 14.67,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_70965_84912",
    x1: 14.67,
    y1: 13.01,
    x2: 14.67,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_70965_84912",
    x1: 14.67,
    y1: 13.01,
    x2: 14.67,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_70965_84912",
    x1: 14.67,
    y1: 13.01,
    x2: 14.67,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_70965_84912",
    x1: 14.67,
    y1: 13.01,
    x2: 14.67,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  }))));
};
export const DocumentOnePageMultipleSparkleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageMultipleSparkleRegularIcon({}), 'DocumentOnePageMultipleSparkleRegular');
const DocumentOnePageSparkleFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.35 1.07a.42.42 0 01-.8 0l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-1.07-.35a.42.42 0 010-.8l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0zm4.9 7.93l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 000 .57l.77.25a1.58 1.58 0 011 1l.24.77a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02zM6 2h5.43l-.48.15A1.43 1.43 0 0010 3.5a1.41 1.41 0 00.97 1.35l1.06.35c.15.05.3.13.47.29.11.11.2.24.3.47l.05.19A.5.5 0 0012.5 6h-5a.5.5 0 000 1h5a.5.5 0 00.5-.43l.15.48c.1.25.25.48.52.7.14.1.3.16.45.2a1.3 1.3 0 00.77 1.79l.77.25c.08.03.16.08.22.14.05.05.1.11.12.18V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm1 11.5c0 .28.22.5.5.5h5a.5.5 0 000-1h-5a.5.5 0 00-.5.5zm5.5-4h-5a.5.5 0 000 1h5a.5.5 0 000-1z",
    fill: "url(#paint0_linear_70965_84897)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_70965_84897",
    x1: 13.44,
    y1: 18.02,
    x2: 13.43,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  }))));
};
export const DocumentOnePageSparkleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageSparkleFilledIcon({}), 'DocumentOnePageSparkleFilled');
const DocumentOnePageSparkleRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.43 2H6a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2v-5.7a.48.48 0 00-.12-.17.64.64 0 00-.22-.14L15 9.77V16a1 1 0 01-1 1H6a1 1 0 01-1-1V4a1 1 0 011-1h4.09a1.42 1.42 0 01.86-.85l.48-.15z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.88.28l.35 1.07a2.2 2.2 0 001.4 1.4l1.07.35h.02a.42.42 0 010 .8l-1.07.35a2.2 2.2 0 00-1.4 1.4l-.35 1.07a.42.42 0 01-.8 0l-.35-1.07a2.23 2.23 0 00-1.4-1.4l-1.07-.35a.42.42 0 010-.8l1.07-.35a2.2 2.2 0 001.38-1.4l.35-1.07a.42.42 0 01.8 0z",
    fill: "url(#paint0_linear_70965_84892)"
  }), React.createElement("path", {
    d: "M19.78 8.21l-.76-.25a1.58 1.58 0 01-1-1l-.25-.76a.3.3 0 00-.57 0l-.25.77a1.58 1.58 0 01-.98 1l-.77.24a.3.3 0 000 .57l.77.25a1.58 1.58 0 011 1l.24.77a.3.3 0 00.58 0l.24-.77a1.58 1.58 0 011-1l.77-.24a.3.3 0 000-.57h-.02z",
    fill: "url(#paint1_linear_70965_84892)"
  }), React.createElement("path", {
    d: "M12.5 6a.5.5 0 01.5.57.5.5 0 01-.41.42L12.5 7h-5a.5.5 0 01-.09-1h5.09z",
    fill: "url(#paint2_linear_70965_84892)"
  }), React.createElement("path", {
    d: "M13 10a.5.5 0 01-.41.5H7.5a.5.5 0 01-.09-1h5.09c.28 0 .5.22.5.5z",
    fill: "url(#paint3_linear_70965_84892)"
  }), React.createElement("path", {
    d: "M12.59 14a.5.5 0 00-.09-1H7.41a.5.5 0 00.09 1h5.09z",
    fill: "url(#paint4_linear_70965_84892)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_70965_84892",
    x1: 14.67,
    y1: 14.01,
    x2: 14.67,
    y2: 0.15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_70965_84892",
    x1: 14.67,
    y1: 14.01,
    x2: 14.67,
    y2: 0.15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_70965_84892",
    x1: 14.67,
    y1: 14.01,
    x2: 14.67,
    y2: 0.15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_70965_84892",
    x1: 14.67,
    y1: 14.01,
    x2: 14.67,
    y2: 0.15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_70965_84892",
    x1: 14.67,
    y1: 14.01,
    x2: 14.67,
    y2: 0.15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9354FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7385FF"
  }))));
};
export const DocumentOnePageSparkleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentOnePageSparkleRegularIcon({}), 'DocumentOnePageSparkleRegular');
const DragonCopilotColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.26 2.51c0-.66 1-.69 1 0C10.26 6.71 7.72 8.8 8 12c.09 1 .82 2 2 2a2 2 0 002-2 4 4 0 01-8 0c0-2.65 1.57-4.21 3.1-5.73C8.27 5.1 9.26 3.64 9.26 2.5z",
    fill: "url(#paint0_radial_72229_7436)"
  }), React.createElement("path", {
    d: "M9.26 2.51c0-.66 1-.69 1 0C10.26 6.71 7.72 8.8 8 12c.09 1 .82 2 2 2a2 2 0 002-2 4 4 0 01-8 0c0-2.65 1.57-4.21 3.1-5.73C8.27 5.1 9.26 3.64 9.26 2.5z",
    fill: "url(#paint1_radial_72229_7436)",
    fillOpacity: 0.9
  }), React.createElement("path", {
    d: "M9.26 2.51c0-.66 1-.69 1 0C10.26 6.71 7.72 8.8 8 12c.09 1 .82 2 2 2a2 2 0 002-2 4 4 0 01-8 0c0-2.65 1.57-4.21 3.1-5.73C8.27 5.1 9.26 3.64 9.26 2.5z",
    fill: "url(#paint2_radial_72229_7436)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M10 10a2 2 0 012 2c0 1.66-1.8 3-4 3s-4-1.34-4-3a6 6 0 006 6c1.66 0 4-1.8 4-4s-2.39-4.35-4-4z",
    fill: "url(#paint3_linear_72229_7436)"
  }), React.createElement("path", {
    d: "M10 10a2 2 0 012 2c0 1.66-1.8 3-4 3s-4-1.34-4-3a6 6 0 006 6c1.66 0 4-1.8 4-4s-2.39-4.35-4-4z",
    fill: "url(#paint4_radial_72229_7436)"
  }), React.createElement("path", {
    d: "M14.76 8.34a4.1 4.1 0 01-1-3.35c.1-.37-.26-.76-.68-.57-1.75.79-3.14 2.63-3.75 4.96-.08.48.33.63.5.63L10 10c1.66 0 3 1.8 3 4s-1.34 4-3 4a6 6 0 004.76-9.66z",
    fill: "url(#paint5_linear_72229_7436)"
  }), React.createElement("path", {
    d: "M14.76 8.34a4.1 4.1 0 01-1-3.35c.1-.37-.26-.76-.68-.57-1.75.79-3.14 2.63-3.75 4.96-.08.48.33.63.5.63L10 10c1.66 0 3 1.8 3 4s-1.34 4-3 4a6 6 0 004.76-9.66z",
    fill: "url(#paint6_radial_72229_7436)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_72229_7436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(69.15 1 5.11) scale(16.7941 14.0673)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFD638"
  }), React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FB5B6C"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_72229_7436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.15628 6.99998 -4.49818 -2.67082 5.1 3.03)"
  }, React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFE06B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE06B",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_72229_7436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(86.64 1.92 5.98) scale(12.3064 7.89129)"
  }, React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8E250B",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8E250B",
    stopOpacity: 0.35
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8E250B"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_72229_7436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(20.35 -34.55 21.5) scale(10.0621 6.74401)"
  }, React.createElement("stop", {
    offset: 0.47,
    stopColor: "#312A9A",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#312A9A",
    stopOpacity: 0.36
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#312A9A"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_72229_7436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(50.39 -5.78 13.5) scale(14.3602 18.6547)"
  }, React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8B52F4",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8B52F4"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_72229_7436",
    x1: 3.19,
    y1: 12.66,
    x2: 12.47,
    y2: 17.63,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.03,
    stopColor: "#F97575"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B339F0"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_72229_7436",
    x1: 8.13,
    y1: 9.31,
    x2: 18.03,
    y2: 13.34,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFDC59"
  }), React.createElement("stop", {
    offset: 0.23,
    stopColor: "#64DE89"
  }), React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0091FF"
  }))));
};
export const DragonCopilotColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/DragonCopilotColorIcon({}), 'DragonCopilotColor');
const DragonCopilotFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.24 10h-.42a.5.5 0 01-.5-.45V9.4c.61-2.36 2.03-4.22 3.82-5 .36-.14.68.3.61.68A4 4 0 0014.46 8h.01a5.96 5.96 0 01-1.76 9.34c.5-.78.79-1.78.79-2.85 0-1.2-.37-2.3-.98-3.13a3.22 3.22 0 00-2.28-1.35zm1.48 7.02c-.46.62-1.06.96-1.68.97l.01.01h-.11a6.02 6.02 0 01-5.29-3.29c.78.5 1.78.8 2.85.8 1.2 0 2.31-.38 3.13-.99a3.25 3.25 0 001.35-2.16c.32.58.52 1.32.52 2.13 0 1.01-.31 1.9-.78 2.53z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.65 13.96A2 2 0 018 12c0-1.78.41-2.8.88-3.97.53-1.3 1.13-2.78 1.13-5.52A.5.5 0 009.5 2a.5.5 0 00-.5.5c0 1.98-1.04 2.97-2.25 4.1C5.46 7.84 4 9.23 4 12c0 .63.34 1.24.97 1.71.63.47 1.52.78 2.53.78.82 0 1.56-.2 2.15-.53z",
    fill: "#242424"
  }));
};
export const DragonCopilotFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DragonCopilotFilledIcon({}), 'DragonCopilotFilled');
const DragonCopilotRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.7 5.52c-.03.83.26 1.74.85 2.57A6 6 0 0110.03 18H10a6 6 0 01-6-6c0-2.78 1.46-4.17 2.75-5.39 1.16-1.1 2.16-2.05 2.24-3.87A.77.77 0 019.75 2c.2 0 .39.08.54.22a.8.8 0 01.22.54 14.4 14.4 0 01-1.17 5.58v.01A9.18 9.18 0 008.5 12a1.5 1.5 0 103 0c0-.7-.47-1.3-1.15-1.46a.76.76 0 01-.58-.91c.08-.34.17-.67.29-.99h-.01a7.94 7.94 0 012.26-3.41c.17-.15.35-.29.54-.41.39-.26.87.24.85.7zM7.5 12c0-1.69.43-2.82.9-4.02.32-.81.64-1.64.85-2.71-.49.81-1.16 1.44-1.81 2.06C6.18 8.52 5 9.65 5 12c0 1.28 1.35 2.5 3.25 2.5.35 0 .68-.04 1-.12A2.5 2.5 0 017.5 12zm6 1.75c0 .82-.2 1.61-.55 2.29a5 5 0 001.14-6.91 5.62 5.62 0 01-1.36-2.94 7.27 7.27 0 00-1.92 3.42c1.6.46 2.69 2.21 2.69 4.14zm-1 0c0-.34-.04-.66-.11-.95-.45 1.61-2.21 2.7-4.14 2.7-.82 0-1.61-.2-2.29-.55A5 5 0 0010 17h.01c1.28-.01 2.49-1.36 2.49-3.25z",
    fill: primaryFill
  }));
};
export const DragonCopilotRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DragonCopilotRegularIcon({}), 'DragonCopilotRegular');
const EdgeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.44 13.9a6.38 6.38 0 01-2.9.7C10.58 14.6 8 12.58 8 9.97c0-.73.43-1.37 1.03-1.7-2.67.1-3.36 2.9-3.36 4.53 0 4.62 4.25 5.09 5.17 5.09a6.71 6.71 0 001.77-.32 8.02 8.02 0 004.16-3.3c.14-.22-.1-.47-.33-.35z",
    fill: "url(#paint0_linear_11766_2389)"
  }), React.createElement("path", {
    d: "M8.6 17.09a5.1 5.1 0 01.42-8.83c.2-.1.54-.26.98-.26a2.02 2.02 0 012 1.98c0-.01 1.53-4.97-5-4.97-2.74 0-5 2.6-5 4.88a8.02 8.02 0 0010.53 7.7 4.74 4.74 0 01-3.92-.5z",
    fill: "url(#paint1_linear_11766_2389)"
  }), React.createElement("path", {
    d: "M11.52 11.3c-.05.07-.2.16-.2.36 0 .16.1.32.29.45.9.63 2.6.54 2.6.54a3.72 3.72 0 002.6-1.05A3.86 3.86 0 0018 8.82c.02-1.4-.5-2.33-.7-2.74C15.96 3.49 13.1 2 10 2a8 8 0 00-8 7.89c.03-2.29 2.3-4.13 5-4.13.22 0 1.46.02 2.62.63a4.53 4.53 0 011.93 1.82c.39.67.46 1.51.46 1.85 0 .34-.17.83-.49 1.24z",
    fill: "url(#paint2_linear_11766_2389)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_11766_2389",
    x1: 5.67,
    y1: 13.07,
    x2: 16.81,
    y2: 13.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#094987"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0C59A4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_11766_2389",
    x1: 6.8,
    y1: 5.2,
    x2: 4.58,
    y2: 15.81,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#117FBA"
  }), React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1797E0"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0078D4"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_11766_2389",
    x1: 18,
    y1: 8.4,
    x2: 6.8,
    y2: 4.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#48D566"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#35C1F1"
  }))));
};
export const EdgeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/EdgeColorIcon({}), 'EdgeColor');
const EdgeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.69 6.75c1-.78 2.36-1.25 3.81-1.25C9.43 5.5 12 7.42 12 10c0 .49-.18.94-.47 1.29a.5.5 0 00.19.78 5.9 5.9 0 002.28.43c1.01 0 2-.38 2.74-1A3.3 3.3 0 0018 9c0-4.21-3.9-7-8-7a8 8 0 00-7.31 4.75zm7.5 1.26L10 8c-2.58 0-4.5 2.57-4.5 5.5 0 1.45.47 2.8 1.25 3.81A8 8 0 012 10c0-1.83 1.9-3.5 4.5-3.5 1.58 0 2.9.62 3.7 1.5zm6.16 6.86A7.99 7.99 0 0110 18c-1.83 0-3.5-1.9-3.5-4.5 0-1.58.62-2.9 1.5-3.7v.2c0 2.4 2.37 4.5 5.5 4.5a6.5 6.5 0 002.28-.4.5.5 0 01.57.77z",
    fill: primaryFill
  }));
};
export const EdgeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EdgeFilledIcon({}), 'EdgeFilled');
const EdgeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a8 8 0 018-8c4.1 0 8 2.79 8 7 0 1-.52 1.89-1.26 2.5-.74.62-1.73 1-2.74 1a5.9 5.9 0 01-2.28-.43.5.5 0 01-.19-.78A2 2 0 108 10c0 2.4 2.37 4.5 5.5 4.5a6.5 6.5 0 002.28-.4.5.5 0 01.57.77A7.99 7.99 0 012 10zm4.62 6.13A6.29 6.29 0 015.5 12.5c0-2.86 1.83-5.39 4.33-5.5a5.43 5.43 0 00-2.33-.5C4.9 6.5 3 8.17 3 10a7 7 0 003.62 6.13zM10 17c1.66 0 3.2-.58 4.4-1.55-.3.03-.6.05-.9.05-3.44 0-6.39-2.3-6.5-5.33-.31.67-.5 1.46-.5 2.33 0 2.6 1.67 4.5 3.5 4.5zm3-7c0 .48-.11.94-.31 1.34.4.1.84.16 1.31.16.77 0 1.53-.3 2.1-.77.56-.47.9-1.09.9-1.73 0-3.49-3.26-6-7-6a7 7 0 00-6.13 3.62A6.29 6.29 0 017.5 5.5c2.93 0 5.5 1.92 5.5 4.5z",
    fill: primaryFill
  }));
};
export const EdgeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EdgeRegularIcon({}), 'EdgeRegular');
const EditorColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 13H6a1 1 0 00-1 1 1 1 0 001 1h6a1 1 0 001-1 1 1 0 00-1-1z",
    fill: "#103F91"
  }), React.createElement("path", {
    d: "M14 10H8a1 1 0 00-1 1 1 1 0 001 1h6a1 1 0 001-1 1 1 0 00-1-1z",
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M16.04 7h-5.08a.96.96 0 00-.96.96v.08c0 .53.43.96.96.96h5.08c.53 0 .96-.43.96-.96v-.08a.96.96 0 00-.96-.96z",
    fill: "#185ABD"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M9.3 13H6a1 1 0 00-1 1 1 1 0 001 1h1.85l1.45-2z",
    fill: "#000"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M8 10a1 1 0 00-1 1 1 1 0 001 1h2.03l1.45-2H8z",
    fill: "#000"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M10.96 7a.96.96 0 00-.96.96v.09c0 .53.43.96.96.96h1.25l1.45-2h-2.71l.01-.01z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M10.64 3.24L3.15 13.51l-.79 2.63c-.03.1 0 .21.09.27l.55.58 5.9-6.74 4.49-5.67-2.44-1.53-.31.18v.01z",
    fill: "#41A5EE"
  }), React.createElement("path", {
    d: "M12.29 3.89L2.78 17.06l.84.2c.08.05.19.05.27 0l2.25-1.61 7.75-10.68-1.62-1.07.02-.01z",
    fill: "#2B7CD3"
  }), React.createElement("path", {
    d: "M13.61 5.37l.82-1.14c.07-.1.03-.19-.05-.3a7.2 7.2 0 00-2.69-1.9c-.11.01-.14 0-.24.09l-.82 1.14 2.98 2.11z",
    fill: "#103F91"
  }), React.createElement("path", {
    d: "M3.44 16.14l-1 .28-.34 1.13c-.02.1.09.24.16.3.08.06.32.16.42.1l.93-.69-.18-1.11.01-.01z",
    fill: "#103F91"
  }));
};
export const EditorColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditorColorIcon({}), 'EditorColor');
const EditorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.48 2.46a1 1 0 011.41-.28l2.7 1.9a1 1 0 01.24 1.38l-.47.7-4.3-3.06.42-.64zm-.96 1.48L13.8 7H17a1 1 0 110 2h-4.54l-.67 1H15a1 1 0 110 2h-4.55l-.67 1H13a1 1 0 110 2H8.44l-.52.78a.5.5 0 01-.2.17l-1.24.62-2.97-2.16.25-1.5a.5.5 0 01.07-.18l5.69-8.8zm-6.2 11.58l-.31 1.9a.5.5 0 00.71.53l1.75-.88-2.15-1.55z",
    fill: primaryFill
  }));
};
export const EditorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditorFilledIcon({}), 'EditorFilled');
const EditorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.9 2.18a1 1 0 00-1.42.28L3.83 12.73a.5.5 0 00-.07.19L3 17.42a.5.5 0 00.71.53l4-2a.5.5 0 00.2-.17l.52-.78H13a1 1 0 100-2H9.78l.67-1H15a1 1 0 100-2h-3.21l.67-1H17a1 1 0 100-2h-3.2l1.03-1.54a1 1 0 00-.25-1.37l-2.69-1.9zM10.33 4.5L13 6.4l-5.84 8.71-2.1 1.05-.74-.54.4-2.44 5.62-8.68z",
    fill: primaryFill
  }));
};
export const EditorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EditorRegularIcon({}), 'EditorRegular');
const EventifyColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4a2 2 0 00-2-2H4a2 2 0 100 4h12a2 2 0 002-2z",
    fill: "url(#paint0_linear_164168_692)"
  }), React.createElement("path", {
    d: "M2 10c0-1.1.9-2 2-2h5a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: "url(#paint1_linear_164168_692)"
  }), React.createElement("path", {
    d: "M2 16c0-1.1.9-2 2-2h12a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: "url(#paint2_linear_164168_692)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_164168_692",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00FFD1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_164168_692",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00FFD1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_164168_692",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00FFD1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  }))));
};
export const EventifyColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/EventifyColorIcon({}), 'EventifyColor');
const EventifyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 4a2 2 0 00-2-2H4a2 2 0 100 4h12a2 2 0 002-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2 10c0-1.1.9-2 2-2h5a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M2 16c0-1.1.9-2 2-2h12a2 2 0 110 4H4a2 2 0 01-2-2z",
    fill: "#242424"
  }));
};
export const EventifyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EventifyFilledIcon({}), 'EventifyFilled');
const ExcelColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 7c0-1.1.9-2 2-2h11v11.67c0 .73-.6 1.33-1.33 1.33h-9A2.67 2.67 0 014 15.33V7z",
    fill: "url(#paint0_radial_79311_35668)"
  }), React.createElement("path", {
    d: "M4 7c0-1.1.9-2 2-2h11v11.67c0 .73-.6 1.33-1.33 1.33h-9A2.67 2.67 0 014 15.33V7z",
    fill: "url(#paint1_radial_79311_35668)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M4 9.5c0-1.1.9-2 2-2h6.5-1.17c-.73 0-1.33.6-1.33 1.33v2.34c0 .73-.6 1.33-1.33 1.33h-2A2.67 2.67 0 004 15.17v.08V9.5z",
    fill: "url(#paint2_linear_79311_35668)"
  }), React.createElement("path", {
    d: "M4 9.5c0-1.1.9-2 2-2h6.5-1.17c-.73 0-1.33.6-1.33 1.33v2.34c0 .73-.6 1.33-1.33 1.33h-2A2.67 2.67 0 004 15.17v.08V9.5z",
    fill: "url(#paint3_linear_79311_35668)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M4 4.67C4 3.19 5.2 2 6.67 2H12v5.5H6.5A2.5 2.5 0 004 10V4.67z",
    fill: "url(#paint4_linear_79311_35668)"
  }), React.createElement("path", {
    d: "M4 4.67C4 3.19 5.2 2 6.67 2H12v5.5H6.5A2.5 2.5 0 004 10V4.67z",
    fill: "url(#paint5_linear_79311_35668)"
  }), React.createElement("path", {
    d: "M4 4.67C4 3.19 5.2 2 6.67 2H12v5.5H6.5A2.5 2.5 0 004 10V4.67z",
    fill: "url(#paint6_linear_79311_35668)"
  }), React.createElement("path", {
    d: "M17 3.33C17 2.6 16.4 2 15.67 2h-4.34C10.6 2 10 2.6 10 3.33v2.84c0 .73.6 1.33 1.33 1.33h4.34c.73 0 1.33-.6 1.33-1.33V3.33z",
    fill: "url(#paint7_radial_79311_35668)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint8_radial_79311_35668)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint9_radial_79311_35668)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M8.8 14H7.45l-.85-1.6a4.9 4.9 0 01-.11-.24h-.01l-.06.13a5.8 5.8 0 00-.07.13L5.47 14H4.2l1.52-2.5L4.3 9h1.33l.76 1.42a4.64 4.64 0 01.14.3h.02a19.35 19.35 0 00.16-.31L7.49 9h1.27l-1.44 2.46L8.8 14z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_79311_35668",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-135 12.45 6.02) scale(16.4365)"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#379539"
  }), React.createElement("stop", {
    offset: 0.45,
    stopColor: "#297C2D"
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#15561C"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_79311_35668",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-135 6 3.2) scale(7.34114)"
  }, React.createElement("stop", {
    stopColor: "#073B10"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#084A13",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint7_radial_79311_35668",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.89177 -6.26972 6.75201 -7.32808 17.9 8.27)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.44,
    stopColor: "#79E96D"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EB76"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_79311_35668",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    stopColor: "#20A85E"
  }), React.createElement("stop", {
    offset: 0.46,
    stopColor: "#15824A"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#09442A"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_79311_35668",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.75 -6.75 0 6.5 12.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#33A662",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#98F0B0"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_79311_35668",
    x1: 4,
    y1: 11.38,
    x2: 10.51,
    y2: 11.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#52D17C"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4AA647"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79311_35668",
    x1: 10.38,
    y1: 7.5,
    x2: 10.38,
    y2: 12.88,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#29852F"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4AA647",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79311_35668",
    x1: 4.29,
    y1: 8.29,
    x2: 11.49,
    y2: 1.85,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#66D052"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#85E972"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_79311_35668",
    x1: 12,
    y1: 4.64,
    x2: 6.4,
    y2: 4.64,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#4EB43B"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#72CC61",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint6_linear_79311_35668",
    x1: 7.61,
    y1: 5.62,
    x2: 4,
    y2: 5.62,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C0E075",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D1EB95"
  }))));
};
export const ExcelColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExcelColorIcon({}), 'ExcelColor');
const ExcelFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16a2 2 0 01-2 2H7c-.89 0-1.68-.39-2.23-1H9a3 3 0 003-3V9a3 3 0 00-.08-.68c.31-.2.68-.32 1.08-.32h2c.77 0 1.47-.3 2-.77V16zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zm-3.28 4.5L4.2 14h1.27l.88-1.58a6.07 6.07 0 01.12-.26h.02l.04.11.07.14.85 1.59H8.8l-1.48-2.54L8.76 9H7.5l-.78 1.4-.08.17-.08.16h-.02a4.64 4.64 0 00-.15-.3L5.64 9H4.3l1.42 2.5zM15 2a2 2 0 012 2v1a2 2 0 01-2 2h-2a2 2 0 01-2-2V4c0-1.1.9-2 2-2h2zm-4.23 0A2.99 2.99 0 0010 4v1c0 .47.1.9.3 1.3C9.9 6.1 9.47 6 9 6H4V5a3 3 0 013-3h3.77z",
    fill: primaryFill
  }));
};
export const ExcelFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExcelFilledIcon({}), 'ExcelFilled');
const ExcelRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 2a2 2 0 012 2v12a2 2 0 01-2 2H7a3 3 0 01-2.83-2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2V5a3 3 0 013-3h8zm-9.28 9.5L4.2 14h1.27l.88-1.58a6.07 6.07 0 01.13-.26 4.73 4.73 0 00.12.25L7.45 14H8.8l-1.48-2.54L8.76 9H7.5l-.78 1.4-.08.17-.08.16h-.01l-.08-.15-.07-.16L5.63 9H4.3l1.42 2.5zM12 3a1 1 0 00-1 1v2a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zM5.27 16c.35.6.99 1 1.73 1h8a1 1 0 001-1V7.73c-.3.17-.64.27-1 .27h-3a1 1 0 00-1 1v5a2 2 0 01-2 2H5.27zm5-9c-.17-.3-.27-.64-.27-1V4c0-.36.1-.7.27-1H7a2 2 0 00-2 2v2h5.27z",
    fill: primaryFill
  }));
};
export const ExcelRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExcelRegularIcon({}), 'ExcelRegular');
const ExchangeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 5v10c0 1.1.9 2 2 2h1.92a2 2 0 001.42-.59L11 14.75l1.66 1.66a2 2 0 001.42.59H16a2 2 0 002-2v-1.92a2 2 0 00-.59-1.42L15.75 10l1.66-1.66A2 2 0 0018 6.92V5a2 2 0 00-2-2h-1.92a2 2 0 00-1.42.59L11 5.25 9.34 3.59A2 2 0 007.92 3H6a2 2 0 00-2 2z",
    fill: "#28A8EA"
  }), React.createElement("path", {
    d: "M7.92 3H6a2 2 0 00-2 2v3.5c0 .83.67 1.5 1.5 1.5H11V5.25L9.34 3.59A2 2 0 007.92 3z",
    fill: "#50D9FF"
  }), React.createElement("path", {
    d: "M18 15v-1.92a2 2 0 00-.59-1.42L15.75 10H11v4.75l1.66 1.66a2 2 0 001.42.59H16a2 2 0 002-2z",
    fill: "#0078D4"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.53 15.28A2 2 0 0012 14V7a1 1 0 00-1-1H4v9c0 .36.1.7.27 1h5.48L11 14.75l.53.53z",
    fill: "#000",
    fillOpacity: 0.5
  }), React.createElement("rect", {
    x: 1,
    y: 5,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#0078D4"
  }), React.createElement("path", {
    d: "M7.7 13H4.3V7h3.25v.87H5.33v1.67H7.4v.86H5.33v1.73H7.7V13z",
    fill: "#fff"
  }));
};
export const ExchangeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExchangeColorIcon({}), 'ExchangeColor');
const ExchangeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.27 16c.34.6.99 1 1.73 1h1.92a2 2 0 001.42-.59l.41-.41H4.27zm7.26-.72l1.13 1.13a2 2 0 001.42.59H16a2 2 0 002-2v-1.92a2 2 0 00-.59-1.42l-1.16-1.16H12V14a2 2 0 01-.47 1.28zM12 9.5h4.25l1.16-1.16A2 2 0 0018 6.92V5a2 2 0 00-2-2h-1.92a2 2 0 00-1.42.59l-1.13 1.13c.3.34.47.8.47 1.28v3.5zM9.75 4l-.41-.41A2 2 0 007.92 3H6a2 2 0 00-1.73 1h5.48zM1 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V6zm6.7 7v-.87H5.34V10.4H7.4v-.86H5.34V7.87h2.22V7H4.31v6H7.7z",
    fill: primaryFill
  }));
};
export const ExchangeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExchangeFilledIcon({}), 'ExchangeFilled');
const ExchangeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.7 16l-.4.41a2 2 0 01-1.42.59H6a2 2 0 01-1.73-1H9.7zm3 .41l-1.15-1.15a2 2 0 00.43-.99l1.43 1.44a1 1 0 00.71.29H16a1 1 0 001-1v-1.88a1 1 0 00-.3-.7l-1.9-1.92H12v-1h2.8l1.9-1.91a1 1 0 00.3-.71V5a1 1 0 00-1-1h-1.88a1 1 0 00-.7.3l-1.44 1.43a2 2 0 00-.43-.99l1.16-1.15A2 2 0 0114.12 3H16a2 2 0 012 2v1.88a2 2 0 01-.59 1.41L15.71 10l1.7 1.7a2 2 0 01.59 1.42V15a2 2 0 01-2 2h-1.88a2 2 0 01-1.41-.59zM9.7 4l-.4-.41A2 2 0 007.87 3H6a2 2 0 00-1.73 1H9.7zM1 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V6zm6.7 7v-.87H5.34V10.4H7.4v-.86H5.34V7.87h2.22V7H4.31v6H7.7z",
    fill: primaryFill
  }));
};
export const ExchangeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ExchangeRegularIcon({}), 'ExchangeRegular');
const FacilitatorColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.73 16.98c.3-.02.6-.06.91-.17l.84-.28a4.75 4.75 0 013.04 0l.84.28a3.52 3.52 0 003.61-5.8A3.5 3.5 0 0010 13.47a3.49 3.49 0 01-3.27 3.5z",
    fill: "#4A43CB"
  }), React.createElement("path", {
    d: "M6.73 16.98c.3-.02.6-.06.91-.17l.84-.28a4.75 4.75 0 013.04 0l.84.28a3.52 3.52 0 003.61-5.8A3.5 3.5 0 0010 13.47a3.49 3.49 0 01-3.27 3.5z",
    fill: "#5041D0"
  }), React.createElement("path", {
    d: "M6.73 16.98c.3-.02.6-.06.91-.17l.84-.28a4.75 4.75 0 013.04 0l.84.28a3.52 3.52 0 003.61-5.8A3.5 3.5 0 0010 13.47a3.49 3.49 0 01-3.27 3.5z",
    fill: "#3D2DB8"
  }), React.createElement("path", {
    d: "M6.73 16.98c.3-.02.6-.06.91-.17l.84-.28a4.75 4.75 0 013.04 0l.84.28a3.52 3.52 0 003.61-5.8A3.5 3.5 0 0010 13.47a3.49 3.49 0 01-3.27 3.5z",
    fill: "url(#paint0_linear_74470_22237)"
  }), React.createElement("path", {
    d: "M6.73 16.98c.3-.02.6-.06.91-.17l.84-.28a4.75 4.75 0 013.04 0l.84.28a3.52 3.52 0 003.61-5.8A3.5 3.5 0 0010 13.47a3.49 3.49 0 01-3.27 3.5z",
    fill: "url(#paint1_radial_74470_22237)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M6.73 16.98c.3-.02.6-.06.91-.17l.84-.28a4.75 4.75 0 013.04 0l.84.28a3.52 3.52 0 003.61-5.8A3.5 3.5 0 0010 13.47a3.49 3.49 0 01-3.27 3.5z",
    fill: "url(#paint2_radial_74470_22237)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M16.98 13.27c-.02-.3-.06-.6-.17-.91l-.28-.84a4.75 4.75 0 010-3.04l.28-.84a3.52 3.52 0 00-5.8-3.61A3.5 3.5 0 0013.47 10a3.49 3.49 0 013.5 3.27z",
    fill: "#6864F6"
  }), React.createElement("path", {
    d: "M16.98 13.27c-.02-.3-.06-.6-.17-.91l-.28-.84a4.75 4.75 0 010-3.04l.28-.84a3.52 3.52 0 00-5.8-3.61A3.5 3.5 0 0013.47 10a3.49 3.49 0 013.5 3.27z",
    fill: "url(#paint3_radial_74470_22237)",
    fillOpacity: 0.15
  }), React.createElement("path", {
    d: "M16.98 13.27c-.02-.3-.06-.6-.17-.91l-.28-.84a4.75 4.75 0 010-3.04l.28-.84a3.52 3.52 0 00-5.8-3.61A3.5 3.5 0 0013.47 10a3.49 3.49 0 013.5 3.27z",
    fill: "url(#paint4_radial_74470_22237)"
  }), React.createElement("path", {
    d: "M16.98 13.27c-.02-.3-.06-.6-.17-.91l-.28-.84a4.75 4.75 0 010-3.04l.28-.84a3.52 3.52 0 00-5.8-3.61A3.5 3.5 0 0013.47 10a3.49 3.49 0 013.5 3.27z",
    fill: "url(#paint5_radial_74470_22237)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M16.98 13.27c-.02-.3-.06-.6-.17-.91l-.28-.84a4.75 4.75 0 010-3.04l.28-.84a3.52 3.52 0 00-5.8-3.61A3.5 3.5 0 0013.47 10a3.49 3.49 0 013.5 3.27z",
    fill: "url(#paint6_radial_74470_22237)"
  }), React.createElement("path", {
    d: "M3.02 6.73c.02.3.06.6.17.91l.28.84c.33.99.33 2.05 0 3.04l-.28.84a3.52 3.52 0 005.8 3.61A3.5 3.5 0 006.53 10a3.49 3.49 0 01-3.5-3.27z",
    fill: "url(#paint7_radial_74470_22237)"
  }), React.createElement("path", {
    d: "M3.02 6.73c.02.3.06.6.17.91l.28.84c.33.99.33 2.05 0 3.04l-.28.84a3.52 3.52 0 005.8 3.61A3.5 3.5 0 006.53 10a3.49 3.49 0 01-3.5-3.27z",
    fill: "url(#paint8_radial_74470_22237)"
  }), React.createElement("path", {
    d: "M3.02 6.73c.02.3.06.6.17.91l.28.84c.33.99.33 2.05 0 3.04l-.28.84a3.52 3.52 0 005.8 3.61A3.5 3.5 0 006.53 10a3.49 3.49 0 01-3.5-3.27z",
    fill: "url(#paint9_radial_74470_22237)",
    fillOpacity: 0.1
  }), React.createElement("path", {
    d: "M13.27 3.02c-.3.02-.6.06-.91.17l-.84.28c-.99.33-2.05.33-3.04 0l-.84-.28a3.52 3.52 0 00-3.61 5.8A3.5 3.5 0 0010 6.53a3.49 3.49 0 013.27-3.5z",
    fill: "url(#paint10_linear_74470_22237)"
  }), React.createElement("path", {
    d: "M13.27 3.02c-.3.02-.6.06-.91.17l-.84.28c-.99.33-2.05.33-3.04 0l-.84-.28a3.52 3.52 0 00-3.61 5.8A3.5 3.5 0 0010 6.53a3.49 3.49 0 013.27-3.5z",
    fill: "url(#paint11_radial_74470_22237)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M13.27 3.02c-.3.02-.6.06-.91.17l-.84.28c-.99.33-2.05.33-3.04 0l-.84-.28a3.52 3.52 0 00-3.61 5.8A3.5 3.5 0 0010 6.53a3.49 3.49 0 013.27-3.5z",
    fill: "url(#paint12_radial_74470_22237)",
    fillOpacity: 0.3
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-6.41668 -4.0833 2.63743 -4.14456 14.67 11.75)"
  }, React.createElement("stop", {
    stopColor: "#DC8AFD"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D373FC",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.91669 -2.33333 1.34668 5.72338 8.25 14.67)"
  }, React.createElement("stop", {
    offset: 0.64,
    stopColor: "#4157DA",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#322AAC"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(86.19 3.94 8.67) scale(8.76942)"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#716CF7",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-9.21438 -2.63279 2.6124 -9.14307 17.44 10)"
  }, React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5F80F9",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#4841E1"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.46509 -7.92164 16.73843 9.43474 16.29 6.32)"
  }, React.createElement("stop", {
    stopColor: "#E3ACFD"
  }), React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9FA2FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(117.9 3.04 8.25) scale(11.2206)"
  }, React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D373FC",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8AFD"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(59.53 -5.28 5.14) scale(11.5051)"
  }, React.createElement("stop", {
    stopColor: "#3BD5FF"
  }), React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6864F6"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.2144 2.63272 -2.61234 9.14308 2.56 10)"
  }, React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5D82F8",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1D17A0"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-135 6.27 4.29) scale(5.7747)"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fff",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint11_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.91666 8.16666 -8.10331 2.89404 6.5 1.83)"
  }, React.createElement("stop", {
    offset: 0.48,
    stopColor: "#75A5FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.98,
    stopColor: "#3923B1"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_74470_22237",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-19.98 16.44 -14.42) scale(6.82774 4.41007)"
  }, React.createElement("stop", {
    stopColor: "#9ACAFF"
  }), React.createElement("stop", {
    offset: 0.64,
    stopColor: "#7D9EFF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_74470_22237",
    x1: 15.83,
    y1: 14.08,
    x2: 10,
    y2: 8.83,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2764E7",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4D84F9"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_74470_22237",
    x1: 1.25,
    y1: 1.83,
    x2: 7.67,
    y2: 8.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3BD5FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8FFF"
  }))));
};
export const FacilitatorColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FacilitatorColorIcon({}), 'FacilitatorColor');
const FacilitatorFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.25 9.5a3.25 3.25 0 110-6.5c.87 0 1.5.29 2.06.53l.02.01a3.84 3.84 0 001.82.46c-.41.65-.65 1.42-.65 2.25 0 1.8-1.45 3.24-3.24 3.25h-.01zm.01 1h-.01c-.83 0-1.6-.24-2.25-.65V10c0 .64-.2 1.11-.46 1.67v.02c-.25.55-.54 1.2-.54 2.06a3.25 3.25 0 103.26-3.25zM13.75 3a3.25 3.25 0 000 6.5c.83 0 1.6.24 2.25.65V10c0-.64.2-1.11.46-1.67V8.3c.25-.55.54-1.2.54-2.06C17 4.45 15.54 3 13.75 3zM17 13.75a3.25 3.25 0 00-6.5 0c0 .83-.24 1.6-.65 2.25H10c.64 0 1.11.2 1.67.46h.02c.55.25 1.2.54 2.06.54 1.8 0 3.25-1.46 3.25-3.25z",
    fill: primaryFill
  }));
};
export const FacilitatorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FacilitatorFilledIcon({}), 'FacilitatorFilled');
const FacilitatorRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 6.75a2.74 2.74 0 00.42 1.45l.03.05.08.13A2.75 2.75 0 009.5 6.75c0-.63.16-1.23.43-1.75-.4 0-.74-.08-1.02-.2-.27-.1-.48-.23-.66-.35l-.05-.03c-.2-.12-.36-.22-.57-.3-.2-.06-.48-.12-.88-.12A2.75 2.75 0 004 6.75zm-.3 2.19a3.75 3.75 0 015.04-5.36l.03.02c.2.12.33.21.5.28.18.07.4.12.73.12a1.9 1.9 0 001.06-.3 3.76 3.76 0 015.76 4.26c-.12.33-.27.57-.4.78l-.02.03c-.12.2-.21.33-.28.5-.07.18-.12.4-.12.73a1.9 1.9 0 00.3 1.06 3.75 3.75 0 01-5.04 5.36l-.03-.02c-.2-.12-.33-.21-.5-.28A1.9 1.9 0 0010 16a1.9 1.9 0 00-1.06.3 3.74 3.74 0 01-2.19.7h-.02a3.75 3.75 0 01-3.15-5.74l.02-.03c.12-.2.21-.33.28-.5.07-.18.12-.4.12-.73a1.9 1.9 0 00-.3-1.06zm11.3 1a2.84 2.84 0 01.55-1.69l.03-.05c.12-.2.22-.36.3-.57.06-.2.12-.48.12-.88a2.75 2.75 0 00-4.2-2.33l-.05.03-.13.08a2.75 2.75 0 001.63 4.97c.63 0 1.23.16 1.75.43zm-3.62.06A3.77 3.77 0 0110 8.62c-.33.57-.8 1.05-1.38 1.38.57.33 1.05.8 1.38 1.38.33-.57.8-1.05 1.38-1.38zm-.88 3.25c0 .63-.16 1.23-.43 1.75a2.84 2.84 0 011.68.55l.05.03c.2.12.36.22.57.3a2.62 2.62 0 001.16.1 2.75 2.75 0 002.05-4.18l-.03-.05-.08-.13a2.75 2.75 0 00-4.97 1.63zm-1 0a2.75 2.75 0 00-2.75-2.75c-.63 0-1.23-.16-1.75-.43a2.85 2.85 0 01-.55 1.68l-.03.05c-.12.2-.22.36-.3.57-.06.2-.12.48-.12.88a2.75 2.75 0 004.2 2.33l.05-.03.13-.08c.68-.5 1.12-1.31 1.12-2.22z",
    fill: primaryFill
  }));
};
export const FacilitatorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FacilitatorRegularIcon({}), 'FacilitatorRegular');
const FamilySafetyColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 13l-.5-2.17c-.7-.7-1.1-1.66-1.1-2.65L7 7.67l-.97-.35c-4.7 0-3.08 3.54-2.18 4.59l.9.9.12.12c2.24 2.24 4.94 1.52 5.13.07z",
    fill: "url(#paint0_linear_73134_10436)"
  }), React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 8,
    height: 8
  }, React.createElement("path", {
    d: "M10 13l-.5-2.17c-.7-.7-1.1-1.66-1.1-2.65L7 7.67l-.97-.35c-4.7 0-3.08 3.54-2.18 4.59l.9.9.12.12c2.24 2.24 4.94 1.52 5.13.07z",
    fill: "url(#paint1_linear_73134_10436)"
  })), React.createElement("g", {
    filter: "url(#filter0_d_73134_10436)",
    mask: "url(#a)"
  }, React.createElement("path", {
    d: "M16.54 8.04c-.23-.23-.5-.41-.8-.55-.33-.15-1.29-.3-1.68-.3L13 7.68l-.83.72c0 1-.4 1.95-1.1 2.66L10 13a3.75 3.75 0 01-5.13-.07l3.88 3.83c.7.69 1.8.69 2.5 0l4.87-4.81c.34-.45 1.2-1.42 1.2-2.02 0-.74-.3-1.4-.78-1.89z",
    fill: "url(#paint2_linear_73134_10436)"
  })), React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 8,
    height: 8
  }, React.createElement("path", {
    d: "M10 13l-.5-2.17c-.7-.7-1.1-1.66-1.1-2.65L7 7.67l-.97-.35c-4.7 0-3.08 3.54-2.18 4.59l.9.9.12.12c2.24 2.24 4.94 1.52 5.13.07z",
    fill: "url(#paint3_linear_73134_10436)"
  })), React.createElement("g", {
    filter: "url(#filter1_dd_73134_10436)",
    mask: "url(#b)"
  }, React.createElement("path", {
    d: "M10 5.33c0 1.3-1.34 2.34-3 2.34H6a2.66 2.66 0 00-2.15 4.24l-.6-.6a4.98 4.98 0 01.21-6.85C4.36 3.56 5.62 3 7 3c1.66 0 3 1.04 3 2.33z",
    fill: "url(#paint4_linear_73134_10436)"
  })), React.createElement("path", {
    d: "M16.54 8.04c-.23-.23-.5-.41-.8-.55-.33-.15-1.29-.3-1.68-.3L13 7.68l-.83.72c0 1-.4 1.95-1.1 2.66L10 13a3.75 3.75 0 01-5.13-.07l3.88 3.83c.7.69 1.8.69 2.5 0l4.87-4.81c.34-.45 1.2-1.42 1.2-2.02 0-.74-.3-1.4-.78-1.89z",
    fill: "url(#paint5_linear_73134_10436)"
  }), React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 14,
    height: 11
  }, React.createElement("path", {
    d: "M16.54 8.04c-.23-.23-.5-.41-.8-.55-.33-.15-1.29-.3-1.68-.3L13 7.68l-.83.72c0 1-.4 1.95-1.1 2.66L10 13a3.75 3.75 0 01-5.13-.07l3.88 3.83c.7.69 1.8.69 2.5 0l4.87-4.81c.34-.45 1.2-1.42 1.2-2.02 0-.74-.3-1.4-.78-1.89z",
    fill: "url(#paint6_linear_73134_10436)"
  })), React.createElement("g", {
    filter: "url(#filter2_dd_73134_10436)",
    mask: "url(#c)"
  }, React.createElement("path", {
    d: "M10 5.33c0 1.3 1.34 2.34 3 2.34h1a2.66 2.66 0 012.15 4.24l.6-.6a4.98 4.98 0 00-.21-6.85A4.98 4.98 0 0013 3c-1.66 0-3 1.04-3 2.33z",
    fill: "url(#paint7_linear_73134_10436)"
  })), React.createElement("path", {
    d: "M13 7.67v.77c0 1-.4 1.96-1.1 2.66l-1.78 1.78L10 13l-1.9-1.9C7.4 10.4 7 9.44 7 8.44v-3.1h6v2.33z",
    fill: "url(#paint8_linear_73134_10436)"
  }), React.createElement("path", {
    d: "M10 5.33c0 1.3-1.34 2.34-3 2.34H6a2.66 2.66 0 00-2.15 4.24l-.6-.6a4.98 4.98 0 01.21-6.85C4.36 3.56 5.62 3 7 3c1.66 0 3 1.04 3 2.33z",
    fill: "url(#paint9_linear_73134_10436)"
  }), React.createElement("path", {
    d: "M10 5.33c0 1.3 1.34 2.34 3 2.34h1a2.66 2.66 0 012.15 4.24l.6-.6a4.98 4.98 0 00-.21-6.85A4.98 4.98 0 0013 3c-1.66 0-3 1.04-3 2.33z",
    fill: "url(#paint10_linear_73134_10436)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_73134_10436",
    x1: 9.47,
    y1: 15.9,
    x2: 4.48,
    y2: 7.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0C9D8C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#047769"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_73134_10436",
    x1: 9.47,
    y1: 15.9,
    x2: 4.48,
    y2: 7.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0C9D8C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#047769"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_73134_10436",
    x1: 8.23,
    y1: 16.53,
    x2: 14.03,
    y2: 6.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0E4D44"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0B5B50"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_73134_10436",
    x1: 9.47,
    y1: 15.9,
    x2: 4.48,
    y2: 7.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0C9D8C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#047769"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_73134_10436",
    x1: 7.55,
    y1: 9.77,
    x2: 4.15,
    y2: 3.87,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0C9D8C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#24CDB9"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_73134_10436",
    x1: 8.23,
    y1: 16.53,
    x2: 14.03,
    y2: 6.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0E4D44"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0B5B50"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_73134_10436",
    x1: 8.23,
    y1: 16.53,
    x2: 14.03,
    y2: 6.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0E4D44"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0B5B50"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_73134_10436",
    x1: 16.99,
    y1: 11.42,
    x2: 12.1,
    y2: 2.95,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#047769"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0C9D8C"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_73134_10436",
    x1: 12.43,
    y1: 11.59,
    x2: 8.36,
    y2: 4.55,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#24CDB9"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#30E5D0"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_73134_10436",
    x1: 7.55,
    y1: 9.77,
    x2: 4.15,
    y2: 3.87,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0C9D8C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#24CDB9"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_73134_10436",
    x1: 16.99,
    y1: 11.42,
    x2: 12.1,
    y2: 2.95,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#047769"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0C9D8C"
  })), React.createElement("filter", {
    id: "filter0_d_73134_10436",
    x: 4.21,
    y: 6.33,
    width: 13.78,
    height: 11.41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: -0.2
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.33
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73134_10436"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_73134_10436",
    result: "shape"
  })), React.createElement("filter", {
    id: "filter1_dd_73134_10436",
    x: 1.33,
    y: 2.67,
    width: 9.33,
    height: 10.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: 0.33
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.33
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73134_10436"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: 0.07
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.03
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_73134_10436",
    result: "effect2_dropShadow_73134_10436"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_73134_10436",
    result: "shape"
  })), React.createElement("filter", {
    id: "filter2_dd_73134_10436",
    x: 9.33,
    y: 2.67,
    width: 9.33,
    height: 10.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: 0.33
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.33
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73134_10436"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: 0.07
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.03
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_73134_10436",
    result: "effect2_dropShadow_73134_10436"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_73134_10436",
    result: "shape"
  }))));
};
export const FamilySafetyColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FamilySafetyColorIcon({}), 'FamilySafetyColor');
const FamilySafetyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.5 3h-.09C4.42 3 2 5.42 2 8.41c0 .89.26 1.75.75 2.47A3.89 3.89 0 016.61 7h.89a2 2 0 100-4zM4.87 13.12l-.58-.58a2.8 2.8 0 01-.54-1.65 2.9 2.9 0 012.34-2.84c.1.57.38 1.13.82 1.57L9.3 12l-.85.85a2.75 2.75 0 01-3.57.27zm1.53 1.53l1.48 1.48a3 3 0 004.24 0l3.59-3.59a2.8 2.8 0 00.54-1.65 2.9 2.9 0 00-2.34-2.84c-.1.57-.38 1.13-.82 1.57l-3.94 3.94a3.74 3.74 0 01-2.75 1.1zm10.85-3.77c.49-.72.75-1.58.75-2.47C18 5.42 15.58 3 12.59 3h-.09a2 2 0 100 4h.9a3.86 3.86 0 013.85 3.88zM7.5 8A3 3 0 0010 6.66 3 3 0 0012.5 8h.4c-.08.34-.26.65-.52.91L10 11.3 7.62 8.91A1.99 1.99 0 017.1 8h.4z",
    fill: primaryFill
  }));
};
export const FamilySafetyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FamilySafetyFilledIcon({}), 'FamilySafetyFilled');
const FamilySafetyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 8.35C2 5.4 4.4 3 7.35 3H8c.82 0 1.54.4 2 1 .46-.6 1.18-1 2-1h.65C15.6 3 18 5.4 18 8.35c0 1.19-.47 2.33-1.31 3.17l-1.16 1.16-.13.13-3.28 3.28a3 3 0 01-4.24 0L4.6 12.8l-.13-.13-1.16-1.16A4.47 4.47 0 012 8.35zm3.18 3.62l.13.13a2.75 2.75 0 003.88 0l.1-.1-2.38-2.38c-.42-.43-.7-.95-.81-1.5a2.33 2.33 0 00-.92 3.85zM7.1 8c.08.34.26.65.52.91L10 11.3l2.38-2.38c.26-.26.44-.57.52-.91H12a2.5 2.5 0 01-2-1c-.46.6-1.18 1-2 1h-.9zm2.4-2.5C9.5 4.67 8.83 4 8 4h-.65A4.35 4.35 0 003 8.35c0 .65.18 1.27.5 1.8A3.33 3.33 0 016.83 7H8c.83 0 1.5-.67 1.5-1.5zm1 0c0 .83.67 1.5 1.5 1.5h1.17a3.33 3.33 0 013.32 3.16c.33-.54.51-1.16.51-1.8C17 5.94 15.05 4 12.65 4H12c-.83 0-1.5.67-1.5 1.5zm4.32 6.47a2.33 2.33 0 00-.92-3.85 2.99 2.99 0 01-.81 1.5l-2.74 2.73-.45.46a3.74 3.74 0 01-2.8 1.1l1.49 1.47a2 2 0 002.82 0l3.28-3.28.13-.13z",
    fill: primaryFill
  }));
};
export const FamilySafetyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FamilySafetyRegularIcon({}), 'FamilySafetyRegular');
const FileAccessColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12639)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12639)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12639)"
  }), React.createElement("path", {
    d: "M13 13c0 .44-.84.8-2 .94V11.5c0-.17-.02-.34-.05-.5H13v2z",
    fill: "url(#paint3_linear_82689_12639)"
  }), React.createElement("path", {
    d: "M13 13c0 .44-.84.8-2 .94V11.5c0-.17-.02-.34-.05-.5H13v2z",
    fill: "url(#paint4_radial_82689_12639)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M13 11c0 .44-.84.8-2 .94v-.44A2.5 2.5 0 008.5 9H13v2z",
    fill: "url(#paint5_linear_82689_12639)"
  }), React.createElement("path", {
    d: "M13 11c0 .44-.84.8-2 .94v-.44A2.5 2.5 0 008.5 9H13v2z",
    fill: "url(#paint6_radial_82689_12639)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M13 9c0 .5-1.09.9-2.51.99A2.5 2.5 0 008.5 9H7V7h6v2z",
    fill: "url(#paint7_linear_82689_12639)"
  }), React.createElement("path", {
    d: "M13 9c0 .5-1.09.9-2.51.99A2.5 2.5 0 008.5 9H7V7h6v2z",
    fill: "url(#paint8_radial_82689_12639)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M10 6c1.66 0 3 .45 3 1s-1.34 1-3 1-3-.45-3-1 1.34-1 3-1z",
    fill: "url(#paint9_linear_82689_12639)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint10_radial_82689_12639)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint11_radial_82689_12639)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M3.07 17l1.78-5H6.2l1.74 5H6.75l-.34-1H4.58l-.34 1H3.07zm1.76-1.92h1.3l-.52-1.75a9.06 9.06 0 00-.1-.35h-.03a3.65 3.65 0 01-.1.35l-.55 1.75z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_12639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 3.12071 -68.0158 0 -13.34 11)"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#560B14"
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#560B14",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_12639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 3.12071 -30.2292 0 1.3 9)"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#560B14"
  }), React.createElement("stop", {
    offset: 0.75,
    stopColor: "#560B14",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_12639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 3.07477 -10.3273 0 9 7)"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF9FB2"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF9FB2",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint10_radial_82689_12639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    stopColor: "#E82C58"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#AA1D2D"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_82689_12639",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17188 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5778",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FF9FB2"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_12639",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12639",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12639",
    x1: 13,
    y1: 12.7,
    x2: -39.69,
    y2: 12.7,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9C0D55"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#A61727"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8A1421"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12639",
    x1: 13,
    y1: 10.7,
    x2: -10.42,
    y2: 10.7,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E82C41"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#CA2134"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12639",
    x1: 13,
    y1: 8.68,
    x2: 5,
    y2: 8.68,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F97DBD"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FB5B6C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F83F54"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_12639",
    x1: 9.46,
    y1: 5.48,
    x2: 8.69,
    y2: 8.35,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F97DBD"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF9FB2"
  }))));
};
export const FileAccessColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileAccessColorIcon({}), 'FileAccessColor');
const FileAlbumColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
    fill: "url(#paint0_linear_82689_11897)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3h6a3 3 0 013 3v7a1 1 0 01-1 1H6a2 2 0 00-1 .27V4a1 1 0 011-1zM5 16a1 1 0 001 1h8a1 1 0 001-1v-1.27a2 2 0 01-1 .27H6a1 1 0 00-1 1z",
    fill: "url(#paint1_linear_82689_11897)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3h6a3 3 0 013 3v7a1 1 0 01-1 1H6a2 2 0 00-1 .27V4a1 1 0 011-1zM5 16a1 1 0 001 1h8a1 1 0 001-1v-1.27a2 2 0 01-1 .27H6a1 1 0 00-1 1z",
    fill: "url(#paint2_radial_82689_11897)"
  }), React.createElement("path", {
    d: "M13 5a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "url(#paint3_linear_82689_11897)"
  }), React.createElement("path", {
    d: "M9.45 7.33L7.2 9.73A.75.75 0 007.73 11h4.53c.66 0 1-.79.55-1.26l-2.27-2.41a.75.75 0 00-1.09 0z",
    fill: "url(#paint4_linear_82689_11897)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_11897",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_11897",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_11897",
    x1: 11,
    y1: 2.75,
    x2: 13.17,
    y2: 6.91,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_11897",
    x1: 8,
    y1: 5.25,
    x2: 11.5,
    y2: 12.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_11897",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileAlbumColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileAlbumColorIcon({}), 'FileAlbumColor');
const FileAppFileColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12069)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12069)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12069)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.73 6.44a1.5 1.5 0 012.12 0l.71.71a1.5 1.5 0 010 2.12l-.7.7c-.15.15-.3.25-.47.32.37.28.61.71.61 1.21v1c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 016 12.5v-4C6 7.67 6.67 7 7.5 7h1c.5 0 .94.24 1.2.61.08-.16.19-.32.32-.46l.71-.7zM7 12.5c0 .28.22.5.5.5H9v-2H7v1.5zm3 .5h1.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H10v2zm0-3h.75l-.02-.02-.7-.7-.03-.04V10zM7.5 8a.5.5 0 00-.5.5V10h2V8.5a.5.5 0 00-.5-.5h-1z",
    fill: "url(#paint3_linear_82689_12069)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12069",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12069",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12069",
    x1: 7.5,
    y1: 6,
    x2: 11.98,
    y2: 13.04,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileAppFileColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileAppFileColorIcon({}), 'FileAppFileColor');
const FileAudioColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_11921)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_11921)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_11921)"
  }), React.createElement("path", {
    d: "M9.75 6c.41 0 .75.34.75.75v6.5a.75.75 0 01-1.5 0v-6.5c0-.41.34-.75.75-.75z",
    fill: "url(#paint3_linear_82689_11921)"
  }), React.createElement("path", {
    d: "M12.75 8c.41 0 .75.34.75.75v2.5a.75.75 0 01-1.5 0v-2.5c0-.41.34-.75.75-.75z",
    fill: "url(#paint4_linear_82689_11921)"
  }), React.createElement("path", {
    d: "M6.75 8.75c.41 0 .75.34.75.75v1a.75.75 0 01-1.5 0v-1c0-.41.34-.75.75-.75z",
    fill: "url(#paint5_linear_82689_11921)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_11921",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_11921",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_11921",
    x1: 9.75,
    y1: 12.04,
    x2: 8.13,
    y2: 5.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#892FFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A966FF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_11921",
    x1: 9.75,
    y1: 12.04,
    x2: 8.13,
    y2: 5.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#892FFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A966FF"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_11921",
    x1: 9.75,
    y1: 12.04,
    x2: 8.13,
    y2: 5.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#892FFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A966FF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_11921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileAudioColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileAudioColorIcon({}), 'FileAudioColor');
const FileAudioWatermarkColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_11941)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_11941)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_11941)"
  }), React.createElement("path", {
    d: "M9.75 6c.41 0 .75.34.75.75v6.5a.75.75 0 01-1.5 0v-6.5c0-.41.34-.75.75-.75z",
    fill: "url(#paint3_linear_82689_11941)"
  }), React.createElement("path", {
    d: "M12.75 8c.41 0 .75.34.75.75v2.5a.75.75 0 01-1.5 0v-2.5c0-.41.34-.75.75-.75z",
    fill: "url(#paint4_linear_82689_11941)"
  }), React.createElement("path", {
    d: "M6.75 8.75c.41 0 .75.34.75.75v1a.75.75 0 01-1.5 0v-1c0-.41.34-.75.75-.75z",
    fill: "url(#paint5_linear_82689_11941)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_11941",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_11941",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_11941",
    x1: 9.75,
    y1: 12.04,
    x2: 8.13,
    y2: 5.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#888"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B2B2"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_11941",
    x1: 9.75,
    y1: 12.04,
    x2: 8.13,
    y2: 5.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#888"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B2B2"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_11941",
    x1: 9.75,
    y1: 12.04,
    x2: 8.13,
    y2: 5.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#888"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B2B2"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_11941",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileAudioWatermarkColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileAudioWatermarkColorIcon({}), 'FileAudioWatermarkColor');
const FileCalendarColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_11981)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_11981)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_11981)"
  }), React.createElement("path", {
    d: "M5.5 7a.5.5 0 000 1h9a.5.5 0 000-1h-9z",
    fill: "url(#paint3_linear_82689_11981)"
  }), React.createElement("path", {
    d: "M7.25 10.5a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: "url(#paint4_linear_82689_11981)"
  }), React.createElement("path", {
    d: "M8 12.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: "url(#paint5_linear_82689_11981)"
  }), React.createElement("path", {
    d: "M10 10.5A.75.75 0 1010 9a.75.75 0 000 1.5z",
    fill: "url(#paint6_linear_82689_11981)"
  }), React.createElement("path", {
    d: "M10.75 12.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: "url(#paint7_linear_82689_11981)"
  }), React.createElement("path", {
    d: "M12.75 10.5a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: "url(#paint8_linear_82689_11981)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_11981",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_11981",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_11981",
    x1: 7.25,
    y1: 4,
    x2: 10.59,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_11981",
    x1: 7.25,
    y1: 4,
    x2: 10.59,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_11981",
    x1: 7.25,
    y1: 4,
    x2: 10.59,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_11981",
    x1: 7.25,
    y1: 4,
    x2: 10.59,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_11981",
    x1: 7.25,
    y1: 4,
    x2: 10.59,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_11981",
    x1: 7.25,
    y1: 4,
    x2: 10.59,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_11981",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileCalendarColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileCalendarColorIcon({}), 'FileCalendarColor');
const FileClipchampColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12712)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12712)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12712)"
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "#7611F0"
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "url(#paint3_radial_82689_12712)",
    fillOpacity: 0.9
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "url(#paint4_radial_82689_12712)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "url(#paint5_radial_82689_12712)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "#BC7FFF"
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "url(#paint6_linear_82689_12712)"
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "url(#paint7_linear_82689_12712)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "url(#paint8_radial_82689_12712)"
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "#974CFF"
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "#A966FF",
    fillOpacity: 0.35
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "url(#paint9_linear_82689_12712)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "url(#paint10_linear_82689_12712)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "url(#paint11_linear_82689_12712)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "#7611F0"
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "#A966FF",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint12_linear_82689_12712)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint13_linear_82689_12712)",
    fillOpacity: 0.15
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint14_linear_82689_12712)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint15_linear_82689_12712)",
    fillOpacity: 0.2
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12712",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12712",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_12712",
    x1: 8.18,
    y1: 9.73,
    x2: 6,
    y2: 9.73,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BC80FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12712",
    x1: 11.35,
    y1: 9.73,
    x2: 14,
    y2: 9.73,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BC7FFF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_12712",
    x1: 10.76,
    y1: 8.96,
    x2: 10.64,
    y2: 11.63,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6200D5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3E008D",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint10_linear_82689_12712",
    x1: 11.82,
    y1: 11.1,
    x2: 14,
    y2: 11.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9B54FD",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_82689_12712",
    x1: 8.18,
    y1: 11.1,
    x2: 6,
    y2: 11.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#944EF6",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_82689_12712",
    x1: 11.13,
    y1: 12.62,
    x2: 10.86,
    y2: 14.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#330072"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7611F0",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint13_linear_82689_12712",
    x1: 7.79,
    y1: 12.62,
    x2: 7.79,
    y2: 14.81,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_82689_12712",
    x1: 8.18,
    y1: 12.48,
    x2: 6,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_82689_12712",
    x1: 11.59,
    y1: 12.5,
    x2: 15.08,
    y2: 15.16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_12712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.52863 3.4824 4.35695 7.5725 10.05 2.4)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.63,
    stopColor: "#974CFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5000B0"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.95089 2.67684 6.46523 13.1202 14.11 5.4)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DE91FF"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D373FC",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_12712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.45383 3.34832 9.96375 4.2049 10.73 4.2)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_12712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.61209 4.38971 5.27375 10.368 12.61 4.12)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  }))));
};
export const FileClipchampColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileClipchampColorIcon({}), 'FileClipchampColor');
const FileClipchampTemplateColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12746)"
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint1_radial_82689_12746)"
  }), React.createElement("path", {
    d: "M5.07 15.96a.5.5 0 01.66-.24c.39.18.82.28 1.27.28h1.11a.5.5 0 010 1H7c-.6 0-1.18-.13-1.7-.37a.5.5 0 01-.23-.67zm7.04.04a.5.5 0 010 1H9.9a.5.5 0 010-1h2.22zM16 15v-1.11a.5.5 0 011 0V15a2 2 0 01-2 2h-1.11a.5.5 0 010-1H15a1 1 0 001-1zM3 13v-1.11a.5.5 0 011 0V13c0 .45.1.88.28 1.27a.5.5 0 01-.9.42A3.99 3.99 0 013 13zm13-.89V9.9a.5.5 0 011 0v2.22a.5.5 0 01-1 0zm-13-2V7.9a.5.5 0 011 0v2.22a.5.5 0 01-1 0zm13-2V7c0-.45-.1-.88-.28-1.27a.5.5 0 01.9-.42c.25.51.38 1.09.38 1.69v1.11a.5.5 0 01-1 0zm-13-2V5c0-1.1.9-2 2-2h1.11a.5.5 0 010 1H5a1 1 0 00-1 1v1.11a.5.5 0 01-1 0zM13 3c.6 0 1.18.13 1.7.37a.5.5 0 01-.43.91A2.99 2.99 0 0013 4h-1.11a.5.5 0 010-1H13zm-2.89 0a.5.5 0 010 1H7.9a.5.5 0 010-1h2.22z",
    fill: "url(#paint2_linear_82689_12746)"
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "#7611F0"
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "url(#paint3_radial_82689_12746)",
    fillOpacity: 0.9
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "url(#paint4_radial_82689_12746)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M6.09 8.53c.08.42.5.7.92.62L13.21 8a.84.84 0 00.67-1l-.06-.28a.87.87 0 00-1-.68L6.68 7.17a.84.84 0 00-.68 1l.08.36z",
    fill: "url(#paint5_radial_82689_12746)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "#BC7FFF"
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "url(#paint6_linear_82689_12746)"
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "url(#paint7_linear_82689_12746)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M6 9.89c0 .48.39.87.87.87h6.08c.58 0 1.05.47 1.05 1.05v.4-2.4a.95.95 0 00-.95-.95h-6.1A.95.95 0 016 7.91v-.38 2.36z",
    fill: "url(#paint8_radial_82689_12746)"
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "#974CFF"
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "#A966FF",
    fillOpacity: 0.35
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "url(#paint9_linear_82689_12746)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "url(#paint10_linear_82689_12746)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 11.22c0 .58.47 1.05 1.05 1.05h6c.53 0 .95.43.95.95v-1.71a.95.95 0 00-.95-.95h-6C6.47 10.56 6 10.1 6 9.51v-.55 2.26z",
    fill: "url(#paint11_linear_82689_12746)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "#7611F0"
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "#A966FF",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint12_linear_82689_12746)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint13_linear_82689_12746)",
    fillOpacity: 0.15
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint14_linear_82689_12746)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M6 12.86C6 13.49 6.5 14 7.14 14h5.91c.53 0 .95-.42.95-.95v-.02a.95.95 0 00-.95-.95H7.41c-.78 0-1.41-.64-1.41-1.41v2.19z",
    fill: "url(#paint15_linear_82689_12746)",
    fillOpacity: 0.2
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12746",
    x1: 6.89,
    y1: 3,
    x2: 8.66,
    y2: 17.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_12746",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_12746",
    x1: 8.18,
    y1: 9.73,
    x2: 6,
    y2: 9.73,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BC80FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12746",
    x1: 11.35,
    y1: 9.73,
    x2: 14,
    y2: 9.73,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BC7FFF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_12746",
    x1: 10.76,
    y1: 8.96,
    x2: 10.64,
    y2: 11.63,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6200D5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3E008D",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint10_linear_82689_12746",
    x1: 11.82,
    y1: 11.1,
    x2: 14,
    y2: 11.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9B54FD",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_82689_12746",
    x1: 8.18,
    y1: 11.1,
    x2: 6,
    y2: 11.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#944EF6",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ECB4FF"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_82689_12746",
    x1: 11.13,
    y1: 12.62,
    x2: 10.86,
    y2: 14.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#330072"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7611F0",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint13_linear_82689_12746",
    x1: 7.79,
    y1: 12.62,
    x2: 7.79,
    y2: 14.81,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("linearGradient", {
    id: "paint14_linear_82689_12746",
    x1: 8.18,
    y1: 12.48,
    x2: 6,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("linearGradient", {
    id: "paint15_linear_82689_12746",
    x1: 11.59,
    y1: 12.5,
    x2: 15.08,
    y2: 15.16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9136F2",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#B76AFF"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_82689_12746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 11.0833 -11.0833 4.15625 7.47 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_12746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.52863 3.4824 4.35695 7.5725 10.05 2.4)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.63,
    stopColor: "#974CFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5000B0"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.95089 2.67684 6.46523 13.1202 14.11 5.4)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DE91FF"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D373FC",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_12746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.45383 3.34832 9.96375 4.2049 10.73 4.2)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_12746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.61209 4.38971 5.27375 10.368 12.61 4.12)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  }))));
};
export const FileClipchampTemplateColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileClipchampTemplateColorIcon({}), 'FileClipchampTemplateColor');
const FileCodeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H5a2 2 0 01-1-3.73V4z",
    fill: "url(#paint0_linear_82689_12001)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17h6.77a2 2 0 010-2H5a1 1 0 100 2zm9 0h-.5a1 1 0 110-2 .5.5 0 100-1H5V4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1z",
    fill: "url(#paint1_linear_82689_12001)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17h6.77a2 2 0 010-2H5a1 1 0 100 2zm9 0h-.5a1 1 0 110-2 .5.5 0 100-1H5V4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1z",
    fill: "url(#paint2_radial_82689_12001)"
  }), React.createElement("path", {
    d: "M11.19 5.04c.25.1.38.39.27.65l-2 5a.5.5 0 01-.92-.38l2-5a.5.5 0 01.65-.27z",
    fill: "url(#paint3_linear_82689_12001)"
  }), React.createElement("path", {
    d: "M7.85 6.65c.2.2.2.5 0 .7L7.21 8l.64.65a.5.5 0 11-.7.7l-1-1a.5.5 0 010-.7l1-1c.2-.2.5-.2.7 0z",
    fill: "url(#paint4_linear_82689_12001)"
  }), React.createElement("path", {
    d: "M12.15 6.65c.2-.2.5-.2.7 0l1 1c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l.64-.65-.64-.65a.5.5 0 010-.7z",
    fill: "url(#paint5_linear_82689_12001)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12001",
    x1: 7.2,
    y1: 2,
    x2: 9.83,
    y2: 18.01,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12001",
    x1: 7.06,
    y1: 3,
    x2: 9.29,
    y2: 17.03,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12001",
    x1: 7.75,
    y1: 4,
    x2: 10.47,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12001",
    x1: 7.75,
    y1: 4,
    x2: 10.47,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12001",
    x1: 7.75,
    y1: 4,
    x2: 10.47,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12001",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.80556 11.0833 -8.70833 4.15625 7.51 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileCodeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileCodeColorIcon({}), 'FileCodeColor');
const FileCodeNotebookColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
    fill: "url(#paint0_linear_82689_12182)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3h6a3 3 0 013 3v7a1 1 0 01-1 1H6a2 2 0 00-1 .27V4a1 1 0 011-1zM5 16a1 1 0 001 1h8a1 1 0 001-1v-1.27a2 2 0 01-1 .27H6a1 1 0 00-1 1z",
    fill: "url(#paint1_linear_82689_12182)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3h6a3 3 0 013 3v7a1 1 0 01-1 1H6a2 2 0 00-1 .27V4a1 1 0 011-1zM5 16a1 1 0 001 1h8a1 1 0 001-1v-1.27a2 2 0 01-1 .27H6a1 1 0 00-1 1z",
    fill: "url(#paint2_radial_82689_12182)"
  }), React.createElement("path", {
    d: "M11.19 5.04c.25.1.38.39.27.65l-2 5a.5.5 0 01-.92-.38l2-5a.5.5 0 01.65-.27z",
    fill: "url(#paint3_linear_82689_12182)"
  }), React.createElement("path", {
    d: "M7.85 6.65c.2.2.2.5 0 .7L7.21 8l.64.65a.5.5 0 11-.7.7l-1-1a.5.5 0 010-.7l1-1c.2-.2.5-.2.7 0z",
    fill: "url(#paint4_linear_82689_12182)"
  }), React.createElement("path", {
    d: "M12.15 6.65c.2-.2.5-.2.7 0l1 1c.2.2.2.5 0 .7l-1 1a.5.5 0 01-.7-.7l.64-.65-.64-.65a.5.5 0 010-.7z",
    fill: "url(#paint5_linear_82689_12182)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12182",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12182",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12182",
    x1: 7.75,
    y1: 4,
    x2: 10.47,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12182",
    x1: 7.75,
    y1: 4,
    x2: 10.47,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12182",
    x1: 7.75,
    y1: 4,
    x2: 10.47,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileCodeNotebookColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileCodeNotebookColorIcon({}), 'FileCodeNotebookColor');
const FileContactColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12021)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12021)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12021)"
  }), React.createElement("path", {
    d: "M11.5 8a.5.5 0 000 1h3a.5.5 0 000-1h-3zm0 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM7.26 9.71a1.36 1.36 0 100-2.71 1.36 1.36 0 000 2.71zm-1.4.68a.86.86 0 00-.86.86c0 .77.52 1.43 1.27 1.62l.05.01c.62.16 1.27.16 1.88 0h.06a1.67 1.67 0 001.26-1.63.86.86 0 00-.86-.86h-2.8z",
    fill: "url(#paint3_linear_82689_12021)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12021",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12021",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12021",
    x1: 7,
    y1: 5.5,
    x2: 10.59,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12021",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileContactColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileContactColorIcon({}), 'FileContactColor');
const FileCopilotColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12781)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12781)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12781)"
  }), React.createElement("path", {
    d: "M12.06 6.57A.82.82 0 0011.3 6h-.5c-.4 0-.74.29-.81.68L9.45 9.5l.26-.9c.1-.36.42-.6.79-.6h1.62l.7.93.62-.93h-.3a.82.82 0 01-.79-.57l-.29-.86z",
    fill: "url(#paint3_radial_82689_12781)"
  }), React.createElement("path", {
    d: "M8.03 13.43c.11.34.43.57.78.57h.83c.44 0 .8-.36.82-.82l.04-2.53-.22.75c-.1.36-.42.6-.79.6H7.87l-.7-.62-.5.62h.3c.35 0 .67.23.78.57l.28.86z",
    fill: "url(#paint4_radial_82689_12781)"
  }), React.createElement("path", {
    d: "M11.13 6H7.84c-.93 0-1.5 1.26-1.87 2.52C5.53 10 4.94 12 6.63 12h1.5c.37 0 .7-.24.8-.6l1.04-3.66c.17-.6.32-1.1.54-1.41a.74.74 0 01.62-.33z",
    fill: "url(#paint5_radial_82689_12781)"
  }), React.createElement("path", {
    d: "M11.13 6H7.84c-.93 0-1.5 1.26-1.87 2.52C5.53 10 4.94 12 6.63 12h1.5c.37 0 .7-.24.8-.6l1.04-3.66c.17-.6.32-1.1.54-1.41a.74.74 0 01.62-.33z",
    fill: "url(#paint6_linear_82689_12781)"
  }), React.createElement("path", {
    d: "M8.88 14h3.28c.93 0 1.5-1.26 1.87-2.52C14.48 10 15.06 8 13.37 8h-1.5a.82.82 0 00-.8.6l-1.04 3.66c-.17.6-.32 1.1-.54 1.41a.74.74 0 01-.62.33z",
    fill: "url(#paint7_radial_82689_12781)"
  }), React.createElement("path", {
    d: "M8.88 14h3.28c.93 0 1.5-1.26 1.87-2.52C14.48 10 15.06 8 13.37 8h-1.5a.82.82 0 00-.8.6l-1.04 3.66c-.17.6-.32 1.1-.54 1.41a.74.74 0 01-.62.33z",
    fill: "url(#paint8_linear_82689_12781)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_12781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_12781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.26121 -2.85987 -2.44138 2.39876 12.86 9.53)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00AEFF"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.00375 2.52755 2.36538 -2.06303 7.36 11.75)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFB657"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF5F3D"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C02B3C"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_12781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.29725 -5.31808 29.4063 -1.69594 7.76 12)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFC800"
  }), React.createElement("stop", {
    offset: 0.31,
    stopColor: "#98BD42"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#52B471"
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0D91E1"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_82689_12781",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.59201 7.52721 -8.8216 -3.32213 13.54 7.41)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_12781",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12781",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_12781",
    x1: 8.06,
    y1: 6,
    x2: 8.32,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_12781",
    x1: 13.8,
    y1: 7.63,
    x2: 13.8,
    y2: 9.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8ADFA"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A86EDD",
    stopOpacity: 0
  }))));
};
export const FileCopilotColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileCopilotColorIcon({}), 'FileCopilotColor');
const FileCopilotPageColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_13822)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_13822)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_13822)"
  }), React.createElement("path", {
    d: "M11.94 8h.44c.34 0 .62.28.62.62v3.56c0 .45-.37.82-.82.82H7.82a.82.82 0 01-.82-.82v-.42l3.7-.82L11.95 8z",
    fill: "url(#paint3_linear_82689_13822)"
  }), React.createElement("path", {
    d: "M12 7.62a.62.62 0 00-.61-.62h-.68v2.91c0 .11-.1.22-.23.23-.4.04-1.05.13-1.7.38-.48.19-.97.46-1.37.86 0 0-.41.38-.41.8 0 .26.13.5.33.65l.38-.26a5.7 5.7 0 011.7-.57c.75-.15 1.55-.15 1.98-.17.34-.01.61-.28.61-.62V7.6z",
    fill: "url(#paint4_radial_82689_13822)"
  }), React.createElement("path", {
    d: "M11 9.91c0 .34-.27.61-.6.64a5.5 5.5 0 00-1.48.36c-.56.21-1.43.8-1.86 1.57a.82.82 0 01-.06-.3V9.9c0-1.27.6-2.16 1.3-2.78.72-.6 1.44-.94 1.95-1.1.4-.13.75.18.75.56v3.32z",
    fill: "url(#paint5_radial_82689_13822)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_13822",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_13822",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.5148 -5.24159 8.9258 -9.95717 12.51 12.48)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E331D8"
  }), React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AC3445"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_13822",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.40914 6.55845 -5.04793 4.95617 7.57 4.64)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_13822",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13822",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13822",
    x1: 11.25,
    y1: 10.73,
    x2: 19,
    y2: 28.24,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4022A0"
  }), React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C570FB"
  }))));
};
export const FileCopilotPageColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileCopilotPageColorIcon({}), 'FileCopilotPageColor');
const FileCsvColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12681)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12681)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12681)"
  }), React.createElement("path", {
    d: "M14.5 11c.28 0 .5.22.5.5 0 .8-.14 1.37-.29 1.75a2.34 2.34 0 01-.3.54l-.03.04-.02.01v.01L14 13.5l.35.35a.5.5 0 01-.77-.63l.06-.07.02-.03c.03-.04.08-.12.13-.24.1-.25.21-.69.21-1.38 0-.28.22-.5.5-.5z",
    fill: "url(#paint3_linear_82689_12681)"
  }), React.createElement("path", {
    d: "M10.5 7c.54 0 1.16.13 1.65.5.52.39.85 1 .85 1.83v3.17a.5.5 0 01-1 0v-.03a4.4 4.4 0 01-1 .42v-1.05a3.58 3.58 0 00.95-.55l.05-.04v-1.18c-.12.01-.25.02-.37.01-.19 0-.4-.03-.62-.04a9.5 9.5 0 00-.5-.03 2.5 2.5 0 00-1.15-.85c.28-.1.6-.16.93-.16.3 0 .58.02.8.04.24.02.42.04.58.04.14 0 .24 0 .3-.02a1.1 1.1 0 00-.42-.76c-.27-.2-.65-.3-1.05-.3-.44 0-.85.05-1.15.35a.5.5 0 01-.7-.7A2.5 2.5 0 0110.5 7z",
    fill: "url(#paint4_linear_82689_12681)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint5_radial_82689_12681)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint6_radial_82689_12681)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M7.8 17H6.45l-.85-1.6a4.94 4.94 0 01-.11-.24h-.01l-.06.13a5.8 5.8 0 00-.07.13L4.47 17H3.2l1.52-2.5L3.3 12h1.33l.76 1.42a4.64 4.64 0 01.14.3h.02a19.35 19.35 0 00.16-.31L6.49 12h1.27l-1.44 2.46L7.8 17z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12681",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12681",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12681",
    x1: 17.78,
    y1: 17.44,
    x2: 9.44,
    y2: 4.4,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.17,
    stopColor: "#15561C"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#15561C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#297C2D"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12681",
    x1: 17.78,
    y1: 17.44,
    x2: 9.44,
    y2: 4.4,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.17,
    stopColor: "#15561C"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#15561C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#297C2D"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_12681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.99998 8.99998 -25.62053 25.62053 1 10)"
  }, React.createElement("stop", {
    stopColor: "#20A85E"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#09442A"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_12681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.25625 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#33A662",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#98F0B0"
  }))));
};
export const FileCsvColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileCsvColorIcon({}), 'FileCsvColor');
const FileDesignerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12814)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12814)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12814)"
  }), React.createElement("path", {
    d: "M13.1 12.5A4.1 4.1 0 019.93 14H7.36a.5.5 0 01-.5-.4V13c0-1.6 1.28-2.92 2.9-3h.16v-.13h3.19v2.62z",
    fill: "url(#paint3_radial_82689_12814)"
  }), React.createElement("path", {
    d: "M13.1 12.5A4.1 4.1 0 019.93 14H7.36a.5.5 0 01-.5-.4V13c0-1.6 1.28-2.92 2.9-3h.16v-.13h3.19v2.62z",
    fill: "url(#paint4_radial_82689_12814)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M9.92 6C12.17 6 14 7.8 14 10c0 1-.38 1.9-1 2.6.07-.18.1-.39.1-.6 0-1.04-.8-1.89-1.83-1.99l-.2-.01H9.75a3.03 3.03 0 01-2.9-3v-.5c0-.28.22-.5.5-.5h2.56z",
    fill: "url(#paint5_radial_82689_12814)"
  }), React.createElement("path", {
    d: "M9.92 6C12.17 6 14 7.8 14 10c0 1-.38 1.9-1 2.6.07-.18.1-.39.1-.6 0-1.04-.8-1.89-1.83-1.99l-.2-.01H9.75a3.03 3.03 0 01-2.9-3v-.5c0-.28.22-.5.5-.5h2.56z",
    fill: "url(#paint6_radial_82689_12814)",
    fillOpacity: 0.5
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_12814",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_12814",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.16824 -4.125 5.16316 6.20696 6.85 14.3)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD7DFF"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6864F6"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5750E2"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3E36B1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#261D82"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12814",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.2373 -2.53778 2.59079 -7.08924 13.69 13.85)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AC80FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#BD96FF"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_12814",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.14551 5.50608 -4.64694 5.7815 6.85 6.24)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B339F0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C354FF"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_12814",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.82699 -3.97712 3.85727 -5.418 9.78 11.73)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFB357",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFB357"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_12814",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12814",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  }))));
};
export const FileDesignerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileDesignerColorIcon({}), 'FileDesignerColor');
const FileExcelColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12843)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12843)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12843)"
  }), React.createElement("path", {
    d: "M13 13.33c0 .37-.3.67-.67.67H11v-2.5A2.5 2.5 0 008.5 9H7v-.5a1 1 0 011-1h5v5.83z",
    fill: "url(#paint3_radial_82689_12843)"
  }), React.createElement("path", {
    d: "M13 13.33c0 .37-.3.67-.67.67H11v-2.5A2.5 2.5 0 008.5 9H7v-.5a1 1 0 011-1h5v5.83z",
    fill: "url(#paint4_radial_82689_12843)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M11 9H7V7.33C7 6.6 7.6 6 8.33 6H11v3z",
    fill: "url(#paint5_linear_82689_12843)"
  }), React.createElement("path", {
    d: "M11 9H7V7.33C7 6.6 7.6 6 8.33 6H11v3z",
    fill: "url(#paint6_radial_82689_12843)"
  }), React.createElement("path", {
    d: "M11 9H7V7.33C7 6.6 7.6 6 8.33 6H11v3z",
    fill: "url(#paint7_linear_82689_12843)"
  }), React.createElement("path", {
    d: "M10.66 9a.66.66 0 00-.64.52A2.49 2.49 0 008.5 9h2.16z",
    fill: "url(#paint8_linear_82689_12843)"
  }), React.createElement("path", {
    d: "M10.66 9a.66.66 0 00-.64.52A2.49 2.49 0 008.5 9h2.16z",
    fill: "url(#paint9_linear_82689_12843)",
    fillOpacity: 0.3
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint10_radial_82689_12843)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint11_radial_82689_12843)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M12.33 6c.37 0 .67.3.67.67v1.66c0 .37-.3.67-.67.67h-1.66a.67.67 0 01-.67-.67V6.67c0-.37.3-.67.67-.67h1.66z",
    fill: "url(#paint12_radial_82689_12843)"
  }), React.createElement("path", {
    d: "M7.8 17H6.45l-.85-1.6a4.94 4.94 0 01-.11-.24h-.01l-.06.13a5.8 5.8 0 00-.07.13L4.47 17H3.2l1.52-2.5L3.3 12h1.33l.76 1.42a4.64 4.64 0 01.14.3h.02a19.35 19.35 0 00.16-.31L6.49 12h1.27l-1.44 2.46L7.8 17z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_12843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_12843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.2578 -6.68056 10.3285 -4.75127 14 14.54)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#379539"
  }), React.createElement("stop", {
    offset: 0.42,
    stopColor: "#297C2D"
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#15561C"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.18254 -2.59549 4.01281 -2.00885 4.99 9.85)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#073B10"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#084A13",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_12843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.02645 0 0 -6.01107 10.85 8.41)"
  }, React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4EB43B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#72CC61",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint10_radial_82689_12843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.99998 8.99998 -25.62053 25.62053 1 10)"
  }, React.createElement("stop", {
    stopColor: "#20A85E"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#09442A"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_82689_12843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.25625 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#33A662",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#98F0B0"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_82689_12843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.38219 -3.13486 2.77388 -3.82234 13.38 9.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.44,
    stopColor: "#79E96D"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EB76"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_12843",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12843",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12843",
    x1: 7.1,
    y1: 10.59,
    x2: 11.84,
    y2: 7.66,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#66D052"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#85E972"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12843",
    x1: 8.78,
    y1: 8.64,
    x2: 6.96,
    y2: 8.64,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C0E075",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D1EB95"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_12843",
    x1: 8.78,
    y1: 10.89,
    x2: 10.22,
    y2: 10.89,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#52D17C"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4AA647"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_12843",
    x1: 10.19,
    y1: 9.96,
    x2: 10.19,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#29852F"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4AA647",
    stopOpacity: 0
  }))));
};
export const FileExcelColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileExcelColorIcon({}), 'FileExcelColor');
const FileExcelTemplateColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12888)"
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint1_radial_82689_12888)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 00-1 1v1.5a.5.5 0 01-1 0V6c0-1.1.9-2 2-2h1.25a.5.5 0 010 1H4zm3.25-.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5zm5 0c0-.28.22-.5.5-.5H14c.54 0 1.06.1 1.53.3a.5.5 0 11-.38.93A2.99 2.99 0 0014 5h-1.25a.5.5 0 01-.5-.5zm4.8 1.7a.5.5 0 01.65.27c.2.47.3.99.3 1.53v1.5a.5.5 0 01-1 0V8c0-.4-.08-.8-.23-1.15a.5.5 0 01.27-.65zM2.5 10c.28 0 .5.22.5.5V12c0 .4.08.8.23 1.15a.5.5 0 01-.93.38c-.2-.47-.3-.99-.3-1.53v-1.5c0-.28.22-.5.5-.5zm15 2c.28 0 .5.22.5.5V14a2 2 0 01-2 2h-1.25a.5.5 0 010-1H16a1 1 0 001-1v-1.5c0-.28.22-.5.5-.5zM4.2 15.04a.5.5 0 01.65-.27c.35.15.74.23 1.15.23h1.25a.5.5 0 010 1H6a4 4 0 01-1.53-.3.5.5 0 01-.27-.66zm5.05.46c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5z",
    fill: "url(#paint2_linear_82689_12888)"
  }), React.createElement("path", {
    d: "M13 13.33c0 .37-.3.67-.67.67H11v-2.5A2.5 2.5 0 008.5 9H7v-.5a1 1 0 011-1h5v5.83z",
    fill: "url(#paint3_radial_82689_12888)"
  }), React.createElement("path", {
    d: "M13 13.33c0 .37-.3.67-.67.67H11v-2.5A2.5 2.5 0 008.5 9H7v-.5a1 1 0 011-1h5v5.83z",
    fill: "url(#paint4_radial_82689_12888)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M11 9H7V7.33C7 6.6 7.6 6 8.33 6H11v3z",
    fill: "url(#paint5_linear_82689_12888)"
  }), React.createElement("path", {
    d: "M11 9H7V7.33C7 6.6 7.6 6 8.33 6H11v3z",
    fill: "url(#paint6_radial_82689_12888)"
  }), React.createElement("path", {
    d: "M11 9H7V7.33C7 6.6 7.6 6 8.33 6H11v3z",
    fill: "url(#paint7_linear_82689_12888)"
  }), React.createElement("path", {
    d: "M12.33 6c.37 0 .67.3.67.67v1.66c0 .37-.3.67-.67.67h-1.66a.67.67 0 01-.67-.67V6.67c0-.37.3-.67.67-.67h1.66z",
    fill: "url(#paint8_radial_82689_12888)"
  }), React.createElement("path", {
    d: "M10.66 9a.66.66 0 00-.64.52A2.49 2.49 0 008.5 9h2.16z",
    fill: "url(#paint9_linear_82689_12888)"
  }), React.createElement("path", {
    d: "M10.66 9a.66.66 0 00-.64.52A2.49 2.49 0 008.5 9h2.16z",
    fill: "url(#paint10_linear_82689_12888)",
    fillOpacity: 0.3
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint11_radial_82689_12888)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint12_radial_82689_12888)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M7.8 17H6.45l-.85-1.6a4.94 4.94 0 01-.11-.24h-.01l-.06.13a5.8 5.8 0 00-.07.13L4.47 17H3.2l1.52-2.5L3.3 12h1.33l.76 1.42a4.64 4.64 0 01.14.3h.02a19.35 19.35 0 00.16-.31L6.49 12h1.27l-1.44 2.46L7.8 17z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_82689_12888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.44444 9.5 -12.6667 3.5625 7.11 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_12888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.2578 -6.68056 10.3285 -4.75127 14 14.54)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#379539"
  }), React.createElement("stop", {
    offset: 0.42,
    stopColor: "#297C2D"
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#15561C"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.18254 -2.59549 4.01281 -2.00885 4.99 9.85)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#073B10"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#084A13",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_12888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.02645 0 0 -6.01107 10.85 8.41)"
  }, React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4EB43B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#72CC61",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_12888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.38219 -3.13486 2.77388 -3.82234 13.38 9.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.44,
    stopColor: "#79E96D"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D0EB76"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_82689_12888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.99998 8.99998 -25.62053 25.62053 1 10)"
  }, React.createElement("stop", {
    stopColor: "#20A85E"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#09442A"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_82689_12888",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.25625 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#33A662",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#98F0B0"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_12888",
    x1: 6.44,
    y1: 4,
    x2: 7.59,
    y2: 16.23,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_12888",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12888",
    x1: 7.1,
    y1: 10.59,
    x2: 11.84,
    y2: 7.66,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#66D052"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#85E972"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12888",
    x1: 8.78,
    y1: 8.64,
    x2: 6.96,
    y2: 8.64,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#C0E075",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D1EB95"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_12888",
    x1: 8.78,
    y1: 10.89,
    x2: 10.22,
    y2: 10.89,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#52D17C"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4AA647"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_82689_12888",
    x1: 10.19,
    y1: 9.96,
    x2: 10.19,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#29852F"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4AA647",
    stopOpacity: 0
  }))));
};
export const FileExcelTemplateColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileExcelTemplateColorIcon({}), 'FileExcelTemplateColor');
const FileFileColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12088)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12088)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12088)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12088",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12088",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12088",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileFileColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileFileColorIcon({}), 'FileFileColor');
const FileFileMultipleColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4c0-1.1.9-2 2-2h6a4 4 0 014 4v8a2 2 0 01-2 2 2 2 0 01-2 2H9a6 6 0 01-6-6V6c0-1.1.9-2 2-2z",
    fill: "url(#paint0_linear_82689_12103)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h6a3 3 0 013 3v8a1 1 0 01-1 1H9a3 3 0 01-3-3V4a1 1 0 011-1zM5 5a1 1 0 00-1 1v6a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V5z",
    fill: "url(#paint1_linear_82689_12103)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h6a3 3 0 013 3v8a1 1 0 01-1 1H9a3 3 0 01-3-3V4a1 1 0 011-1zM5 5a1 1 0 00-1 1v6a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V5z",
    fill: "url(#paint2_radial_82689_12103)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12103",
    x1: 7.52,
    y1: 2,
    x2: 9.97,
    y2: 18.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12103",
    x1: 7.33,
    y1: 3,
    x2: 9.39,
    y2: 17.09,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12103",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 11.0833 -9.5 4.15625 7.83 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileFileMultipleColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileFileMultipleColorIcon({}), 'FileFileMultipleColor');
const FileFileRecycledColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12126)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12126)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12126)"
  }), React.createElement("path", {
    d: "M10 8.73c-1.15 0-2.08.91-2.08 2.04 0 .18-.15.34-.34.34H7.4c-.86 0-1.56.68-1.56 1.52 0 .85.7 1.53 1.56 1.53h5.2c.86 0 1.56-.68 1.56-1.53 0-.84-.7-1.52-1.56-1.52h-.17a.34.34 0 01-.35-.34c0-1.13-.93-2.04-2.08-2.04zm-2.75 1.7A2.75 2.75 0 0110 8.05a2.75 2.75 0 012.75 2.38 2.23 2.23 0 012.1 2.2c0 1.22-1 2.21-2.25 2.21H7.4a2.23 2.23 0 01-2.25-2.2c0-1.18.93-2.13 2.1-2.2z",
    fill: "#605E5C",
    fillOpacity: 0.67
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.87c-1.07 0-1.94.85-1.94 1.9 0 .26-.22.48-.48.48H7.4a1.4 1.4 0 00-1.42 1.38c0 .77.64 1.4 1.42 1.4h5.2a1.4 1.4 0 001.42-1.4 1.4 1.4 0 00-1.42-1.38h-.17a.48.48 0 01-.5-.48c0-1.05-.86-1.9-1.93-1.9zM7.13 10.3A2.9 2.9 0 0110 7.91a2.9 2.9 0 012.87 2.4A2.36 2.36 0 0115 12.62c0 1.3-1.07 2.35-2.4 2.35H7.4a2.37 2.37 0 01-2.39-2.35c0-1.2.93-2.2 2.12-2.33zm.12.13A2.75 2.75 0 0110 8.05a2.75 2.75 0 012.75 2.38 2.23 2.23 0 012.1 2.2c0 1.22-1 2.21-2.25 2.21H7.4a2.23 2.23 0 01-2.25-2.2c0-1.18.93-2.13 2.1-2.2zm.67.34c0-1.13.93-2.04 2.08-2.04s2.08.91 2.08 2.04c0 .18.15.34.35.34h.17c.86 0 1.56.68 1.56 1.52 0 .85-.7 1.53-1.56 1.53H7.4c-.86 0-1.56-.68-1.56-1.53 0-.84.7-1.52 1.56-1.52h.18c.19 0 .34-.16.34-.34z",
    fill: "#605E5C",
    fillOpacity: 0.67
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12126",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12126",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileFileRecycledColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileFileRecycledColorIcon({}), 'FileFileRecycledColor');
const FileFontColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12142)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12142)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12142)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.46 6.3a.5.5 0 00-.92 0L6.67 13H6.5a.5.5 0 000 1h1a.5.5 0 00.23-.94L8.2 12h3.1l.42 1h-.21a.5.5 0 000 1h2a.5.5 0 000-1h-.17l-2.87-6.7zm.43 4.7L9.78 8.28 8.62 11h2.27z",
    fill: "url(#paint3_linear_82689_12142)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12142",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12142",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12142",
    x1: 8.45,
    y1: 7,
    x2: 10.76,
    y2: 13.9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileFontColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileFontColorIcon({}), 'FileFontColor');
const FileFormColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12934)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12934)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12934)"
  }), React.createElement("path", {
    d: "M13 13.33c0 .37-.3.67-.67.67H11v-2.5a2.5 2.5 0 00-2.23-2.49L9 9h4v4.33z",
    fill: "url(#paint3_radial_82689_12934)"
  }), React.createElement("path", {
    d: "M13 13.33c0 .37-.3.67-.67.67H11v-2.5a2.5 2.5 0 00-2.23-2.49L9 9h4v4.33z",
    fill: "url(#paint4_radial_82689_12934)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M12.27 6c.4 0 .73.33.73.73v2.54c0 .4-.33.73-.73.73H10.5a2.5 2.5 0 00-2-1H7V7.34C7 6.6 7.6 6 8.34 6h3.93z",
    fill: "url(#paint5_linear_82689_12934)"
  }), React.createElement("path", {
    d: "M12.27 6c.4 0 .73.33.73.73v2.54c0 .4-.33.73-.73.73H10.5a2.5 2.5 0 00-2-1H7V7.34C7 6.6 7.6 6 8.34 6h3.93z",
    fill: "url(#paint6_linear_82689_12934)"
  }), React.createElement("path", {
    d: "M11 9a1 1 0 100-2 1 1 0 000 2z",
    fill: "url(#paint7_linear_82689_12934)"
  }), React.createElement("path", {
    d: "M11 9a1 1 0 100-2 1 1 0 000 2z",
    fill: "url(#paint8_linear_82689_12934)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint9_radial_82689_12934)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint10_radial_82689_12934)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M11.82 11c.1 0 .18.08.18.18v1.64c0 .1-.08.18-.18.18H11v-1.5c0-.17-.02-.34-.05-.5h.87z",
    fill: "url(#paint11_linear_82689_12934)"
  }), React.createElement("path", {
    d: "M6.94 12.93H5.18v1.2H6.8v.93H5.18V17H4.06v-5h2.88v.93z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12934",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12934",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12934",
    x1: 7.14,
    y1: 10.33,
    x2: 13.71,
    y2: 7.78,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.23,
    stopColor: "#15B4D5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#43E5CA"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_12934",
    x1: 8.65,
    y1: 8.49,
    x2: 7,
    y2: 8.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#29CBDC",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#36DFF1"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12934",
    x1: 10.29,
    y1: 7.14,
    x2: 11.57,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#119FC5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#22918B"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_12934",
    x1: 10.29,
    y1: 7.14,
    x2: 11.57,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#06517B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7F7C"
  })), React.createElement("linearGradient", {
    id: "paint11_linear_82689_12934",
    x1: 11.32,
    y1: 11.54,
    x2: 11.64,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#119FC5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#20AC9D"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_12934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.89246 -15.6288 13.4995 -7.95243 9.83 22.57)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1A7F7C"
  }), React.createElement("stop", {
    offset: 0.45,
    stopColor: "#14717C"
  }), React.createElement("stop", {
    offset: 0.8,
    stopColor: "#08567B"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.81041 -5.91222 4.49897 -4.57592 2.95 11.06)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#06517B"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#06517B",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint9_radial_82689_12934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#009BBC"
  }), React.createElement("stop", {
    offset: 0.59,
    stopColor: "#01657D"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#014354"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_82689_12934",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17187 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1E8581",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1ECBE6"
  }))));
};
export const FileFormColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileFormColorIcon({}), 'FileFormColor');
const FileFormGenericColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_14630)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_14630)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_14630)"
  }), React.createElement("path", {
    d: "M7.5 11.5a1 1 0 110 2 1 1 0 010-2z",
    fill: "url(#paint3_linear_82689_14630)"
  }), React.createElement("path", {
    d: "M12.5 12a.5.5 0 010 1h-2a.5.5 0 010-1h2z",
    fill: "url(#paint4_linear_82689_14630)"
  }), React.createElement("path", {
    d: "M7.5 8.5a1 1 0 110 2 1 1 0 010-2z",
    fill: "url(#paint5_linear_82689_14630)"
  }), React.createElement("path", {
    d: "M12.5 9a.5.5 0 010 1h-2a.5.5 0 010-1h2z",
    fill: "url(#paint6_linear_82689_14630)"
  }), React.createElement("path", {
    d: "M13.5 6a.5.5 0 010 1h-7a.5.5 0 010-1h7z",
    fill: "url(#paint7_linear_82689_14630)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14630",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14630",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14630",
    x1: 8.45,
    y1: 6.94,
    x2: 10.5,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_14630",
    x1: 8.45,
    y1: 6.94,
    x2: 10.5,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_14630",
    x1: 8.45,
    y1: 6.94,
    x2: 10.5,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_14630",
    x1: 8.45,
    y1: 6.94,
    x2: 10.5,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_14630",
    x1: 8.45,
    y1: 6.94,
    x2: 10.5,
    y2: 13.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileFormGenericColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileFormGenericColorIcon({}), 'FileFormGenericColor');
const FileLinkColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12207)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12207)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12207)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 010 8l-.1-.01a.5.5 0 01-.32-.21A.5.5 0 0110 13c.04 0 .12-.02.23-.13.12-.12.25-.31.37-.6.2-.45.34-1.06.38-1.77H10a.5.5 0 010-1h.98a5.56 5.56 0 00-.38-1.78 1.88 1.88 0 00-.37-.59c-.11-.11-.2-.13-.23-.13-.06 0-.24.06-.47.45-.2.38-.38.93-.47 1.61a.5.5 0 01-1-.12c.08-.55.2-1.06.37-1.5a3 3 0 00-1.3 1.7.5.5 0 01-.96-.28A4 4 0 0110 6zm-1.53 4.5a.5.5 0 01.53.52v1.48a.5.5 0 01-1 0v-.3l-1.15 1.15a.5.5 0 11-.7-.7l1.14-1.15H7a.5.5 0 010-1h1.47zm3.51 0c-.04.77-.19 1.48-.41 2.05a3 3 0 001.39-2.05h-.98zm-.41-3.06c.22.58.37 1.29.41 2.06h.98a3 3 0 00-1.4-2.06z",
    fill: "url(#paint3_linear_82689_12207)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12207",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12207",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12207",
    x1: 7.5,
    y1: 6,
    x2: 11.98,
    y2: 13.04,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12207",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileLinkColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileLinkColorIcon({}), 'FileLinkColor');
const FileListsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12984)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12984)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12984)"
  }), React.createElement("path", {
    d: "M6 8l2-2h5.68c.18 0 .32.14.32.32V8l-4 .92L6 8z",
    fill: "#FEE200"
  }), React.createElement("path", {
    d: "M8.48 9.94L6 10.96V8h2l.48 1.94z",
    fill: "url(#paint3_linear_82689_12984)"
  }), React.createElement("path", {
    d: "M14 10.02V8H8v2.05l2.73.49 3.27-.52z",
    fill: "url(#paint4_linear_82689_12984)"
  }), React.createElement("path", {
    d: "M8 12l-2 .67V10h2v2z",
    fill: "url(#paint5_linear_82689_12984)"
  }), React.createElement("path", {
    d: "M14 12v-2H7.56v2.01l3.96.37L14 12z",
    fill: "url(#paint6_linear_82689_12984)"
  }), React.createElement("path", {
    d: "M8 14H6.38a.38.38 0 01-.38-.38V12h2v2z",
    fill: "url(#paint7_linear_82689_12984)"
  }), React.createElement("path", {
    d: "M8 12l-.31.95L8 14h4l2-2H8z",
    fill: "url(#paint8_linear_82689_12984)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12984",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12984",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12984",
    x1: 7.24,
    y1: 10.96,
    x2: 7.24,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E25A01"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E15801"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E05101"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4A01"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12984",
    x1: 11,
    y1: 10.54,
    x2: 11,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F18C0A"
  }), React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F0880A"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC7C0A"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EB770A"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12984",
    x1: 7,
    y1: 12.67,
    x2: 7,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#BF3207"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BB3207"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#AF3007"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AD3007"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_12984",
    x1: 10.78,
    y1: 12.38,
    x2: 10.78,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D83B01"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D63701"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CE2B01"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#CD2901"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12984",
    x1: 7,
    y1: 14,
    x2: 7,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#703D6E"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#6C3B6A"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#663764"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_12984",
    x1: 10.85,
    y1: 14,
    x2: 10.85,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#854A81"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#82497E"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#794475"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#703F6C"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12984",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileListsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileListsColorIcon({}), 'FileListsColor');
const FileListsFormColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_13036)"
  }), React.createElement("path", {
    d: "M13 6a1 1 0 011 1v6a1 1 0 01-1 1h-3v-2.5c0-.83-.67-1.5-1.5-1.5H6V7a1 1 0 011-1h6z",
    fill: "url(#paint3_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M12 11a1 1 0 110 2h-2v-1.5c0-.18-.03-.34-.08-.5H12z",
    fill: "#87447D"
  }), React.createElement("path", {
    d: "M12.1 7a1 1 0 01-.1 2H8a1 1 0 110-2h4.1z",
    fill: "#87447D"
  }), React.createElement("path", {
    d: "M1 13l2-2h5.68c.18 0 .32.14.32.32V13l-4 .92L1 13z",
    fill: "#FEE200"
  }), React.createElement("path", {
    d: "M3.48 14.94L1 15.96V13h2l.48 1.94z",
    fill: "url(#paint4_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M9 15.02V13H3v2.05l2.73.49L9 15.02z",
    fill: "url(#paint5_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M9 17v-2H2.56v2.01l3.96.37L9 17z",
    fill: "url(#paint6_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M3 17l-2 .67V15h2v2z",
    fill: "url(#paint7_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M3 17l-.3.95L3 19h4l2-2H3z",
    fill: "url(#paint8_linear_82689_13036)"
  }), React.createElement("path", {
    d: "M3 19H1.38a.38.38 0 01-.38-.38V17h2v2z",
    fill: "url(#paint9_linear_82689_13036)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13036",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13036",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13036",
    x1: 6.86,
    y1: 4.29,
    x2: 14,
    y2: 17.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E0BEDB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A35B98"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13036",
    x1: 2.24,
    y1: 15.96,
    x2: 2.24,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E25A01"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E15801"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E05101"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4A01"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13036",
    x1: 6,
    y1: 15.54,
    x2: 6,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F18C0A"
  }), React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F0880A"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC7C0A"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EB770A"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13036",
    x1: 5.78,
    y1: 17.38,
    x2: 5.78,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D83B01"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D63701"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CE2B01"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#CD2901"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13036",
    x1: 2,
    y1: 17.67,
    x2: 2,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#BF3207"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BB3207"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#AF3007"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AD3007"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_13036",
    x1: 5.85,
    y1: 19,
    x2: 5.85,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#854A81"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#82497E"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#794475"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#703F6C"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_13036",
    x1: 2,
    y1: 19,
    x2: 2,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#703D6E"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#6C3B6A"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#663764"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13036",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileListsFormColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileListsFormColorIcon({}), 'FileListsFormColor');
const FileListsItemColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_13098)"
  }), React.createElement("path", {
    d: "M13.5 11a.5.5 0 010 1H10v-1h3.5zm-6-3a.5.5 0 010 1h-1a.5.5 0 010-1h1zm6 0a.5.5 0 010 1h-4a.5.5 0 010-1h4z",
    fill: "url(#paint3_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M1 13l2-2h5.68c.18 0 .32.14.32.32V13l-4 .92L1 13z",
    fill: "#FEE200"
  }), React.createElement("path", {
    d: "M3.48 14.94L1 15.96V13h2l.48 1.94z",
    fill: "url(#paint4_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M9 15.02V13H3v2.05l2.73.49L9 15.02z",
    fill: "url(#paint5_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M9 17v-2H2.56v2.01l3.96.37L9 17z",
    fill: "url(#paint6_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M3 17l-2 .67V15h2v2z",
    fill: "url(#paint7_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M3 17l-.3.95L3 19h4l2-2H3z",
    fill: "url(#paint8_linear_82689_13098)"
  }), React.createElement("path", {
    d: "M3 19H1.38a.38.38 0 01-.38-.38V17h2v2z",
    fill: "url(#paint9_linear_82689_13098)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13098",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13098",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13098",
    x1: 9.5,
    y1: 8,
    x2: 11,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A35B98"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#87447D"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13098",
    x1: 2.24,
    y1: 15.96,
    x2: 2.24,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E25A01"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E15801"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E05101"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#DE4A01"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13098",
    x1: 6,
    y1: 15.54,
    x2: 6,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F18C0A"
  }), React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F0880A"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC7C0A"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EB770A"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13098",
    x1: 5.78,
    y1: 17.38,
    x2: 5.78,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D83B01"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D63701"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CE2B01"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#CD2901"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13098",
    x1: 2,
    y1: 17.67,
    x2: 2,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#BF3207"
  }), React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BB3207"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#AF3007"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AD3007"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_13098",
    x1: 5.85,
    y1: 19,
    x2: 5.85,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#854A81"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#82497E"
  }), React.createElement("stop", {
    offset: 0.81,
    stopColor: "#794475"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#703F6C"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_13098",
    x1: 2,
    y1: 19,
    x2: 2,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#703D6E"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#6C3B6A"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#663764"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13098",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileListsItemColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileListsItemColorIcon({}), 'FileListsItemColor');
const FileLoopColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_13169)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_13169)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_13169)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6a4 4 0 010 8H6v-4a4 4 0 014-4zm0 2.5c-.83 0-1.5.67-1.5 1.5v1.5H10a1.5 1.5 0 000-3z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6a4 4 0 010 8H6v-4a4 4 0 014-4zm0 2.5c-.83 0-1.5.67-1.5 1.5v1.5H10a1.5 1.5 0 000-3z",
    fill: "url(#paint3_linear_82689_13169)"
  }), React.createElement("path", {
    d: "M14 10a4 4 0 01-4 4H6a2.5 2.5 0 012.5-2.5H10a1.5 1.5 0 001.5-1.35V10H14z",
    fill: "url(#paint4_linear_82689_13169)"
  }), React.createElement("path", {
    d: "M14 10a4 4 0 01-4 4H6a2.5 2.5 0 012.5-2.5H10a1.5 1.5 0 001.5-1.35V10H14z",
    fill: "url(#paint5_radial_82689_13169)",
    fillOpacity: 0.56
  }), React.createElement("path", {
    d: "M14 10a4 4 0 01-4 4H6a2.5 2.5 0 012.5-2.5H10a1.5 1.5 0 001.5-1.35V10H14z",
    fill: "url(#paint6_radial_82689_13169)",
    fillOpacity: 0.1
  }), React.createElement("path", {
    d: "M10 6c1.1 0 2.1.45 2.83 1.17l-1.77 1.77A1.5 1.5 0 008.5 10v1.5A2.5 2.5 0 016 14v-4a4 4 0 014-4z",
    fill: "url(#paint7_linear_82689_13169)"
  }), React.createElement("path", {
    d: "M10 6c1.1 0 2.1.45 2.83 1.17l-1.77 1.77A1.5 1.5 0 008.5 10v1.5A2.5 2.5 0 016 14v-4a4 4 0 014-4z",
    fill: "url(#paint8_radial_82689_13169)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13169",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13169",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13169",
    x1: 10.88,
    y1: 8.84,
    x2: 9.56,
    y2: 14.24,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9237E3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#48E6F3"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13169",
    x1: 8.6,
    y1: 13.4,
    x2: 12.12,
    y2: 12.6,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#51E6FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#71D4FF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13169",
    x1: 7.64,
    y1: 10.31,
    x2: 9.7,
    y2: 7.42,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AB5ADD",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13169",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_13169",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.59998 1.1 -1.93324 2.81204 7.4 12.3)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", null), React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_13169",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.95995 1.84 -3.23379 5.20227 6.92 12)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.33
  }), React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_13169",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.35159 -.9258 2.41501 14.1809 5.32 8.5)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6D05E8",
    stopOpacity: 0
  }))));
};
export const FileLoopColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileLoopColorIcon({}), 'FileLoopColor');
const FileLoopWorkspaceColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_13202)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_13202)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_13202)"
  }), React.createElement("path", {
    d: "M14 12a1 1 0 01-1 1h-2.2A5.5 5.5 0 006 9.02V8h8v4z",
    fill: "url(#paint3_linear_82689_13202)"
  }), React.createElement("path", {
    d: "M13 7a1 1 0 011 1v1H6V8a1 1 0 011-1h6z",
    fill: "url(#paint4_linear_82689_13202)"
  }), React.createElement("path", {
    d: "M8.31 14.5a2.81 2.81 0 11-5.62 0 2.81 2.81 0 015.62 0z",
    fill: "#F3F3F3"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10a4.5 4.5 0 110 9H1v-4.5A4.5 4.5 0 015.5 10zm0 3c-.83 0-1.5.67-1.5 1.5V16h1.5a1.5 1.5 0 000-3z",
    fill: "url(#paint5_linear_82689_13202)"
  }), React.createElement("path", {
    d: "M10 14.5A4.5 4.5 0 015.5 19H1a3 3 0 013-3h1.5A1.5 1.5 0 007 14.65v-.15h3z",
    fill: "url(#paint6_linear_82689_13202)"
  }), React.createElement("path", {
    d: "M10 14.5A4.5 4.5 0 015.5 19H1a3 3 0 013-3h1.5A1.5 1.5 0 007 14.65v-.15h3z",
    fill: "url(#paint7_radial_82689_13202)",
    fillOpacity: 0.56
  }), React.createElement("path", {
    d: "M10 14.5A4.5 4.5 0 015.5 19H1a3 3 0 013-3h1.5A1.5 1.5 0 007 14.65v-.15h3z",
    fill: "url(#paint8_radial_82689_13202)",
    fillOpacity: 0.1
  }), React.createElement("path", {
    d: "M5.5 10c1.24 0 2.37.5 3.18 1.32l-2.12 2.12A1.5 1.5 0 004 14.5V16a3 3 0 01-3 3v-4.5A4.5 4.5 0 015.5 10z",
    fill: "url(#paint9_linear_82689_13202)"
  }), React.createElement("path", {
    d: "M5.5 10c1.24 0 2.37.5 3.18 1.32l-2.12 2.12A1.5 1.5 0 004 14.5V16a3 3 0 01-3 3v-4.5A4.5 4.5 0 015.5 10z",
    fill: "url(#paint10_radial_82689_13202)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13202",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13202",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13202",
    x1: 10,
    y1: 8,
    x2: 10,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D0BEFE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C2AAFE"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13202",
    x1: 10.28,
    y1: 7,
    x2: 10.28,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#AB85FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9354FF"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13202",
    x1: 6.49,
    y1: 13.2,
    x2: 5,
    y2: 19.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9237E3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#48E6F3"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13202",
    x1: 3.92,
    y1: 18.32,
    x2: 7.88,
    y2: 17.43,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#51E6FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#71D4FF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_13202",
    x1: 2.84,
    y1: 14.85,
    x2: 5.16,
    y2: 11.6,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AB5ADD",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13202",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_82689_13202",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.79997 1.2375 -2.1749 3.16354 2.57 17.09)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", null), React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_13202",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.32995 2.07 -3.63801 5.85255 2.03 16.75)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.33
  }), React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint10_radial_82689_13202",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.02054 -1.04151 2.71689 15.9535 .24 12.8)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6D05E8",
    stopOpacity: 0
  }))));
};
export const FileLoopWorkspaceColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileLoopWorkspaceColorIcon({}), 'FileLoopWorkspaceColor');
const FileMailColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12232)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12232)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12232)"
  }), React.createElement("path", {
    d: "M4.11 6.18a.5.5 0 01.7-.07l4.23 3.5a1.5 1.5 0 001.92 0l4.22-3.5a.5.5 0 01.64.78l-4.23 3.5a2.5 2.5 0 01-3.18 0l-4.23-3.5a.5.5 0 01-.07-.7z",
    fill: "url(#paint3_linear_82689_12232)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12232",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12232",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12232",
    x1: 8.09,
    y1: 1.95,
    x2: 12.56,
    y2: 12.47,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12232",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileMailColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileMailColorIcon({}), 'FileMailColor');
const FileMinecraftColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_13278)"
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint1_radial_82689_13278)"
  }), React.createElement("path", {
    d: "M6.2 17.04a.5.5 0 01.65-.27A3 3 0 008 17h1.5a.5.5 0 010 1H8a4 4 0 01-1.53-.3.5.5 0 01-.27-.66zM15 16v-1.25a.5.5 0 011 0V16a2 2 0 01-2 2h-1.5a.5.5 0 010-1H14a1 1 0 001-1zM4 14v-1.25a.5.5 0 011 0V14c0 .4.08.8.23 1.15a.5.5 0 01-.93.38c-.2-.47-.3-.99-.3-1.53zm11-1.75v-2.5a.5.5 0 011 0v2.5a.5.5 0 01-1 0zm-11-2v-2.5a.5.5 0 011 0v2.5a.5.5 0 01-1 0zm11-3V6a3 3 0 00-.23-1.15.5.5 0 01.93-.38c.2.47.3.99.3 1.53v1.25a.5.5 0 01-1 0zm-11-2V4c0-1.1.9-2 2-2h1.5a.5.5 0 010 1H6a1 1 0 00-1 1v1.25a.5.5 0 01-1 0zM12 2c.54 0 1.06.1 1.53.3a.5.5 0 01-.38.93A2.99 2.99 0 0012 3h-1.5a.5.5 0 010-1H12z",
    fill: "url(#paint2_linear_82689_13278)"
  }), React.createElement("path", {
    d: "M8.25 7H7v1.25h1.25V7z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M9.25 7H8v1.25h1.25V7z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M10.25 7H9v1.25h1.25V7z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M11.25 7H10v1.25h1.25V7z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M12.25 7H11v1.25h1.25V7z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M13 7h-1v1.25h1V7z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M8.25 8H7v1.25h1.25V8z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M9.25 8H8v1.25h1.25V8z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M10.25 8H9v1.25h1.25V8z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M11.25 8H10v1.25h1.25V8z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M12.25 8H11v1.25h1.25V8z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M13 8h-1v1.25h1V8z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M8.25 9H7v1.25h1.25V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M9.25 9H8v1.25h1.25V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M10.25 9H9v1.25h1.25V9z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M11.25 9H10v1.25h1.25V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M12.25 9H11v1.25h1.25V9z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M13 9h-1v1.25h1V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M8.25 10H7v1.25h1.25V10z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M9.25 10H8v1.25h1.25V10z",
    fill: "#AD7A54"
  }), React.createElement("path", {
    d: "M10.25 10H9v1.25h1.25V10z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M11.25 10H10v1.25h1.25V10z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M12.25 10H11v1.25h1.25V10z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M13 10h-1v1.25h1V10z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M8.25 11H7v1.25h1.25V11z",
    fill: "#976746"
  }), React.createElement("path", {
    d: "M9.25 11H8v1.25h1.25V11z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M10.25 11H9v1.25h1.25V11z",
    fill: "#976746"
  }), React.createElement("path", {
    d: "M11.25 11H10v1.25h1.25V11z",
    fill: "#AD7A54"
  }), React.createElement("path", {
    d: "M12.25 11H11v1.25h1.25V11z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M13 11h-1v1.25h1V11z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M8.25 12H7v1h1.25v-1z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M9.25 12H8v1h1.25v-1z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M10.25 12H9v1h1.25v-1z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M11.25 12H10v1h1.25v-1z",
    fill: "#976746"
  }), React.createElement("path", {
    d: "M12.25 12H11v1h1.25v-1z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M13 12h-1v1h1v-1z",
    fill: "#AD7A54"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13278",
    x1: 7.33,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_13278",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_82689_13278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(63.43 -1.07 9.42) scale(14.1618 10.6213)"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileMinecraftColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileMinecraftColorIcon({}), 'FileMinecraftColor');
const FileMinecraftWorldColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_13480)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_13480)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_13480)"
  }), React.createElement("path", {
    d: "M8.25 7H7v1.25h1.25V7z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M9.25 7H8v1.25h1.25V7z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M10.25 7H9v1.25h1.25V7z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M11.25 7H10v1.25h1.25V7z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M12.25 7H11v1.25h1.25V7z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M13 7h-1v1.25h1V7z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M8.25 8H7v1.25h1.25V8z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M9.25 8H8v1.25h1.25V8z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M10.25 8H9v1.25h1.25V8z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M11.25 8H10v1.25h1.25V8z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M12.25 8H11v1.25h1.25V8z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M13 8h-1v1.25h1V8z",
    fill: "#86D562"
  }), React.createElement("path", {
    d: "M8.25 9H7v1.25h1.25V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M9.25 9H8v1.25h1.25V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M10.25 9H9v1.25h1.25V9z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M11.25 9H10v1.25h1.25V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M12.25 9H11v1.25h1.25V9z",
    fill: "#52A535"
  }), React.createElement("path", {
    d: "M13 9h-1v1.25h1V9z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M8.25 10H7v1.25h1.25V10z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M9.25 10H8v1.25h1.25V10z",
    fill: "#AD7A54"
  }), React.createElement("path", {
    d: "M10.25 10H9v1.25h1.25V10z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M11.25 10H10v1.25h1.25V10z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M12.25 10H11v1.25h1.25V10z",
    fill: "#6CC349"
  }), React.createElement("path", {
    d: "M13 10h-1v1.25h1V10z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M8.25 11H7v1.25h1.25V11z",
    fill: "#976746"
  }), React.createElement("path", {
    d: "M9.25 11H8v1.25h1.25V11z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M10.25 11H9v1.25h1.25V11z",
    fill: "#976746"
  }), React.createElement("path", {
    d: "M11.25 11H10v1.25h1.25V11z",
    fill: "#AD7A54"
  }), React.createElement("path", {
    d: "M12.25 11H11v1.25h1.25V11z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M13 11h-1v1.25h1V11z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M8.25 12H7v1h1.25v-1z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M9.25 12H8v1h1.25v-1z",
    fill: "#66412C"
  }), React.createElement("path", {
    d: "M10.25 12H9v1h1.25v-1z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M11.25 12H10v1h1.25v-1z",
    fill: "#976746"
  }), React.createElement("path", {
    d: "M12.25 12H11v1h1.25v-1z",
    fill: "#805539"
  }), React.createElement("path", {
    d: "M13 12h-1v1h1v-1z",
    fill: "#AD7A54"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13480",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13480",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13480",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileMinecraftWorldColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileMinecraftWorldColorIcon({}), 'FileMinecraftWorldColor');
const FileModelColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12252)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12252)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12252)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.47 6.09c-.3-.12-.64-.12-.94 0l-2.75 1.1c-.47.2-.78.65-.78 1.16v3.3c0 .5.31.97.78 1.16l2.75 1.1c.3.13.64.13.94 0l2.75-1.1c.47-.2.78-.65.78-1.16v-3.3c0-.5-.31-.97-.78-1.16l-2.75-1.1zm.03 3.66a2 2 0 00.34-.12l2.16-1v3.02c0 .1-.06.2-.16.23l-2.75 1.1a.25.25 0 01-.18 0l-2.75-1.1a.25.25 0 01-.16-.23V8.63l2.16 1a2 2 0 00.34.12v1.7a.5.5 0 101 0v-1.7z",
    fill: "url(#paint3_linear_82689_12252)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12252",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12252",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12252",
    x1: 7.14,
    y1: 3.99,
    x2: 11.84,
    y2: 13.81,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12252",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileModelColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileModelColorIcon({}), 'FileModelColor');
const FileMusicColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_11961)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_11961)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_11961)"
  }), React.createElement("path", {
    d: "M9.82 6a.25.25 0 00-.32.25v4.34a1.75 1.75 0 101 1.58V8.53l2.18.61c.16.05.32-.07.32-.24V7.66a1 1 0 00-.73-.96L9.82 6z",
    fill: "url(#paint3_linear_82689_11961)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_11961",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_11961",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_11961",
    x1: 8.84,
    y1: 6.99,
    x2: 11.64,
    y2: 13.35,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_11961",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileMusicColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileMusicColorIcon({}), 'FileMusicColor');
const FileOfficeScriptColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H5a2 2 0 01-1-3.73V4z",
    fill: "url(#paint0_linear_82689_13646)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17h6.77a2 2 0 010-2H5a1 1 0 100 2zm9 0h-.5a1 1 0 110-2 .5.5 0 100-1H5V4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1z",
    fill: "url(#paint1_linear_82689_13646)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17h6.77a2 2 0 010-2H5a1 1 0 100 2zm9 0h-.5a1 1 0 110-2 .5.5 0 100-1H5V4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1z",
    fill: "url(#paint2_radial_82689_13646)"
  }), React.createElement("path", {
    d: "M12.5 11a.5.5 0 010 1h-5a.5.5 0 010-1h5z",
    fill: "url(#paint3_linear_82689_13646)"
  }), React.createElement("path", {
    d: "M12.5 8a.5.5 0 010 1h-5a.5.5 0 010-1h5z",
    fill: "url(#paint4_linear_82689_13646)"
  }), React.createElement("path", {
    d: "M12.5 5a.5.5 0 010 1h-5a.5.5 0 010-1h5z",
    fill: "url(#paint5_linear_82689_13646)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13646",
    x1: 7.2,
    y1: 2,
    x2: 9.83,
    y2: 18.01,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13646",
    x1: 7.06,
    y1: 3,
    x2: 9.29,
    y2: 17.03,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13646",
    x1: 4.5,
    y1: -0.38,
    x2: 13.63,
    y2: 12.91,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E15C01"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DA4401"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D83B01"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13646",
    x1: 4.5,
    y1: -0.38,
    x2: 13.63,
    y2: 12.91,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E15C01"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DA4401"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D83B01"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13646",
    x1: 4.5,
    y1: -0.38,
    x2: 13.63,
    y2: 12.91,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E15C01"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DA4401"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D83B01"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13646",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.80556 11.0833 -8.70833 4.15625 7.51 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileOfficeScriptColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileOfficeScriptColorIcon({}), 'FileOfficeScriptColor');
const FileOnenoteColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_13719)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_13719)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_13719)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint3_radial_82689_13719)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint4_radial_82689_13719)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M13 13.27c0 .4-.33.73-.73.73H11v-2.5c0-.36-.08-.7-.21-1H13v2.77z",
    fill: "url(#paint5_radial_82689_13719)"
  }), React.createElement("path", {
    d: "M13 10.27c0 .4-.33.73-.73.73h-1.32a2.5 2.5 0 00-.72-1.3V7.86L13 7.75v2.52z",
    fill: "url(#paint6_linear_82689_13719)"
  }), React.createElement("path", {
    d: "M12.22 6c.43 0 .78.35.78.78v.94c0 .43-.35.78-.78.78h-.44a.78.78 0 00-.78.78v.94c0 .17-.05.32-.14.45A2.5 2.5 0 008.5 9H7V7.37C7 6.63 7.62 6 8.38 6h3.84z",
    fill: "url(#paint7_linear_82689_13719)"
  }), React.createElement("path", {
    d: "M12.22 6c.43 0 .78.35.78.78v.94c0 .43-.35.78-.78.78h-.44a.78.78 0 00-.78.78v.94c0 .17-.05.32-.14.45A2.5 2.5 0 008.5 9H7V7.37C7 6.63 7.62 6 8.38 6h3.84z",
    fill: "url(#paint8_radial_82689_13719)"
  }), React.createElement("path", {
    d: "M7.75 17H6.61l-2.06-3.09a9.96 9.96 0 01-.24-.41H4.3a9.75 9.75 0 01.01.8V17H3.25v-5h1.21l1.99 2.99a6.03 6.03 0 01.24.4h.01a4.73 4.73 0 01-.01-.68V12h1.06v5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_13719",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_13719",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#AC13EB"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#580087"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_13719",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.25625 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#841FB0",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D373FC"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_13719",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(271.898 0 0 16.3726 8 22.75)"
  }, React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A931D8"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6E1996"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_13719",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.01614 11.3369 -8.84963 -11.4959 13.43 5.17)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_13719",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13719",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13719",
    x1: 14.24,
    y1: 9.86,
    x2: 10.58,
    y2: 8.35,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CA59F7"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#691A90"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13719",
    x1: 13.27,
    y1: 9.57,
    x2: 7,
    y2: 9.57,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE66FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB1FF"
  }))));
};
export const FileOnenoteColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileOnenoteColorIcon({}), 'FileOnenoteColor');
const FileOnenoteNotebookColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H6a2 2 0 01-2-2V4z",
    fill: "url(#paint0_linear_82689_13759)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3h6a3 3 0 013 3v7a1 1 0 01-1 1H6a2 2 0 00-1 .27V4a1 1 0 011-1zM5 16a1 1 0 001 1h8a1 1 0 001-1v-1.27a2 2 0 01-1 .27H6a1 1 0 00-1 1z",
    fill: "url(#paint1_linear_82689_13759)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3h6a3 3 0 013 3v7a1 1 0 01-1 1H6a2 2 0 00-1 .27V4a1 1 0 011-1zM5 16a1 1 0 001 1h8a1 1 0 001-1v-1.27a2 2 0 01-1 .27H6a1 1 0 00-1 1z",
    fill: "url(#paint2_radial_82689_13759)"
  }), React.createElement("path", {
    d: "M13 11.27c0 .4-.33.73-.73.73H11v-.5A2.5 2.5 0 008.5 9H7.36c.26-.3.66-.5 1.1-.5H13v2.77z",
    fill: "url(#paint3_radial_82689_13759)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint4_radial_82689_13759)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint5_radial_82689_13759)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M13 8.77c0 .4-.33.73-.73.73h-2.04V6.86L13 6.75v2.02z",
    fill: "url(#paint6_linear_82689_13759)"
  }), React.createElement("path", {
    d: "M12.22 5c.43 0 .78.35.78.78v.94c0 .43-.35.78-.78.78h-.44a.78.78 0 00-.78.78v.44c0 .43-.35.78-.78.78H10c-.42-.31-.94-.5-1.5-.5H7V6.37C7 5.63 7.62 5 8.38 5h3.84z",
    fill: "url(#paint7_linear_82689_13759)"
  }), React.createElement("path", {
    d: "M12.22 5c.43 0 .78.35.78.78v.94c0 .43-.35.78-.78.78h-.44a.78.78 0 00-.78.78v.44c0 .43-.35.78-.78.78H10c-.42-.31-.94-.5-1.5-.5H7V6.37C7 5.63 7.62 5 8.38 5h3.84z",
    fill: "url(#paint8_radial_82689_13759)"
  }), React.createElement("path", {
    d: "M7.75 17H6.61l-2.06-3.09a9.96 9.96 0 01-.24-.41H4.3a9.75 9.75 0 01.01.8V17H3.25v-5h1.21l1.99 2.99a6.03 6.03 0 01.24.4h.01a4.73 4.73 0 01-.01-.68V12h1.06v5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_13759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_13759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.51467 0 0 4.67788 12.83 12)"
  }, React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A931D8"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6E1996"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_13759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#AC13EB"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#580087"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_13759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.25625 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#841FB0",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D373FC"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_13759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.01614 5.43829 -8.84963 -5.51456 13.43 4.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_13759",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13759",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13759",
    x1: 14.24,
    y1: 8.66,
    x2: 10.69,
    y2: 7.04,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CA59F7"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#691A90"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13759",
    x1: 13.27,
    y1: 6.71,
    x2: 7,
    y2: 6.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE66FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB1FF"
  }))));
};
export const FileOnenoteNotebookColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileOnenoteNotebookColorIcon({}), 'FileOnenoteNotebookColor');
const FileOnenoteSectionColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4c0-1.1.9-2 2-2h6a4 4 0 014 4v8a2 2 0 01-2 2 2 2 0 01-2 2H9a6 6 0 01-6-6V6c0-1.1.9-2 2-2z",
    fill: "url(#paint0_linear_82689_13671)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h6a3 3 0 013 3v8a1 1 0 01-1 1H9a3 3 0 01-3-3V4a1 1 0 011-1zM5 5a1 1 0 00-1 1v6a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V5z",
    fill: "url(#paint1_linear_82689_13671)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h6a3 3 0 013 3v8a1 1 0 01-1 1H9a3 3 0 01-3-3V4a1 1 0 011-1zM5 5a1 1 0 00-1 1v6a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V5z",
    fill: "url(#paint2_radial_82689_13671)"
  }), React.createElement("path", {
    d: "M14 12.27c0 .4-.33.73-.73.73H11v-1a3 3 0 00-1.34-2.5l4.34-1v3.77z",
    fill: "url(#paint3_radial_82689_13671)"
  }), React.createElement("path", {
    d: "M11.23 6.86L14 6.75v2.52c0 .4-.33.73-.73.73h-2.04V6.86z",
    fill: "url(#paint4_linear_82689_13671)"
  }), React.createElement("path", {
    d: "M13.22 5c.43 0 .78.35.78.78v.94c0 .43-.35.78-.78.78h-.44a.78.78 0 00-.78.78v.94c0 .43-.35.78-.78.78h-.99C9.68 9.39 8.9 9 8 9V6.37C8 5.63 8.62 5 9.38 5h3.84z",
    fill: "url(#paint5_linear_82689_13671)"
  }), React.createElement("path", {
    d: "M13.22 5c.43 0 .78.35.78.78v.94c0 .43-.35.78-.78.78h-.44a.78.78 0 00-.78.78v.94c0 .43-.35.78-.78.78h-.99C9.68 9.39 8.9 9 8 9V6.37C8 5.63 8.62 5 9.38 5h3.84z",
    fill: "url(#paint6_radial_82689_13671)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint7_radial_82689_13671)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint8_radial_82689_13671)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M7.75 17H6.61l-2.06-3.09a9.96 9.96 0 01-.24-.41H4.3a9.75 9.75 0 01.01.8V17H3.25v-5h1.21l1.99 2.99a6.03 6.03 0 01.24.4h.01a4.73 4.73 0 01-.01-.68V12h1.06v5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_13671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 11.0833 -9.5 4.15625 7.83 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_13671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(9.51467 0 0 4.67788 13.83 13)"
  }, React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A931D8"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6E1996"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_13671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.01614 5.43829 -8.84963 -5.51456 14.43 4.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DE67FD",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint7_radial_82689_13671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#AC13EB"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#580087"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_13671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.25625 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#841FB0",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D373FC"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_13671",
    x1: 7.52,
    y1: 2,
    x2: 9.97,
    y2: 18.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13671",
    x1: 7.33,
    y1: 3,
    x2: 9.39,
    y2: 17.09,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13671",
    x1: 15.24,
    y1: 8.66,
    x2: 11.69,
    y2: 7.04,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CA59F7"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#691A90"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13671",
    x1: 14.27,
    y1: 6.71,
    x2: 8,
    y2: 6.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE66FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB1FF"
  }))));
};
export const FileOnenoteSectionColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileOnenoteSectionColorIcon({}), 'FileOnenoteSectionColor');
const FilePdfColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_13796)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_13796)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_13796)"
  }), React.createElement("path", {
    d: "M6.5 6a.5.5 0 00-.5.5v2a.5.5 0 001 0V8c.16 0 .4-.04.6-.2.24-.16.4-.44.4-.8a.96.96 0 00-.4-.8C7.4 6.03 7.16 6 7 6h-.5z",
    fill: "#D20112"
  }), React.createElement("path", {
    d: "M9 6.5c0-.28.22-.5.5-.5h.25c.35 0 .71.11.96.43.22.3.29.68.29 1.07 0 .4-.07.78-.3 1.07-.24.32-.6.43-.95.43H9.5a.5.5 0 01-.5-.5v-2z",
    fill: "#D20112"
  }), React.createElement("path", {
    d: "M12 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-.25a.5.5 0 010 1H13v.5a.5.5 0 01-1 0v-2z",
    fill: "#D20112"
  }), React.createElement("path", {
    d: "M12.5 13a.5.5 0 010 1h-5a.5.5 0 010-1h5z",
    fill: "url(#paint3_linear_82689_13796)"
  }), React.createElement("path", {
    d: "M12.5 11a.5.5 0 010 1h-5a.5.5 0 010-1h5z",
    fill: "url(#paint4_linear_82689_13796)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13796",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13796",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13796",
    x1: 8.94,
    y1: 11,
    x2: 9.14,
    y2: 14.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#898989"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#636262"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13796",
    x1: 8.94,
    y1: 11,
    x2: 9.14,
    y2: 14.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#898989"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#636262"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13796",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePdfColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePdfColorIcon({}), 'FilePdfColor');
const FilePhotoColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12273)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12273)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12273)"
  }), React.createElement("circle", {
    cx: 13,
    cy: 7,
    r: 1,
    fill: "url(#paint3_linear_82689_12273)"
  }), React.createElement("path", {
    d: "M9.3 9.56L6.56 12.3a1 1 0 00.7 1.71h5.46a1 1 0 00.7-1.7l-2.72-2.74a1 1 0 00-1.42 0z",
    fill: "url(#paint4_linear_82689_12273)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12273",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12273",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12273",
    x1: 12,
    y1: 4.75,
    x2: 14.17,
    y2: 8.91,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12273",
    x1: 6.21,
    y1: 7.51,
    x2: 10.01,
    y2: 17.63,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePhotoColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePhotoColorIcon({}), 'FilePhotoColor');
const FilePhotoWatermarkColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12298)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12298)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12298)"
  }), React.createElement("circle", {
    cx: 13,
    cy: 7,
    r: 1,
    fill: "url(#paint3_linear_82689_12298)"
  }), React.createElement("path", {
    d: "M9.3 9.56L6.56 12.3a1 1 0 00.7 1.71h5.46a1 1 0 00.7-1.7l-2.72-2.74a1 1 0 00-1.42 0z",
    fill: "url(#paint4_linear_82689_12298)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12298",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12298",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12298",
    x1: 11.98,
    y1: 5.25,
    x2: 14.13,
    y2: 8.87,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12298",
    x1: 6.21,
    y1: 7.51,
    x2: 10.01,
    y2: 17.63,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12298",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePhotoWatermarkColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePhotoWatermarkColorIcon({}), 'FilePhotoWatermarkColor');
const FilePlannerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_13860)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_13860)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_13860)"
  }), React.createElement("path", {
    d: "M5.9 10c.38.38 1 .38 1.37 0l4.1-4.1a.96.96 0 011.36 0l1.36 1.37c.38.38.38.99 0 1.37L10 12.73a.96.96 0 01-1.36 0L5.9 10z",
    fill: "url(#paint3_linear_82689_13860)"
  }), React.createElement("path", {
    d: "M5.9 10c.38.38 1 .38 1.37 0l4.1-4.1a.96.96 0 011.36 0l1.36 1.37c.38.38.38.99 0 1.37L10 12.73a.96.96 0 01-1.36 0L5.9 10z",
    fill: "url(#paint4_linear_82689_13860)"
  }), React.createElement("path", {
    d: "M8.64 11.36a.96.96 0 01-1.37 0L5.91 10a.96.96 0 010-1.36l1.36-1.37a.96.96 0 011.37 0L10 8.64c.38.37.38.98 0 1.36l-1.36 1.36z",
    fill: "url(#paint5_linear_82689_13860)"
  }), React.createElement("path", {
    d: "M8.64 11.36a.96.96 0 01-1.37 0L5.91 10a.96.96 0 010-1.36l1.36-1.37a.96.96 0 011.37 0L10 8.64c.38.37.38.98 0 1.36l-1.36 1.36z",
    fill: "url(#paint6_linear_82689_13860)"
  }), React.createElement("path", {
    d: "M7.27 11.36c.38.38.99.38 1.37 0l2.72-2.72a.96.96 0 011.37 0L14.09 10c.38.38.38.99 0 1.36l-2.73 2.73a.96.96 0 01-1.36 0l-2.73-2.73z",
    fill: "url(#paint7_linear_82689_13860)"
  }), React.createElement("path", {
    d: "M7.27 11.36c.38.38.99.38 1.37 0l2.72-2.72a.96.96 0 011.37 0L14.09 10c.38.38.38.99 0 1.36l-2.73 2.73a.96.96 0 01-1.36 0l-2.73-2.73z",
    fill: "url(#paint8_linear_82689_13860)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13860",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13860",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13860",
    x1: 12.32,
    y1: 5.62,
    x2: 9.22,
    y2: 13.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6C0F71"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13860",
    x1: 12.32,
    y1: 5.62,
    x2: 9.22,
    y2: 13.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A829AE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8F28B3"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13860",
    x1: 7.95,
    y1: 6.99,
    x2: 6.41,
    y2: 10.28,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8752E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#541278"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13860",
    x1: 8.68,
    y1: 9.66,
    x2: 7.43,
    y2: 8.43,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3D0D59"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7034B0",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13860",
    x1: 12.19,
    y1: 8.36,
    x2: 10.73,
    y2: 14.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00479E"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_13860",
    x1: 12.27,
    y1: 8.52,
    x2: 9.46,
    y2: 13.99,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4A40D4"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13860",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePlannerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePlannerColorIcon({}), 'FilePlannerColor');
const FilePlannerPortfolioColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5c0-1.1.9-2 2-2h6a4 4 0 014 4v6a2 2 0 01-2 2 2 2 0 01-2 2H9a6 6 0 01-6-6V7c0-1.1.9-2 2-2z",
    fill: "url(#paint0_linear_82689_13890)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4h6a3 3 0 013 3v6a1 1 0 01-1 1H9a3 3 0 01-3-3V5a1 1 0 011-1zM5 6a1 1 0 00-1 1v4a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V6z",
    fill: "url(#paint1_linear_82689_13890)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4h6a3 3 0 013 3v6a1 1 0 01-1 1H9a3 3 0 01-3-3V5a1 1 0 011-1zM5 6a1 1 0 00-1 1v4a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V6z",
    fill: "url(#paint2_radial_82689_13890)"
  }), React.createElement("path", {
    d: "M8.13 9c.27.26.7.26.96 0l2.86-2.86c.27-.27.7-.27.96 0l.95.95c.27.26.27.7 0 .96L11 10.9a.68.68 0 01-.96 0L8.14 9z",
    fill: "url(#paint3_linear_82689_13890)"
  }), React.createElement("path", {
    d: "M8.13 9c.27.26.7.26.96 0l2.86-2.86c.27-.27.7-.27.96 0l.95.95c.27.26.27.7 0 .96L11 10.9a.68.68 0 01-.96 0L8.14 9z",
    fill: "url(#paint4_linear_82689_13890)"
  }), React.createElement("path", {
    d: "M10.05 9.96a.68.68 0 01-.96 0L8.14 9a.68.68 0 010-.95l.95-.96c.26-.26.7-.26.96 0l.95.96c.26.26.26.69 0 .95l-.95.96z",
    fill: "url(#paint5_linear_82689_13890)"
  }), React.createElement("path", {
    d: "M10.05 9.96a.68.68 0 01-.96 0L8.14 9a.68.68 0 010-.95l.95-.96c.26-.26.7-.26.96 0l.95.96c.26.26.26.69 0 .95l-.95.96z",
    fill: "url(#paint6_linear_82689_13890)"
  }), React.createElement("path", {
    d: "M9.09 9.96c.26.26.7.26.95 0l1.91-1.91c.27-.27.7-.27.96 0l.95.95c.27.26.27.7 0 .96l-1.9 1.9a.68.68 0 01-.96 0l-1.91-1.9z",
    fill: "url(#paint7_linear_82689_13890)"
  }), React.createElement("path", {
    d: "M9.09 9.96c.26.26.7.26.95 0l1.91-1.91c.27-.27.7-.27.96 0l.95.95c.27.26.27.7 0 .96l-1.9 1.9a.68.68 0 01-.96 0l-1.91-1.9z",
    fill: "url(#paint8_linear_82689_13890)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13890",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13890",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13890",
    x1: 12.63,
    y1: 5.94,
    x2: 10.45,
    y2: 11.15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6C0F71"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13890",
    x1: 12.63,
    y1: 5.94,
    x2: 10.45,
    y2: 11.15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A829AE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8F28B3"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13890",
    x1: 9.57,
    y1: 6.89,
    x2: 8.49,
    y2: 9.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8752E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#541278"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13890",
    x1: 10.08,
    y1: 8.76,
    x2: 9.2,
    y2: 7.9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3D0D59"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7034B0",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13890",
    x1: 12.53,
    y1: 7.85,
    x2: 11.51,
    y2: 12.06,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00479E"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_13890",
    x1: 12.59,
    y1: 7.96,
    x2: 10.62,
    y2: 11.79,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4A40D4"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePlannerPortfolioColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePlannerPortfolioColorIcon({}), 'FilePlannerPortfolioColor');
const FilePowerBiColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_13941)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_13941)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_13941)"
  }), React.createElement("path", {
    d: "M13 6.67v6.66c0 .37-.3.67-.67.67H10V6.67c0-.37.3-.67.67-.67h1.66c.37 0 .67.3.67.67z",
    fill: "url(#paint3_linear_82689_13941)"
  }), React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.56c0-.31-.28-.56-.64-.56l-2.31.24v5.52l2.68.24h.27V8.56z",
    fill: "#000",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M11 8.67V14H8V8.67c0-.37.3-.67.67-.67h1.66c.37 0 .67.3.67.67z",
    fill: "url(#paint4_linear_82689_13941)"
  }), React.createElement("path", {
    d: "M6 10.67v2.66c0 .37.3.67.67.67H9v-3.33c0-.37-.3-.67-.67-.67H6.67c-.37 0-.67.3-.67.67z",
    fill: "url(#paint5_linear_82689_13941)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13941",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13941",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13941",
    x1: 9.5,
    y1: 6,
    x2: 12.39,
    y2: 13.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E6AD10"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C87E0E"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13941",
    x1: 8,
    y1: 8,
    x2: 10.75,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F6D751"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD10"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13941",
    x1: 6,
    y1: 10,
    x2: 7.47,
    y2: 14.03,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F9E589"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D751"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13941",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePowerBiColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePowerBiColorIcon({}), 'FilePowerBiColor');
const FilePowerBiProjectColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_13979)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_13979)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_13979)"
  }), React.createElement("path", {
    d: "M13 7a1 1 0 011 1v1H6V8a1 1 0 011-1h6z",
    fill: "url(#paint3_linear_82689_13979)"
  }), React.createElement("path", {
    d: "M8.5 7.5a.5.5 0 110 1 .5.5 0 010-1z",
    fill: "#FEF4DD"
  }), React.createElement("path", {
    d: "M10.5 7.5a.5.5 0 110 1 .5.5 0 010-1z",
    fill: "#FEF4DD"
  }), React.createElement("path", {
    d: "M12.5 7.5a.5.5 0 110 1 .5.5 0 010-1z",
    fill: "#FEF4DD"
  }), React.createElement("path", {
    d: "M14 12a1 1 0 01-1 1H9v-2.5C9 9.67 8.33 9 7.5 9H6V8h8v4z",
    fill: "url(#paint4_linear_82689_13979)"
  }), React.createElement("path", {
    d: "M8 10.67v7.66c0 .37-.3.67-.67.67H5v-8.33c0-.37.3-.67.67-.67h1.66c.37 0 .67.3.67.67z",
    fill: "url(#paint5_linear_82689_13979)"
  }), React.createElement("path", {
    d: "M6 13.17V19H3v-5.83c0-.37.3-.67.67-.67h1.66c.37 0 .67.3.67.67z",
    fill: "url(#paint6_linear_82689_13979)"
  }), React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 13.06c0-.31-.28-.56-.64-.56l-2.31.24v6.02l2.68.24h.27v-5.94z",
    fill: "#000",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M1 15.67v2.66c0 .37.3.67.67.67H4v-3.33c0-.37-.3-.67-.67-.67H1.67c-.37 0-.67.3-.67.67z",
    fill: "url(#paint7_linear_82689_13979)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13979",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13979",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13979",
    x1: 10,
    y1: 7,
    x2: 10.25,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F2C661"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA300"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_13979",
    x1: 10,
    y1: 8,
    x2: 10.35,
    y2: 13.01,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F9E2AE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C661"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_13979",
    x1: 4.5,
    y1: 11,
    x2: 7.39,
    y2: 18.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E6AD10"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C87E0E"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_13979",
    x1: 3,
    y1: 13,
    x2: 5.75,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F6D751"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD10"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_13979",
    x1: 1,
    y1: 15,
    x2: 2.47,
    y2: 19.03,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#F9E589"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D751"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13979",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePowerBiProjectColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePowerBiProjectColorIcon({}), 'FilePowerBiProjectColor');
const FilePowerpointColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14026)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14026)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14026)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 011 7.88V11.5A2.5 2.5 0 008.5 9H6.13A4 4 0 0110 6z",
    fill: "url(#paint3_linear_82689_14026)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 011 7.88V11.5A2.5 2.5 0 008.5 9H6.13A4 4 0 0110 6z",
    fill: "url(#paint4_radial_82689_14026)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 011 7.88V11.5A2.5 2.5 0 008.5 9H6.13A4 4 0 0110 6z",
    fill: "url(#paint5_radial_82689_14026)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M10 6a4 4 0 013.46 6l.06-.13c.4-.88-.25-1.87-1.21-1.87h-1.6a.71.71 0 01-.25-.05 2.51 2.51 0 00-.41-.41.71.71 0 01-.05-.26V7.69c0-.96-1-1.6-1.88-1.21L8 6.53A3.98 3.98 0 0110 6z",
    fill: "url(#paint6_radial_82689_14026)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 013.46 6l.06-.13c.4-.88-.25-1.87-1.21-1.87h-1.6a.71.71 0 01-.25-.05 2.51 2.51 0 00-.41-.41.71.71 0 01-.05-.26V7.69c0-.96-1-1.6-1.88-1.21L8 6.53A3.98 3.98 0 0110 6z",
    fill: "url(#paint7_radial_82689_14026)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint8_radial_82689_14026)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint9_radial_82689_14026)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M4.8 15.37V17H3.67v-5h1.74c.63 0 1.1.14 1.43.4.33.28.49.68.49 1.22 0 .55-.18.98-.55 1.29-.37.3-.86.46-1.48.46h-.5zm0-2.5v1.64h.47c.28 0 .5-.08.65-.22.15-.15.22-.36.22-.63 0-.26-.07-.45-.22-.59-.15-.14-.36-.2-.63-.2h-.5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_14026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_14026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.83785 5.77014 -11.509 -9.71191 11.09 8.36)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AA1D2D"
  }), React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D12B18",
    stopOpacity: 0.44
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF3C00",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_14026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.28873 -3.30376 7.09277 12.6715 2.69 13.37)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FF66FB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3D01",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.65362 -4.18262 3.89947 3.24575 9.56 10.55)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FD6EF9"
  }), React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F94"
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCC479"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_82689_14026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.4127 2.79632 -6.3265 -.8897 9.2 6.53)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF8D13"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF7F29",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_14026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    stopColor: "#F8193E"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#920616"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_82689_14026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17188 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFB055",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FFF2BE"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_14026",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14026",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14026",
    x1: 8.7,
    y1: 5.74,
    x2: 3.75,
    y2: 11.35,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FF7F48"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#E5495B"
  }))));
};
export const FilePowerpointColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePowerpointColorIcon({}), 'FilePowerpointColor');
const FilePowerpointSlideshowColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14062)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14062)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14062)"
  }), React.createElement("path", {
    d: "M13 10a2 2 0 01-1.8 1.99L11 12v-.5A2.5 2.5 0 008.5 9H7V6.5h6V10z",
    fill: "url(#paint3_linear_82689_14062)"
  }), React.createElement("path", {
    d: "M6 6.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z",
    fill: "#D9D9D9"
  }), React.createElement("path", {
    d: "M6 6.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z",
    fill: "url(#paint4_linear_82689_14062)"
  }), React.createElement("path", {
    d: "M6 6.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z",
    fill: "url(#paint5_linear_82689_14062)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint6_radial_82689_14062)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint7_radial_82689_14062)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M11.5 13a.5.5 0 110 1H11v-1h.5z",
    fill: "url(#paint8_linear_82689_14062)"
  }), React.createElement("path", {
    d: "M4.8 15.37V17H3.67v-5h1.74c.63 0 1.1.14 1.43.4.33.28.5.68.5 1.22 0 .55-.2.98-.56 1.29-.37.3-.86.46-1.47.46H4.8zm0-2.5v1.64h.47c.28 0 .5-.08.65-.22.15-.15.22-.36.22-.63 0-.26-.07-.45-.22-.59-.15-.14-.36-.2-.63-.2H4.8z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14062",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14062",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14062",
    x1: 12,
    y1: 6.5,
    x2: 9.14,
    y2: 13.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFA05C"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDB567"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_14062",
    x1: 8.29,
    y1: 8,
    x2: 7.85,
    y2: 3.74,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C64925"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F6B"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_14062",
    x1: 8.86,
    y1: 4,
    x2: 9.74,
    y2: 8.55,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF7F48"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5495B"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#AA1D2D"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_14062",
    x1: -10.23,
    y1: -30.61,
    x2: 2.67,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FA734C"
  }), React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E5495B"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AA1D2D"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    stopColor: "#F8193E"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#920616"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_82689_14062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17188 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFB055",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FFF2BE"
  }))));
};
export const FilePowerpointSlideshowColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePowerpointSlideshowColorIcon({}), 'FilePowerpointSlideshowColor');
const FilePowerpointTemplateColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14101)"
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint1_radial_82689_14101)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 00-1 1v1.5a.5.5 0 01-1 0V6c0-1.1.9-2 2-2h1.25a.5.5 0 010 1H4zm3.25-.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5zm5 0c0-.28.22-.5.5-.5H14c.54 0 1.06.1 1.53.3a.5.5 0 11-.38.93A2.99 2.99 0 0014 5h-1.25a.5.5 0 01-.5-.5zm4.8 1.7a.5.5 0 01.65.27c.2.47.3.99.3 1.53v1.5a.5.5 0 01-1 0V8c0-.4-.08-.8-.23-1.15a.5.5 0 01.27-.65zM2.5 10c.28 0 .5.22.5.5V12c0 .4.08.8.23 1.15a.5.5 0 01-.93.38c-.2-.47-.3-.99-.3-1.53v-1.5c0-.28.22-.5.5-.5zm15 2c.28 0 .5.22.5.5V14a2 2 0 01-2 2h-1.25a.5.5 0 010-1H16a1 1 0 001-1v-1.5c0-.28.22-.5.5-.5zM4.2 15.04a.5.5 0 01.65-.27c.35.15.74.23 1.15.23h1.25a.5.5 0 010 1H6a4 4 0 01-1.53-.3.5.5 0 01-.27-.66zm5.05.46c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5z",
    fill: "url(#paint2_linear_82689_14101)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 011 7.88V11.5A2.5 2.5 0 008.5 9H6.12A4 4 0 0110 6z",
    fill: "url(#paint3_linear_82689_14101)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 011 7.88V11.5A2.5 2.5 0 008.5 9H6.12A4 4 0 0110 6z",
    fill: "url(#paint4_radial_82689_14101)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 011 7.88V11.5A2.5 2.5 0 008.5 9H6.12A4 4 0 0110 6z",
    fill: "url(#paint5_radial_82689_14101)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M10 6a4 4 0 013.46 6l.06-.13c.4-.88-.25-1.87-1.21-1.87h-1.6a.71.71 0 01-.25-.05 2.51 2.51 0 00-.41-.41.71.71 0 01-.05-.26V7.69c0-.96-1-1.6-1.88-1.21L8 6.53A3.98 3.98 0 0110 6z",
    fill: "url(#paint6_radial_82689_14101)"
  }), React.createElement("path", {
    d: "M10 6a4 4 0 013.46 6l.06-.13c.4-.88-.25-1.87-1.21-1.87h-1.6a.71.71 0 01-.25-.05 2.51 2.51 0 00-.41-.41.71.71 0 01-.05-.26V7.69c0-.96-1-1.6-1.88-1.21L8 6.53A3.98 3.98 0 0110 6z",
    fill: "url(#paint7_radial_82689_14101)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint8_radial_82689_14101)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint9_radial_82689_14101)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M4.8 15.37V17H3.67v-5h1.74c.63 0 1.1.14 1.43.4.33.28.5.68.5 1.22 0 .55-.2.98-.56 1.29-.37.3-.86.46-1.47.46H4.8zm0-2.5v1.64h.47c.28 0 .5-.08.65-.22.15-.15.22-.36.22-.63 0-.26-.07-.45-.22-.59-.15-.14-.36-.2-.63-.2H4.8z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_82689_14101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.44444 9.5 -12.6667 3.5625 7.11 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_14101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-6.83785 5.77014 -11.509 -9.71191 11.09 8.36)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AA1D2D"
  }), React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D12B18",
    stopOpacity: 0.44
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF3C00",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_14101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.28873 -3.30376 7.09277 12.6715 2.69 13.37)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FF66FB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3D01",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.65362 -4.18262 3.89947 3.24575 9.56 10.55)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FD6EF9"
  }), React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F94"
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCC479"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_82689_14101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.4127 2.79632 -6.3265 -.8897 9.2 6.53)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF8D13"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF7F29",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_14101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    stopColor: "#F8193E"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#920616"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_82689_14101",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17188 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFB055",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FFF2BE"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_14101",
    x1: 6.44,
    y1: 4,
    x2: 7.59,
    y2: 16.23,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_14101",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14101",
    x1: 8.69,
    y1: 5.74,
    x2: 3.75,
    y2: 11.35,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FF7F48"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#E5495B"
  }))));
};
export const FilePowerpointTemplateColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePowerpointTemplateColorIcon({}), 'FilePowerpointTemplateColor');
const FilePresentationColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12322)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12322)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12322)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6a4 4 0 100 8 4 4 0 000-8zm0 1a3 3 0 103 3h-2a1 1 0 01-1-1V7z",
    fill: "url(#paint3_linear_82689_12322)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12322",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12322",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12322",
    x1: 8.45,
    y1: 7,
    x2: 10.76,
    y2: 13.9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12322",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePresentationColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePresentationColorIcon({}), 'FilePresentationColor');
const FileProjectColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14137)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14137)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14137)"
  }), React.createElement("path", {
    d: "M10 6a1 1 0 011 1v2l-1.1.44C9.5 9.16 9.03 9 8.5 9H6V7a1 1 0 011-1h3z",
    fill: "#33C481"
  }), React.createElement("path", {
    d: "M12 9a1 1 0 011 1v1l-2 .8v-.3A2.5 2.5 0 008.5 9H12z",
    fill: "#21A366"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#107C41"
  }), React.createElement("path", {
    d: "M13 11a1 1 0 011 1v1a1 1 0 01-1 1h-2v-2.5c0-.17-.02-.34-.05-.5H13z",
    fill: "#185C37"
  }), React.createElement("path", {
    d: "M4.8 15.37V17H3.67v-5h1.74c.63 0 1.1.14 1.43.4.32.28.49.68.49 1.22 0 .55-.19.98-.55 1.29-.37.3-.86.46-1.48.46h-.5zm0-2.5v1.64h.47c.28 0 .5-.08.64-.22.16-.15.23-.36.23-.63 0-.26-.07-.45-.22-.59-.15-.14-.36-.2-.63-.2h-.5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14137",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14137",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14137",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileProjectColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileProjectColorIcon({}), 'FileProjectColor');
const FileProjectTemplateColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14177)"
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint1_radial_82689_14177)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 00-1 1v1.5a.5.5 0 01-1 0V6c0-1.1.9-2 2-2h1.25a.5.5 0 010 1H4zm3.25-.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5zm5 0c0-.28.22-.5.5-.5H14c.54 0 1.06.1 1.53.3a.5.5 0 11-.38.93A2.99 2.99 0 0014 5h-1.25a.5.5 0 01-.5-.5zm4.8 1.7a.5.5 0 01.65.27c.2.47.3.99.3 1.53v1.5a.5.5 0 01-1 0V8c0-.4-.08-.8-.23-1.15a.5.5 0 01.27-.65zM2.5 10c.28 0 .5.22.5.5V12c0 .4.08.8.23 1.15a.5.5 0 01-.93.38c-.2-.47-.3-.99-.3-1.53v-1.5c0-.28.22-.5.5-.5zm15 2c.28 0 .5.22.5.5V14a2 2 0 01-2 2h-1.25a.5.5 0 010-1H16a1 1 0 001-1v-1.5c0-.28.22-.5.5-.5zM4.2 15.04a.5.5 0 01.65-.27c.35.15.74.23 1.15.23h1.25a.5.5 0 010 1H6a4 4 0 01-1.53-.3.5.5 0 01-.27-.66zm5.05.46c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5z",
    fill: "url(#paint2_linear_82689_14177)"
  }), React.createElement("path", {
    d: "M10 6a1 1 0 011 1v2l-1.1.44C9.5 9.16 9.03 9 8.5 9H6V7a1 1 0 011-1h3z",
    fill: "#33C481"
  }), React.createElement("path", {
    d: "M12 9a1 1 0 011 1v1l-2 .8v-.3A2.5 2.5 0 008.5 9H12z",
    fill: "#21A366"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#107C41"
  }), React.createElement("path", {
    d: "M13 11a1 1 0 011 1v1a1 1 0 01-1 1h-2v-2.5c0-.17-.02-.34-.05-.5H13z",
    fill: "#185C37"
  }), React.createElement("path", {
    d: "M4.8 15.37V17H3.67v-5h1.74c.63 0 1.1.14 1.43.4.33.28.49.68.49 1.22 0 .55-.18.98-.55 1.29-.37.3-.86.46-1.48.46h-.5zm0-2.5v1.64h.47c.28 0 .5-.08.65-.22.15-.15.22-.36.22-.63 0-.26-.07-.45-.22-.59-.15-.14-.36-.2-.63-.2h-.5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14177",
    x1: 6.44,
    y1: 4,
    x2: 7.59,
    y2: 16.23,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_14177",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_82689_14177",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.44444 9.5 -12.6667 3.5625 7.11 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileProjectTemplateColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileProjectTemplateColorIcon({}), 'FileProjectTemplateColor');
const FilePublisherColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_14220)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_14220)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_14220)"
  }), React.createElement("path", {
    d: "M12.46 7c.3 0 .54.24.54.54v4.92c0 .3-.24.54-.54.54H11v-1.5c0-.82-.4-1.54-1-2V7.54c0-.3.24-.54.54-.54h1.92z",
    fill: "#038387"
  }), React.createElement("path", {
    d: "M11.5 6c.28 0 .5.22.5.5V10h-1.5a2.5 2.5 0 00-2-1H7V6.5c0-.28.22-.5.5-.5h4z",
    fill: "#37C6D0"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M12.5 7v6H12V7h.5z",
    fill: "#000"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#038387"
  }), React.createElement("path", {
    d: "M12 10v2h-1v-.5c0-.56-.19-1.08-.5-1.5H12z",
    fill: "#1A9BA1"
  }), React.createElement("path", {
    d: "M4.8 15.37V17H3.67v-5h1.74c.63 0 1.1.14 1.43.4.33.28.49.68.49 1.22 0 .55-.18.98-.55 1.29-.37.3-.86.46-1.48.46h-.5zm0-2.5v1.64h.47c.28 0 .5-.08.65-.22.15-.15.22-.36.22-.63 0-.26-.07-.45-.22-.59-.15-.14-.36-.2-.63-.2h-.5z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M12 13.5a.5.5 0 01-.5.5H11v-2h1v1.5z",
    fill: "#038387"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14220",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14220",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FilePublisherColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilePublisherColorIcon({}), 'FilePublisherColor');
const FileRtfColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12342)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12342)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12342)"
  }), React.createElement("path", {
    d: "M8.97 6.34a.5.5 0 00-.94 0l-1 3a.5.5 0 00.47.66h2a.5.5 0 00.47-.66l-1-3z",
    fill: "url(#paint3_linear_82689_12342)"
  }), React.createElement("path", {
    d: "M11.5 7a.5.5 0 000 1h1a.5.5 0 100-1h-1z",
    fill: "url(#paint4_linear_82689_12342)"
  }), React.createElement("path", {
    d: "M11.5 9a.5.5 0 000 1h1a.5.5 0 100-1h-1z",
    fill: "url(#paint5_linear_82689_12342)"
  }), React.createElement("path", {
    d: "M7.5 11a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: "url(#paint6_linear_82689_12342)"
  }), React.createElement("path", {
    d: "M7.5 13a.5.5 0 000 1h1a.5.5 0 000-1h-1z",
    fill: "url(#paint7_linear_82689_12342)"
  }), React.createElement("path", {
    d: "M10.5 11a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2z",
    fill: "url(#paint8_linear_82689_12342)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12342",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12342",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12342",
    x1: 7,
    y1: 3,
    x2: 12.75,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12342",
    x1: 7,
    y1: 3,
    x2: 12.75,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12342",
    x1: 7,
    y1: 3,
    x2: 12.75,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_12342",
    x1: 7,
    y1: 3,
    x2: 12.75,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_12342",
    x1: 7,
    y1: 3,
    x2: 12.75,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_82689_12342",
    x1: 7,
    y1: 3,
    x2: 12.75,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12342",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileRtfColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileRtfColorIcon({}), 'FileRtfColor');
const FileSharepointColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14268)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14268)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14268)"
  }), React.createElement("path", {
    d: "M9.5 6a2.5 2.5 0 011.33 4.61A2.5 2.5 0 008.5 9H7.05A2.51 2.51 0 019.5 6z",
    fill: "url(#paint3_linear_82689_14268)"
  }), React.createElement("path", {
    d: "M9.5 6a2.5 2.5 0 011.33 4.61A2.5 2.5 0 008.5 9H7.05A2.51 2.51 0 019.5 6z",
    fill: "url(#paint4_radial_82689_14268)",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M9.5 6a2.5 2.5 0 011.33 4.61A2.5 2.5 0 008.5 9H7.05A2.51 2.51 0 019.5 6z",
    fill: "url(#paint5_radial_82689_14268)",
    fillOpacity: 0.31
  }), React.createElement("path", {
    d: "M9.5 6a2.5 2.5 0 011.33 4.61A2.5 2.5 0 008.5 9H7.05A2.51 2.51 0 019.5 6z",
    fill: "url(#paint6_radial_82689_14268)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M11.5 8.5a2 2 0 11-.5 3.93v-.93a2.5 2.5 0 00-1.16-2.11 2 2 0 011.66-.89z",
    fill: "url(#paint7_linear_82689_14268)"
  }), React.createElement("path", {
    d: "M11.5 8.5a2 2 0 11-.5 3.93v-.93a2.5 2.5 0 00-1.16-2.11 2 2 0 011.66-.89z",
    fill: "url(#paint8_radial_82689_14268)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M11.5 8.5a2 2 0 11-.5 3.93v-.93a2.5 2.5 0 00-1.16-2.11 2 2 0 011.66-.89z",
    fill: "url(#paint9_radial_82689_14268)",
    fillOpacity: 0.7
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint10_radial_82689_14268)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint11_radial_82689_14268)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M10.96 11.08A1.68 1.68 0 0111 13.5V11.5c0-.14-.01-.28-.04-.42z",
    fill: "url(#paint12_linear_82689_14268)"
  }), React.createElement("path", {
    d: "M10.96 11.08A1.68 1.68 0 0111 13.5V11.5c0-.14-.01-.28-.04-.42z",
    fill: "url(#paint13_linear_82689_14268)",
    fillOpacity: 0.32
  }), React.createElement("path", {
    d: "M3.61 15.97l.95-.48c.11.2.25.36.42.46.18.1.37.15.57.15.23 0 .41-.05.53-.14.12-.09.18-.23.18-.41a.46.46 0 00-.17-.37c-.12-.1-.32-.17-.62-.22-.56-.1-.97-.28-1.23-.52a1.24 1.24 0 01-.38-.93c0-.46.17-.82.5-1.1.34-.27.78-.41 1.33-.41.37 0 .7.07.98.22s.5.35.67.63l-.93.46c-.1-.15-.21-.26-.33-.33a.87.87 0 00-.45-.1.76.76 0 00-.49.13c-.1.09-.16.2-.16.35 0 .12.05.23.16.33.1.09.32.16.64.22.54.1.94.28 1.2.54.27.26.4.59.4.98 0 .49-.15.87-.47 1.15a2 2 0 01-1.37.42c-.42 0-.81-.09-1.16-.27-.34-.18-.6-.44-.77-.76z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.63009 -4.27808 7.09384 -3.17785 10.07 12.86)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.29,
    stopColor: "#003B5D"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#004A6C",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#006F94",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.35343 -3.6207 5.99643 -2.63526 10.17 11.53)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.26,
    stopColor: "#002A42"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#004261",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#006F94",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.70505 2.69531 -2.48579 -1.84876 10.8 6.32)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#78EDFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2CCFCA",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.33166 -2.33333 6.89045 1.46395 8.34 12.17)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#004A5D"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00556C",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#007A86",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint9_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.0103 1.78822 -2.93082 -1.22657 12.1 8.71)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#78EDFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2CCFCA",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint10_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00B6BD"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00495C"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_82689_14268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17187 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1E8581",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1ECBE6"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_14268",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14268",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14268",
    x1: 7.13,
    y1: 6.75,
    x2: 11.23,
    y2: 11.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00E3DF"
  }), React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0097A8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#007791"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_14268",
    x1: 7.76,
    y1: 9,
    x2: 9.88,
    y2: 13.55,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00E0D9"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#009FB8"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#056475"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_82689_14268",
    x1: -110.18,
    y1: 9.37,
    x2: -109.99,
    y2: 17.61,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#75FFF6"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C7D1"
  }), React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0096AD"
  })), React.createElement("linearGradient", {
    id: "paint13_linear_82689_14268",
    x1: 11.17,
    y1: 15.64,
    x2: 11.05,
    y2: 11.91,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0E5A5D"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#126C6B",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1C948A",
    stopOpacity: 0
  }))));
};
export const FileSharepointColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileSharepointColorIcon({}), 'FileSharepointColor');
const FileSharepointDocumentSetColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4c0-1.1.9-2 2-2h6a4 4 0 014 4v8a2 2 0 01-2 2 2 2 0 01-2 2H9a6 6 0 01-6-6V6c0-1.1.9-2 2-2z",
    fill: "url(#paint0_linear_82689_12041)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h6a3 3 0 013 3v8a1 1 0 01-1 1H9a3 3 0 01-3-3V4a1 1 0 011-1zM5 5a1 1 0 00-1 1v6a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V5z",
    fill: "url(#paint1_linear_82689_12041)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h6a3 3 0 013 3v8a1 1 0 01-1 1H9a3 3 0 01-3-3V4a1 1 0 011-1zM5 5a1 1 0 00-1 1v6a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V5z",
    fill: "url(#paint2_radial_82689_12041)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5c.44 0 .9.1 1.28.3.38.22.72.6.72 1.15 0 .2-.03.4-.1.56a1.2 1.2 0 01-.32.42c-.08.08-.08.08-.1.13v.12l.04.36A16.67 16.67 0 0012.9 10h.1a1 1 0 011 1v1a1 1 0 01-1 1H9a1 1 0 01-1-1v-1a1 1 0 011-1h.14a21.1 21.1 0 00.36-1.87 3.68 3.68 0 00.01-.55c0-.02-.03-.03-.17-.19-.08-.09-.18-.2-.24-.38-.07-.16-.1-.35-.1-.56 0-.56.34-.94.72-1.15.38-.22.85-.3 1.28-.3zm0 1c-.32 0-.6.06-.79.17-.17.1-.21.19-.21.28 0 .11.02.17.03.2 0 .02.02.04.05.07l.02.02c.07.07.29.28.38.56.04.15.05.3.05.45l-.03.49a13.1 13.1 0 01-.33 1.76h1.7a32.8 32.8 0 01-.34-1.83 5.49 5.49 0 01-.04-.44c0-.12 0-.27.02-.4.08-.34.29-.54.39-.63a1.16 1.16 0 00.08-.1c0-.01.02-.05.02-.15 0-.07-.03-.17-.21-.27a1.7 1.7 0 00-.8-.18z",
    fill: "url(#paint3_linear_82689_12041)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12041",
    x1: 7.52,
    y1: 2,
    x2: 9.97,
    y2: 18.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12041",
    x1: 7.33,
    y1: 3,
    x2: 9.39,
    y2: 17.09,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12041",
    x1: 9.37,
    y1: 4.08,
    x2: 14.18,
    y2: 12.98,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 11.0833 -9.5 4.15625 7.83 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileSharepointDocumentSetColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileSharepointDocumentSetColorIcon({}), 'FileSharepointDocumentSetColor');
const FileSharepointNewsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14308)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14308)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14308)"
  }), React.createElement("path", {
    d: "M13 8a1 1 0 011 1v2.75c0 .6-.43 1.1-1 1.22l-.25.03V8H13z",
    fill: "url(#paint3_linear_82689_14308)"
  }), React.createElement("path", {
    d: "M12 7a1 1 0 011 1v4.97c-.08.02-.16.03-.25.03H11v-1.5A2.5 2.5 0 008.5 9H6V8a1 1 0 011-1h5z",
    fill: "url(#paint4_linear_82689_14308)"
  }), React.createElement("path", {
    d: "M11.75 11a.25.25 0 110 .5H11c0-.17-.02-.34-.05-.5h.8z",
    fill: "#028298"
  }), React.createElement("path", {
    d: "M11.75 9.5a.25.25 0 110 .5H10.5c-.12-.16-.26-.3-.42-.43.05-.05.1-.07.17-.07h1.5z",
    fill: "#028298"
  }), React.createElement("path", {
    d: "M11.25 8a.25.25 0 110 .5h-3.5a.25.25 0 010-.5h3.5z",
    fill: "#028298"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint5_radial_82689_14308)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint6_radial_82689_14308)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M3.61 15.97l.95-.48c.11.2.25.36.42.46.18.1.37.15.57.15.23 0 .41-.05.53-.14.12-.09.18-.23.18-.41a.46.46 0 00-.17-.37c-.12-.1-.32-.17-.62-.22-.56-.1-.97-.28-1.23-.52a1.24 1.24 0 01-.38-.93c0-.46.17-.82.5-1.1.34-.27.78-.41 1.33-.41.37 0 .7.07.98.22s.5.35.67.63l-.93.46c-.1-.15-.21-.26-.33-.33a.87.87 0 00-.45-.1.76.76 0 00-.49.13c-.1.09-.16.2-.16.35 0 .12.05.23.16.33.1.09.32.16.64.22.54.1.94.28 1.2.54.27.26.4.59.4.98 0 .49-.15.87-.47 1.15a2 2 0 01-1.37.42c-.42 0-.81-.09-1.16-.27-.34-.18-.6-.44-.77-.76z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14308",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14308",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14308",
    x1: 12.83,
    y1: 4.67,
    x2: 15.65,
    y2: 14.19,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00E3DF"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0097A8"
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#007791"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_14308",
    x1: 7.94,
    y1: 7,
    x2: 8.6,
    y2: 13.1,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#86F2F2"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#37C6D0"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_14308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00B6BD"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00495C"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17187 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1E8581",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1ECBE6"
  }))));
};
export const FileSharepointNewsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileSharepointNewsColorIcon({}), 'FileSharepointNewsColor');
const FileSharepointSiteColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14351)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14351)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14351)"
  }), React.createElement("path", {
    d: "M14 12a1 1 0 01-1 1h-2v-1.5A2.5 2.5 0 008.5 9H6V8h8v4z",
    fill: "url(#paint3_linear_82689_14351)"
  }), React.createElement("path", {
    d: "M13 7a1 1 0 011 1v1H6V8a1 1 0 011-1h6z",
    fill: "url(#paint4_linear_82689_14351)"
  }), React.createElement("path", {
    d: "M13 8a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: "#BCFCFF"
  }), React.createElement("path", {
    d: "M11 8a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: "#BCFCFF"
  }), React.createElement("path", {
    d: "M9 8a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: "#BCFCFF"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint5_radial_82689_14351)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint6_radial_82689_14351)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M3.61 15.97l.95-.48c.11.2.25.36.42.46.18.1.37.15.57.15.23 0 .41-.05.53-.14.12-.09.18-.23.18-.41a.46.46 0 00-.17-.37c-.12-.1-.32-.17-.62-.22-.56-.1-.97-.28-1.23-.52a1.24 1.24 0 01-.38-.93c0-.46.17-.82.5-1.1.34-.27.78-.41 1.33-.41.37 0 .7.07.98.22s.5.35.67.63l-.93.46c-.1-.15-.21-.26-.33-.33a.87.87 0 00-.45-.1.76.76 0 00-.49.13c-.1.09-.16.2-.16.35 0 .12.05.23.16.33.1.09.32.16.64.22.54.1.94.28 1.2.54.27.26.4.59.4.98 0 .49-.15.87-.47 1.15a2 2 0 01-1.37.42c-.42 0-.81-.09-1.16-.27-.34-.18-.6-.44-.77-.76z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14351",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14351",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14351",
    x1: 11.5,
    y1: 7.36,
    x2: 14.92,
    y2: 15.7,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#75FFF6"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C7D1"
  }), React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0096AD"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_14351",
    x1: 10.56,
    y1: 2,
    x2: 17.44,
    y2: 14.01,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00E3DF"
  }), React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0097A8"
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#007791"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14351",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_14351",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00B6BD"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00495C"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14351",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17187 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1E8581",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1ECBE6"
  }))));
};
export const FileSharepointSiteColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileSharepointSiteColorIcon({}), 'FileSharepointSiteColor');
const FileSpreadsheetColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12362)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12362)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12362)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.5C6 7.67 6.67 7 7.5 7h5.02c.83 0 1.5.67 1.5 1.5v3.01c0 .83-.67 1.5-1.5 1.5H7.5a1.5 1.5 0 01-1.5-1.5V8.5zm4.51 3.51h2.01a.5.5 0 00.5-.5v-1h-2.5V12zm-1-1.5V12H7.5a.5.5 0 01-.5-.5v-1h2.51zm1-1h2.51V8.5a.5.5 0 00-.5-.5h-2v1.5zM9.51 8v1.5H7v-1c0-.28.22-.5.5-.5h2.01z",
    fill: "url(#paint3_linear_82689_12362)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12362",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12362",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12362",
    x1: 7.75,
    y1: 6.25,
    x2: 10.48,
    y2: 13.01,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12362",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileSpreadsheetColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileSpreadsheetColorIcon({}), 'FileSpreadsheetColor');
const FileSwayColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14387)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14387)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14387)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 6a.75.75 0 010 1.5H13V10a2 2 0 01-2 2h-.5v1h1l.1.01a.5.5 0 010 .98l-.1.01h-3a.5.5 0 010-1h1v-1H9a2 2 0 01-2-2V7.5h-.25a.75.75 0 010-1.5h6.5zM8 7.5V10a1 1 0 001 1h2a1 1 0 001-1V7.5H8z",
    fill: "url(#paint3_linear_82689_14387)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14387",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14387",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14387",
    x1: 7.6,
    y1: 4.4,
    x2: 12.31,
    y2: 12.99,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileSwayColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileSwayColorIcon({}), 'FileSwayColor');
const FileSystemColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12382)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12382)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12382)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14 13.9a.46.46 0 01-.35-.42l-.03-.5a.5.5 0 00-.72-.41l-.44.22a.46.46 0 01-.55-.1 4.01 4.01 0 01-.86-1.48c-.06-.2.02-.4.2-.52l.4-.27a.5.5 0 000-.84l-.4-.27a.46.46 0 01-.2-.52 4.02 4.02 0 01.86-1.49.46.46 0 01.55-.09l.44.22a.5.5 0 00.72-.41l.03-.5c.01-.2.15-.38.35-.43a4.01 4.01 0 011.72 0c.2.05.34.23.35.43l.03.5c.03.35.4.57.72.41l.45-.22c.18-.09.4-.06.55.1a4.01 4.01 0 01.85 1.48c.07.2-.02.4-.2.52l-.4.27a.5.5 0 000 .84l.4.27c.18.11.27.32.2.52a4.01 4.01 0 01-.85 1.49.46.46 0 01-.55.09l-.45-.22a.5.5 0 00-.72.41l-.03.5a.46.46 0 01-.35.43 4.01 4.01 0 01-1.72 0zM10 11a1 1 0 100-2 1 1 0 000 2z",
    fill: "url(#paint3_linear_82689_12382)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12382",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12382",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12382",
    x1: 8.52,
    y1: 7,
    x2: 10.9,
    y2: 13.84,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12382",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileSystemColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileSystemColorIcon({}), 'FileSystemColor');
const FileTextColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12402)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12402)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12402)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 3c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: "url(#paint3_linear_82689_12402)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12402",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12402",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12402",
    x1: 8.84,
    y1: 6.88,
    x2: 11.11,
    y2: 12.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12402",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileTextColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileTextColorIcon({}), 'FileTextColor');
const FileToDoColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_14408)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_14408)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_14408)"
  }), React.createElement("path", {
    d: "M13.7 8.46l-.91-.97a.47.47 0 00-.68 0l-1.26 1.26-1.6 1.65L8 11.66c-.2.2-.2.48 0 .68l.92.92c.2.19.49.19.68 0L10.85 12l1.6-1.6 1.26-1.26c.19-.2.19-.53 0-.68z",
    fill: "url(#paint3_linear_82689_14408)"
  }), React.createElement("path", {
    d: "M7.26 9.14l-.92.92c-.19.2-.19.49 0 .68L8 12.34l1.6-1.6-1.6-1.6a.53.53 0 00-.73 0z",
    fill: "#185ABD"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14408",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14408",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14408",
    x1: 10.75,
    y1: 5.67,
    x2: 6.17,
    y2: 10.42,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#62C4F6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2A88E5"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14408",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileToDoColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileToDoColorIcon({}), 'FileToDoColor');
const FileVaultClosedColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("rect", {
    x: 2,
    y: 4,
    width: 16,
    height: 12,
    rx: 3,
    fill: "url(#paint0_linear_82689_12430)"
  }), React.createElement("path", {
    d: "M15 5a2 2 0 012 2v6a2 2 0 01-1.8 1.99L15 15H5l-.2-.01A2 2 0 013 13.2L3 13V7c0-1.1.9-2 2-2h10zM5 5.5c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h10c.83 0 1.5-.67 1.5-1.5V7c0-.83-.67-1.5-1.5-1.5H5zM5.5 7c.28 0 .5.22.5.5v5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zm8.15.65a.5.5 0 11.7.7l-.63.64a1.99 1.99 0 010 2.02l.63.64a.5.5 0 11-.7.7l-.64-.63a1.99 1.99 0 01-2.02 0l-.64.63a.5.5 0 11-.7-.7l.63-.64a1.99 1.99 0 010-2.02l-.63-.64a.5.5 0 11.7-.7l.64.63a1.99 1.99 0 012.02 0l.64-.63zM12 9a1 1 0 100 2 1 1 0 000-2z",
    fill: "url(#paint1_linear_82689_12430)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12430",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#CAD3D8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9AA6AD"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12430",
    x1: 7.52,
    y1: 5,
    x2: 8.49,
    y2: 15.19,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#4D565C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#394146"
  }))));
};
export const FileVaultClosedColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVaultClosedColorIcon({}), 'FileVaultClosedColor');
const FileVaultOpenColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("rect", {
    x: 2,
    y: 4,
    width: 16,
    height: 12,
    rx: 3,
    fill: "url(#paint0_linear_82689_12482)"
  }), React.createElement("rect", {
    x: 3,
    y: 5,
    width: 14,
    height: 10,
    rx: 2,
    fill: "url(#paint1_linear_82689_12482)"
  }), React.createElement("rect", {
    x: 3,
    y: 5,
    width: 14,
    height: 10,
    rx: 2,
    fill: "url(#paint2_linear_82689_12482)",
    fillOpacity: 0.28
  }), React.createElement("path", {
    d: "M7 6.75c0-.41.34-.75.75-.75h3.75c.83 0 1.5.67 1.5 1.5v5.75c0 .41-.34.75-.75.75H8.5A1.5 1.5 0 017 12.5V6.75z",
    fill: "url(#paint3_linear_82689_12482)"
  }), React.createElement("path", {
    d: "M7 6.75c0-.41.34-.75.75-.75h3.75c.83 0 1.5.67 1.5 1.5v5.75c0 .41-.34.75-.75.75H8.5A1.5 1.5 0 017 12.5V6.75z",
    fill: "url(#paint4_radial_82689_12482)"
  }), React.createElement("rect", {
    x: 16,
    y: 5,
    width: 1,
    height: 10,
    rx: 0.5,
    fill: "url(#paint5_linear_82689_12482)"
  }), React.createElement("path", {
    d: "M15 7a1 1 0 011-1v8a1 1 0 01-1-1V7z",
    fill: "url(#paint6_linear_82689_12482)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12482",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#CAD3D8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9AA6AD"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12482",
    x1: 7.52,
    y1: 5,
    x2: 8.49,
    y2: 15.19,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#626C72"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4D565C"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_12482",
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", null), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5C666C",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12482",
    x1: 8.67,
    y1: 6,
    x2: 10,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12482",
    x1: 16.38,
    y1: 5,
    x2: 20.64,
    y2: 7.05,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#EEF0F2"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CED0"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82689_12482",
    x1: 15.5,
    y1: 6,
    x2: 15.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#CAD1D6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#929CA2"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82689_12482",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.16667 6.33333 -4.75 2.375 8.92 8.08)"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVaultOpenColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVaultOpenColorIcon({}), 'FileVaultOpenColor');
const FileVectorColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_12514)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_12514)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_12514)"
  }), React.createElement("path", {
    d: "M6 6.25c0-.14.11-.25.25-.25h1.5c.14 0 .25.11.25.25v.25h4.13a1 1 0 110 1h-1.4c.3.21.6.44.86.7 1.06.99 1.91 2.36 1.91 3.8h.25c.14 0 .25.11.25.25v1.5c0 .14-.11.25-.25.25h-1.5a.25.25 0 01-.25-.25v-1.5c0-.14.11-.25.25-.25h.25c0-1.06-.65-2.19-1.6-3.07C9.97 8.03 8.83 7.5 8 7.5v.25c0 .14-.11.25-.25.25h-1.5A.25.25 0 016 7.75v-1.5z",
    fill: "url(#paint3_linear_82689_12514)"
  }), React.createElement("path", {
    d: "M8.47 9.32a.5.5 0 00-.94 0l-1.5 4a.5.5 0 00.7.63L8 13.3l1.28.64a.5.5 0 00.69-.63l-1.5-4z",
    fill: "url(#paint4_linear_82689_12514)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12514",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12514",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12514",
    x1: 7.14,
    y1: 4.29,
    x2: 10.87,
    y2: 13.85,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12514",
    x1: 7.14,
    y1: 4.29,
    x2: 10.87,
    y2: 13.85,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12514",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVectorColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVectorColorIcon({}), 'FileVectorColor');
const FileVideoColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12534)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12534)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12534)"
  }), React.createElement("path", {
    d: "M8.42 6.13C7.8 5.76 7 6.23 7 7v6c0 .76.79 1.24 1.42.87l5.1-3c.64-.38.64-1.36 0-1.74l-5.1-3z",
    fill: "url(#paint3_linear_82689_12534)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12534",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12534",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12534",
    x1: 10.5,
    y1: 12.04,
    x2: 9.51,
    y2: 7.54,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#892FFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A966FF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12534",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVideoColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVideoColorIcon({}), 'FileVideoColor');
const FileVideoPlaylistColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5c0-1.1.9-2 2-2h6a4 4 0 014 4v6a2 2 0 01-2 2 2 2 0 01-2 2H9a6 6 0 01-6-6V7c0-1.1.9-2 2-2z",
    fill: "url(#paint0_linear_82689_13918)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4h6a3 3 0 013 3v6a1 1 0 01-1 1H9a3 3 0 01-3-3V5a1 1 0 011-1zM5 6a1 1 0 00-1 1v4a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V6z",
    fill: "url(#paint1_linear_82689_13918)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4h6a3 3 0 013 3v6a1 1 0 01-1 1H9a3 3 0 01-3-3V5a1 1 0 011-1zM5 6a1 1 0 00-1 1v4a5 5 0 005 5h4a1 1 0 001-1H9a4 4 0 01-4-4V6z",
    fill: "url(#paint2_radial_82689_13918)"
  }), React.createElement("path", {
    d: "M10 6.1c-.45-.28-1 .07-1 .63v4.54c0 .56.55.91 1 .63l3.66-2.27a.76.76 0 000-1.26L10 6.1z",
    fill: "url(#paint3_linear_82689_13918)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_13918",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_13918",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_13918",
    x1: 11.5,
    y1: 10.53,
    x2: 10.72,
    y2: 7.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#892FFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#A966FF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_13918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVideoPlaylistColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVideoPlaylistColorIcon({}), 'FileVideoPlaylistColor');
const FileVideoWatermarkColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h8a4 4 0 014 4v8a2 2 0 01-2 2H7a4 4 0 01-4-4V5z",
    fill: "url(#paint0_linear_82689_12554)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint1_linear_82689_12554)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 011-1h8a3 3 0 013 3v8a1 1 0 01-1 1H7a3 3 0 01-3-3V5z",
    fill: "url(#paint2_radial_82689_12554)"
  }), React.createElement("path", {
    d: "M8.42 6.13C7.8 5.76 7 6.23 7 7v6c0 .76.79 1.24 1.42.87l5.1-3c.64-.38.64-1.36 0-1.74l-5.1-3z",
    fill: "url(#paint3_linear_82689_12554)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12554",
    x1: 7.52,
    y1: 3,
    x2: 9.41,
    y2: 17.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12554",
    x1: 7.33,
    y1: 4,
    x2: 8.85,
    y2: 16.14,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12554",
    x1: 10.5,
    y1: 12.04,
    x2: 9.51,
    y2: 7.54,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#969696"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(6.33333 9.5 -9.5 3.5625 7.83 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVideoWatermarkColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVideoWatermarkColorIcon({}), 'FileVideoWatermarkColor');
const FileVisioColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14436)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14436)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14436)"
  }), React.createElement("path", {
    d: "M12.5 8c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5H11v-.5a2.5 2.5 0 00-2-2.45V8.5c0-.28.22-.5.5-.5h3z",
    fill: "#2B7CD3"
  }), React.createElement("path", {
    d: "M8.65 6.15c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7L9.82 9.38A2.49 2.49 0 008.5 9h-.7l-.65-.65a.5.5 0 010-.7l1.5-1.5z",
    fill: "#41A5EE"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M7.85 12l-1.72 5H4.85l-1.7-5h1.2l1.06 3.36a2.84 2.84 0 01.1.4h.02a16.7 16.7 0 00.1-.41L6.7 12h1.16z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14436",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14436",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14436",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVisioColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVisioColorIcon({}), 'FileVisioColor');
const FileVisioShapeStencilColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14514)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_14514)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_14514)"
  }), React.createElement("path", {
    d: "M9 7c.28 0 .5.22.5.5V9a.5.5 0 01-.04.2A2.5 2.5 0 008.5 9H6V7.5c0-.28.22-.5.5-.5H9z",
    fill: "url(#paint3_linear_82689_14514)"
  }), React.createElement("path", {
    d: "M10.5 7.5c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5V9a.5.5 0 01-.5.5H11a.5.5 0 01-.5-.5V7.5z",
    fill: "url(#paint4_linear_82689_14514)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M10.5 11c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H11a.5.5 0 01-.5-.5V11z",
    fill: "url(#paint5_linear_82689_14514)"
  }), React.createElement("path", {
    d: "M7.85 12l-1.72 5H4.85l-1.7-5h1.2l1.06 3.36a2.84 2.84 0 01.1.4h.02a16.7 16.7 0 00.1-.41L6.7 12h1.16z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14514",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14514",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_14514",
    x1: 8.87,
    y1: 7,
    x2: 8.87,
    y2: 7.12,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#50D9FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_14514",
    x1: 12.5,
    y1: 7,
    x2: 12.5,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#28A8EA"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1490DF"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_14514",
    x1: 12.5,
    y1: 11,
    x2: 12.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2B7CD3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1D59C1"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_14514",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVisioShapeStencilColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVisioShapeStencilColorIcon({}), 'FileVisioShapeStencilColor');
const FileVisioTemplateColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_14475)"
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint1_radial_82689_14475)"
  }), React.createElement("path", {
    d: "M4 5a1 1 0 00-1 1v1.5a.5.5 0 01-1 0V6c0-1.1.9-2 2-2h1.25a.5.5 0 010 1H4zm3.25-.5c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5zm5 0c0-.28.22-.5.5-.5H14c.54 0 1.06.1 1.53.3a.5.5 0 11-.38.93A2.99 2.99 0 0014 5h-1.25a.5.5 0 01-.5-.5zm4.8 1.7a.5.5 0 01.65.27c.2.47.3.99.3 1.53v1.5a.5.5 0 01-1 0V8c0-.4-.08-.8-.23-1.15a.5.5 0 01.27-.65zM2.5 10c.28 0 .5.22.5.5V12c0 .4.08.8.23 1.15a.5.5 0 01-.93.38c-.2-.47-.3-.99-.3-1.53v-1.5c0-.28.22-.5.5-.5zm15 2c.28 0 .5.22.5.5V14a2 2 0 01-2 2h-1.25a.5.5 0 010-1H16a1 1 0 001-1v-1.5c0-.28.22-.5.5-.5zM4.2 15.04a.5.5 0 01.65-.27c.35.15.74.23 1.15.23h1.25a.5.5 0 010 1H6a4 4 0 01-1.53-.3.5.5 0 01-.27-.66zm5.05.46c0-.28.22-.5.5-.5h2.5a.5.5 0 010 1h-2.5a.5.5 0 01-.5-.5z",
    fill: "url(#paint2_linear_82689_14475)"
  }), React.createElement("path", {
    d: "M12.5 8c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5H11v-.5a2.5 2.5 0 00-2-2.45V8.5c0-.28.22-.5.5-.5h3z",
    fill: "#2B7CD3"
  }), React.createElement("path", {
    d: "M8.65 6.15c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7L9.82 9.38A2.49 2.49 0 008.5 9h-.7l-.65-.65a.5.5 0 010-.7l1.5-1.5z",
    fill: "#41A5EE"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M7.85 12l-1.72 5H4.85l-1.7-5h1.2l1.06 3.36a2.84 2.84 0 01.1.4h.02a16.7 16.7 0 00.1-.41L6.7 12h1.16z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_14475",
    x1: 6.44,
    y1: 4,
    x2: 7.59,
    y2: 16.23,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_14475",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_82689_14475",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.44444 9.5 -12.6667 3.5625 7.11 7.13)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileVisioTemplateColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileVisioTemplateColorIcon({}), 'FileVisioTemplateColor');
const FileWebPageColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12162)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12162)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12162)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10a4 4 0 118 0 4 4 0 01-8 0zm1.04-.5A3 3 0 018.6 7.35c-.28.58-.5 1.32-.57 2.15h-.98zm0 1a3 3 0 001.55 2.15 6.18 6.18 0 01-.57-2.15h-.98zm1.98 0c.07.68.26 1.3.5 1.75a2.73 2.73 0 00.48.71l.08-.07c.12-.14.27-.35.4-.64.24-.46.43-1.07.5-1.75H9.02zm2.96 0c-.07.83-.3 1.57-.57 2.15a3 3 0 001.55-2.15h-.98zm.98-1h-.98a6.19 6.19 0 00-.57-2.15 3 3 0 011.55 2.15zm-1.98 0H9.02c.07-.68.26-1.3.5-1.75a2.73 2.73 0 01.48-.71 2.73 2.73 0 01.49.7c.23.47.42 1.08.49 1.76z",
    fill: "url(#paint3_linear_82689_12162)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12162",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12162",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12162",
    x1: 8.45,
    y1: 7,
    x2: 10.76,
    y2: 13.9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileWebPageColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileWebPageColorIcon({}), 'FileWebPageColor');
const FileWhiteboardColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12578)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12578)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12578)"
  }), React.createElement("path", {
    d: "M13.5 7h-7a.5.5 0 00-.5.5v5c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5z",
    fill: "url(#paint3_linear_82689_12578)"
  }), React.createElement("path", {
    d: "M10.72 10.07c-.08-.06-.14 0-.14 0a.94.94 0 01-.89.2.87.87 0 01-.34-.24c-.08-.1-.55-.68-.73-.85-.18-.17-.42-.3-.68-.33-.25-.04-.5 0-.72.13-.21.12-.37.3-.45.5 0 0-.03.07.04.13.06.04.13-.01.13-.01a.94.94 0 01.89-.2c.13.04.23.12.34.23.08.1.55.69.73.86.18.16.42.3.68.33.25.03.5-.01.72-.13.2-.12.37-.3.45-.51 0 0 .03-.07-.03-.12z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M11.12 9.79l-.3.23c-.06.04-.15-.02-.14-.09l.08-.37.36.23z",
    fill: "#1E2021"
  }), React.createElement("path", {
    d: "M10.86 8.93l-.01.03-.08.36-.08.33c-.01.03 0 .06.02.07l.29.18.07-.01.27-.21.29-.23.01-.02-.25-.42-.53-.07z",
    fill: "#CCC"
  }), React.createElement("path", {
    d: "M11.65 9.42l1.84-2.9c.02-.02.01-.05-.02-.08A2.5 2.5 0 0012.8 6a.07.07 0 00-.09.02l-1.84 2.89-.01.01.78.5.01-.02z",
    fill: "#333"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12578",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12578",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12578",
    x1: 12.99,
    y1: 15.18,
    x2: 8.58,
    y2: 7.54,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#30E5D0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0C34FB"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12578",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileWhiteboardColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileWhiteboardColorIcon({}), 'FileWhiteboardColor');
const FileWordColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_14554)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint1_linear_82689_14554)"
  }), React.createElement("path", {
    d: "M5 4a1 1 0 011-1h6a3 3 0 013 3v10a1 1 0 01-1 1H8a3 3 0 01-3-3V4z",
    fill: "url(#paint2_radial_82689_14554)"
  }), React.createElement("path", {
    d: "M13 10.75v2.52c0 .4-.33.73-.73.73H11v-2.5a2.5 2.5 0 00-1.8-2.4l.59-.77L13 10.75z",
    fill: "url(#paint3_radial_82689_14554)"
  }), React.createElement("path", {
    d: "M13 10.6c0 .4-.33.73-.73.73h-1.28A2.5 2.5 0 008.5 9H7.07c.14-.35.47-.6.87-.6l4.43-.02L13 8v2.6z",
    fill: "url(#paint4_linear_82689_14554)"
  }), React.createElement("path", {
    d: "M13 10.6c0 .4-.33.73-.73.73h-1.28A2.5 2.5 0 008.5 9H7.07c.14-.35.47-.6.87-.6l4.43-.02L13 8v2.6z",
    fill: "url(#paint5_radial_82689_14554)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M13 10.6c0 .4-.33.73-.73.73h-1.28A2.5 2.5 0 008.5 9H7.07c.14-.35.47-.6.87-.6l4.43-.02L13 8v2.6z",
    fill: "url(#paint6_radial_82689_14554)",
    fillOpacity: 0.1
  }), React.createElement("path", {
    d: "M12.27 6c.4 0 .73.33.73.73v1.2c0 .4-.33.74-.73.74H8.18c-.32 0-.6.12-.82.33H7V7.26C7 6.56 7.56 6 8.26 6h4z",
    fill: "url(#paint7_linear_82689_14554)"
  }), React.createElement("path", {
    d: "M12.27 6c.4 0 .73.33.73.73v1.2c0 .4-.33.74-.73.74H8.18c-.32 0-.6.12-.82.33H7V7.26C7 6.56 7.56 6 8.26 6h4z",
    fill: "url(#paint8_radial_82689_14554)",
    fillOpacity: 0.8
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint9_radial_82689_14554)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint10_radial_82689_14554)",
    fillOpacity: 0.65
  }), React.createElement("path", {
    d: "M8.5 12l-1.08 5H6.14l-.64-3-.67 3h-1.3L2.5 12h1.06l.64 3.3.63-3.3h1.3l.67 3.3.62-3.3H8.5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_82689_14554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.27778 11.0833 -7.91667 4.15625 8.2 6.65)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_14554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.0151 0 0 7.85818 12.49 18.47)"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1657F4"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0036C4"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_14554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.0831 8.63058 -8.97491 -23.5949 12.97 8.99)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D471FF"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#509DF5",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 7.54839 -20.5153 0 12.09 14.88)"
  }, React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4F006F",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4F006F"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_14554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.66748 2.31567 -3.55138 -23.5937 12.97 6.93)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E4A7FE"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E4A7FE",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint9_radial_82689_14554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.08,
    stopColor: "#367AF2"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#001A8F"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_82689_14554",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.1803 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2763E5",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#58AAFE"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_14554",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_14554",
    x1: 7.78,
    y1: 3,
    x2: 10.22,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_14554",
    x1: 6.92,
    y1: 13.16,
    x2: 11.56,
    y2: 13.16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#66C0FF"
  }), React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0094F0"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_82689_14554",
    x1: 7.05,
    y1: 9.84,
    x2: 12.97,
    y2: 9.89,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9DEAFF"
  }), React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3BD5FF"
  }))));
};
export const FileWordColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileWordColorIcon({}), 'FileWordColor');
const FileWordTemplateColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint0_linear_82689_14594)"
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h6a4 4 0 014 4v10a2 2 0 01-2 2H8a4 4 0 01-4-4V4z",
    fill: "url(#paint1_radial_82689_14594)"
  }), React.createElement("path", {
    d: "M6.2 17.04a.5.5 0 01.65-.27A3 3 0 008 17h1.5a.5.5 0 010 1H8a4 4 0 01-1.53-.3.5.5 0 01-.27-.66zM15 16v-1.25a.5.5 0 011 0V16a2 2 0 01-2 2h-1.5a.5.5 0 010-1H14a1 1 0 001-1zM4 14v-1.25a.5.5 0 011 0V14c0 .4.08.8.23 1.15a.5.5 0 01-.93.38c-.2-.47-.3-.99-.3-1.53zm11-1.75v-2.5a.5.5 0 011 0v2.5a.5.5 0 01-1 0zm-11-2v-2.5a.5.5 0 011 0v2.5a.5.5 0 01-1 0zm11-3V6a3 3 0 00-.23-1.15.5.5 0 01.93-.38c.2.47.3.99.3 1.53v1.25a.5.5 0 01-1 0zm-11-2V4c0-1.1.9-2 2-2h1.5a.5.5 0 010 1H6a1 1 0 00-1 1v1.25a.5.5 0 01-1 0zM12 2c.54 0 1.06.1 1.53.3a.5.5 0 01-.38.93A2.99 2.99 0 0012 3h-1.5a.5.5 0 010-1H12z",
    fill: "url(#paint2_linear_82689_14594)"
  }), React.createElement("path", {
    d: "M13 10.75v2.52c0 .4-.33.73-.73.73H11v-2.5a2.5 2.5 0 00-1.8-2.4l.59-.77L13 10.75z",
    fill: "url(#paint3_radial_82689_14594)"
  }), React.createElement("path", {
    d: "M13 10.6c0 .4-.33.73-.73.73h-1.28A2.5 2.5 0 008.5 9H7.07c.14-.35.47-.6.87-.6l4.43-.02L13 8v2.6z",
    fill: "url(#paint4_linear_82689_14594)"
  }), React.createElement("path", {
    d: "M13 10.6c0 .4-.33.73-.73.73h-1.28A2.5 2.5 0 008.5 9H7.07c.14-.35.47-.6.87-.6l4.43-.02L13 8v2.6z",
    fill: "url(#paint5_radial_82689_14594)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M13 10.6c0 .4-.33.73-.73.73h-1.28A2.5 2.5 0 008.5 9H7.07c.14-.35.47-.6.87-.6l4.43-.02L13 8v2.6z",
    fill: "url(#paint6_radial_82689_14594)",
    fillOpacity: 0.1
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint7_radial_82689_14594)"
  }), React.createElement("rect", {
    x: 1,
    y: 10,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint8_radial_82689_14594)",
    fillOpacity: 0.65
  }), React.createElement("path", {
    d: "M8.5 12l-1.08 5H6.14l-.64-3-.67 3h-1.3L2.5 12h1.06l.64 3.3.63-3.3h1.3l.67 3.3.62-3.3H8.5z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M12.27 6c.4 0 .73.33.73.73v1.2c0 .4-.33.74-.73.74H8.18c-.32 0-.6.12-.82.33H7V7.26C7 6.56 7.56 6 8.26 6h4z",
    fill: "url(#paint9_linear_82689_14594)"
  }), React.createElement("path", {
    d: "M12.27 6c.4 0 .73.33.73.73v1.2c0 .4-.33.74-.73.74H8.18c-.32 0-.6.12-.82.33H7V7.26C7 6.56 7.56 6 8.26 6h4z",
    fill: "url(#paint10_radial_82689_14594)",
    fillOpacity: 0.8
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_82689_14594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(63.43 -1.07 9.42) scale(14.1618 10.6213)"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_82689_14594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(24.0151 0 0 7.85818 12.49 18.47)"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1657F4"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0036C4"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82689_14594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.0831 8.63058 -8.97491 -23.5949 12.97 8.99)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D471FF"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#509DF5",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_82689_14594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 7.54839 -20.5153 0 12.09 14.88)"
  }, React.createElement("stop", {
    offset: 0.28,
    stopColor: "#4F006F",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4F006F"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_82689_14594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -11.57 6.2) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.08,
    stopColor: "#367AF2"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#001A8F"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_82689_14594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.1803 0 5.5 15.4)"
  }, React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2763E5",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#58AAFE"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_82689_14594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.66748 2.31567 -3.55138 -23.5937 12.97 6.93)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E4A7FE"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E4A7FE",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_82689_14594",
    x1: 7.33,
    y1: 2,
    x2: 10,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82689_14594",
    x1: 7.88,
    y1: 2,
    x2: 10.71,
    y2: 17.94,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_14594",
    x1: 6.92,
    y1: 13.16,
    x2: 11.56,
    y2: 13.16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#66C0FF"
  }), React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0094F0"
  })), React.createElement("linearGradient", {
    id: "paint9_linear_82689_14594",
    x1: 7.05,
    y1: 9.84,
    x2: 12.97,
    y2: 9.89,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9DEAFF"
  }), React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3BD5FF"
  }))));
};
export const FileWordTemplateColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileWordTemplateColorIcon({}), 'FileWordTemplateColor');
const FileXmlColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h10a4 4 0 014 4v6a2 2 0 01-2 2H6a4 4 0 01-4-4V6z",
    fill: "url(#paint0_linear_82689_12614)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint1_linear_82689_12614)"
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h10a3 3 0 013 3v6a1 1 0 01-1 1H6a3 3 0 01-3-3V6z",
    fill: "url(#paint2_radial_82689_12614)"
  }), React.createElement("path", {
    d: "M9.39 7.01a.5.5 0 01.56.27l.55 1.1.55-1.1a.5.5 0 01.95.22v4a.5.5 0 11-1 0V9.62l-.05.1a.5.5 0 01-.9 0l-.05-.1v1.88a.5.5 0 11-1 0v-4a.5.5 0 01.39-.49z",
    fill: "url(#paint3_linear_82689_12614)"
  }), React.createElement("path", {
    d: "M13.5 7c.28 0 .5.22.5.5V11h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-4c0-.28.22-.5.5-.5z",
    fill: "url(#paint4_linear_82689_12614)"
  }), React.createElement("path", {
    d: "M5.95 7.28a.5.5 0 10-.9.44l.9 1.78-.9 1.78a.5.5 0 10.9.44l.55-1.1.55 1.1a.5.5 0 10.9-.44l-.9-1.78.9-1.78a.5.5 0 10-.9-.44l-.55 1.1-.55-1.1z",
    fill: "url(#paint5_linear_82689_12614)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82689_12614",
    x1: 7.17,
    y1: 4,
    x2: 8.39,
    y2: 16.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BBB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82689_12614",
    x1: 6.89,
    y1: 5,
    x2: 7.8,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82689_12614",
    x1: 5.98,
    y1: 4.92,
    x2: 8.16,
    y2: 12.75,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82689_12614",
    x1: 5.98,
    y1: 4.92,
    x2: 8.16,
    y2: 12.75,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82689_12614",
    x1: 5.98,
    y1: 4.92,
    x2: 8.16,
    y2: 12.75,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#597493"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2F56"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_82689_12614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.38889 7.91667 -11.0833 2.96875 7.47 7.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  }))));
};
export const FileXmlColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FileXmlColorIcon({}), 'FileXmlColor');
const FilesTaskbarColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 6.33C14 5.6 14.6 5 15.33 5h1.34C17.4 5 18 5.6 18 6.33v8.34c0 .73-.6 1.33-1.33 1.33h-1.34c-.73 0-1.33-.6-1.33-1.33V6.33z",
    fill: "url(#paint0_linear_74711_27152)"
  }), React.createElement("path", {
    d: "M14 6.33C14 5.6 14.6 5 15.33 5h1.34C17.4 5 18 5.6 18 6.33v8.34c0 .73-.6 1.33-1.33 1.33h-1.34c-.73 0-1.33-.6-1.33-1.33V6.33z",
    fill: "url(#paint1_linear_74711_27152)"
  }), React.createElement("path", {
    d: "M14 6.33C14 5.6 14.6 5 15.33 5h1.34C17.4 5 18 5.6 18 6.33v8.34c0 .73-.6 1.33-1.33 1.33h-1.34c-.73 0-1.33-.6-1.33-1.33V6.33z",
    fill: "url(#paint2_linear_74711_27152)"
  }), React.createElement("path", {
    d: "M4 3.33C4 2.6 4.6 2 5.33 2h8.34C14.4 2 15 2.6 15 3.33v11.34c0 .73.6 1.33 1.33 1.33h.17H5.33C4.6 16 4 15.4 4 14.67V3.33z",
    fill: "url(#paint3_linear_74711_27152)"
  }), React.createElement("path", {
    d: "M4 3.33C4 2.6 4.6 2 5.33 2h8.34C14.4 2 15 2.6 15 3.33v11.34c0 .73.6 1.33 1.33 1.33h.17H5.33C4.6 16 4 15.4 4 14.67V3.33z",
    fill: "url(#paint4_radial_74711_27152)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M4 3.33C4 2.6 4.6 2 5.33 2h8.34C14.4 2 15 2.6 15 3.33v11.34c0 .73.6 1.33 1.33 1.33h.17H5.33C4.6 16 4 15.4 4 14.67V3.33z",
    fill: "url(#paint5_linear_74711_27152)"
  }), React.createElement("path", {
    d: "M12.26 11a.67.67 0 010 1.33H7.33a.67.67 0 110-1.33h4.93zm.07-3a.67.67 0 010 1.33H6.67a.67.67 0 110-1.33h5.66zm0-3a.67.67 0 010 1.33H6.6A.67.67 0 116.6 5h5.73z",
    fill: "url(#paint6_linear_74711_27152)"
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.37l1.5 1.5-.47.46-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "#D7257D"
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.37l1.5 1.5-.47.46-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "url(#paint7_radial_74711_27152)",
    fillOpacity: 0.9
  }), React.createElement("path", {
    d: "M7.33 13.33a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "url(#paint8_linear_74711_27152)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_74711_27152",
    x1: 14.25,
    y1: 4.04,
    x2: 13.65,
    y2: 15.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FF9C70"
  }), React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FB5B6C"
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D7257D"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#85148A"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_74711_27152",
    x1: 17.67,
    y1: 9,
    x2: 13.67,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FB5B6C",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CA2134"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_74711_27152",
    x1: 15.67,
    y1: 10,
    x2: 16.94,
    y2: 15.36,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E82C41",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9F1459"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_74711_27152",
    x1: 8.36,
    y1: 3.33,
    x2: 17.28,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFE06B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB500"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_74711_27152",
    x1: 9.04,
    y1: 2,
    x2: 8.46,
    y2: 15.98,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFE06B"
  }), React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDCF40"
  }), React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FAB500"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921F"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_74711_27152",
    x1: 6.6,
    y1: 3.33,
    x2: 10.66,
    y2: 16.04,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF921F"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CA6407"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_74711_27152",
    x1: 3.83,
    y1: 12.08,
    x2: 6.58,
    y2: 14.84,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9DEAFF"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_74711_27152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.18848 12.87946 -11.51093 7.3184 3.43 .4)"
  }, React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFF2BE"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFF2BE",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint7_radial_74711_27152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.65 -9.3 7.12) scale(8.22531 6.0126)"
  }, React.createElement("stop", {
    stopColor: "#FE8401"
  }), React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FE8401",
    stopOpacity: 0
  }))));
};
export const FilesTaskbarColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilesTaskbarColorIcon({}), 'FilesTaskbarColor');
const FilesTaskbarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 9.5c.84 0 1.6.3 2.21.79l.03.02c.16.13.31.28.45.45l.02.02A3.5 3.5 0 018.37 15c-.09.13-.19.25-.3.37l1.78 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.29 16a3.5 3.5 0 01-4.78-4.82A3.5 3.5 0 015.5 9.5zm6-7.5c1.2 0 2.22.86 2.45 2h1.55c1.3 0 2.36.98 2.49 2.24l.01.26v7a2.5 2.5 0 01-2.24 2.48l-.26.02h-5.38l-.73-.73.14-.27h3.97c-.31-.42-.5-.94-.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-5C5.67 3 5 3.67 5 4.5v4.03c-.35.04-.68.11-1 .23V4.5A2.5 2.5 0 016.5 2h5zm-6 8.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm5.6.5a.5.5 0 010 .99H9.9c-.08-.34-.2-.68-.36-1H11l.1.02zM11 8a.5.5 0 010 1H7.56c-.33-.17-.68-.3-1.05-.38A.5.5 0 017 8h4zm0-3a.5.5 0 010 1H7a.5.5 0 010-1h4z",
    fill: primaryFill
  }));
};
export const FilesTaskbarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilesTaskbarFilledIcon({}), 'FilesTaskbarFilled');
const FilesTaskbarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 9.5a3.5 3.5 0 012.57 5.87l1.78 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.3 16a3.5 3.5 0 01-4.62-5.08l.06-.06a3.51 3.51 0 011.17-.98l.08-.04A3.48 3.48 0 015.5 9.5zm6-7.5c1.2 0 2.22.86 2.45 2h1.55c1.3 0 2.36.98 2.49 2.24l.01.26v7a2.5 2.5 0 01-2.24 2.49l-.26.01h-5.38l-.73-.73.14-.27h3.97c-.31-.42-.5-.94-.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-5C5.67 3 5 3.67 5 4.5v4.03c-.35.04-.68.11-1 .23V4.5A2.5 2.5 0 016.5 2h5zm-6 8.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm8.5 3c0 .78.59 1.42 1.35 1.5h.3A1.5 1.5 0 0017 13.5V6.35A1.5 1.5 0 0015.5 5H14v8.5zm-2.9-2.49a.5.5 0 010 .98L11 12H9.89c-.08-.35-.2-.69-.36-1H11l.1.01zM11 8a.5.5 0 010 1H7.56c-.33-.17-.68-.3-1.05-.38A.5.5 0 017 8h4zm0-3a.5.5 0 010 1H7a.5.5 0 010-1h4z",
    fill: primaryFill
  }));
};
export const FilesTaskbarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilesTaskbarRegularIcon({}), 'FilesTaskbarRegular');
const FluidFrameworkColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("g", {
    clipPath: "url(#clip0_68602_14142)"
  }, React.createElement("path", {
    d: "M17.96 7.06a5 5 0 01-3.02 4.31c-.81.28-1.7.47-2.53.6-3.26.53-4 3.52-2.41 6.03a8 8 0 008-8V6.49l-.04.57z",
    fill: "url(#paint0_radial_68602_14142)"
  }), React.createElement("path", {
    d: "M17.96 7.06a5 5 0 01-3.02 4.31c-.81.28-1.7.47-2.53.6-3.26.53-4 3.52-2.41 6.03a8 8 0 008-8V6.49l-.04.57z",
    fill: "url(#paint1_linear_68602_14142)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M17.96 7.06a5 5 0 01-3.02 4.31c-.81.28-1.7.47-2.53.6-3.26.53-4 3.52-2.41 6.03a8 8 0 008-8V6.49l-.04.57z",
    fill: "url(#paint2_radial_68602_14142)"
  }), React.createElement("g", {
    filter: "url(#filter0_d_68602_14142)"
  }, React.createElement("path", {
    d: "M6.86 9.55c.86-1.37 2.68-2.35 5.95-2.35h.18c2.65-.07 4.79-1.71 5-4.32L18 6.44c0 2.19-1.12 4.18-3.06 4.93-.81.28-1.7.47-2.53.6-3.26.53-4 3.52-2.41 6.03-2.14-.29-5.08-5.36-3.14-8.45z",
    fill: "url(#paint3_linear_68602_14142)"
  }), React.createElement("path", {
    d: "M6.86 9.55c.86-1.37 2.68-2.35 5.95-2.35h.18c2.65-.07 4.79-1.71 5-4.32L18 6.44c0 2.19-1.12 4.18-3.06 4.93-.81.28-1.7.47-2.53.6-3.26.53-4 3.52-2.41 6.03-2.14-.29-5.08-5.36-3.14-8.45z",
    fill: "url(#paint4_radial_68602_14142)",
    fillOpacity: 0.86
  }), React.createElement("path", {
    d: "M6.86 9.55c.86-1.37 2.68-2.35 5.95-2.35h.18c2.65-.07 4.79-1.71 5-4.32L18 6.44c0 2.19-1.12 4.18-3.06 4.93-.81.28-1.7.47-2.53.6-3.26.53-4 3.52-2.41 6.03-2.14-.29-5.08-5.36-3.14-8.45z",
    fill: "url(#paint5_radial_68602_14142)",
    fillOpacity: 0.8
  })), React.createElement("g", {
    filter: "url(#filter1_d_68602_14142)"
  }, React.createElement("path", {
    d: "M17.17 2H10a8 8 0 100 16c-3.08-.39-7.87-10.8 2.8-10.8 2.73 0 4.97-1.66 5.19-4.33v-.05a.83.83 0 00-.83-.82z",
    fill: "url(#paint6_radial_68602_14142)"
  }), React.createElement("path", {
    d: "M17.17 2H10a8 8 0 100 16c-3.08-.39-7.87-10.8 2.8-10.8 2.73 0 4.97-1.66 5.19-4.33v-.05a.83.83 0 00-.83-.82z",
    fill: "url(#paint7_linear_68602_14142)"
  }), React.createElement("path", {
    d: "M17.17 2H10a8 8 0 100 16c-3.08-.39-7.87-10.8 2.8-10.8 2.73 0 4.97-1.66 5.19-4.33v-.05a.83.83 0 00-.83-.82z",
    fill: "url(#paint8_radial_68602_14142)",
    fillOpacity: 0.6
  }))), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_68602_14142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-57.59 23.07 1.9) scale(15.5742 17.8515)"
  }, React.createElement("stop", {
    stopColor: "#2F27A5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7650E2"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_68602_14142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(96.79 13.27 .13) scale(29.17 31.4477)"
  }, React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3B148A"
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3B148A",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_68602_14142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(119.77 6.98 7.34) scale(18.9138 14.9857)"
  }, React.createElement("stop", {
    stopColor: "#AB59FC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#277FE7"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_68602_14142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90.98 18.1 -7.8) scale(36.6665 32.5664)"
  }, React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3B148A"
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#3B148A",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_68602_14142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-55.77 10.2 -16.15) scale(10.2157 15.903)"
  }, React.createElement("stop", {
    stopColor: "#55E1FE"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#29C3FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0FAFFF"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_68602_14142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(122.41 9.03 3.07) scale(25.4207 20.8667)"
  }, React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2052CB",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2052CB"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_68602_14142",
    x1: 18.83,
    y1: 11.39,
    x2: 10.14,
    y2: 17.79,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#CC23D1",
    stopOpacity: 0.8
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#CC23D1",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint3_linear_68602_14142",
    x1: 14.86,
    y1: 11.35,
    x2: 10.71,
    y2: 14.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#48B0FC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#063EB6"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_68602_14142",
    x1: 8.91,
    y1: 10,
    x2: 0.23,
    y2: 3.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.01,
    stopColor: "#839BFE",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#DC8AFD",
    stopOpacity: 0.8
  })), React.createElement("filter", {
    id: "filter0_d_68602_14142",
    x: 5.67,
    y: 2.32,
    width: 14.02,
    height: 17.37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dx: 0.56,
    dy: 0.56
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.56
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882 0 0 0 0 0.156863 0 0 0 0 0.509804 0 0 0 0.4 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68602_14142"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68602_14142",
    result: "shape"
  })), React.createElement("filter", {
    id: "filter1_d_68602_14142",
    x: 1.44,
    y: 1.44,
    width: 18.25,
    height: 18.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dx: 0.56,
    dy: 0.56
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.56
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0705882 0 0 0 0 0.156863 0 0 0 0 0.509804 0 0 0 0.4 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68602_14142"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68602_14142",
    result: "shape"
  })), React.createElement("clipPath", {
    id: "clip0_68602_14142"
  }, React.createElement("path", {
    d: "M2 2h15.17c.46 0 .83.37.83.83V18h-7.93A8.07 8.07 0 012 9.93V2z",
    fill: "#fff"
  }))));
};
export const FluidFrameworkColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FluidFrameworkColorIcon({}), 'FluidFrameworkColor');
const FluidFrameworkFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2h6a2 2 0 012 1.98A3.06 3.06 0 0114.94 7H12.5a6.5 6.5 0 00-5.06 10.58A8 8 0 0110 2zm4.94 6c1.22 0 2.32-.54 3.06-1.39v1.4A4 4 0 0114 12h-.5a4.5 4.5 0 00-4.27 5.92A5.5 5.5 0 0112.5 8h2.44zm-4.6 10a8 8 0 007.59-6.9A5 5 0 0114 13h-.5a3.5 3.5 0 00-3.17 5z",
    fill: primaryFill
  }));
};
export const FluidFrameworkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FluidFrameworkFilledIcon({}), 'FluidFrameworkFilled');
const FluidFrameworkRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 10a7 7 0 017-7h6a1 1 0 011 .95A3.14 3.14 0 0113.86 7H12.5a6 6 0 00-4.79 9.62A7 7 0 013 10zm7.17 7a3 3 0 012.85-4c1.57 0 2.97-.73 3.89-1.86A7 7 0 0110.17 17zM17 8.06c0 2.17-1.8 3.94-3.98 3.94a4.02 4.02 0 00-3.97 4.62A4.99 4.99 0 0112.5 8h1.36c1.26 0 2.38-.56 3.14-1.44v1.5zM10 2a8 8 0 108 8V4a2 2 0 00-2-2h-6z",
    fill: primaryFill
  }));
};
export const FluidFrameworkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FluidFrameworkRegularIcon({}), 'FluidFrameworkRegular');
const FormsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 12.5a5 5 0 015-5h8l.08 9.16c0 .74-.6 1.34-1.33 1.34H6.68A2.68 2.68 0 014 15.32V12.5z",
    fill: "url(#paint0_radial_79311_35620)"
  }), React.createElement("path", {
    d: "M4 12.5a5 5 0 015-5h8l.08 9.16c0 .74-.6 1.34-1.33 1.34H6.68A2.68 2.68 0 014 15.32V12.5z",
    fill: "url(#paint1_radial_79311_35620)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M4 4.68C4 3.2 5.2 2 6.68 2h8.87c.8 0 1.45.65 1.45 1.45v5.1c0 .8-.65 1.45-1.45 1.45H6.68A2.69 2.69 0 004 12.7V4.67z",
    fill: "url(#paint2_linear_79311_35620)"
  }), React.createElement("path", {
    d: "M4 4.68C4 3.2 5.2 2 6.68 2h8.87c.8 0 1.45.65 1.45 1.45v5.1c0 .8-.65 1.45-1.45 1.45H6.68A2.69 2.69 0 004 12.7V4.67z",
    fill: "url(#paint3_linear_79311_35620)"
  }), React.createElement("path", {
    d: "M13.6 8.05a2.55 2.55 0 100-5.1 2.55 2.55 0 000 5.1z",
    fill: "url(#paint4_linear_79311_35620)"
  }), React.createElement("path", {
    d: "M13.6 6.95a1.45 1.45 0 100-2.9 1.45 1.45 0 000 2.9z",
    fill: "url(#paint5_linear_79311_35620)"
  }), React.createElement("path", {
    d: "M15.64 12h-3.28c-.2 0-.36.16-.36.36v3.28c0 .2.16.36.36.36h3.28c.2 0 .36-.16.36-.36v-3.28c0-.2-.16-.36-.36-.36z",
    fill: "url(#paint6_linear_79311_35620)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint7_radial_79311_35620)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint8_radial_79311_35620)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M7.94 9.93H6.18v1.2H7.8v.93H6.18V14H5.06V9h2.88v.93z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint2_linear_79311_35620",
    x1: 4.29,
    y1: 8.48,
    x2: 16.75,
    y2: 1.47,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.23,
    stopColor: "#15B4D5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#43E5CA"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79311_35620",
    x1: 7.58,
    y1: 5.73,
    x2: 4,
    y2: 5.73,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.18,
    stopColor: "#29CBDC",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#36DFF1"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79311_35620",
    x1: 11.77,
    y1: 3.32,
    x2: 15.05,
    y2: 8.05,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#119FC5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#22918B"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_79311_35620",
    x1: 12.55,
    y1: 4.25,
    x2: 14.42,
    y2: 6.95,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#06517B"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7F7C"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_79311_35620",
    x1: 12.57,
    y1: 12.29,
    x2: 15.14,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#119FC5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#20AC9D"
  })), React.createElement("radialGradient", {
    id: "paint0_radial_79311_35620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8 -14.2501 12.1447 -7.2509 14.18 19.88)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1A7F7C"
  }), React.createElement("stop", {
    offset: 0.45,
    stopColor: "#14717C"
  }), React.createElement("stop", {
    offset: 0.8,
    stopColor: "#08567B"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_79311_35620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.22727 -5.39067 5.37662 -5.24093 8 9.37)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#06517B"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#06517B",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint7_radial_79311_35620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#009BBC"
  }), React.createElement("stop", {
    offset: 0.59,
    stopColor: "#01657D"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#014354"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_79311_35620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 -3.14 9.64) scale(7.07143)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1E8581",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1ECBE6"
  }))));
};
export const FormsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormsColorIcon({}), 'FormsColor');
const FormsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16a2 2 0 01-2 2H7c-.89 0-1.68-.39-2.23-1H9a3 3 0 003-2.7v1.34c0 .2.16.36.36.36h2.28c.2 0 .36-.16.36-.36v-2.28c0-.2-.16-.36-.36-.36h-2.28c-.2 0-.36.16-.36.36V11h3c.77 0 1.47-.3 2-.77V16zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zm-3.94 7h1.12v-1.94H7.8v-.92H6.18v-1.2h1.76V9H5.06v5zM15 2a2 2 0 012 2v4a2 2 0 01-2 2h-3V9c0-.44-.1-.86-.27-1.23A2.5 2.5 0 0016 6a2.5 2.5 0 10-4.81.95A2.99 2.99 0 009 6H4V5a3 3 0 013-3h8zm-1.5 2.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: primaryFill
  }));
};
export const FormsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormsFilledIcon({}), 'FormsFilled');
const FormsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 2a2 2 0 012 2v12a2 2 0 01-2 2H7a3 3 0 01-2.83-2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2V5a3 3 0 013-3h8zm-.36 10c.2 0 .36.16.36.36v2.28c0 .2-.16.36-.36.36h-2.28a.36.36 0 01-.36-.36v-2.28c0-.2.16-.36.36-.36h2.28zm-9.58 2h1.12v-1.94H7.8v-.92H6.18v-1.2h1.76V9H5.06v5zm8.53-9.96a1.45 1.45 0 110 2.91 1.45 1.45 0 010-2.9zM5.27 16c.35.6.99 1 1.73 1h8a1 1 0 001-1V9.73c-.3.17-.64.27-1 .27h-4v4a2 2 0 01-2 2H5.27zM9 7a2 2 0 012 2h4a1 1 0 001-1V4a1 1 0 00-1-1H7a2 2 0 00-2 2v2h4z",
    fill: primaryFill
  }));
};
export const FormsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormsRegularIcon({}), 'FormsRegular');
const GroupmeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 2A3.5 3.5 0 0117 5.5v7a3.5 3.5 0 01-3.5 3.5h-1.68c-.49 0-.93.37-1.05.91-.04.2-.1.4-.16.56a1.2 1.2 0 01-.12.26.6.6 0 01-.49.27.6.6 0 01-.49-.27 1.2 1.2 0 01-.12-.26 4.25 4.25 0 01-.16-.56c-.12-.54-.56-.91-1.05-.91H6.5A3.5 3.5 0 013 12.5v-7A3.5 3.5 0 016.5 2h7zm.86 8c-.2 0-.38.11-.48.29a4.5 4.5 0 01-7.76 0 .56.56 0 00-.48-.29c-.36 0-.62.37-.43.7a5.5 5.5 0 009.58 0c.19-.33-.07-.7-.43-.7zM8.5 5.5H7.25v1H8.5v1H7.25v1H8.5v1.25h1V8.5h1v1.25h1V8.5h1.25v-1H11.5v-1h1.25v-1H11.5V4.25h-1V5.5h-1V4.25h-1V5.5zm2 2h-1v-1h1v1z",
    fill: "url(#paint0_linear_79399_8154)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_79399_8154",
    x1: 14.13,
    y1: 15.4,
    x2: 0,
    y2: 2.82,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3C16D3"
  }), React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1271FF"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2CF2FF"
  }))));
};
export const GroupmeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupmeColorIcon({}), 'GroupmeColor');
const GroupmeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 2A3.5 3.5 0 0117 5.5v7a3.5 3.5 0 01-3.5 3.5h-1.68c-.49 0-.93.37-1.05.91-.04.2-.1.4-.16.56a1.2 1.2 0 01-.12.26.6.6 0 01-.49.27.6.6 0 01-.49-.27 1.2 1.2 0 01-.12-.26 4.25 4.25 0 01-.16-.56c-.12-.54-.56-.91-1.05-.91H6.5A3.5 3.5 0 013 12.5v-7A3.5 3.5 0 016.5 2h7zm.86 8c-.2 0-.38.11-.48.29a4.5 4.5 0 01-7.76 0 .56.56 0 00-.48-.29c-.36 0-.62.37-.43.7a5.5 5.5 0 009.58 0c.19-.33-.07-.7-.43-.7zM8.5 5.5H7.25v1H8.5v1H7.25v1H8.5v1.25h1V8.5h1v1.25h1V8.5h1.25v-1H11.5v-1h1.25v-1H11.5V4.25h-1V5.5h-1V4.25h-1V5.5zm2 2h-1v-1h1v1z",
    fill: primaryFill
  }));
};
export const GroupmeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupmeFilledIcon({}), 'GroupmeFilled');
const GroupmeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.5 2A3.5 3.5 0 0117 5.5v7a3.5 3.5 0 01-3.5 3.5H12c-.26 0-.54.23-.64.61-.07.28-.18.6-.38.87-.2.28-.53.52-.98.52a1.2 1.2 0 01-.98-.52c-.2-.26-.31-.59-.38-.87-.1-.38-.38-.61-.64-.61H6.5A3.5 3.5 0 013 12.5v-7A3.5 3.5 0 016.5 2h7zm-7 1A2.5 2.5 0 004 5.5v7A2.5 2.5 0 006.5 15H8c.85 0 1.44.68 1.6 1.37.06.22.14.4.22.52.07.1.13.11.18.11.05 0 .1-.02.18-.11.08-.12.16-.3.21-.52.17-.69.76-1.37 1.61-1.37h1.5a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0013.5 3h-7zm7.43 7.25c.36 0 .62.37.44.69a5 5 0 01-8.74 0c-.17-.32.08-.69.44-.69.2 0 .39.12.49.29a4 4 0 006.88 0c.1-.17.29-.29.49-.29zM9.5 6h1V4.75h1V6h1.25v1H11.5v1h1.25v1H11.5v1.25h-1V9h-1v1.25h-1V9H7.25V8H8.5V7H7.25V6H8.5V4.75h1V6zm0 2h1V7h-1v1z",
    fill: primaryFill
  }));
};
export const GroupmeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/GroupmeRegularIcon({}), 'GroupmeRegular');
const HouseEmptyColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2.39a1.5 1.5 0 012 0l5.5 4.95c.32.28.5.68.5 1.11v7.05c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 013 15.5V8.45c0-.43.18-.83.5-1.11L9 2.39z",
    fill: "url(#paint0_radial_73293_90)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_73293_90",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(62.13 3.44 3.52) scale(24.1235 28.5497)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB152"
  }))));
};
export const HouseEmptyColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/HouseEmptyColorIcon({}), 'HouseEmptyColor');
const LineHorizontal4LoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M1.75 3.75c0-.41.34-.75.75-.75h15a.75.75 0 010 1.5h-15a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17.5 7a.75.75 0 010 1.5h-15a.75.75 0 010-1.5h15z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.5 11a.75.75 0 000 1.5h8.17c.34-.59.8-1.1 1.33-1.5H2.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10 15v1.5H2.5a.75.75 0 010-1.5H10z",
    fill: primaryFill
  }));
};
export const LineHorizontal4LoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LineHorizontal4LoopFilledIcon({}), 'LineHorizontal4LoopFilled');
const LoopColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8v8h8a8 8 0 100-16zm0 5.2a2.8 2.8 0 110 5.6H7.2V10A2.8 2.8 0 0110 7.2z",
    fill: "url(#paint0_linear_1_32)"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 01-8 8H2a5.2 5.2 0 015.2-5.2H10a2.8 2.8 0 002.8-2.8H18z",
    fill: "url(#paint1_linear_1_32)"
  }), React.createElement("path", {
    d: "M18 10a8 8 0 01-8 8H2a5.2 5.2 0 015.2-5.2H10a2.8 2.8 0 002.8-2.8H18z",
    fill: "url(#paint2_radial_1_32)",
    fillOpacity: 0.56
  }), React.createElement("path", {
    d: "M18 10a8 8 0 01-8 8H2a5.2 5.2 0 015.2-5.2H10a2.8 2.8 0 002.8-2.8H18z",
    fill: "url(#paint3_radial_1_32)",
    fillOpacity: 0.1
  }), React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8v8a5.2 5.2 0 005.2-5.18l.02-.02H7.2V10A2.8 2.8 0 0112 8.04l3.68-3.68A7.98 7.98 0 0010 2z",
    fill: "url(#paint4_linear_1_32)"
  }), React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8v8a5.2 5.2 0 005.2-5.18l.02-.02H7.2V10A2.8 2.8 0 0112 8.04l3.68-3.68A7.98 7.98 0 0010 2z",
    fill: "url(#paint5_radial_1_32)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint2_radial_1_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.2 2.2 -3.86655 5.62407 4.8 14.6)"
  }, React.createElement("stop", null), React.createElement("stop", {
    offset: 0.7,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint3_radial_1_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.92 3.68 -6.46767 10.4045 3.84 14)"
  }, React.createElement("stop", {
    offset: 0.33
  }), React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_1_32",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.72004 -1.84 4.83761 28.18435 .64 6.96)"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6D05E8",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_1_32",
    x1: 11.76,
    y1: 7.68,
    x2: 9.12,
    y2: 18.48,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9237E3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#48E6F3"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_1_32",
    x1: 7.2,
    y1: 16.8,
    x2: 14.24,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#51E6FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#71D4FF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_1_32",
    x1: 5.28,
    y1: 10.56,
    x2: 9.36,
    y2: 4.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6D05E8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AB5ADD",
    stopOpacity: 0
  }))));
};
export const LoopColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/LoopColorIcon({}), 'LoopColor');
const LoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 00-8 8v8a5 5 0 005-5v-3a3 3 0 113 3H8a6 6 0 01-2.68 5H10a8 8 0 100-16z",
    fill: primaryFill
  }));
};
export const LoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/LoopFilledIcon({}), 'LoopFilled');
const LoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 18v-8a8 8 0 118 8H2zm3.45-1H10a7 7 0 10-7-7v6.96a4.74 4.74 0 002.58-1.38c.87-.86 1.42-2 1.42-3.08V10a3 3 0 113 3H7.97a5.7 5.7 0 01-1.68 3.3c-.26.25-.54.49-.84.7zM8 12h2a2 2 0 10-2-2v2z",
    fill: primaryFill
  }));
};
export const LoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/LoopRegularIcon({}), 'LoopRegular');
const M365ColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.14 3.35A1.88 1.88 0 0012.34 2h-.6c-.9 0-1.66.63-1.84 1.51L8.85 8.85l.3-.96c.24-.78.97-1.32 1.8-1.32h3.29l1.4 1.17 1.24-1.17h-.39c-.83 0-1.57-.55-1.8-1.35l-.55-1.87z",
    fill: "url(#paint0_radial_71966_322)"
  }), React.createElement("path", {
    d: "M6.05 16.64c.23.8.97 1.36 1.8 1.36h1.22c1.01 0 1.84-.8 1.88-1.8l.18-5.06-.29.96c-.24.79-.97 1.33-1.8 1.33h-3.3l-1.39-.89-1.02.89h.38c.84 0 1.57.55 1.8 1.36l.54 1.85z",
    fill: "url(#paint1_radial_71966_322)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint2_linear_71966_322)"
  }), React.createElement("path", {
    d: "M12.25 2H5.69c-1.88 0-3 2.4-3.75 4.8-.9 2.84-2.05 6.63 1.31 6.63h2.86c.83 0 1.57-.54 1.8-1.34.5-1.67 1.35-4.57 2.03-6.78.35-1.12.63-2.09 1.07-2.69A1.5 1.5 0 0112.25 2z",
    fill: "url(#paint3_linear_71966_322)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint4_radial_71966_322)"
  }), React.createElement("path", {
    d: "M7.75 18h6.56c1.88 0 3-2.4 3.75-4.8.89-2.83 2.05-6.63-1.31-6.63h-2.86c-.83 0-1.57.55-1.8 1.34l-2.03 6.78c-.35 1.12-.63 2.09-1.07 2.69a1.5 1.5 0 01-1.24.62z",
    fill: "url(#paint5_linear_71966_322)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_71966_322",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-129.14 9.97 .71) scale(7.20751 6.76953)"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00AEFF"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_71966_322",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.73 -11.45 11.6) scale(6.58647 6.39483)"
  }, React.createElement("stop", {
    stopColor: "#FFB657"
  }), React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF5F3D"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C02B3C"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_71966_322",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-5.18437 14.3365 -17.62744 -6.37443 17.09 5.45)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_71966_322",
    x1: 5.29,
    y1: 3.39,
    x2: 6.17,
    y2: 13.87,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0D91E1"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#52B471"
  }), React.createElement("stop", {
    offset: 0.65,
    stopColor: "#98BD42"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFC800"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_71966_322",
    x1: 6.11,
    y1: 2,
    x2: 6.59,
    y2: 13.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint5_linear_71966_322",
    x1: 17.6,
    y1: 5.87,
    x2: 17.6,
    y2: 8.99,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8ADFA"
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#A86EDD",
    stopOpacity: 0
  }))));
};
export const M365Color = /*#__PURE__*/wrapIcon( /*#__PURE__*/M365ColorIcon({}), 'M365Color');
const M365FilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.93 2h6.2c1.06 0 1.99.7 2.29 1.7l.47 1.6c.16.55.64.93 1.2.98h.29c.88 0 1.57.25 2.02.77.44.5.6 1.17.6 1.84.02 1.32-.5 2.96-.9 4.27a12.57 12.57 0 01-1.44 3.22c-.62.9-1.46 1.62-2.59 1.62h-6.2c-1.06 0-1.99-.7-2.29-1.7l-.47-1.6a1.38 1.38 0 00-1.2-.98h-.29c-.88 0-1.57-.25-2.02-.77a2.78 2.78 0 01-.6-1.84c-.02-1.32.5-2.96.9-4.26.37-1.14.83-2.32 1.44-3.23C3.96 2.72 4.8 2 5.93 2zm-.2 11.72c.15.2.27.44.34.7l.47 1.6c.17.58.71.98 1.32.98h.03c.36 0 .6-.17.75-.38a4 4 0 00.48-.95c.14-.4.28-.83.43-1.33l.03-.1.2-.64c-.24.07-.49.11-.74.11H6.4l-.16.01h-.52zm2.46-1h.85c.55 0 1.04-.34 1.26-.84l1.17-3.9c.07-.25.19-.49.34-.7h-.85c-.55 0-1.04.34-1.26.83l-1.17 3.91c-.07.25-.19.49-.34.7zm2.03-6.32c.24-.07.49-.11.74-.11h3.31c-.15-.22-.27-.45-.34-.7l-.47-1.6c-.17-.59-.71-.99-1.32-.99h-.02a.92.92 0 00-.76.38 4 4 0 00-.48.96c-.14.38-.28.82-.43 1.32l-.03.1-.2.64z",
    fill: primaryFill
  }));
};
export const M365Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/M365FilledIcon({}), 'M365Filled');
const M365RegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.93 2h6.2c1.06 0 1.99.7 2.29 1.7l.47 1.6c.16.55.64.93 1.2.98h.29c.88 0 1.57.25 2.02.77.44.5.6 1.17.6 1.84.02 1.32-.5 2.96-.9 4.27a12.57 12.57 0 01-1.44 3.22c-.62.9-1.46 1.62-2.59 1.62h-6.2c-1.06 0-1.99-.7-2.29-1.7l-.47-1.6a1.38 1.38 0 00-1.2-.98h-.29c-.88 0-1.57-.25-2.02-.77a2.78 2.78 0 01-.6-1.84c-.02-1.32.5-2.96.9-4.26.37-1.14.83-2.32 1.44-3.23C3.96 2.72 4.8 2 5.93 2zM2.86 7.15C2.43 8.5 1.98 9.97 2 11.1c0 .55.13.94.35 1.2.2.23.57.42 1.27.42h2.63c.61 0 1.15-.4 1.32-.98.47-1.58 1.27-4.24 1.9-6.28l.03-.1c.15-.5.3-.96.45-1.38.13-.35.28-.69.46-.98H5.93c-.65 0-1.22.4-1.76 1.19-.53.78-.96 1.84-1.3 2.96zm2.87 6.57c.15.2.27.44.34.7l.47 1.6c.17.58.71.98 1.32.98h.03c.36 0 .6-.17.75-.38a4 4 0 00.48-.95c.14-.4.28-.83.43-1.33l.03-.1.2-.64c-.24.07-.49.11-.74.11H6.4l-.16.01h-.52zm2.46-1h.85c.55 0 1.04-.34 1.26-.84l1.17-3.9c.07-.25.19-.49.34-.7h-.85c-.55 0-1.04.34-1.26.83l-1.17 3.91c-.07.25-.19.49-.34.7zm2.03-6.32c.24-.07.49-.11.74-.11h3.31c-.15-.22-.27-.45-.34-.7l-.47-1.6c-.17-.59-.71-.99-1.32-.99h-.02a.92.92 0 00-.76.38 4 4 0 00-.48.96c-.14.38-.28.82-.43 1.32l-.03.1-.2.64zm6.92 6.45c.43-1.35.88-2.82.86-3.95 0-.55-.13-.94-.35-1.2-.2-.23-.57-.42-1.27-.42h-2.63c-.61 0-1.15.4-1.32.99-.47 1.57-1.27 4.23-1.9 6.27l-.03.1c-.15.5-.3.96-.45 1.38-.13.35-.28.69-.46.98h4.48c.65 0 1.22-.4 1.76-1.19.53-.78.96-1.84 1.3-2.96z",
    fill: primaryFill
  }));
};
export const M365Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/M365RegularIcon({}), 'M365Regular');
const MicrosoftColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fill: "#F25022",
    d: "M2 2h7v7H2z"
  }), React.createElement("path", {
    fill: "#80BA01",
    d: "M11 2h7v7h-7z"
  }), React.createElement("path", {
    fill: "#FFB902",
    d: "M11 11h7v7h-7z"
  }), React.createElement("path", {
    fill: "#02A4EF",
    d: "M2 11h7v7H2z"
  }));
};
export const MicrosoftColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicrosoftColorIcon({}), 'MicrosoftColor');
const MicrosoftFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2H2v7h7V2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M18 2h-7v7h7V2z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M11 11h7v7h-7v-7z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M9 11H2v7h7v-7z",
    fill: "#242424"
  }));
};
export const MicrosoftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicrosoftFilledIcon({}), 'MicrosoftFilled');
const MicrosoftBlendColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.49 3.89C7.19 4.17 7 4.56 7 5v11.5a1.5 1.5 0 01-2.98.26l-.01-.06v-.01l-.08-.62-.01-.14L3.55 13l-.53-4.24-.01-.07L3 8.5c0-.44.19-.83.49-1.11l.02-.01v-.01l3.98-3.48z",
    fill: "url(#paint0_linear_82401_2624)"
  }), React.createElement("path", {
    d: "M7.49 3.89C7.19 4.17 7 4.56 7 5v11.5a1.5 1.5 0 01-2.98.26l-.01-.06v-.01l-.08-.62-.01-.14L3.55 13l-.53-4.24-.01-.07L3 8.5c0-.44.19-.83.49-1.11l.02-.01v-.01l3.98-3.48z",
    fill: "url(#paint1_linear_82401_2624)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M18 4.5v1A1.5 1.5 0 0116.5 7h-12c-.38 0-.72.14-.99.37l3.98-3.48.02-.02c.24-.21.55-.34.89-.37h.03l4.6-.29 1.02-.06 1.87-.12.48-.03h.1c.15 0 .29.02.43.07.62.18 1.07.75 1.07 1.43z",
    fill: "#20AC9D"
  }), React.createElement("path", {
    d: "M18 4.5v1A1.5 1.5 0 0116.5 7h-12c-.38 0-.72.14-.99.37l3.98-3.48.02-.02c.24-.21.55-.34.89-.37h.03l4.6-.29 1.02-.06 1.87-.12.48-.03h.1c.15 0 .29.02.43.07.62.18 1.07.75 1.07 1.43z",
    fill: "url(#paint2_linear_82401_2624)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M18 4.5v1A1.5 1.5 0 0116.5 7h-12c-.38 0-.72.14-.99.37l3.98-3.48.02-.02c.24-.21.55-.34.89-.37h.03l4.6-.29 1.02-.06 1.87-.12.48-.03h.1c.15 0 .29.02.43.07.62.18 1.07.75 1.07 1.43z",
    fill: "url(#paint3_linear_82401_2624)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M16.56 12.56l-4 4a1.5 1.5 0 01-1.06.44l-.19-.01-.07-.01L7 16.45l-2.93-.37-.14-.01-.62-.08H3.3l-.06-.01A1.5 1.5 0 013.5 13h12c.41 0 .79-.17 1.06-.44z",
    fill: "url(#paint4_linear_82401_2624)"
  }), React.createElement("path", {
    d: "M16.56 12.56l-4 4a1.5 1.5 0 01-1.06.44l-.19-.01-.07-.01L7 16.45l-2.93-.37-.14-.01-.62-.08H3.3l-.06-.01A1.5 1.5 0 013.5 13h12c.41 0 .79-.17 1.06-.44z",
    fill: "url(#paint5_radial_82401_2624)"
  }), React.createElement("path", {
    d: "M17 3.5v8c0 .41-.17.79-.44 1.06l-4 4c.27-.27.44-.65.44-1.06v-12a1.5 1.5 0 011.03-1.42.36.36 0 01.11-.04c.11-.02.23-.04.36-.04h1c.68 0 1.25.45 1.43 1.07.05.14.07.28.07.43z",
    fill: "url(#paint6_linear_82401_2624)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82401_2624",
    x1: 5.25,
    y1: 5.6,
    x2: 5.25,
    y2: 18.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#08494E"
  }), React.createElement("stop", {
    offset: 0.31,
    stopColor: "#136C6C"
  }), React.createElement("stop", {
    offset: 0.78,
    stopColor: "#20AC9D"
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#64DE89"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82401_2624",
    x1: 5.43,
    y1: 11.62,
    x2: 4.12,
    y2: 16.81,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0E5A5D",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0E5A5D",
    stopOpacity: 0.7
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#0E5A5D"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0E5A5D",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82401_2624",
    x1: 18,
    y1: 5.54,
    x2: 9.63,
    y2: 5.54,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.01,
    stopColor: "#0E5A5D",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E5A5D"
  }), React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0E5A5D",
    stopOpacity: 0.7
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#0E5A5D",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82401_2624",
    x1: 9.72,
    y1: 7.31,
    x2: 6.64,
    y2: 4.01,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2BDABE",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F6C7"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_82401_2624",
    x1: 2,
    y1: 11.92,
    x2: 12.76,
    y2: 17.29,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#64DE89"
  }), React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1EC8B0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0C74A1"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_82401_2624",
    x1: 15.09,
    y1: 1.15,
    x2: 14.28,
    y2: 16.52,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C8F5B7"
  }), React.createElement("stop", {
    offset: 0.28,
    stopColor: "#76EB95"
  }), React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1EC8B0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1384B1"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_82401_2624",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12.3583 4.45563 -6.54301 14.435 2 13.4)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1EC8B0",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.82,
    stopColor: "#024169"
  }))));
};
export const MicrosoftBlendColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicrosoftBlendColorIcon({}), 'MicrosoftBlendColor');
const MicrosoftBlendFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.4 3.5c-.34.03-.65.16-.89.37l-.02.02-3.98 3.48v.01l-.02.01c-.3.28-.49.67-.49 1.11l.01.19.01.07.4 3.25.08-.01H7V7h5V3.5c0-.08.02-.15.03-.23l-3.6.23H8.4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2 14.5a1.5 1.5 0 001.3 1.49h.01l.62.08.08.62v.01l.01.06A1.5 1.5 0 007 16.5v-.05l1.47.18 1.65.21c.47.06.95-.09 1.31-.41.36-.31.57-.77.57-1.25V13H3.5c-.83 0-1.5.67-1.5 1.5z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M16.93 3.07A1.48 1.48 0 0015.5 2h-1c-.13 0-.25.02-.36.04a.36.36 0 00-.11.04A1.5 1.5 0 0013 3.5v11.68c0 .46-.13.9-.35 1.3l3.91-3.92c.27-.27.44-.65.44-1.06V6.91c.58-.2 1-.76 1-1.41v-1c0-.68-.45-1.25-1.07-1.43z",
    fill: "#242424"
  }));
};
export const MicrosoftBlendFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicrosoftBlendFilledIcon({}), 'MicrosoftBlendFilled');
const MicrosoftBlendRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 2h-1c-.1 0-.39.02-.47.08-.51.17-.9.6-1 1.13l-4.6.29H8.4c-.34.03-.65.16-.89.37l-.02.02-2.55 2.23-1.28 1.12-.34.33c-.2.27-.32.6-.32.94l.02.25.16 1.24.37 3H3.5a1.5 1.5 0 00-.2 3h.01l.62.07.08.62v.01l.01.06A1.5 1.5 0 007 16.5v-.05l4.24.53.07.01.2.01c.4 0 .78-.17 1.05-.44l4-4c.27-.27.44-.65.44-1.06V6.91c.58-.2 1-.76 1-1.4v-1c0-.69-.45-1.26-1.07-1.44A1.48 1.48 0 0015.5 2zM14 13.71V3.5l.01-.1c.02-.1.07-.19.15-.26a.45.45 0 01.19-.11l.06-.02.09-.01h1a.4.4 0 01.19.04c.13.05.24.16.28.31l.01.03.01.03.01.09v8c0 .13-.05.26-.15.35L14.71 13l-.71.71zM6.6 6l.4-.35 1.15-1.01.03-.03c.08-.06.17-.1.27-.11h.04L13 4.22V6H6.6zm.4 7V7h6v6H7zm-2.44 0l-.38-2.98-.17-1.4A.75.75 0 014 8.5c0-.11.04-.22.06-.26L5.46 7H6v6H4.56zm6.89 3l-.09-.01-4.23-.53-.13-.02-1-.12L3.49 15l-.12-.01A.52.52 0 013 14.5c0-.28.22-.5.5-.5H13v.71l-1.15 1.14a.47.47 0 01-.35.15h-.05zM5.5 17a.52.52 0 01-.49-.37L5 16.51l-.04-.32 1.04.13v.18a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};
export const MicrosoftBlendRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MicrosoftBlendRegularIcon({}), 'MicrosoftBlendRegular');
const NewsletterColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 15.5a1.5 1.5 0 003 0V5a1 1 0 00-1-1h-2v11.5z",
    fill: "url(#paint0_linear_63490_22024)"
  }), React.createElement("path", {
    d: "M14 15.5a1.5 1.5 0 003 0V5a1 1 0 00-1-1h-2v11.5z",
    fill: "url(#paint1_linear_63490_22024)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M14 15.5a1.5 1.5 0 003 0V5a1 1 0 00-1-1h-2v11.5z",
    fill: "url(#paint2_linear_63490_22024)",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M4.5 17A1.5 1.5 0 013 15.5V4a1 1 0 011-1h9a1 1 0 011 1v11.5c0 .83.67 1.5 1.5 1.5h-11z",
    fill: "url(#paint3_linear_63490_22024)"
  }), React.createElement("path", {
    d: "M6.5 17A1.5 1.5 0 015 15.5v-3c0-.28.22-.5.5-.5h6c.28 0 .5.22.5.5v3c0 .83.67 1.5 1.5 1.5h-7z",
    fill: "url(#paint4_linear_63490_22024)"
  }), React.createElement("rect", {
    width: 7,
    height: 2,
    rx: 0.5,
    transform: "matrix(1 0 0 -1 5 11)",
    fill: "#0084DF"
  }), React.createElement("rect", {
    x: 5,
    y: 5,
    width: 7,
    height: 3,
    rx: 0.5,
    fill: "url(#paint5_linear_63490_22024)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_63490_22024",
    x1: 15.5,
    y1: 17,
    x2: 15.5,
    y2: 7.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00479E"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_63490_22024",
    x1: 13,
    y1: 10,
    x2: 15,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.44
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint2_linear_63490_22024",
    x1: 13,
    y1: 10,
    x2: 15,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.48
  }), React.createElement("stop", {
    offset: 0.71,
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint3_linear_63490_22024",
    x1: 7.75,
    y1: 18,
    x2: 7.75,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0078D4"
  }), React.createElement("stop", {
    offset: 0.14,
    stopColor: "#14B1FF"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3DCBFF"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_63490_22024",
    x1: 6.75,
    y1: 17,
    x2: 6.75,
    y2: 8.11,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0057AD"
  }), React.createElement("stop", {
    offset: 0.14,
    stopColor: "#0078D4"
  }), React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0091EB"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_63490_22024",
    x1: 8.5,
    y1: 5,
    x2: 8.5,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#D7F7FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#ABEEFF"
  }))));
};
export const NewsletterColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsletterColorIcon({}), 'NewsletterColor');
const NewsletterFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.99 4.77H14v9.73a.5.5 0 001 0V4a2 2 0 012 2v8.5a2.5 2.5 0 01-5 0V13a1 1 0 00-1-1H6a1 1 0 00-1 1v2.5c0 .54.17 1.04.46 1.45A3 3 0 013 14V5c0-1.1.9-2 2-2h7a2 2 0 011.99 1.77zM7.5 17h4.55A3.49 3.49 0 0111 14.5V13H6v2.5c0 .83.67 1.5 1.5 1.5zM6 5a1 1 0 00-1 1v2a1 1 0 001 1h5a1 1 0 001-1V6a1 1 0 00-1-1H6zm0 1h5v2H6V6zm-1 4.5c0 .28.22.5.5.5h6a.5.5 0 000-1h-6a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};
export const NewsletterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsletterFilledIcon({}), 'NewsletterFilled');
const NewsletterRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5 3a2 2 0 00-2 2v9a3 3 0 003 3h8.5a2.5 2.5 0 002.5-2.5V6a2 2 0 00-2-2h-.27A2 2 0 0013 3H5zm9.5 13a1.5 1.5 0 01-1.5-1.5V13a1 1 0 00-1-1H6a1 1 0 00-1 1v2c0 .3.06.57.18.82A2 2 0 014 14V5a1 1 0 011-1h8a1 1 0 011 1v9.5a.5.5 0 001 0V5a1 1 0 011 1v8.5c0 .83-.67 1.5-1.5 1.5zM7 16a1 1 0 01-1-1v-2h6v1.5c0 .56.19 1.08.5 1.5H7zM6 5a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V6a1 1 0 00-1-1H6zm0 1h6v2H6V6zm-1 4.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};
export const NewsletterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NewsletterRegularIcon({}), 'NewsletterRegular');
const NotepadLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.47a3.37 3.37 0 001.35-2.7h1.12a1.8 1.8 0 10-1.8-1.8v1.8A2.7 2.7 0 0110 19v-4.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M6.5 2c.28 0 .5.22.5.5V3h2.5v-.5a.5.5 0 011 0V3H13v-.5a.5.5 0 011 0V3h.5c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 00-4.66.8H7.5a.5.5 0 000 1h2.76a5.48 5.48 0 00-1.05 2H7.5a.5.5 0 000 1h1.52l-.02.5V18H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3H6v-.5c0-.28.22-.5.5-.5zm1 5a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};
export const NotepadLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadLoopFilledIcon({}), 'NotepadLoopFilled');
const NotepadLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.47a3.37 3.37 0 001.35-2.7h1.12a1.8 1.8 0 10-1.8-1.8v1.8A2.7 2.7 0 0110 19v-4.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M7 7.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.5 10a.5.5 0 000 1h2.76c.31-.38.67-.72 1.08-1H7.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M15 9.02V4.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v12c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3H6v-.5a.5.5 0 011 0V3h2.5v-.5a.5.5 0 011 0V3H13v-.5a.5.5 0 011 0V3h.5c.83 0 1.5.67 1.5 1.5v4.7c-.32-.08-.66-.15-1-.18z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.2 13c-.08.32-.15.66-.18 1H7.5a.5.5 0 010-1h1.7z",
    fill: primaryFill
  }));
};
export const NotepadLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadLoopRegularIcon({}), 'NotepadLoopRegular');
const OfficeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 15.92V4.08a1.85 1.85 0 00-1.34-1.78L10.72.57 12 4v11l-1.29 4.43 6-1.72A1.87 1.87 0 0018 15.92z",
    fill: "url(#paint0_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M12 15H6.45a1.23 1.23 0 00-.61 2.3l3.5 2c.27.15.57.23.88.23A1.78 1.78 0 0012 17.75V15z",
    fill: "url(#paint1_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M10.72.57a1.72 1.72 0 00-1.38.17L2.93 4.46A1.86 1.86 0 002 6.07v8a.9.9 0 001.34.78l2-1.1a1.37 1.37 0 00.7-1.19v-5.5a1.38 1.38 0 01.91-1.29L12 4V2.27a1.77 1.77 0 00-1.28-1.7z",
    fill: "url(#paint2_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M12 15H6.45a1.23 1.23 0 00-.61 2.3l3.5 2c.27.15.57.23.88.23A1.78 1.78 0 0012 17.75V15z",
    fill: "url(#paint3_linear_38966_55081)"
  }), React.createElement("path", {
    d: "M10.72.57a1.72 1.72 0 00-1.38.17L2.93 4.46A1.86 1.86 0 002 6.07v8a.9.9 0 001.34.78l2-1.1a1.37 1.37 0 00.7-1.19v-5.5a1.38 1.38 0 01.91-1.29L12 4V2.27a1.77 1.77 0 00-1.28-1.7z",
    fill: "url(#paint4_linear_38966_55081)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_38966_55081",
    x1: 14.23,
    y1: -0.54,
    x2: 14.42,
    y2: 18.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFCE00"
  }), React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FABB00"
  }), React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EB8401"
  }), React.createElement("stop", {
    offset: 0.33,
    stopColor: "#E15C01"
  }), React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DA4401"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D83B01"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_38966_55081",
    x1: 5.76,
    y1: 17.25,
    x2: 18.22,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FA2C46"
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B0080B"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_38966_55081",
    x1: 10.49,
    y1: -0.01,
    x2: 0.64,
    y2: 14.05,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8C0700"
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C72127"
  }), React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CA2B3D"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D04374"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#D5559C"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D860B4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D964BD"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_38966_55081",
    x1: 14.27,
    y1: 17.53,
    x2: 8.66,
    y2: 17.04,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopOpacity: 0.4
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint4_linear_38966_55081",
    x1: 10.69,
    y1: -0.3,
    x2: 8.6,
    y2: 2.68,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopOpacity: 0.4
  }), React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))));
};
export const OfficeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeColorIcon({}), 'OfficeColor');
const OfficeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.66 2.3L10.72.57a1.72 1.72 0 00-1.38.17L2.93 4.46A1.85 1.85 0 002 6.07v8a.9.9 0 001.34.78l2-1.1a1.37 1.37 0 00.7-1.19v-5.5a1.38 1.38 0 01.91-1.29l4.09-1.45V15H6.49a1.23 1.23 0 00-.61 2.3l3.5 2a1.81 1.81 0 001.37.16l6-1.72a1.87 1.87 0 001.34-1.79V4.08a1.85 1.85 0 00-1.43-1.78zM17 15.92a.88.88 0 01-.62.83L12 18V2.27v-.29l4.4 1.28a.85.85 0 01.62.82L17 15.92z",
    fill: primaryFill
  }));
};
export const OfficeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OfficeRegularIcon({}), 'OfficeRegular');
const OnedriveColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.75 5.3a5.33 5.33 0 00-5.24 5.03c.1.57.44 1.7.96 1.64.65-.07 2.29 0 3.69-2.53 1.02-1.85 3.12-4.14.6-4.14z",
    fill: "url(#paint0_radial_79311_35591)"
  }), React.createElement("path", {
    d: "M5.08 6.3c-.98 1.54-2.3 3.75-2.74 4.45a1 1 0 01-1.8-.71l-.03.29a5.32 5.32 0 005.3 5.66c3.37 0 11.38-4.2 10.57-8.39a6.37 6.37 0 00-5.98-4.23 6.2 6.2 0 00-5.32 2.92z",
    fill: "url(#paint1_radial_79311_35591)"
  }), React.createElement("path", {
    d: "M5.08 6.3c-.98 1.54-2.3 3.75-2.74 4.45a1 1 0 01-1.8-.71l-.03.29a5.32 5.32 0 005.3 5.66c3.37 0 11.38-4.2 10.57-8.39a6.37 6.37 0 00-5.98-4.23 6.2 6.2 0 00-5.32 2.92z",
    fill: "url(#paint2_radial_79311_35591)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M5.08 6.3c-.98 1.54-2.3 3.75-2.74 4.45a1 1 0 01-1.8-.71l-.03.29a5.32 5.32 0 005.3 5.66c3.37 0 11.38-4.2 10.57-8.39a6.37 6.37 0 00-5.98-4.23 6.2 6.2 0 00-5.32 2.92z",
    fill: "url(#paint3_radial_79311_35591)"
  }), React.createElement("path", {
    d: "M5.08 6.3c-.98 1.54-2.3 3.75-2.74 4.45a1 1 0 01-1.8-.71l-.03.29a5.32 5.32 0 005.3 5.66c3.37 0 11.38-4.2 10.57-8.39a6.37 6.37 0 00-5.98-4.23 6.2 6.2 0 00-5.32 2.92z",
    fill: "url(#paint4_radial_79311_35591)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M5.08 6.3c-.98 1.54-2.3 3.75-2.74 4.45a1 1 0 01-1.8-.71l-.03.29a5.32 5.32 0 005.3 5.66c3.37 0 11.38-4.2 10.57-8.39a6.37 6.37 0 00-5.98-4.23 6.2 6.2 0 00-5.32 2.92z",
    fill: "url(#paint5_radial_79311_35591)",
    fillOpacity: 0.9
  }), React.createElement("path", {
    d: "M5.77 15.99l9.38.01a4.35 4.35 0 000-8.72c-2.43 0-3.83 1.82-4.88 3.8-1.23 2.33-2.8 4.88-4.5 4.9z",
    fill: "url(#paint6_linear_79311_35591)"
  }), React.createElement("path", {
    d: "M5.77 15.99l9.38.01a4.35 4.35 0 000-8.72c-2.43 0-3.83 1.82-4.88 3.8-1.23 2.33-2.8 4.88-4.5 4.9z",
    fill: "url(#paint7_radial_79311_35591)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M5.77 15.99l9.38.01a4.35 4.35 0 000-8.72c-2.43 0-3.83 1.82-4.88 3.8-1.23 2.33-2.8 4.88-4.5 4.9z",
    fill: "url(#paint8_radial_79311_35591)",
    fillOpacity: 0.9
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.83709 4.59768 -6.40887 7.82302 .87 6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#4894FE"
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0934B3"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.8681 19.4572 -14.867 -11.9814 16.95 -.9)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.17,
    stopColor: "#23C0FE"
  }), React.createElement("stop", {
    offset: 0.53,
    stopColor: "#1C91FF"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.00977 -3.36623 -7.50057 9.35169 4.76 6.34)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ADC0FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint3_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.50483 -3.81173 5.78894 -6.84157 10.45 12.53)"
  }, React.createElement("stop", {
    stopColor: "#033ACC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#368EFF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.14835 11.8808 -12.8265 5.55689 4.41 2.97)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3464E3",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#033ACC"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-13.46798 13.46798 -21.09978 -21.09978 16.74 .45)"
  }, React.createElement("stop", {
    stopColor: "#4BFDE8"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4BFDE8",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint7_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.02285 3.18172 -10.1658 13.5505 8.14 8.3)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fff",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_79311_35591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.96294 7.72488 -10.6247 -6.51665 19.23 6.6)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#4BFDE8"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4BFDE8",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint6_linear_79311_35591",
    x1: 12.64,
    y1: 16,
    x2: 12.64,
    y2: 7.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0086FF"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0BF"
  }))));
};
export const OnedriveColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OnedriveColorIcon({}), 'OnedriveColor');
const OnedriveFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.5 7a4.5 4.5 0 110 9H7.8c.26-.22.5-.48.72-.75.8-1.01 1.3-2.34 1.8-3.56a11.13 11.13 0 011.8-3.3A4.24 4.24 0 0115.5 7zm-4.25-4.5c2.42 0 4.48 1.5 5.33 3.6-.35-.06-.7-.1-1.08-.1-1.9 0-3.18.69-4.12 1.73a12.04 12.04 0 00-1.99 3.58c-.52 1.28-.97 2.45-1.65 3.32a3.33 3.33 0 01-2.57 1.36 5.5 5.5 0 01-4.94-3.9 2 2 0 002.5-.9 61.78 61.78 0 013.72-6.1 5.75 5.75 0 014.8-2.59zM5.27 5a67.53 67.53 0 00-3.41 5.71c-.42.77-1.57.65-1.82-.15a.8.8 0 01-.04-.25A5.47 5.47 0 015.27 5z",
    fill: primaryFill
  }));
};
export const OnedriveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OnedriveFilledIcon({}), 'OnedriveFilled');
const OnedriveRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 2.54a6.38 6.38 0 016.23 4.07c.1.23.15.42.2.55l.02.08A4.5 4.5 0 0115.5 16h-10a5.5 5.5 0 010-11h.2l.09-.15c.17-.27.43-.61.81-.95a5.65 5.65 0 013.9-1.36zm0 1c-1.62 0-2.63.56-3.23 1.1a3.69 3.69 0 00-.77.98l-.05.1C4.95 8.71 4.2 10 3.35 10.85a2.44 2.44 0 01-2.23.67A4.5 4.5 0 005.5 15H6c.33 0 .72-.14 1.15-.44.44-.3.88-.74 1.33-1.26a22.4 22.4 0 002.35-3.56A5.13 5.13 0 0115.27 7h.23l.31.01V7c-.17-.38-.43-.9-.83-1.41a5.38 5.38 0 00-4.48-2.04zM15.27 8c-1.48 0-2.84.88-3.57 2.21a23.38 23.38 0 01-2.46 3.73c-.33.4-.68.75-1.03 1.06h7.29a3.5 3.5 0 100-7h-.23zM5.18 6.01A4.5 4.5 0 001 10.41l.02.02c.08.06.23.11.42.14.37.04.83-.05 1.2-.42C3.3 9.49 3.93 8.49 5.19 6z",
    fill: primaryFill
  }));
};
export const OnedriveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OnedriveRegularIcon({}), 'OnedriveRegular');
const OnenoteColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 13.9C4 12.3 5.3 11 6.9 11H17v5.55c0 .8-.65 1.45-1.45 1.45h-8.8A2.75 2.75 0 014 15.25V13.9z",
    fill: "url(#paint0_linear_79311_35556)"
  }), React.createElement("path", {
    d: "M4 13.9C4 12.3 5.3 11 6.9 11H17v5.55c0 .8-.65 1.45-1.45 1.45h-8.8A2.75 2.75 0 014 15.25V13.9z",
    fill: "url(#paint1_radial_79311_35556)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M11 5.72l6-.22v5.55c0 .8-.65 1.45-1.45 1.45H11V5.72z",
    fill: "url(#paint2_linear_79311_35556)"
  }), React.createElement("path", {
    d: "M4 4.75A2.75 2.75 0 016.75 2h8.7C16.3 2 17 2.7 17 3.56v2.38c0 .86-.7 1.56-1.56 1.56h-.88c-.86 0-1.56.7-1.56 1.56v1.88c0 .86-.7 1.56-1.56 1.56H6.75A2.75 2.75 0 004 15.25V4.75z",
    fill: "url(#paint3_linear_79311_35556)"
  }), React.createElement("path", {
    d: "M4 4.75A2.75 2.75 0 016.75 2h8.7C16.3 2 17 2.7 17 3.56v2.38c0 .86-.7 1.56-1.56 1.56h-.88c-.86 0-1.56.7-1.56 1.56v1.88c0 .86-.7 1.56-1.56 1.56H6.75A2.75 2.75 0 004 15.25V4.75z",
    fill: "url(#paint4_radial_79311_35556)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint5_radial_79311_35556)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint6_radial_79311_35556)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M8.75 14H7.61l-2.06-3.09a9.96 9.96 0 01-.24-.41H5.3a9.75 9.75 0 01.01.8V14H4.25V9h1.21l1.99 2.99a6.03 6.03 0 01.24.4h.01a4.73 4.73 0 01-.01-.68V9h1.06v5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_79311_35556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.5213 10.6963 -11.4604 9.81987 16 19.87)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#A931D8",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6E1996"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_79311_35556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(120 8.62 5.78) scale(18.1275)"
  }, React.createElement("stop", {
    stopColor: "#FFC7A3"
  }), React.createElement("stop", {
    offset: 0.69,
    stopColor: "#DE67FD",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79311_35556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#AC13EB"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#580087"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_79311_35556",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.75 -6.75 0 6.5 12.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#841FB0",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D373FC"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_79311_35556",
    x1: 10.5,
    y1: 18,
    x2: 9.85,
    y2: 12.85,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#A931D8"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#57097C"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_79311_35556",
    x1: 19.69,
    y1: 9.33,
    x2: 12.23,
    y2: 5.63,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CA59F7"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#691A90"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79311_35556",
    x1: 17.57,
    y1: 5.43,
    x2: 4,
    y2: 5.43,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE66FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FCB1FF"
  }))));
};
export const OnenoteColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OnenoteColorIcon({}), 'OnenoteColor');
const OnenoteFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16a2 2 0 01-2 2H7a3 3 0 01-2.23-1H9a3 3 0 003-3v-1h3c.77 0 1.47-.3 2-.77V16zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zm-4.75 7H5.3v-2.7a28.54 28.54 0 00-.01-.8h.01l.1.17.14.24L7.61 14h1.14V9H7.7v2.7a21.64 21.64 0 00.01.7H7.7a2.98 2.98 0 00-.24-.41L5.46 9H4.25v5zM17 10a2 2 0 01-2 2h-2.27c.17-.3.27-.64.27-1V9a1 1 0 011-1h1c.77 0 1.47-.3 2-.77V10zm-2-8a2 2 0 012 2v1a2 2 0 01-2 2h-1a2 2 0 00-2 2 3 3 0 00-3-3H4V5a3 3 0 013-3h8z",
    fill: primaryFill
  }));
};
export const OnenoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OnenoteFilledIcon({}), 'OnenoteFilled');
const OnenoteRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 2a2 2 0 012 2v12a2 2 0 01-2 2H7a3 3 0 01-2.83-2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2V5a3 3 0 013-3h8zM4.25 14H5.3v-2.7a28.54 28.54 0 00-.01-.8h.01l.1.17.14.24L7.61 14h1.14V9H7.7v2.7a21.64 21.64 0 00.01.7H7.7a2.98 2.98 0 00-.24-.41L5.46 9H4.25v5zM16 7.73c-.3.17-.64.27-1 .27h-1a1 1 0 00-1 1v2c0 .36-.1.7-.27 1H15a1 1 0 001-1V7.73zM5.27 16c.35.6.99 1 1.73 1h8a1 1 0 001-1v-3.27c-.3.17-.64.27-1 .27h-4v1a2 2 0 01-2 2H5.27zM9 7a2 2 0 012 2v3a1 1 0 001-1V9c0-1.1.9-2 2-2h1a1 1 0 001-1V4a1 1 0 00-1-1H7a2 2 0 00-2 2v2h4z",
    fill: primaryFill
  }));
};
export const OnenoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OnenoteRegularIcon({}), 'OnenoteRegular');
const OpalColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.07 6.66c.74-.7 1.83-.79 2.56-.1l.37.28c.43.33 1.02.8 1.79 1.16a7.59 7.59 0 005.02.6c.23-.03.48.13.56.34l.04.1.01.11a.6.6 0 01-.34.58 1.97 1.97 0 001.37-2.41c-.22-.8-.8-1.36-1.66-1.44a4.21 4.21 0 01-2.29-.95c-.72-.59-1.13-1.43-1.85-2.01a4.1 4.1 0 00-3.22-.87 4.1 4.1 0 00-2.94 6l.01.02c.08.14.14.28.2.42a1.9 1.9 0 01.37-1.82v-.01z",
    fill: "url(#paint0_linear_79947_8163)"
  }), React.createElement("path", {
    d: "M4.07 6.66c.74-.7 1.83-.79 2.56-.1l.37.28c.43.33 1.02.8 1.79 1.16a7.59 7.59 0 005.02.6c.23-.03.48.13.56.34l.04.1.01.11a.6.6 0 01-.34.58 1.97 1.97 0 001.37-2.41c-.22-.8-.8-1.36-1.66-1.44a4.21 4.21 0 01-2.29-.95c-.72-.59-1.13-1.43-1.85-2.01a4.1 4.1 0 00-3.22-.87 4.1 4.1 0 00-2.94 6l.01.02c.08.14.14.28.2.42a1.9 1.9 0 01.37-1.82v-.01z",
    fill: "url(#paint1_radial_79947_8163)"
  }), React.createElement("path", {
    d: "M17.97 9.4a4.1 4.1 0 00-3.95-3.5l-.24-.02a1.96 1.96 0 01.3 3.84l-.1.03A7.76 7.76 0 009.4 13.2c-.3.49-.52.95-.7 1.33-.13.3-.23.63-.6.68a.6.6 0 01-.58-.39c-.04-.12-.03-.24-.03-.24-.14.91.47 1.82 1.39 2 .66.13 1.34-.16 1.73-.65.16-.2.32-.38.5-.55a4.3 4.3 0 012.89-1.28c.17 0 .35-.02.54-.04a4.09 4.09 0 003.4-4.65h.02z",
    fill: "url(#paint2_linear_79947_8163)"
  }), React.createElement("path", {
    d: "M17.97 9.4a4.1 4.1 0 00-3.95-3.5l-.24-.02a1.96 1.96 0 01.3 3.84l-.1.03A7.76 7.76 0 009.4 13.2c-.3.49-.52.95-.7 1.33-.13.3-.23.63-.6.68a.6.6 0 01-.58-.39c-.04-.12-.03-.24-.03-.24-.14.91.47 1.82 1.39 2 .66.13 1.34-.16 1.73-.65.16-.2.32-.38.5-.55a4.3 4.3 0 012.89-1.28c.17 0 .35-.02.54-.04a4.09 4.09 0 003.4-4.65h.02z",
    fill: "url(#paint3_radial_79947_8163)"
  }), React.createElement("path", {
    d: "M8.92 16.54a1.78 1.78 0 01-1.4-2.09l.02-.07a7.61 7.61 0 00-1.7-6.95l-.02-.03a.56.56 0 01-.14-.32.6.6 0 01.33-.6l.1-.04a.6.6 0 01.4.04l.13.08A1.81 1.81 0 003.7 8.48a4.14 4.14 0 01-.2 3.45v.02a4.1 4.1 0 005.44 5.6c.75-.38 1.17-1.02 1.68-1.63-.4.5-1.04.75-1.7.62z",
    fill: "url(#paint4_linear_79947_8163)"
  }), React.createElement("path", {
    d: "M8.92 16.54a1.78 1.78 0 01-1.4-2.09l.02-.07a7.61 7.61 0 00-1.7-6.95l-.02-.03a.56.56 0 01-.14-.32.6.6 0 01.33-.6l.1-.04a.6.6 0 01.4.04l.13.08A1.81 1.81 0 003.7 8.48a4.14 4.14 0 01-.2 3.45v.02a4.1 4.1 0 005.44 5.6c.75-.38 1.17-1.02 1.68-1.63-.4.5-1.04.75-1.7.62z",
    fill: "url(#paint5_radial_79947_8163)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_79947_8163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.5615 4.67658 4.27837 -6.98724 10.47 9.8)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AF2BFB",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#D9B8FF"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_79947_8163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(8.58947 .0771 4.58977 -15.7535 10.03 9.93)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5073FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#75B8FF"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79947_8163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.5205 7.01487 9.61407 -3.48917 4.85 10.59)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AF2BFB",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F696FF"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_79947_8163",
    x1: 6.79,
    y1: 7.67,
    x2: 15.13,
    y2: 9.79,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9263FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3D0B82"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_79947_8163",
    x1: 13.58,
    y1: 5.13,
    x2: 8.87,
    y2: 20.7,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.16,
    stopColor: "#094AFF"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#002E7F"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79947_8163",
    x1: 9.31,
    y1: 14.68,
    x2: 3.08,
    y2: 1.88,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#E563FF"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#500069"
  }))));
};
export const OpalColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpalColorIcon({}), 'OpalColor');
const OpalFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.98 7.12c.43 0 .8.21 1.04.54l.63.98a6.5 6.5 0 011 4.3l-.19 1.53v.23a2.4 2.4 0 002.1 2.37c-2.99 2.54-7.72-.52-6.3-4.46l.45-1.25a4 4 0 00.04-2.62 1.27 1.27 0 011.23-1.62zm10.45-.86c3.64 1.3 3.4 6.91-.7 7.67l-.96.18c-.87.16-2.03.6-2.62 1.25l-.25.29a1.24 1.24 0 01-1.98-1.42l.53-.95a6.5 6.5 0 013.09-2.8l1.44-.63a2.58 2.58 0 001.45-3.6zM3.14 7C2.1 3.07 7.14.19 10 3.35l1.16 1.28c.58.64 1.7 1.08 2.56 1.25a1.42 1.42 0 01-.38 2.76v.01l-1.2.05a6.5 6.5 0 01-4-1.16L6.9 6.69A2.52 2.52 0 003.14 7z",
    fill: primaryFill
  }));
};
export const OpalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpalFilledIcon({}), 'OpalFilled');
const OpalRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.26 7.38C1.77 3.26 7.06.08 9.99 3.35l1.16 1.28c.6.66 1.75 1.1 2.62 1.26l.95.18c4.37.8 4.37 7.06 0 7.86l-.95.18-.34.07c-.8.2-1.76.61-2.28 1.18L10 16.66l-.14.14c-2.91 2.96-7.9-.02-6.66-4l.07-.19.45-1.25a4 4 0 00.06-2.55l-.06-.17-.45-1.26zm2.12-.08a.77.77 0 00-.74.97l.01.03a5 5 0 010 3.4l-.45 1.25c-1.04 2.88 2.31 5.13 4.56 3.47a1.83 1.83 0 01-1.28-2.1l.16-1.38a6.5 6.5 0 00-.99-4.3l-.68-1.06a.76.76 0 00-.59-.28zm9.95 0a2.03 2.03 0 01-1.19 2.48l-1.6.7a6.5 6.5 0 00-3.1 2.8l-.7 1.27a.7.7 0 001.14.74l.53-.6c.43-.47 1-.81 1.54-1.05a7.37 7.37 0 011.64-.51l.95-.18c2.99-.55 3.25-4.5.79-5.65zM7.72 8.47a7.5 7.5 0 01.96 4.14 7.5 7.5 0 013.13-2.9 7.5 7.5 0 01-4.09-1.24zm1.53-4.45C7.08 1.6 3.2 3.88 4.15 6.9a1.95 1.95 0 012.72-.25l1.25.88a6.5 6.5 0 004.01 1.16l1.42-.06a.88.88 0 00.26-1.73l-.22-.04c-.51-.1-1.1-.26-1.64-.51A4.63 4.63 0 0110.4 5.3L9.25 4.02z",
    fill: primaryFill
  }));
};
export const OpalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpalRegularIcon({}), 'OpalRegular');
const OutlookColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.39 4.4l-9.57 6.06L3 9.16V8.04c0-.4.2-.79.55-1L9.1 3.41a2.56 2.56 0 012.78 0l1.5.97z",
    fill: "url(#paint0_linear_79314_10769)"
  }), React.createElement("path", {
    d: "M11.8 3.37l.1.05 4.33 2.82-10.76 6.82-1.65-2.6 7.9-5.02c.75-.48.78-1.54.09-2.07z",
    fill: "url(#paint1_linear_79314_10769)"
  }), React.createElement("path", {
    d: "M11.8 3.37l.1.05 4.33 2.82-10.76 6.82-1.65-2.6 7.9-5.02c.75-.48.78-1.54.09-2.07z",
    fill: "url(#paint2_linear_79314_10769)",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M9.77 14.36l-4.3-1.3 9.13-5.79c.77-.48.77-1.6 0-2.1l-.04-.02.11.08 2.78 1.8c.34.22.55.6.55 1v1.09l-8.23 5.24z",
    fill: "url(#paint3_linear_79314_10769)"
  }), React.createElement("path", {
    d: "M9.77 14.36l-4.3-1.3 9.13-5.79c.77-.48.77-1.6 0-2.1l-.04-.02.11.08 2.78 1.8c.34.22.55.6.55 1v1.09l-8.23 5.24z",
    fill: "url(#paint4_linear_79314_10769)",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M11.9 3.42a2.56 2.56 0 00-2.8 0L3.56 7.03c-.34.22-.55.6-.55 1v.06c.01.41.23.79.58 1l6.91 4.37 6.93-4.35c.36-.23.58-.63.58-1.05v1.06-1.08c0-.41-.2-.79-.55-1.01l-5.56-3.6z",
    fill: "url(#paint5_radial_79314_10769)"
  }), React.createElement("path", {
    d: "M9.27 18h6.21A2.51 2.51 0 0018 15.5V8.06c0 .42-.22.82-.58 1.05l-9.1 5.71c-.5.31-.8.85-.8 1.43 0 .97.79 1.75 1.75 1.75z",
    fill: "url(#paint6_linear_79314_10769)"
  }), React.createElement("path", {
    d: "M9.27 18h6.21A2.51 2.51 0 0018 15.5V8.06c0 .42-.22.82-.58 1.05l-9.1 5.71c-.5.31-.8.85-.8 1.43 0 .97.79 1.75 1.75 1.75z",
    fill: "url(#paint7_radial_79314_10769)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M9.27 18h6.21A2.51 2.51 0 0018 15.5V8.06c0 .42-.22.82-.58 1.05l-9.1 5.71c-.5.31-.8.85-.8 1.43 0 .97.79 1.75 1.75 1.75z",
    fill: "url(#paint8_radial_79314_10769)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M11.76 18H5.51A2.51 2.51 0 013 15.49V8.05c0 .43.22.82.58 1.05l9.1 5.74a1.71 1.71 0 01-.92 3.16z",
    fill: "url(#paint9_radial_79314_10769)"
  }), React.createElement("path", {
    d: "M11.76 18H5.51A2.51 2.51 0 013 15.49V8.05c0 .43.22.82.58 1.05l9.1 5.74a1.71 1.71 0 01-.92 3.16z",
    fill: "url(#paint10_linear_79314_10769)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint11_radial_79314_10769)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint12_radial_79314_10769)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M6.48 14.08a2.4 2.4 0 01-1.78-.7 2.47 2.47 0 01-.7-1.81c0-.8.24-1.43.71-1.92a2.44 2.44 0 011.85-.73c.71 0 1.3.23 1.75.7.45.46.68 1.08.68 1.85a2.6 2.6 0 01-.7 1.9c-.47.47-1.08.71-1.81.71zm.02-.98c.39 0 .7-.14.94-.42.24-.27.36-.66.36-1.15 0-.52-.11-.92-.34-1.2a1.14 1.14 0 00-.94-.43c-.4 0-.72.15-.96.44-.25.3-.37.68-.37 1.17 0 .49.12.88.37 1.16.24.29.56.43.94.43z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_79314_10769",
    x1: 4.66,
    y1: 9.82,
    x2: 13.39,
    y2: 4.41,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#20A7FA"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3BD5FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C4B0FF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_79314_10769",
    x1: 7.67,
    y1: 11.66,
    x2: 16.23,
    y2: 6.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#165AD9"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1880E5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8587FF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_79314_10769",
    x1: 11.21,
    y1: 11.77,
    x2: 5.82,
    y2: 7.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.24,
    stopColor: "#448AFF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0032B1"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79314_10769",
    x1: 10.52,
    y1: 13.46,
    x2: 19.04,
    y2: 8.01,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#1A43A6"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2052CB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5F20CB"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79314_10769",
    x1: 12.93,
    y1: 13.14,
    x2: 7.48,
    y2: 8.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0045B9",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0D1F69"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_79314_10769",
    x1: 18,
    y1: 12.98,
    x2: 10.44,
    y2: 12.98,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#4DC4FF"
  }), React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0FAFFF"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_79314_10769",
    x1: 1.94,
    y1: 16.28,
    x2: 9.22,
    y2: 16.28,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6CE0FF"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#50D5FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79314_10769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 6.92 -3.58) scale(12.0697)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#275FF0",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#002177"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_79314_10769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-45 25.77 -6.59) scale(4.82139)"
  }, React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0060D1"
  }), React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0383F1",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_79314_10769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-52.66 22.53 4.95) scale(16.3664)"
  }, React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F4A7F7",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F4A7F7"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_79314_10769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(134.84 3.15 9.7) scale(18.1722)"
  }, React.createElement("stop", {
    stopColor: "#49DEFF"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#29C3FF"
  })), React.createElement("radialGradient", {
    id: "paint11_radial_79314_10769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(46.92 -7.48 5.94) scale(11.8473)"
  }, React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0091FF"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#183DAD"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_79314_10769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 -3.1 9.6) scale(6.87288)"
  }, React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0FA5F7",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#74C6FF"
  }))));
};
export const OutlookColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/OutlookColorIcon({}), 'OutlookColor');
const OutlookFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.1 15.7c1.04.66.58 2.26-.63 2.3H5.5a2.5 2.5 0 01-2.03-1.05c.17.03.35.05.53.05h5a3 3 0 002.65-1.6l.45.3zm5.9-.2a2.5 2.5 0 01-2.5 2.5h-2.2c.63-.97.52-2.39-.66-3.14l-.67-.44c.02-.13.03-.28.03-.42v-.3l5.92-3.8.08-.06v5.66zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zM6.56 8.92c-.76 0-1.38.24-1.85.73-.47.49-.7 1.13-.7 1.92 0 .74.23 1.35.7 1.82.45.46 1.05.7 1.77.7.74 0 1.34-.25 1.8-.72.47-.49.71-1.12.71-1.9 0-.77-.23-1.38-.68-1.85a2.33 2.33 0 00-1.75-.7zm-.03.98c.38 0 .7.14.93.43.23.29.34.68.34 1.2 0 .5-.12.88-.35 1.15a1.2 1.2 0 01-.95.42c-.38 0-.7-.14-.94-.43a1.73 1.73 0 01-.37-1.16c0-.49.13-.87.37-1.17.24-.3.57-.44.97-.44zm10.85-2.94c.76.49.76 1.6 0 2.1L12 12.5V9.65l3.1-1.99c.58-.37.88-.97.91-1.58l1.37.88zM14.6 5.17a1 1 0 01-.05 1.65l-2.6 1.67a3 3 0 00-1.31-2l1.64-1.05c.46-.3.73-.76.79-1.25l1.53.98zM9.15 3.4a2.5 2.5 0 012.56-.08l.04.02c.46.3.46.97 0 1.26L9.5 6.04A3.02 3.02 0 009 6H5.1l4.05-2.6z",
    fill: primaryFill
  }));
};
export const OutlookFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OutlookFilledIcon({}), 'OutlookFilled');
const OutlookRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 3c.47 0 .94.14 1.35.4l2.42 1.56 2.93 1.88c.5.32.8.88.8 1.47v7.19a2.5 2.5 0 01-2.5 2.5h-3.86H10.5h-5c-1.3 0-2.37-1-2.49-2.26A2 2 0 012 14V9a2 2 0 011.54-1.95l.08-.08.19-.13L9.15 3.4A2.5 2.5 0 0110.5 3zm.92 10.5l1.28.82c1 .64 1.13 1.83.65 2.68h2.15c.83 0 1.5-.67 1.5-1.5V9.92l-5.58 3.58zM6.56 8.92c-.76 0-1.38.24-1.85.73-.47.49-.7 1.13-.7 1.92 0 .74.23 1.35.7 1.82.45.46 1.05.7 1.77.7.74 0 1.34-.25 1.8-.72.47-.49.71-1.12.71-1.9 0-.77-.23-1.38-.68-1.85a2.33 2.33 0 00-1.75-.7zm-.03.98c.38 0 .7.14.93.43.23.28.34.68.34 1.2 0 .5-.12.88-.35 1.15a1.2 1.2 0 01-.95.42c-.38 0-.7-.14-.94-.43a1.73 1.73 0 01-.37-1.16c0-.49.13-.87.37-1.17.24-.3.57-.44.97-.44zm8.77-3.1c-.07.5-.33.96-.8 1.26L11 10.3v2.27l5.65-3.63a.76.76 0 000-1.27l-1.35-.87zm-2.7-1.72c-.06.48-.32.95-.78 1.25l-1.65 1.05A2 2 0 0111 9v.12l2.97-1.9c.45-.3.46-.95.02-1.25l-.27-.18-1.12-.71zm-1.98-1.06a1.5 1.5 0 00-.93.23L5.4 7h3.5l2.37-1.52a.75.75 0 000-1.26A1.5 1.5 0 0011 4.1h-.02a1.5 1.5 0 00-.28-.08h-.1zM4.09 16c.2.58.76 1 1.41 1h6.14c.98-.02 1.35-1.3.52-1.84l-1.2-.77A2 2 0 019 16H4.09z",
    fill: primaryFill
  }));
};
export const OutlookRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OutlookRegularIcon({}), 'OutlookRegular');
const PagesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 7h.5c.83 0 1.5.67 1.5 1.5V16a2 2 0 01-2 2H5a2 2 0 01-2-2v-1l9-2 3-6z",
    fill: "url(#paint0_linear_73293_104)"
  }), React.createElement("path", {
    d: "M15 5.5v-.01A1.5 1.5 0 0013.5 4H12v6.5c0 .27-.23.53-.54.56a16 16 0 00-4.15.93A9.28 9.28 0 004 14.07S3 15 3 16a2 2 0 00.8 1.6c.23-.18.53-.4.93-.64 1.12-.65 2.62-1.1 4.14-1.4 1.81-.35 3.6-.48 4.66-.53.8-.04 1.47-.7 1.47-1.53v-8z",
    fill: "url(#paint1_radial_73293_104)"
  }), React.createElement("path", {
    d: "M13 10.5c0 .83-.66 1.48-1.45 1.55a15 15 0 00-3.88.88 9.69 9.69 0 00-4.53 3.8A2 2 0 013 16v-5.5a8.61 8.61 0 013.18-6.74 14.72 14.72 0 015-2.69c.95-.3 1.82.44 1.82 1.38v8.05z",
    fill: "url(#paint2_radial_73293_104)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_73293_104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-13.3947 -12.73111 22.36626 -23.53208 16.4 16.73)"
  }, React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E331D8"
  }), React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AC3445"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_73293_104",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(62.53 4.08 2.47) scale(17.9532 16.4309)"
  }, React.createElement("stop", {
    stopColor: "#8C48FF"
  }), React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F2598A"
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFB152"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_73293_104",
    x1: 13.32,
    y1: 12.5,
    x2: 32.14,
    y2: 55.02,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4022A0"
  }), React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C570FB"
  }))));
};
export const PagesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PagesColorIcon({}), 'PagesColor');
const PagesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 2.45c0-.94-.87-1.68-1.82-1.38-1.25.4-3.28 1.21-5 2.69A8.61 8.61 0 003 10.5v4.87a8.2 8.2 0 014.04-3.28A16.51 16.51 0 0113 10.98V2.44z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14 4.09v6.88c0 .57-.47 1.02-1.02 1.02-1.02 0-3.39.12-5.56 1.02-1.78.73-3.4 1.97-4.1 4.07l.05.08c1.8-1.09 3.91-1.8 5.84-2.26 2.17-.53 4.15-.75 5.28-.84.3-.02.51-.26.51-.53V5.5c0-.65-.42-1.2-1-1.41z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M5 18a2 2 0 01-.8-.16 20.47 20.47 0 015.24-1.97c2.11-.51 4.03-.72 5.13-.81A1.55 1.55 0 0016 13.53V7.02c.58.2 1 .76 1 1.41V16a2 2 0 01-2 2H5z",
    fill: "#242424"
  }));
};
export const PagesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PagesFilledIcon({}), 'PagesFilled');
const PagesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 5.5V7h.5c.82 0 1.5.67 1.5 1.5V16a2 2 0 01-2 2H5a2 2 0 01-2-2v-5.5a8.61 8.61 0 013.18-6.74 14.72 14.72 0 015-2.69c.95-.3 1.82.44 1.82 1.38V4h.5c.83 0 1.5.67 1.5 1.5zm-3-3.05c0-.33-.27-.5-.52-.43a13.72 13.72 0 00-4.65 2.5A7.62 7.62 0 004 10.5v3.57a9.28 9.28 0 013.31-2.08 16 16 0 014.15-.93.58.58 0 00.54-.56V2.45zM13 5v5.5c0 .83-.66 1.48-1.45 1.55a15 15 0 00-3.88.88A7.5 7.5 0 004 15.65V16a1 1 0 00.02.22c1.31-.81 3.03-1.32 4.65-1.64a33.8 33.8 0 014.81-.55c.3-.01.52-.25.52-.53v-8a.5.5 0 00-.5-.5H13zM5 17h10a1 1 0 001-1V8.5a.5.5 0 00-.5-.5H15v5.5c0 .83-.67 1.5-1.47 1.53-1.07.05-2.85.18-4.66.53-1.52.3-3.02.75-4.14 1.4A1 1 0 005 17z",
    fill: primaryFill
  }));
};
export const PagesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PagesRegularIcon({}), 'PagesRegular');
const PanelLeftLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v7a3 3 0 003 3h4v-1h-.5V5H15a2 2 0 012 2v2.6c.36.18.7.4 1 .66V7a3 3 0 00-3-3H5z",
    fill: primaryFill
  }));
};
export const PanelLeftLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftLoopFilledIcon({}), 'PanelLeftLoopFilled');
const PanelLeftLoopRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 14.5a4.5 4.5 0 114.5 4.5h-2.4a5.05 5.05 0 001.81-3h.59a1.5 1.5 0 10-1.5-1.5v.5a3.98 3.98 0 01-3 3.94V14.5z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v3.26a5.5 5.5 0 00-1-.66V7a2 2 0 00-2-2H8.5v11H9v1H5a3 3 0 01-3-3V7zm3-2a2 2 0 00-2 2v7c0 1.1.9 2 2 2h2.5V5H5z",
    fill: primaryFill
  }));
};
export const PanelLeftLoopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PanelLeftLoopRegularIcon({}), 'PanelLeftLoopRegular');
const PasswordManagerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 7.5C7 4.42 9.42 2 12.5 2S18 4.42 18 7.5 15.58 13 12.5 13c-.5 0-1-.05-1.5-.18V13a1 1 0 01-1 1H9v1a1 1 0 01-1 1H7v.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 16.5v-1.59c0-.4.16-.78.44-1.06l4.54-4.54c.13-.13.2-.37.14-.64A5.62 5.62 0 017 7.5zM15 6a1 1 0 10-2 0 1 1 0 002 0z",
    fill: "url(#paint0_linear_77388_24673)"
  }), React.createElement("path", {
    d: "M16.4 3.6c1 .99 1.6 2.36 1.6 3.9 0 3.08-2.42 5.5-5.5 5.5-.5 0-1-.05-1.5-.18V13a1 1 0 01-1 1H9v1a1 1 0 01-1 1H7v.5c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.06-.44L13.29 6.71A1 1 0 0015 6a1 1 0 00-.3-.7l1.7-1.7z",
    fill: "url(#paint1_radial_77388_24673)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_77388_24673",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(51.77 -12.34 9.52) scale(11.3256 12.173)"
  }, React.createElement("stop", {
    stopColor: "#236FD9"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#236FD9",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_77388_24673",
    x1: 5.56,
    y1: 4.67,
    x2: 17.11,
    y2: 15.33,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#29C3FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2052CB"
  }))));
};
export const PasswordManagerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PasswordManagerColorIcon({}), 'PasswordManagerColor');
const PasswordManagerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7 7.5C7 4.42 9.42 2 12.5 2S18 4.42 18 7.5 15.58 13 12.5 13c-.5 0-1-.05-1.5-.18V13a1 1 0 01-1 1H9v1a1 1 0 01-1 1H7v.5c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 16.5v-1.59c0-.4.16-.78.44-1.06l4.54-4.54c.13-.13.2-.37.14-.64A5.62 5.62 0 017 7.5zM15 6a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};
export const PasswordManagerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PasswordManagerFilledIcon({}), 'PasswordManagerFilled');
const PasswordManagerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6a1 1 0 11-2 0 1 1 0 012 0zm-2.5-4a5.45 5.45 0 00-5.38 6.67c.06.27 0 .5-.14.64l-4.54 4.54A1.5 1.5 0 002 14.91v1.59c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h1a1 1 0 001-1v-1h1a1 1 0 001-1v-.18c.5.13 1 .18 1.5.18 3.08 0 5.5-2.42 5.5-5.5S15.58 2 12.5 2zM8 7.5C8 4.98 9.98 3 12.5 3S17 4.98 17 7.5 15.02 12 12.5 12c-.66 0-1.27-.1-1.78-.35a.5.5 0 00-.72.45v.9H9a1 1 0 00-1 1v1H7a1 1 0 00-1 1v.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1.59a.5.5 0 01.15-.35l4.54-4.54c.43-.43.52-1.04.4-1.56-.06-.3-.09-.63-.09-.96z",
    fill: primaryFill
  }));
};
export const PasswordManagerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PasswordManagerRegularIcon({}), 'PasswordManagerRegular');
const PeopleTaskbarColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.67 16c.73 0 1.33-.6 1.33-1.33V6.33C18 5.6 17.4 5 16.67 5H7v11h9.67z",
    fill: "url(#paint0_radial_74711_26927)"
  }), React.createElement("path", {
    d: "M16.67 16c.73 0 1.33-.6 1.33-1.33V6.33C18 5.6 17.4 5 16.67 5H7v11h9.67z",
    fill: "url(#paint1_linear_74711_26927)"
  }), React.createElement("path", {
    d: "M16.67 16c.73 0 1.33-.6 1.33-1.33V6.33C18 5.6 17.4 5 16.67 5H7v11h9.67z",
    fill: "url(#paint2_radial_74711_26927)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M16.67 16c.73 0 1.33-.6 1.33-1.33V6.33C18 5.6 17.4 5 16.67 5H7v11h9.67z",
    fill: "url(#paint3_radial_74711_26927)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M16.67 16c.73 0 1.33-.6 1.33-1.33V6.33C18 5.6 17.4 5 16.67 5H7v11h9.67z",
    fill: "url(#paint4_radial_74711_26927)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M15 14.67V13a2 2 0 00-2-2H5.67C4.75 11 4 11.75 4 12.67v1.66c0 .92.75 1.67 1.67 1.67h10.66c-.73 0-1.33-.6-1.33-1.33z",
    fill: "url(#paint5_linear_74711_26927)"
  }), React.createElement("path", {
    d: "M15 14.67V13a2 2 0 00-2-2H5.67C4.75 11 4 11.75 4 12.67v1.66c0 .92.75 1.67 1.67 1.67h10.66c-.73 0-1.33-.6-1.33-1.33z",
    fill: "url(#paint6_linear_74711_26927)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M15 14.67V13a2 2 0 00-2-2H5.67C4.75 11 4 11.75 4 12.67v1.66c0 .92.75 1.67 1.67 1.67h10.66c-.73 0-1.33-.6-1.33-1.33z",
    fill: "url(#paint7_linear_74711_26927)"
  }), React.createElement("path", {
    d: "M15 14.67V13a2 2 0 00-2-2H5.67C4.75 11 4 11.75 4 12.67v1.66c0 .92.75 1.67 1.67 1.67h10.66c-.73 0-1.33-.6-1.33-1.33z",
    fill: "url(#paint8_linear_74711_26927)"
  }), React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 4,
    fill: "url(#paint9_radial_74711_26927)"
  }), React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 4,
    fill: "url(#paint10_radial_74711_26927)"
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.37l1.5 1.5-.47.46-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "#0057AA"
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.37l1.5 1.5-.47.46-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "url(#paint11_radial_74711_26927)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M7.33 13.33a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "url(#paint12_linear_74711_26927)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_74711_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(104.55 7.4 8.05) scale(13.5381 11.2258)"
  }, React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0C74A1"
  }), React.createElement("stop", {
    offset: 0.88,
    stopColor: "#06517B"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_74711_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(7.96079 0 0 11.7288 7.33 9)"
  }, React.createElement("stop", {
    stopColor: "#004695"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#004695",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint3_radial_74711_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.58823 -5.0026 4.68816 2.42555 12.04 12.6)"
  }, React.createElement("stop", {
    stopColor: "#004695"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#004695",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_74711_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(133.26 7.68 6.09) scale(8.75446 8.7384)"
  }, React.createElement("stop", {
    stopColor: "#76EB95"
  }), React.createElement("stop", {
    offset: 0.41,
    stopColor: "#76EB95",
    stopOpacity: 0.34
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#76EB95",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint9_radial_74711_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 2.1 4.86) scale(8.36492)"
  }, React.createElement("stop", {
    stopColor: "#2BDABE"
  }), React.createElement("stop", {
    offset: 0.52,
    stopColor: "#16BBDA"
  }), React.createElement("stop", {
    offset: 0.75,
    stopColor: "#119FC5"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_74711_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.18181 -7.27273 7.52841 6.39914 11.54 3.1)"
  }, React.createElement("stop", {
    stopColor: "#76EB95"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#16BBDA",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint11_radial_74711_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.0765 5.92226 -5.96493 5.11307 2.08 10)"
  }, React.createElement("stop", {
    stopColor: "#76EBD0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#76EB95",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint1_linear_74711_26927",
    x1: 16.33,
    y1: 4.67,
    x2: 16.33,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0FAFFF"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0057AA"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_74711_26927",
    x1: 6.97,
    y1: 10.67,
    x2: 15.39,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#43E5CA"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#26CFE8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0FAFFF"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_74711_26927",
    x1: 10.39,
    y1: 16,
    x2: 10.39,
    y2: 12.33,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#367AF2"
  }), React.createElement("stop", {
    offset: 0.7,
    stopColor: "#80AEFF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint7_linear_74711_26927",
    x1: 9.98,
    y1: 10.67,
    x2: 9.98,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2BDABE"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#13ACCF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_74711_26927",
    x1: 10.86,
    y1: 14.12,
    x2: 13.66,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#16BBDA",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#76EB95"
  })), React.createElement("linearGradient", {
    id: "paint12_linear_74711_26927",
    x1: 3.83,
    y1: 12.08,
    x2: 6.58,
    y2: 14.84,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9DEAFF"
  }))));
};
export const PeopleTaskbarColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTaskbarColorIcon({}), 'PeopleTaskbarColor');
const PeopleTaskbarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 9.5a3.5 3.5 0 012.57 5.87l1.78 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.3 16a3.5 3.5 0 11-1.8-6.5zm3-7.5c1.56 0 2.93.8 3.74 2h3.26c1.3 0 2.36.98 2.49 2.24l.01.26v7a2.5 2.5 0 01-2.24 2.49l-.26.01h-5.38l-.73-.73.14-.27h3.97c-.31-.42-.5-.94-.5-1.5v-1c0-.83-.67-1.5-1.5-1.5H9.53a4.5 4.5 0 00-.7-1.02 3.5 3.5 0 10-3.2-1.48H5.5c-.34 0-.66.04-.98.1A4.5 4.5 0 018.5 2zm-3 8.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    fill: primaryFill
  }));
};
export const PeopleTaskbarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTaskbarFilledIcon({}), 'PeopleTaskbarFilled');
const PeopleTaskbarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 9.5A3.5 3.5 0 018.37 15c-.09.13-.19.25-.3.37l1.78 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.29 16A3.5 3.5 0 012 13.18V13c0-.18.01-.35.04-.51l.01-.09a3.47 3.47 0 012.1-2.63c.42-.17.87-.27 1.35-.27zm3-7.5c1.56 0 2.93.8 3.74 2h3.26c1.3 0 2.36.98 2.49 2.24l.01.26v7a2.5 2.5 0 01-2.24 2.48l-.26.02h-5.38l-.73-.73.14-.27h3.97c-.31-.42-.5-.94-.5-1.5v-1c0-.83-.67-1.5-1.5-1.5H9.53a4.5 4.5 0 00-.7-1.02 3.5 3.5 0 10-3.2-1.48H5.5c-.33 0-.66.04-.97.1A4.5 4.5 0 018.5 2zm-3 8.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM12.74 5a4.5 4.5 0 01-1.41 5h.17c1.3 0 2.36.98 2.49 2.24l.01.26v1c0 .77.59 1.41 1.35 1.49h.3a1.5 1.5 0 001.35-1.5V6.35A1.5 1.5 0 0015.5 5h-2.76z",
    fill: primaryFill
  }));
};
export const PeopleTaskbarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PeopleTaskbarRegularIcon({}), 'PeopleTaskbarRegular');
const PlacesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79 17.99V4.65h6.36a6.97 6.97 0 01-.79 7.85l-4.22 4.97A1.5 1.5 0 019.8 18z",
    fill: "url(#paint0_radial_0_165)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18V8.5a3.5 3.5 0 017-.2V8a7 7 0 10-12.36 4.5l4.22 4.97c.3.36.72.53 1.14.53z",
    fill: "url(#paint1_radial_0_165)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18V8.5a3.5 3.5 0 017-.2V8a7 7 0 10-12.36 4.5l4.22 4.97c.3.36.72.53 1.14.53z",
    fill: "url(#paint2_linear_0_165)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_0_165",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-69.78 17.9 1.84) scale(13.7978 7.50958)"
  }, React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D59DFF"
  }), React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0078D4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0C59A4"
  })), React.createElement("radialGradient", {
    id: "paint1_radial_0_165",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.33492 5.08542 -6.85585 16.62918 3.72 5.07)"
  }, React.createElement("stop", {
    stopColor: "#43EFB1"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#21C6B3"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1E8FCF"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_0_165",
    x1: 14.08,
    y1: 24.77,
    x2: 1.53,
    y2: 14.44,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#A194F4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#975ECE",
    stopOpacity: 0
  }))));
};
export const PlacesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlacesColorIcon({}), 'PlacesColor');
const PlacesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 9a7 7 0 0113.57-2.43A4.25 4.25 0 009.5 9.75v9.15a1.5 1.5 0 01-.64-.44l-3.98-4.69A6.98 6.98 0 013 9z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.5 18.9c.24-.08.46-.23.64-.44l3.98-4.69a7 7 0 001.57-2.72c.32-1.04.36-2.23-.25-3.13a3.25 3.25 0 00-5.94 1.83v9.15z",
    fill: "#242424"
  }));
};
export const PlacesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlacesFilledIcon({}), 'PlacesFilled');
const PlacesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 9a6 6 0 0111.1-3.17A3.99 3.99 0 009.5 9.5v8.17L5.63 13.1l-.01-.01A5.98 5.98 0 014 9zm6.5 8.67V9.5a3 3 0 015.34-1.88 6.02 6.02 0 01-1.46 5.48l-3.88 4.57zM10 2a7 7 0 00-5.12 11.77l3.98 4.69c.6.7 1.68.7 2.28 0l3.98-4.69A7 7 0 0010 2z",
    fill: primaryFill
  }));
};
export const PlacesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlacesRegularIcon({}), 'PlacesRegular');
const PlannerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.2 12.8c-.78.78-2.04.78-2.81 0L1.59 10a1.98 1.98 0 010-2.8l2.8-2.81a1.98 1.98 0 012.8 0L10 7.19c.77.78.77 2.04 0 2.81l-2.8 2.8z",
    fill: "url(#paint0_linear_72976_3906)"
  }), React.createElement("path", {
    d: "M7.2 12.8c-.78.78-2.04.78-2.81 0L1.59 10a1.98 1.98 0 010-2.8l2.8-2.81a1.98 1.98 0 012.8 0L10 7.19c.77.78.77 2.04 0 2.81l-2.8 2.8z",
    fill: "url(#paint1_linear_72976_3906)"
  }), React.createElement("path", {
    d: "M1.58 10c.78.78 2.03.78 2.8 0l8.43-8.42a1.98 1.98 0 012.8 0l2.8 2.8c.78.78.78 2.04 0 2.81L10 15.61c-.77.78-2.03.78-2.8 0L1.57 10z",
    fill: "url(#paint2_linear_72976_3906)"
  }), React.createElement("path", {
    d: "M1.58 10c.78.78 2.03.78 2.8 0l8.43-8.42a1.98 1.98 0 012.8 0l2.8 2.8c.78.78.78 2.04 0 2.81L10 15.61c-.77.78-2.03.78-2.8 0L1.57 10z",
    fill: "url(#paint3_linear_72976_3906)"
  }), React.createElement("path", {
    d: "M4.39 12.8c.77.78 2.03.78 2.8 0l5.62-5.6a1.98 1.98 0 012.8 0l2.8 2.8c.78.77.78 2.03 0 2.8l-5.6 5.62c-.78.77-2.04.77-2.81 0L4.39 12.8z",
    fill: "url(#paint4_linear_72976_3906)"
  }), React.createElement("path", {
    d: "M4.39 12.8c.77.78 2.03.78 2.8 0l5.62-5.6a1.98 1.98 0 012.8 0l2.8 2.8c.78.77.78 2.03 0 2.8l-5.6 5.62c-.78.77-2.04.77-2.81 0L4.39 12.8z",
    fill: "url(#paint5_linear_72976_3906)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_72976_3906",
    x1: 5.79,
    y1: 3.81,
    x2: 2.62,
    y2: 10.58,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#8752E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#541278"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_72976_3906",
    x1: 7.29,
    y1: 9.3,
    x2: 4.71,
    y2: 6.77,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.12,
    stopColor: "#3D0D59"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#7034B0",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint2_linear_72976_3906",
    x1: 14.78,
    y1: 1,
    x2: 8.39,
    y2: 16.31,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6C0F71"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_72976_3906",
    x1: 14.78,
    y1: 1,
    x2: 8.39,
    y2: 16.31,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#DB45E0"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A829AE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8F28B3"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_72976_3906",
    x1: 14.5,
    y1: 6.62,
    x2: 11.5,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#00479E"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_72976_3906",
    x1: 14.66,
    y1: 6.94,
    x2: 8.89,
    y2: 18.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4A40D4"
  }))));
};
export const PlannerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlannerColorIcon({}), 'PlannerColor');
const PlannerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.4 13.03l-1.79-1.76a2.49 2.49 0 001.55-.73l8.61-8.58c.46-.46 1-.72 1.6-.72.58 0 1.12.26 1.58.72L18.3 4.3c.47.46.72 1.01.7 1.6a2.36 2.36 0 01-.77 1.57l-.54.51-1.42-1.42a2.5 2.5 0 00-3.54 0L6.4 12.91a1.5 1.5 0 01-1.98.12zm1.31 1.29l4.07 4c.44.44 1 .68 1.57.68.58 0 1.13-.24 1.57-.68l5.36-5.26c.43-.44.7-.96.72-1.52.02-.57-.2-1.12-.65-1.56l-2.79-2.71a1.5 1.5 0 00-2.12 0L7.09 13.6c-.39.4-.87.63-1.38.7zm-4.7-5.48c0 .36.07.73.33 1a1.5 1.5 0 002.12 0l4.58-4.59-.57-.56A2.27 2.27 0 005.93 4a2.18 2.18 0 00-1.61.7L1.67 7.3c-.43.44-.67.98-.67 1.55z",
    fill: primaryFill
  }));
};
export const PlannerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlannerFilledIcon({}), 'PlannerFilled');
const PlannerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.78 18.32c.44.44 1 .68 1.57.68.58 0 1.13-.24 1.57-.68l5.36-5.26c.43-.44.7-.96.72-1.52.02-.57-.2-1.12-.65-1.56L17 8.63l1.23-1.15v-.01c.46-.45.75-.99.77-1.57a2.13 2.13 0 00-.7-1.6l-2.58-2.57c-.46-.46-1-.73-1.6-.73-.58 0-1.12.27-1.58.73L8.51 5.7 7.47 4.7A2.27 2.27 0 005.93 4a2.18 2.18 0 00-1.61.7L1.67 7.3c-.43.44-.67.98-.67 1.55 0 .56.24 1.1.67 1.53 2.72 2.65 5.42 5.3 8.11 7.95zM5.1 10.48l8.15-8.04c.31-.32.62-.44.88-.44s.56.12.88.44L17.6 5c.3.3.41.6.4.85-.01.26-.14.57-.46.9l-1.25 1.16-.75-.74a2.37 2.37 0 00-3.33.05L7.09 12.4c-.48.48-1.34.49-1.88.02L3.98 11.2c.35-.11.73-.33 1.12-.72zm2.7 2.62l5.12-5.17c.53-.54 1.42-.55 1.91-.05l2.81 2.8c.27.28.37.56.36.82a1.3 1.3 0 01-.42.85l-5.36 5.26c-.28.27-.58.4-.87.4-.28 0-.59-.13-.86-.4l-3.94-3.87c.46-.08.9-.28 1.25-.64zm0-6.68L4.4 9.77c-.53.52-.93.55-1.14.51C2.69 10.2 2 9.42 2 8.84c0-.28.11-.57.38-.83l2.64-2.6V5.4c.3-.3.61-.41.89-.4.28 0 .58.13.85.4L7.8 6.42z",
    fill: primaryFill
  }));
};
export const PlannerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PlannerRegularIcon({}), 'PlannerRegular');
const PowerpointColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("circle", {
    cx: 10,
    cy: 10,
    fill: "url(#paint0_linear_79314_10734)",
    r: 7.75
  }), React.createElement("circle", {
    cx: 10,
    cy: 10,
    fill: "url(#paint1_radial_79314_10734)",
    r: 7.75
  }), React.createElement("circle", {
    cx: 10,
    cy: 10,
    fill: "url(#paint2_radial_79314_10734)",
    r: 7.75
  }), React.createElement("circle", {
    cx: 10,
    cy: 10,
    fill: "url(#paint3_radial_79314_10734)",
    fillOpacity: 0.5,
    r: 7.75
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint4_radial_79314_10734)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint5_radial_79314_10734)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M5.8 12.37V14H4.67V9h1.74c.63 0 1.1.14 1.43.4.33.28.49.68.49 1.22 0 .55-.18.98-.55 1.29-.37.3-.86.46-1.48.46h-.5zm0-2.5v1.64h.47c.28 0 .5-.08.65-.22.15-.15.22-.36.22-.63 0-.26-.07-.45-.22-.59-.15-.14-.36-.2-.63-.2h-.5z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M10 2.25a7.75 7.75 0 016.7 11.64l.12-.27A2.57 2.57 0 0014.48 10h-3.1C10.61 10 10 9.37 10 8.6V5.53a2.57 2.57 0 00-3.63-2.35l-.22.1A7.71 7.71 0 0110 2.25z",
    fill: "url(#paint6_radial_79314_10734)"
  }), React.createElement("path", {
    d: "M10 2.25a7.75 7.75 0 016.7 11.64l.12-.27A2.57 2.57 0 0014.48 10h-3.1C10.61 10 10 9.37 10 8.6V5.53a2.57 2.57 0 00-3.63-2.35l-.22.1A7.71 7.71 0 0110 2.25z",
    fill: "url(#paint7_radial_79314_10734)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_79314_10734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "scale(-16.0399 -16.0588) rotate(-45 -.9 .8)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#AA1D2D"
  }), React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D12B18",
    stopOpacity: 0.44
  }), React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF3C00",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79314_10734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "scale(-31.0698 -31.1066) rotate(-45 -.4 .58)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.2,
    stopColor: "#AA1D2D"
  }), React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D12B18",
    stopOpacity: 0.44
  }), React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FF3C00",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint3_radial_79314_10734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(19.8295 -11.4621 11.4486 19.853 -3.6 19.9)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF66FB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3D01",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_79314_10734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    stopColor: "#F8193E"
  }), React.createElement("stop", {
    offset: 0.94,
    stopColor: "#920616"
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79314_10734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.3 -7.17188 0 6.5 12.4)"
  }, React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFB055",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FFF2BE"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_79314_10734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.07457 -8.10354 8.10267 7.07533 9.15 11.06)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FD6EF9"
  }), React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F94"
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCC479"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_79314_10734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.72924 8.55201 -8.55109 -8.73017 8.56 1.71)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FF8D13"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF7F29",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_79314_10734",
    x1: 14.83,
    y1: 3.42,
    x2: 4.32,
    y2: 15.65,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF7F48"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#E5495B"
  }))));
};
export const PowerpointColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PowerpointColorIcon({}), 'PowerpointColor');
const PowerpointFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.9 10a2.5 2.5 0 012.16 3.75A8 8 0 016.14 17H9a3 3 0 003-3v-4h2.9zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zm-4.13 7H6v-1.63h.5c.62 0 1.11-.15 1.48-.46.37-.31.55-.74.55-1.3 0-.53-.16-.93-.5-1.2-.32-.27-.8-.41-1.42-.41H4.87v5zm1.62-4.14c.27 0 .48.07.63.21.15.14.22.33.22.59 0 .27-.07.48-.22.63-.16.14-.37.22-.65.22H6V9.86h.49zM10 2a8 8 0 017.96 8.8A3.5 3.5 0 0014.9 9H12c0-.89-.39-1.68-1-2.23V5.1a3.5 3.5 0 00-1.8-3.06c.26-.03.53-.04.8-.04zm-2.5.6A2.5 2.5 0 0110 5.1v1.07A3 3 0 009 6H4c-.36 0-.7.07-1.03.19a8.04 8.04 0 013.28-3.26c.37-.2.8-.33 1.25-.33z",
    fill: primaryFill
  }));
};
export const PowerpointFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PowerpointFilledIcon({}), 'PowerpointFilled');
const PowerpointRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 2a8 8 0 11-5.29 14H4a2 2 0 01-2-2V9a2 2 0 01.24-.95A8 8 0 0110 2zM4.87 14H6v-1.63h.5c.62 0 1.11-.15 1.48-.46.37-.31.55-.74.55-1.3 0-.53-.16-.93-.5-1.2-.32-.27-.8-.41-1.42-.41H4.87v5zm1.62-4.14c.27 0 .48.07.63.21.15.14.22.33.22.59 0 .27-.07.48-.22.63-.16.14-.37.22-.65.22H6V9.86h.49zM10 3c-.36 0-.7.03-1.05.08A3.5 3.5 0 0111 6.26V8.5c0 .28.22.5.5.5h2.24a3.5 3.5 0 013.18 2.05A7 7 0 0010 3zm-2.5.76c-.56 0-1.08.19-1.5.5-1 .7-1.81 1.65-2.34 2.77h-.01A2 2 0 014 7h5c.37 0 .72.1 1.02.28L10 7.27V6.26a2.5 2.5 0 00-2.5-2.5zM6.4 16a6.97 6.97 0 009.34-2 2.5 2.5 0 00-2-4H11.5a1.5 1.5 0 01-.5-.09V14a2 2 0 01-2 2H6.4z",
    fill: primaryFill
  }));
};
export const PowerpointRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PowerpointRegularIcon({}), 'PowerpointRegular');
const PrayerTimesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.81 1.55a.2.2 0 01.38 0c.27.83.86 1.52 1.63 1.93l4.11 2.19a6.1 6.1 0 013.22 5.89A5.5 5.5 0 009.02 15H2.58a.93.93 0 01-.83-.52l-.35-.72A6.1 6.1 0 014 5.7l4.18-2.22a3.41 3.41 0 001.63-1.93z",
    fill: "url(#paint0_linear_75681_7525)"
  }), React.createElement("path", {
    d: "M9.81 1.55a.2.2 0 01.38 0c.27.83.86 1.52 1.63 1.93l4.11 2.19a6.1 6.1 0 013.22 5.89A5.5 5.5 0 009.02 15H2.58a.93.93 0 01-.83-.52l-.35-.72A6.1 6.1 0 014 5.7l4.18-2.22a3.41 3.41 0 001.63-1.93z",
    fill: "url(#paint1_linear_75681_7525)"
  }), React.createElement("path", {
    d: "M9.81 1.55a.2.2 0 01.38 0c.27.83.86 1.52 1.63 1.93l4.11 2.19a6.1 6.1 0 013.22 5.89A5.5 5.5 0 009.02 15H2.58a.93.93 0 01-.83-.52l-.35-.72A6.1 6.1 0 014 5.7l4.18-2.22a3.41 3.41 0 001.63-1.93z",
    fill: "url(#paint2_linear_75681_7525)"
  }), React.createElement("path", {
    d: "M9.81 1.55a.2.2 0 01.38 0c.27.83.86 1.52 1.63 1.93l4.11 2.19a6.1 6.1 0 013.22 5.89A5.5 5.5 0 009.02 15H2.58a.93.93 0 01-.83-.52l-.35-.72A6.1 6.1 0 014 5.7l4.18-2.22a3.41 3.41 0 001.63-1.93z",
    fill: "url(#paint3_radial_75681_7525)"
  }), React.createElement("path", {
    d: "M3 12.5a1.5 1.5 0 013 0V15H3v-2.5z",
    fill: "url(#paint4_linear_75681_7525)"
  }), React.createElement("path", {
    d: "M9.5 11c.23 0 .45.05.64.15A5.48 5.48 0 009.02 15H8v-2.5c0-.83.67-1.5 1.5-1.5z",
    fill: "url(#paint5_linear_75681_7525)"
  }), React.createElement("path", {
    d: "M19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    fill: "url(#paint6_linear_75681_7525)"
  }), React.createElement("path", {
    d: "M19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    fill: "url(#paint7_linear_75681_7525)"
  }), React.createElement("path", {
    d: "M14 12a.5.5 0 011 0v2.74l1.54 1.1.08.07a.5.5 0 01-.57.8l-.1-.05-1.74-1.25A.5.5 0 0114 15v-3z",
    fill: "#fff",
    fillOpacity: 0.9
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_75681_7525",
    x1: 7.43,
    y1: 1.21,
    x2: 11.67,
    y2: 16.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#1EC8B0"
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#22918B"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_75681_7525",
    x1: 7.67,
    y1: 2.4,
    x2: 11.4,
    y2: 14.53,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#1EC8B0"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#22918B"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_75681_7525",
    x1: 7.35,
    y1: 2.46,
    x2: 11.39,
    y2: 14.53,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#1EC8B0"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#21A095"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1A7F7C"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_75681_7525",
    x1: 4,
    y1: 11.57,
    x2: 4.65,
    y2: 15.83,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFD394"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB357"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_75681_7525",
    x1: 9,
    y1: 11.57,
    x2: 9.65,
    y2: 15.83,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFD394"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB357"
  })), React.createElement("linearGradient", {
    id: "paint6_linear_75681_7525",
    x1: 10.69,
    y1: 12,
    x2: 17.96,
    y2: 14.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFD394"
  }), React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FFB357"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#E67505"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_75681_7525",
    x1: 14.5,
    y1: 14.5,
    x2: 14.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#B03111",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B03111",
    stopOpacity: 0.55
  })), React.createElement("radialGradient", {
    id: "paint3_radial_75681_7525",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.06316 4.66666 -7.44136 3.28987 5.58 2.46)"
  }, React.createElement("stop", {
    stopColor: "#2BDABE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2BDABE",
    stopOpacity: 0
  }))));
};
export const PrayerTimesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/PrayerTimesColorIcon({}), 'PrayerTimesColor');
const PrayerTimesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 2a.5.5 0 00-.5.5v2c0 .13.05.26.15.35l1.25 1.25.07.07a.5.5 0 00.7-.7l-.07-.07-1.1-1.1v-1.8a.5.5 0 00-.5-.5zM9.81 1.45a.2.2 0 01.38 0l.1.28c.3.72.83 1.32 1.5 1.7l4.43 2.54a6.1 6.1 0 013.04 5.78 5.5 5.5 0 00-8.6-1.2A1.5 1.5 0 008 11.5V14c0 .28.22.5.5.5H9v.28c.03.42.1.83.21 1.22H3.37a1.5 1.5 0 01-1.3-.76l-.55-.95a6.1 6.1 0 012.26-8.32l4.43-2.53c.67-.39 1.2-.99 1.5-1.71l.1-.28zM4.51 10c-.84 0-1.5.67-1.5 1.5V14c0 .28.21.5.5.5h2A.5.5 0 006 14v-2.5C6 10.67 5.32 10 4.5 10z",
    fill: primaryFill
  }));
};
export const PrayerTimesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PrayerTimesFilledIcon({}), 'PrayerTimesFilled');
const PrayerTimesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 2a.5.5 0 00-.5.5v2c0 .13.05.26.15.35l1.5 1.5.07.07a.5.5 0 00.7-.7l-.07-.07L15 14.29V12.5a.5.5 0 00-.5-.5zM9.96 1c.2 0 .38.12.46.3l.26.63.1.23c.27.53.68.97 1.18 1.28l4.43 2.72c2.01 1.23 2.98 3.4 2.83 5.51-.29-.48-.65-.9-1.06-1.28-.23-1.33-1-2.59-2.3-3.38L11.45 4.3a4.2 4.2 0 01-1.48-1.56A4.2 4.2 0 018.49 4.3L4.02 7.05A4.97 4.97 0 003 14.66V12a1.5 1.5 0 013 0v3h2v-3a1.5 1.5 0 012.42-1.19A5.48 5.48 0 009.2 16H3.34a1 1 0 01-.66-.25A5.97 5.97 0 013.5 6.2l4.46-2.76a3.2 3.2 0 001.27-1.5l.27-.63.03-.07A.5.5 0 019.96 1z",
    fill: primaryFill
  }));
};
export const PrayerTimesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PrayerTimesRegularIcon({}), 'PrayerTimesRegular');
const ProjectColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 4a1 1 0 011-1h8a1 1 0 011 1v4H4V4z",
    fill: "#33C481"
  }), React.createElement("path", {
    d: "M4 8h11a1 1 0 011 1v3H4V8z",
    fill: "#21A366"
  }), React.createElement("path", {
    d: "M8 12h9a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-4z",
    fill: "#185C37"
  }), React.createElement("path", {
    opacity: 0.6,
    d: "M8 6h4.25c.41 0 .75.34.75.75v7.75c0 .83-.67 1.5-1.5 1.5H8V6z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11.17 5H2.83a.83.83 0 00-.83.83v8.34c0 .46.37.83.83.83h8.34c.46 0 .83-.37.83-.83V5.83a.83.83 0 00-.83-.83z",
    fill: "#107C41"
  }), React.createElement("path", {
    d: "M7.4 7a2.5 2.5 0 011.65.49 1.73 1.73 0 01.57 1.4c0 .33-.1.66-.28.94-.2.31-.48.56-.8.72-.39.17-.8.26-1.22.25H6.17V13H5V7h2.4zM6.17 9.82H7.2c.32.03.63-.07.89-.26a.66.66 0 00.3-.62c0-.66-.39-1-1.16-1H6.17v1.88z",
    fill: "#fff"
  }));
};
export const ProjectColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectColorIcon({}), 'ProjectColor');
const ProjectRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13 4v3h-1V5.83a.83.83 0 00-.83-.83H5V4h8zM4 4v1H2.83a.83.83 0 00-.83.83v8.34c0 .46.37.83.83.83H8v1a1 1 0 001 1h8a1 1 0 001-1v-3a1 1 0 00-1-1h-1V8a1 1 0 00-1-1h-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1zm5 12v-1h2.17c.46 0 .83-.37.83-.83V13h5v3H9zm6-4h-3V8h3v4zM9.05 7.49a1.73 1.73 0 01.57 1.4c0 .33-.1.66-.28.94-.2.31-.48.56-.8.72-.39.17-.8.26-1.22.25H6.17V13H5V7h2.4a2.5 2.5 0 011.65.49zM7.19 9.8H6.17V7.94h1.05c.77 0 1.16.33 1.16 1a.66.66 0 01-.3.6c-.26.2-.57.3-.9.27z",
    fill: primaryFill
  }));
};
export const ProjectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ProjectRegularIcon({}), 'ProjectRegular');
const SharepointColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 13a6 6 0 100-12 6 6 0 000 12z",
    fill: "url(#paint0_linear_79314_10698)"
  }), React.createElement("path", {
    d: "M10 13a6 6 0 100-12 6 6 0 000 12z",
    fill: "url(#paint1_radial_79314_10698)",
    fillOpacity: 0.2
  }), React.createElement("path", {
    d: "M10 13a6 6 0 100-12 6 6 0 000 12z",
    fill: "url(#paint2_radial_79314_10698)",
    fillOpacity: 0.31
  }), React.createElement("path", {
    d: "M10 13a6 6 0 100-12 6 6 0 000 12z",
    fill: "url(#paint3_radial_79314_10698)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M14.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: "url(#paint4_linear_79314_10698)"
  }), React.createElement("path", {
    d: "M14.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: "url(#paint5_radial_79314_10698)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M14.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
    fill: "url(#paint6_radial_79314_10698)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M10 19a4 4 0 100-8 4 4 0 000 8z",
    fill: "url(#paint7_linear_79314_10698)"
  }), React.createElement("path", {
    d: "M10 19a4 4 0 100-8 4 4 0 000 8z",
    fill: "url(#paint8_linear_79314_10698)",
    fillOpacity: 0.32
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint9_radial_79314_10698)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint10_radial_79314_10698)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M4.62 13.02l.94-.5c.11.22.25.38.42.48.18.1.37.15.57.15.23 0 .41-.04.53-.14.12-.1.18-.23.18-.43a.48.48 0 00-.17-.37c-.12-.1-.32-.19-.62-.24-.56-.1-.97-.28-1.23-.54a1.3 1.3 0 01-.38-.95c0-.48.17-.85.5-1.14.34-.28.78-.42 1.33-.42.37 0 .7.07.98.22s.5.37.67.65l-.93.48c-.1-.16-.21-.27-.33-.34a.85.85 0 00-.45-.11c-.21 0-.38.05-.49.14-.1.1-.16.21-.16.36 0 .13.05.24.16.34.1.1.32.17.64.23.54.1.94.3 1.2.56.27.27.4.6.4 1.02 0 .5-.15.89-.47 1.18-.32.29-.78.43-1.37.43-.42 0-.81-.09-1.15-.28-.35-.18-.6-.45-.77-.78z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_79314_10698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-112.45 10.82 3.37) scale(9.21304)"
  }, React.createElement("stop", {
    offset: 0.29,
    stopColor: "#003B5D"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#004A6C",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#006F94",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79314_10698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-112.06 10.07 1.95) scale(7.77595)"
  }, React.createElement("stop", {
    offset: 0.26,
    stopColor: "#002A42"
  }), React.createElement("stop", {
    offset: 0.61,
    stopColor: "#004261",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#006F94",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint3_radial_79314_10698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(124.45 6.28 4.35) scale(6.50536)"
  }, React.createElement("stop", {
    stopColor: "#78EDFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2CCFCA",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79314_10698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-72.51 16.36 -.5) scale(6.45941)"
  }, React.createElement("stop", {
    stopColor: "#004A5D"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00556C",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#007A86",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_79314_10698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(124.45 6.57 8.23) scale(4.87902)"
  }, React.createElement("stop", {
    stopColor: "#78EDFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2CCFCA",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint9_radial_79314_10698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#00B6BD"
  }), React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00495C"
  })), React.createElement("radialGradient", {
    id: "paint10_radial_79314_10698",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 -2.82 9.32) scale(6.55714)"
  }, React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1E8581",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1ECBE6"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_79314_10698",
    x1: 5.5,
    y1: 2.5,
    x2: 13.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00E3DF"
  }), React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0097A8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#007791"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79314_10698",
    x1: 11.13,
    y1: 8.13,
    x2: 17.13,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#00E0D9"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#009FB8"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#056475"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_79314_10698",
    x1: 7.2,
    y1: 11.4,
    x2: 11.2,
    y2: 19.4,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#75FFF6"
  }), React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C7D1"
  }), React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0096AD"
  })), React.createElement("linearGradient", {
    id: "paint8_linear_79314_10698",
    x1: 13.98,
    y1: 19,
    x2: 11.84,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0E5A5D"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#126C6B",
    stopOpacity: 0.69
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1C948A",
    stopOpacity: 0
  }))));
};
export const SharepointColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/SharepointColorIcon({}), 'SharepointColor');
const SharepointFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12 11.54A4 4 0 116.54 17H9a3 3 0 003-3v-2.46zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zm5.5 0a4.5 4.5 0 01.4 8.98 5.02 5.02 0 00-2.9-5.56V9c0-.39-.08-.75-.2-1.1.75-.56 1.68-.9 2.7-.9zM6.69 8.92c-.55 0-.99.14-1.32.42-.34.29-.5.66-.5 1.14 0 .38.12.7.37.95.26.26.67.44 1.23.54.3.05.5.13.62.24.11.1.17.23.17.38 0 .19-.06.33-.18.42-.12.1-.3.14-.53.14-.2 0-.4-.05-.57-.15a1.1 1.1 0 01-.42-.48l-.94.5c.17.33.42.6.77.78.34.2.73.28 1.15.28.6 0 1.05-.14 1.37-.43.31-.3.47-.69.47-1.18 0-.41-.13-.75-.4-1.02a2.24 2.24 0 00-1.2-.56 1.43 1.43 0 01-.64-.23.45.45 0 01-.16-.34c0-.15.05-.27.16-.36.11-.1.28-.14.49-.14.18 0 .33.04.45.1.11.08.23.2.33.35l.92-.48a1.7 1.7 0 00-.66-.65c-.29-.15-.61-.22-.98-.22zM10 1a6 6 0 015.94 5.2 5.5 5.5 0 00-4.67.85A3 3 0 009 6H4.08A6 6 0 0110 1z",
    fill: primaryFill
  }));
};
export const SharepointFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SharepointFilledIcon({}), 'SharepointFilled');
const SharepointRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 1a6 6 0 016 6.25l.05.02a4.5 4.5 0 01-2.17 8.69 4 4 0 01-7.75.04H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2a6 6 0 016-6zm1 13a2 2 0 01-2 2H7.17A3 3 0 1011 12.17V14zm3.5-6a3.5 3.5 0 00-3.48 3.13A4 4 0 0114 14.97 3.5 3.5 0 1014.5 8zm-7.81.92c-.55 0-.99.14-1.32.42-.34.29-.5.66-.5 1.14 0 .38.12.7.37.95.26.26.67.44 1.23.54.3.05.5.13.62.24.11.1.17.23.17.38 0 .19-.06.33-.18.42-.12.1-.3.14-.53.14-.2 0-.4-.05-.57-.15a1.1 1.1 0 01-.42-.48l-.94.5c.17.33.42.6.77.78.34.2.73.28 1.15.28.6 0 1.05-.14 1.37-.43.31-.3.47-.69.47-1.18 0-.41-.13-.75-.4-1.02a2.23 2.23 0 00-1.2-.56 1.43 1.43 0 01-.64-.23.45.45 0 01-.16-.34c0-.15.05-.27.16-.36.11-.1.28-.14.5-.14.17 0 .32.04.44.1.12.08.23.2.33.35l.93-.48a1.7 1.7 0 00-.67-.65c-.29-.15-.61-.22-.98-.22zM9 7a2 2 0 011.97 1.7A4.5 4.5 0 0115 7.03V7A5 5 0 005 7h4z",
    fill: primaryFill
  }));
};
export const SharepointRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SharepointRegularIcon({}), 'SharepointRegular');
const ShoppingColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9 8.63a2.5 2.5 0 01-.24 1.9l-3.86 6.68a2.5 2.5 0 01-3.42.92L6.33 15.2a2.5 2.5 0 01-.91-3.41L9.27 5.1c.34-.57.88-.99 1.52-1.16l5.2-1.4c.66-.17 1.35.23 1.52.9l1.4 5.18zM13.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "url(#paint0_linear_71376_12488)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9 8.63a2.5 2.5 0 01-.24 1.9l-3.86 6.68a2.5 2.5 0 01-3.42.92L6.33 15.2a2.5 2.5 0 01-.91-3.41L9.27 5.1c.34-.57.88-.99 1.52-1.16l5.2-1.4c.66-.17 1.35.23 1.52.9l1.4 5.18zM13.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "url(#paint1_radial_71376_12488)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.91 8.62c0 .67-.26 1.3-.73 1.77L9.9 16.7a2.5 2.5 0 01-3.53 0l-4.13-4.13a2.5 2.5 0 010-3.54l6.29-6.29A2.5 2.5 0 0110.29 2h5.37c.7 0 1.25.56 1.25 1.25v5.37zM13.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "url(#paint2_linear_71376_12488)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.91 8.62c0 .67-.26 1.3-.73 1.77L9.9 16.7a2.5 2.5 0 01-3.53 0l-4.13-4.13a2.5 2.5 0 010-3.54l6.29-6.29A2.5 2.5 0 0110.29 2h5.37c.7 0 1.25.56 1.25 1.25v5.37zM13.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "url(#paint3_linear_71376_12488)"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4.5a1 1 0 100 2 1 1 0 000-2zm-2 1a2 2 0 114 0 2 2 0 01-4 0z",
    fill: "#2764E7"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_71376_12488",
    x1: 15.25,
    y1: 20.67,
    x2: 15.25,
    y2: 2.52,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD638"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_71376_12488",
    x1: 9.36,
    y1: 17.41,
    x2: 6.6,
    y2: 2.51,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9C6CFE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4894FE"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_71376_12488",
    x1: 4.8,
    y1: -0.52,
    x2: 8.26,
    y2: 9.71,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#61DBFF",
    stopOpacity: 0.8
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#61DBFF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint1_radial_71376_12488",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(39.81 -12.37 23.35) scale(3.25427 11.49)"
  }, React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B91D6B",
    stopOpacity: 0.45
  }), React.createElement("stop", {
    offset: 0.73,
    stopColor: "#D7257D",
    stopOpacity: 0
  }))));
};
export const ShoppingColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingColorIcon({}), 'ShoppingColor');
const ShoppingFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15.52 2.8c-.38-.49-.98-.8-1.64-.8h-4.7c-.55 0-1.08.22-1.47.6L1.38 8.93a2 2 0 000 2.83l4.95 4.95a2 2 0 002.66.15l2.78 1.6a2 2 0 002.73-.73l4.21-7.3c.29-.49.36-1.08.2-1.62l-1.34-4.52a2.08 2.08 0 00-2.05-1.5zm.42 1.06c.32.12.57.37.67.71l1.34 4.52c.08.29.05.6-.1.85l-4.21 7.3a1 1 0 01-1.37.36l-2.54-1.46 5.74-5.74c.4-.4.62-.95.6-1.52l-.12-4.86v-.16zM13.5 5.5a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};
export const ShoppingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingFilledIcon({}), 'ShoppingFilled');
const ShoppingRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.5 6.5a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13.88 2c.66 0 1.26.31 1.64.8.92-.03 1.78.57 2.05 1.49L18.9 8.8c.16.55.09 1.13-.2 1.63l-4.2 7.3a2 2 0 01-2.74.73l-2.78-1.6a2 2 0 01-2.66-.16l-4.95-4.95a2 2 0 010-2.83l6.33-6.32C8.1 2.2 8.63 2 9.18 2h4.7zm2.07 2.02l.13 4.86c.01.57-.2 1.12-.61 1.52l-5.74 5.74 2.54 1.46a1 1 0 001.37-.37l4.2-7.3c.16-.25.2-.55.1-.84l-1.33-4.52c-.1-.34-.35-.6-.67-.7l.01.15zm-1 .03A1.08 1.08 0 0013.88 3h-4.7c-.29 0-.56.11-.76.31L2.09 9.64a1 1 0 000 1.41L7.04 16a1 1 0 001.41 0l6.31-6.3c.21-.22.33-.5.32-.8l-.13-4.85z",
    fill: "#242424"
  }));
};
export const ShoppingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ShoppingRegularIcon({}), 'ShoppingRegular');
const SkypeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.39 11.05a7.35 7.35 0 00-2.1-6.23 7.5 7.5 0 00-5.27-2.17h-.8A4.65 4.65 0 006.71 2a4.73 4.73 0 00-4.08 2.31 4.61 4.61 0 00-.01 4.66 7.3 7.3 0 002.42 6.6 7.46 7.46 0 005.85 1.78 4.74 4.74 0 005.72-.71 4.65 4.65 0 00.77-5.6z",
    fill: "#28A8EA"
  }), React.createElement("path", {
    d: "M8.25 9.84c-.28-.19-.5-.41-.64-.67a1.87 1.87 0 01-.22-.94c0-.44.13-.82.4-1.12.26-.31.6-.54 1.02-.7.43-.14.88-.22 1.35-.22a5.3 5.3 0 011.52.23c.23.09.39.2.49.31.1.12.15.26.15.42a.6.6 0 01-.16.43.52.52 0 01-.4.17c-.1 0-.2-.02-.3-.07-.26-.11-.5-.2-.7-.25-.2-.06-.43-.09-.67-.09-.34 0-.63.07-.85.22a.7.7 0 00-.34.63c0 .17.06.32.17.45.12.13.28.24.48.34a15.1 15.1 0 001.02.44c.44.19.8.37 1.1.57.29.2.51.42.68.7.16.26.24.59.24.96 0 .46-.11.85-.34 1.16-.23.32-.54.55-.95.7a4 4 0 01-1.42.24c-.79 0-1.44-.12-1.94-.37-.18-.08-.32-.19-.4-.3a.7.7 0 01-.13-.43c0-.18.05-.33.17-.43.11-.1.26-.16.44-.16.17 0 .34.05.51.13l.47.23a2.38 2.38 0 00.92.18c.38 0 .67-.08.87-.23.2-.16.29-.37.29-.64a.67.67 0 00-.18-.46c-.13-.14-.3-.27-.54-.4-.24-.12-.58-.27-1-.45a6.25 6.25 0 01-1.11-.58z",
    fill: "#fff"
  }));
};
export const SkypeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkypeColorIcon({}), 'SkypeColor');
const SkypeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.52 9.2a2 2 0 00.65.66v.02c.35.23.72.42 1.11.57.43.18.77.33 1 .46.21.1.4.23.55.4.12.12.19.28.19.45a.75.75 0 01-.3.63 1.4 1.4 0 01-.88.24 3.24 3.24 0 01-.93-.18l-.46-.23a1.27 1.27 0 00-.52-.13.58.58 0 00-.43.13.52.52 0 00-.18.43c0 .15.05.3.13.42.11.14.25.24.4.31.63.26 1.3.38 1.96.36.5.01.98-.06 1.44-.23.38-.13.7-.38.95-.7.24-.34.36-.74.34-1.16.02-.35-.07-.7-.24-1-.18-.28-.41-.51-.69-.7a6.16 6.16 0 00-1.1-.55h-.13c-.4-.16-.7-.3-.9-.4a1.6 1.6 0 01-.47-.33.64.64 0 01-.2-.45.72.72 0 01.35-.63c.26-.15.56-.22.86-.21.21-.02.43 0 .64.04.24.06.48.15.7.26.1.04.2.06.31.06a.55.55 0 00.4-.16c.11-.13.16-.28.16-.44 0-.15-.05-.3-.15-.41-.14-.15-.3-.25-.49-.31A4.93 4.93 0 008.7 6.4c-.39.14-.73.38-1 .69-.28.32-.42.74-.4 1.17 0 .32.07.64.22.93z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5.07 3.54A4.14 4.14 0 017.13 3c.77-.02 1.52.18 2.18.57h.7c1.74 0 3.4.68 4.62 1.9a6.43 6.43 0 011.84 5.45 4.07 4.07 0 01-.68 4.88 4.15 4.15 0 01-5 .63 6.57 6.57 0 01-6.75-3.75 6.4 6.4 0 01-.5-3.58 4.04 4.04 0 011.53-5.56zm3.7.92A3.15 3.15 0 004.23 5.9c-.15.38-.23.78-.23 1.19-.01.52.12 1.03.36 1.49l.18.3v.34c-.05.26-.07.53-.07.8.02 1.43.62 2.8 1.66 3.8a5.56 5.56 0 003.89 1.56h1l.27.24a3.13 3.13 0 003.75-.45 3.07 3.07 0 00.54-3.7l-.17-.3.05-.34a5.35 5.35 0 00-3.17-5.73 5.5 5.5 0 00-2.3-.47c-.2-.02-.4-.02-.59 0h-.34l-.3-.18z",
    fill: "#242424"
  }));
};
export const SkypeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SkypeRegularIcon({}), 'SkypeRegular');
const SparkleColorColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.54 16.85a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4z",
    fill: "url(#paint0_linear_2036_11077)"
  }), React.createElement("path", {
    d: "M13.54 16.85a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4z",
    fill: "url(#paint1_radial_2036_11077)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M13.54 16.85a.8.8 0 001.22-.4l.25-.76a1.09 1.09 0 01.68-.68l.77-.25a.8.8 0 00-.02-1.52l-.77-.25a1.08 1.08 0 01-.68-.68l-.25-.77a.8.8 0 00-1.52.01l-.24.76a1.1 1.1 0 01-.67.68l-.77.25a.8.8 0 000 1.52l.77.25a1.09 1.09 0 01.68.68l.25.77c.06.16.16.3.3.4z",
    fill: "url(#paint2_radial_2036_11077)"
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5z",
    fill: "url(#paint3_linear_2036_11077)"
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5z",
    fill: "url(#paint4_radial_2036_11077)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M7.4 12.8a1.04 1.04 0 001.59-.51l.45-1.37a2.34 2.34 0 011.47-1.48l1.4-.45A1.04 1.04 0 0012.25 7l-1.37-.45A2.34 2.34 0 019.4 5.08L8.95 3.7a1.03 1.03 0 00-.82-.68 1.04 1.04 0 00-1.15.7l-.46 1.4a2.34 2.34 0 01-1.44 1.45L3.7 7a1.04 1.04 0 00.02 1.97l1.37.45a2.33 2.33 0 011.48 1.48l.46 1.4c.07.2.2.37.38.5z",
    fill: "url(#paint5_radial_2036_11077)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.33436 -1.33339 2.02 2.02147 11.66 16.5)"
  }, React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5178C9"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3E74C7",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint2_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.33665 4.66686 -8.01634 7.44914 11.5 11.5)"
  }, React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C69FFF"
  }), React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C096FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint4_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.89399 -2.76243 4.1849 4.38421 3.4 12.21)"
  }, React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5178C9"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3E74C7",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_2036_11077",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -3.17 7.98) scale(8.92954 15.3377)"
  }, React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C69FFF"
  }), React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C096FF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_2036_11077",
    x1: 12.66,
    y1: 12.17,
    x2: 17.16,
    y2: 17.34,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BA6DF1"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7376E1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4B9DF5"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_2036_11077",
    x1: 4.97,
    y1: 4.71,
    x2: 12.34,
    y2: 12.34,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C67EFF"
  }), React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7376E1"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0F6CBD"
  }))));
};
export const SparkleColorColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/SparkleColorColorIcon({}), 'SparkleColorColor');
const StickyNotesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.75 3C3.78 3 3 3.78 3 4.75v10.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75V4.75C17 3.78 16.22 3 15.25 3H4.75z",
    fill: "#FFC424"
  }), React.createElement("path", {
    d: "M4.75 3C3.78 3 3 3.78 3 4.75v10.5c0 .97.78 1.75 1.75 1.75h10.5c.97 0 1.75-.78 1.75-1.75V4.75C17 3.78 16.22 3 15.25 3H4.75z",
    fill: "url(#paint0_radial_58452_140817)"
  }), React.createElement("path", {
    d: "M17 5.33C17 7.82 10.1 17 8.53 17c.78 0 .5-1.94.25-2.9l-.47-1.8c-.22-.82.2-1.68 1-1.97 3.1-1.11 7.08-1.54 7.69-5z",
    fill: "url(#paint1_linear_58452_140817)"
  }), React.createElement("path", {
    d: "M3 4.75C3 3.78 3.78 3 4.75 3h10.5c.97 0 1.75.78 1.75 1.75v.58c-.5 2.8-3.2 3.61-5.84 4.41-.63.19-1.25.38-1.84.6A1.64 1.64 0 008.3 12.3l.47 1.8c.24.92.51 2.77-.18 2.88h-.04l-.03.01H4.75C3.78 17 3 16.22 3 15.25V4.75z",
    fill: "url(#paint2_linear_58452_140817)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint1_linear_58452_140817",
    x1: 8.71,
    y1: 8.79,
    x2: 14.74,
    y2: 13.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#C86FEC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9427C3"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_58452_140817",
    x1: 13.04,
    y1: 11.64,
    x2: 3.49,
    y2: 3.66,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFDC57"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFC424"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB152"
  })), React.createElement("radialGradient", {
    id: "paint0_radial_58452_140817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(12.49999 7.99998 -16.62326 25.9739 8.38 10.5)"
  }, React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A43303"
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFC525",
    stopOpacity: 0
  }))));
};
export const StickyNotesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickyNotesColorIcon({}), 'StickyNotesColor');
const StickyNotesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8c.5 0 .96.12 1.37.33 1.48.97 1.06 3.96-.95 4.72-.95.35-2 .6-3.05.83-.9.2-1.81.42-2.67.7a2.48 2.48 0 00-1.61 3c.07.24.22.55.38.91.54 1.17 1.27 2.76.23 3.51H6a3 3 0 01-3-3V6zm5.84 11H14a3 3 0 003-3V6.9l-.02.04c-1.27 3.9-5.39 9.15-8.14 10.06z",
    fill: primaryFill
  }));
};
export const StickyNotesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickyNotesFilledIcon({}), 'StickyNotesFilled');
const StickyNotesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3.19V14a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm13 .07V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8c0 1.1.9 2 2 2h2.04a.24.24 0 00.08-.07c.02-.04.05-.1.06-.21.02-.23-.05-.56-.2-.96-.13-.4-.32-.8-.5-1.17l-.03-.07c-.15-.33-.3-.67-.37-.9-.3-1.17.27-2.55 1.47-2.98.91-.33 1.86-.55 2.74-.75l.35-.08c.76-.17 1.46-.32 2.08-.52.72-.23 1.27-.5 1.65-.86.35-.32.57-.75.63-1.36zM10.58 16H14a2 2 0 002-2V9.18a23.08 23.08 0 01-2.15 3.42 18.36 18.36 0 01-3.27 3.4z",
    fill: primaryFill
  }));
};
export const StickyNotesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StickyNotesRegularIcon({}), 'StickyNotesRegular');
const StreamColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.06 10v5.56c0 1.14 1.32 1.83 2.32 1.2l8.94-5.55c.45-.29.68-.75.68-1.21l-5.97-1-5.97 1z",
    fill: "url(#paint0_linear_53046_136107)"
  }), React.createElement("path", {
    d: "M8.37 3.23c-1-.61-2.3.07-2.3 1.21V10H18c0-.46-.23-.92-.68-1.2L8.38 3.22z",
    fill: "url(#paint1_linear_53046_136107)"
  }), React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 12,
    height: 14
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06 4.44c0-1.14 1.31-1.82 2.31-1.2l8.94 5.55c.46.3.69.75.69 1.21H6.06V4.44zm0 11.12V10H18c0 .46-.23.92-.69 1.2l-8.93 5.57c-1 .62-2.32-.07-2.32-1.21z",
    fill: "url(#paint2_linear_53046_136107)"
  })), React.createElement("g", {
    filter: "url(#filter0_dd_53046_136107)",
    mask: "url(#a)"
  }, React.createElement("path", {
    d: "M3 6.67c0-.58.68-.92 1.17-.6l5.04 3.34a.7.7 0 010 1.18l-5.04 3.34c-.5.32-1.17-.02-1.17-.6V6.67z",
    fill: "url(#paint3_linear_53046_136107)"
  })), React.createElement("path", {
    d: "M3 6.67c0-.58.68-.92 1.18-.6l5.04 3.34a.7.7 0 010 1.18l-5.04 3.34c-.5.32-1.18-.02-1.18-.6V6.67z",
    fill: "url(#paint4_linear_53046_136107)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_53046_136107",
    x1: 6.06,
    y1: 9.98,
    x2: 6.65,
    y2: 16.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#BD3177"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#832054"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_53046_136107",
    x1: 6.06,
    y1: 2.98,
    x2: 6.66,
    y2: 9.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F992CA"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DA3988"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_53046_136107",
    x1: 6.06,
    y1: 2.98,
    x2: 6.66,
    y2: 9.93,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF98E8"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E11275"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_53046_136107",
    x1: 6.27,
    y1: 5.95,
    x2: 6.27,
    y2: 14.05,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9D73CB"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BC1948"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6F99"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_53046_136107",
    x1: 3,
    y1: 5.93,
    x2: 4.42,
    y2: 13.77,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F992CA"
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DA3988"
  })), React.createElement("filter", {
    id: "filter0_dd_53046_136107",
    x: 2.66,
    y: 5.61,
    width: 7.9,
    height: 9.46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dx: 0.34,
    dy: 0.34
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.34
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_53046_136107"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", {
    dy: 0.07
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.03
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_53046_136107",
    result: "effect2_dropShadow_53046_136107"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_53046_136107",
    result: "shape"
  }))));
};
export const StreamColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamColorIcon({}), 'StreamColor');
const StreamFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.67 3.26l8.5 5.25c1.1.69 1.1 2.3 0 2.98l-8.5 5.25A1.75 1.75 0 016 15.24v-.48l4.07-2.94a2.25 2.25 0 000-3.64L6 5.24v-.49c0-1.37 1.5-2.2 2.67-1.49zM3 6.76a1.25 1.25 0 011.98-1.02l4.5 3.25c.7.5.7 1.53 0 2.02l-4.5 3.25c-.82.6-1.98 0-1.98-1.01v-6.5z",
    fill: primaryFill
  }));
};
export const StreamFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamFilledIcon({}), 'StreamFilled');
const StreamRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.67 3.26l8.5 5.25c1.1.69 1.1 2.3 0 2.98l-8.5 5.25A1.75 1.75 0 016 15.24v-1.71l-1.02.73c-.82.6-1.98 0-1.98-1.01v-6.5a1.25 1.25 0 011.98-1.01L6 6.47V4.75c0-1.37 1.5-2.2 2.67-1.49zM7 7.2l2.48 1.79c.7.5.7 1.53 0 2.02L7 12.81v2.44c0 .59.65.95 1.15.64l8.5-5.25a.75.75 0 000-1.28l-8.5-5.25A.75.75 0 007 4.75V7.2zm-3-.45v6.5c0 .2.23.32.4.2l4.5-3.25c.13-.1.13-.3 0-.4L4.4 6.55a.25.25 0 00-.4.2z",
    fill: primaryFill
  }));
};
export const StreamRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StreamRegularIcon({}), 'StreamRegular');
const StrideColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.92 2.87a2.98 2.98 0 014.2 4.21l-9.35 9.36c-.34.34-.77.57-1.23.68l-3.93.87a.5.5 0 01-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2l9.37-9.37z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.92 2.87a2.98 2.98 0 014.2 4.21l-9.35 9.36c-.34.34-.77.57-1.23.68l-3.93.87a.5.5 0 01-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2l9.37-9.37z",
    fill: "url(#paint0_linear_78368_6855)"
  }), React.createElement("path", {
    d: "M12.92 2.87a2.98 2.98 0 014.2 4.21l-9.35 9.36c-.34.34-.77.57-1.23.68l-3.93.87a.5.5 0 01-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2l9.37-9.37z",
    fill: "url(#paint1_linear_78368_6855)"
  }), React.createElement("path", {
    d: "M2.55 2.55c.56-.55 1.32-.63 2.09-.48.76.15 1.61.55 2.48 1.07a30.63 30.63 0 015.35 4.38 30.63 30.63 0 014.38 5.36c.53.86.92 1.72 1.07 2.48.16.76.08 1.53-.48 2.08-.55.56-1.32.64-2.08.49a8.12 8.12 0 01-2.49-1.07c-.63-.39-1.3-.86-1.96-1.37a.5.5 0 01-.04-.74.5.5 0 01.67-.04c.63.49 1.26.93 1.85 1.3.83.5 1.56.82 2.16.94.6.12.96.01 1.19-.21.22-.23.32-.6.2-1.19A7.18 7.18 0 0016 13.4c-1-1.65-2.6-3.53-4.24-5.16A29.66 29.66 0 006.6 4a7.18 7.18 0 00-2.16-.95c-.6-.12-.96-.01-1.18.21-.23.23-.33.59-.21 1.18.12.6.45 1.34.95 2.16.36.6.8 1.22 1.29 1.86a.5.5 0 01-.04.67.5.5 0 01-.74-.05c-.52-.66-.99-1.32-1.37-1.96a8.12 8.12 0 01-1.07-2.48c-.15-.76-.08-1.53.48-2.09z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M2.55 2.55c.56-.55 1.32-.63 2.09-.48.76.15 1.61.55 2.48 1.07a30.63 30.63 0 015.35 4.38 30.63 30.63 0 014.38 5.36c.53.86.92 1.72 1.07 2.48.16.76.08 1.53-.48 2.08-.55.56-1.32.64-2.08.49a8.12 8.12 0 01-2.49-1.07c-.63-.39-1.3-.86-1.96-1.37a.5.5 0 01-.04-.74.5.5 0 01.67-.04c.63.49 1.26.93 1.85 1.3.83.5 1.56.82 2.16.94.6.12.96.01 1.19-.21.22-.23.32-.6.2-1.19A7.18 7.18 0 0016 13.4c-1-1.65-2.6-3.53-4.24-5.16A29.66 29.66 0 006.6 4a7.18 7.18 0 00-2.16-.95c-.6-.12-.96-.01-1.18.21-.23.23-.33.59-.21 1.18.12.6.45 1.34.95 2.16.36.6.8 1.22 1.29 1.86a.5.5 0 01-.04.67.5.5 0 01-.74-.05c-.52-.66-.99-1.32-1.37-1.96a8.12 8.12 0 01-1.07-2.48c-.15-.76-.08-1.53.48-2.09z",
    fill: "#08009A"
  }), React.createElement("path", {
    d: "M2.55 2.55c.56-.55 1.32-.63 2.09-.48.76.15 1.61.55 2.48 1.07a30.63 30.63 0 015.35 4.38 30.63 30.63 0 014.38 5.36c.53.86.92 1.72 1.07 2.48.16.76.08 1.53-.48 2.08-.55.56-1.32.64-2.08.49a8.12 8.12 0 01-2.49-1.07c-.63-.39-1.3-.86-1.96-1.37a.5.5 0 01-.04-.74.5.5 0 01.67-.04c.63.49 1.26.93 1.85 1.3.83.5 1.56.82 2.16.94.6.12.96.01 1.19-.21.22-.23.32-.6.2-1.19A7.18 7.18 0 0016 13.4c-1-1.65-2.6-3.53-4.24-5.16A29.66 29.66 0 006.6 4a7.18 7.18 0 00-2.16-.95c-.6-.12-.96-.01-1.18.21-.23.23-.33.59-.21 1.18.12.6.45 1.34.95 2.16.36.6.8 1.22 1.29 1.86a.5.5 0 01-.04.67.5.5 0 01-.74-.05c-.52-.66-.99-1.32-1.37-1.96a8.12 8.12 0 01-1.07-2.48c-.15-.76-.08-1.53.48-2.09z",
    fill: "url(#paint2_linear_78368_6855)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_78368_6855",
    x1: 14.8,
    y1: 2.4,
    x2: -6.61,
    y2: 15.46,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFC470"
  }), React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FF835C"
  }), React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F24A9D"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B339F0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_78368_6855",
    x1: 15.6,
    y1: 6.8,
    x2: 4,
    y2: 18.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFB96E",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F44A65"
  }), React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F44A65"
  }), React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F8677C",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint2_linear_78368_6855",
    x1: 4,
    y1: 14.4,
    x2: 19.6,
    y2: -2.8,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.21,
    stopColor: "#4E46E2",
    stopOpacity: 0.8
  }), React.createElement("stop", {
    offset: 0.36,
    stopColor: "#625DF6"
  }), React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E37DFF"
  }))));
};
export const StrideColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/StrideColorIcon({}), 'StrideColor');
const StrideFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.88 6.92a37.54 37.54 0 014.2 4.2l-5.31 5.32c-.34.34-.77.57-1.23.68l-3.93.87a.5.5 0 01-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2l5.33-5.32zM2.55 2.55c.56-.55 1.32-.63 2.09-.48.76.15 1.61.55 2.48 1.07a30.64 30.64 0 015.35 4.38 30.63 30.63 0 014.38 5.36c.53.86.92 1.72 1.08 2.48.15.76.07 1.53-.49 2.09-.55.55-1.32.63-2.08.48a8.12 8.12 0 01-2.49-1.07c-.63-.39-1.3-.86-1.96-1.37a.5.5 0 01-.04-.74.5.5 0 01.67-.04c.63.49 1.26.93 1.85 1.3.83.5 1.56.82 2.16.94.6.12.96.01 1.18-.21.23-.23.33-.6.21-1.19A7.17 7.17 0 0016 13.4c-1-1.64-2.6-3.53-4.24-5.16A29.67 29.67 0 006.6 4a7.17 7.17 0 00-2.16-.95c-.6-.12-.96-.01-1.18.21-.23.23-.33.59-.21 1.19.12.6.45 1.33.95 2.15.36.6.8 1.22 1.29 1.86a.5.5 0 01-.04.67.5.5 0 01-.74-.05c-.52-.66-.99-1.32-1.37-1.96a8.12 8.12 0 01-1.07-2.48c-.15-.76-.08-1.53.48-2.09zm10.37.32a2.98 2.98 0 014.2 4.21L15.22 9a40.92 40.92 0 00-4.2-4.21l1.91-1.92z",
    fill: primaryFill
  }));
};
export const StrideFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/StrideFilledIcon({}), 'StrideFilled');
const StrideRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.63 7.58l-5.38 5.38c-.19.19-.32.43-.38.7l-.71 3.18 3.16-.7c.28-.06.54-.2.74-.4l5.36-5.37.66.75-5.31 5.32c-.34.34-.77.57-1.23.68l-3.93.87a.5.5 0 01-.6-.6l.88-3.95c.1-.45.33-.86.66-1.2l5.32-5.32c.26.21.5.43.76.66zM2.55 2.55c.56-.55 1.33-.63 2.1-.48.75.15 1.6.55 2.47 1.07a30.64 30.64 0 015.35 4.38 30.63 30.63 0 014.39 5.36c.52.86.92 1.72 1.07 2.48.15.76.07 1.53-.48 2.09-.56.55-1.33.63-2.1.48a8.13 8.13 0 01-2.47-1.07 20.8 20.8 0 01-1.96-1.37.5.5 0 01-.05-.74.5.5 0 01.67-.04c.64.49 1.26.93 1.85 1.3.83.5 1.57.82 2.16.94.6.12.96.01 1.19-.21.22-.23.33-.6.2-1.19A7.17 7.17 0 0016 13.4c-1-1.64-2.6-3.53-4.23-5.16A29.67 29.67 0 006.6 4a7.17 7.17 0 00-2.16-.95c-.6-.12-.96-.01-1.19.21-.22.23-.33.59-.2 1.19.11.6.44 1.33.94 2.15.36.6.8 1.22 1.3 1.86a.5.5 0 01-.05.67.5.5 0 01-.74-.05C4 8.42 3.53 7.76 3.14 7.12a8.12 8.12 0 01-1.07-2.48c-.15-.76-.07-1.53.48-2.09zm10.37.32a2.98 2.98 0 014.2 4.21L15.22 9l-.66-.75 1.87-1.88a1.97 1.97 0 00-2.8-2.79l-1.87 1.87L11 4.8l1.92-1.92z",
    fill: primaryFill
  }));
};
export const StrideRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/StrideRegularIcon({}), 'StrideRegular');
const SuiteTaskbarColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.62 9.15a1.33 1.33 0 01.22-1.87l6.34-5a1.33 1.33 0 011.88.23l3.3 4.19c.45.58.35 1.42-.23 1.87l-6.34 5c-.58.45-1.42.35-1.87-.23l-3.3-4.2z",
    fill: "url(#paint0_linear_74711_27268)"
  }), React.createElement("path", {
    d: "M3.62 9.15a1.33 1.33 0 01.22-1.87l6.34-5a1.33 1.33 0 011.88.23l3.3 4.19c.45.58.35 1.42-.23 1.87l-6.34 5c-.58.45-1.42.35-1.87-.23l-3.3-4.2z",
    fill: "url(#paint1_radial_74711_27268)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M5.15 9.04c-.28-.68.03-1.46.71-1.75l7.67-3.26c.68-.29 1.46.03 1.75.7l2.08 4.92c.3.68-.02 1.46-.7 1.75l-7.67 3.25a1.33 1.33 0 01-1.75-.7L5.15 9.04z",
    fill: "url(#paint2_linear_74711_27268)"
  }), React.createElement("path", {
    d: "M5.15 9.04c-.28-.68.03-1.46.71-1.75l7.67-3.26c.68-.29 1.46.03 1.75.7l2.08 4.92c.3.68-.02 1.46-.7 1.75l-7.67 3.25a1.33 1.33 0 01-1.75-.7L5.15 9.04z",
    fill: "url(#paint3_radial_74711_27268)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M5.15 9.04c-.28-.68.03-1.46.71-1.75l7.67-3.26c.68-.29 1.46.03 1.75.7l2.08 4.92c.3.68-.02 1.46-.7 1.75l-7.67 3.25a1.33 1.33 0 01-1.75-.7L5.15 9.04z",
    fill: "url(#paint4_radial_74711_27268)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M7 9.33C7 8.6 7.6 8 8.33 8h8.34C17.4 8 18 8.6 18 9.33v5.34c0 .73-.6 1.33-1.33 1.33H8.33C7.6 16 7 15.4 7 14.67V9.33z",
    fill: "url(#paint5_linear_74711_27268)"
  }), React.createElement("path", {
    d: "M7 9.33C7 8.6 7.6 8 8.33 8h8.34C17.4 8 18 8.6 18 9.33v5.34c0 .73-.6 1.33-1.33 1.33H8.33C7.6 16 7 15.4 7 14.67V9.33z",
    fill: "url(#paint6_radial_74711_27268)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M7 9.33C7 8.6 7.6 8 8.33 8h8.34C17.4 8 18 8.6 18 9.33v5.34c0 .73-.6 1.33-1.33 1.33H8.33C7.6 16 7 15.4 7 14.67V9.33z",
    fill: "url(#paint7_linear_74711_27268)"
  }), React.createElement("path", {
    d: "M7 9.33C7 8.6 7.6 8 8.33 8h8.34C17.4 8 18 8.6 18 9.33v5.34c0 .73-.6 1.33-1.33 1.33H8.33C7.6 16 7 15.4 7 14.67V9.33z",
    fill: "url(#paint8_radial_74711_27268)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.36l1.5 1.5-.47.47-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "#2764E7"
  }), React.createElement("path", {
    d: "M9.47 16.86a.67.67 0 01-.94.94l.94-.94zM5.33 10a3.33 3.33 0 012.64 5.36l1.5 1.5-.47.47-.47.47-1.57-1.56A3.33 3.33 0 115.33 10z",
    fill: "url(#paint9_radial_74711_27268)",
    fillOpacity: 0.85
  }), React.createElement("path", {
    d: "M7.33 13.33a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "url(#paint10_linear_74711_27268)"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_74711_27268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-95.3 11.7 3.47) scale(12.7377 14.0654)"
  }, React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F4A7F7",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A7F7"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_74711_27268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(126.43 2.1 8.53) scale(8.58547 8.22906)"
  }, React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFCD0F",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE994"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_74711_27268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.9265 3.86232 -9.36257 2.24589 12.15 9.63)"
  }, React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D7257D"
  }), React.createElement("stop", {
    offset: 0.84,
    stopColor: "#D7257D",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_74711_27268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-56.45 20.4 1.82) scale(12.831 14.3068)"
  }, React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F4A7F7",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A7F7"
  })), React.createElement("radialGradient", {
    id: "paint8_radial_74711_27268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(149.77 3.46 8.4) scale(8.72493 8.30539)"
  }, React.createElement("stop", {
    offset: 0.73,
    stopColor: "#59C2DF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#76EB95"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_74711_27268",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(5.10393 6.45042 -4.71514 3.73088 2.05 10)"
  }, React.createElement("stop", {
    stopColor: "#66C0FF"
  }), React.createElement("stop", {
    offset: 0.74,
    stopColor: "#66C0FF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_74711_27268",
    x1: 6.4,
    y1: 4.93,
    x2: 6.68,
    y2: 10.57,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6CE0FF"
  }), React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0FAFFF"
  }), React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2764E7"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_74711_27268",
    x1: 10.68,
    y1: 4.99,
    x2: 12.34,
    y2: 10.96,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FDCF40"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF9D1D"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_74711_27268",
    x1: 10.56,
    y1: 8.01,
    x2: 13.27,
    y2: 16.2,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#6CE0FF"
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0FAFFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_74711_27268",
    x1: 11.12,
    y1: 8.35,
    x2: 12.18,
    y2: 15.89,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#43E5CA"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1384B1"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_74711_27268",
    x1: 3.83,
    y1: 12.08,
    x2: 6.59,
    y2: 14.84,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#9DEAFF"
  }))));
};
export const SuiteTaskbarColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/SuiteTaskbarColorIcon({}), 'SuiteTaskbarColor');
const SuiteTaskbarFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.5 9.5a3.5 3.5 0 012.58 5.87l1.77 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.3 16a3.5 3.5 0 11-1.8-6.5zm2.94-7.18a2.03 2.03 0 012.67.44l1.32 1.62-.02.01c.95-.24 1.96.25 2.36 1.18v.01l.95 2.45h.25c1.12 0 2.03.9 2.03 2.02v3.93c0 1.12-.9 2.02-2.03 2.02h-5.85l-.73-.73.14-.26h6.44c.57 0 1.03-.46 1.03-1.03v-3.93c0-.57-.46-1.03-1.03-1.03H9.02c-.33 0-.62.16-.8.4A4.48 4.48 0 005.5 8.5h-.02a2 2 0 011.21-1.71l4.76-2.02-1.12-1.39-.07-.08c-.34-.34-.88-.4-1.28-.14l-.09.06-4.59 3.7c-.43.35-.5.99-.14 1.43v.01l.22.28c-.34.09-.67.21-.97.37l-.04-.04a2.02 2.02 0 01.3-2.83l4.6-3.7.17-.12zM5.5 10.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
    fill: primaryFill
  }));
};
export const SuiteTaskbarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SuiteTaskbarFilledIcon({}), 'SuiteTaskbarFilled');
const SuiteTaskbarRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.65 9.5c.4.02.79.1 1.14.25l.01.03.2.08v-.02c.37.17.7.41.99.7v.03a3.48 3.48 0 01.37 4.44c-.08.12-.18.24-.29.36l1.78 1.78.07.07a.5.5 0 01-.7.7l-.07-.07L7.29 16c-.32.2-.67.33-1.04.42l-.08.01A3.5 3.5 0 012 13.18V13c0-1.4.84-2.61 2.04-3.16l-.02-.01c.32-.15.67-.26 1.03-.3l.02.02a3.53 3.53 0 01.6-.02l-.02-.03zm2.79-7.18a2.03 2.03 0 012.67.44l1.32 1.62-.02.01c.95-.24 1.96.25 2.36 1.17v.02l.95 2.45h.25c1.12 0 2.03.9 2.03 2.02v3.93c0 1.12-.9 2.02-2.03 2.02h-5.85l-.73-.73.14-.26h6.44c.57 0 1.03-.46 1.03-1.03v-3.93c0-.57-.46-1.03-1.03-1.03H9.02c-.33 0-.62.16-.8.4a4.5 4.5 0 00-.87-.52c.37-.53.98-.87 1.67-.87h5.63l-.8-2.08a1.02 1.02 0 00-1.24-.58l-.1.03-5.43 2.3c-.37.16-.6.52-.61.9-.31-.06-.64-.1-.97-.1h-.02a2 2 0 011.21-1.71l4.76-2.02-1.12-1.39-.07-.08c-.34-.34-.88-.4-1.28-.14l-.09.06-4.59 3.7c-.43.34-.5.99-.14 1.43v.01l.22.28c-.34.09-.67.21-.97.37l-.04-.04a2.02 2.02 0 01.3-2.83l4.6-3.7.17-.12zm-2.95 8.2a2.5 2.5 0 100 4.99 2.5 2.5 0 000-4.99z",
    fill: primaryFill
  }));
};
export const SuiteTaskbarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SuiteTaskbarRegularIcon({}), 'SuiteTaskbarRegular');
const SyntexColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.5 12.5c-.14.01-.25.48-.35.6a.6.6 0 00.18.92l8.03 3.89a.97.97 0 00.9-.04l6.6-3.73a.26.26 0 00.06-.4.24.24 0 00-.12-.07l-7-1.4L6.5 12l-4 .5z",
    fill: "#5E438F"
  }), React.createElement("path", {
    d: "M2.5 12.5c-.14.01-.25.48-.35.6a.6.6 0 00.18.92l8.03 3.89a.97.97 0 00.9-.04l6.6-3.73a.26.26 0 00.06-.4.24.24 0 00-.12-.07l-7-1.4L6.5 12l-4 .5z",
    fill: "url(#paint0_linear_1_66)",
    style: {
      mixBlendMode: "multiply"
    }
  }), React.createElement("path", {
    d: "M17.53 4c.18-.08.33-.72.4-.9a.8.8 0 00.03-.57.82.82 0 00-.92-.52L2.41 4.31a.48.48 0 00-.4.48v1.3a.48.48 0 00.31.46l5.06 1.8L13 7l4.53-3z",
    fill: "#159CA2"
  }), React.createElement("path", {
    d: "M17.53 4c.18-.08.33-.72.4-.9a.8.8 0 00.03-.57.82.82 0 00-.92-.52L2.41 4.31a.48.48 0 00-.4.48v1.3a.48.48 0 00.31.46l5.06 1.8L13 7l4.53-3z",
    fill: "url(#paint1_linear_1_66)"
  }), React.createElement("path", {
    d: "M17.55 3.51l-.06.03-10.1 4.8-4.99 2.37-.08.04a.56.56 0 00-.32.5v2.23a.56.56 0 01.52-.56l8.01-.62 6.54-.51.19-.02a.8.8 0 00.74-.8V2.8a.79.79 0 01-.45.71z",
    fill: "#49C9EE"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_1_66",
    x1: 14.01,
    y1: 15.76,
    x2: 2.28,
    y2: 11.27,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#5E438F",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5E438F",
    stopOpacity: 0.7
  })), React.createElement("linearGradient", {
    id: "paint1_linear_1_66",
    x1: 1.98,
    y1: 4.25,
    x2: 18.19,
    y2: 5.7,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#066E74",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.99,
    stopColor: "#066E74"
  }))));
};
export const SyntexColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyntexColorIcon({}), 'SyntexColor');
const SyntexFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.32 6.55l3.73 1.32 11.76-5.59a.82.82 0 00-.76-.27L2.4 4.31A.48.48 0 002 4.8v1.3a.48.48 0 00.32.46zm.08 4.16L6.21 8.9 18 3.3v7.67a.8.8 0 01-.74.8l-.18.02-.94.07L2 12.96v-1.72a.56.56 0 01.32-.5l.08-.04zm-.18 3.25l.1.06 8.04 3.89a.97.97 0 00.9-.04l6.61-3.73a.25.25 0 00.1-.1.26.26 0 00-.04-.3.24.24 0 00-.13-.07L14.4 13l-12.18.97z",
    fill: primaryFill
  }));
};
export const SyntexFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyntexFilledIcon({}), 'SyntexFilled');
const SyntexRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.66 11.77c.22-.23.34-.53.33-.85V3.25a1.23 1.23 0 00-.62-1.08 1.4 1.4 0 00-.85-.17L2.8 4.18a1 1 0 00-.58.32 1 1 0 00-.22.62v1.23a.94.94 0 00.63.89l3.6 1.28-3.65 1.74a1 1 0 00-.58.92v2.09c0 .2.06.38.16.55.1.17.26.3.44.39l7.53 3.64c.19.09.4.14.6.14.23 0 .45-.07.65-.18l6.2-3.5a.84.84 0 00.3-.32c.06-.14.09-.3.06-.44a.66.66 0 00-.19-.39.7.7 0 00-.38-.22l-3-.6 2.44-.19c.32-.01.63-.15.85-.38zM3 6.35V5.17L16.69 3a.29.29 0 01.18 0c.05.03.1.07.12.13a.3.3 0 010 .13.2.2 0 010 .07l-.06.06h-.05L7.51 7.92 3 6.35zm13.52 7.45L10.93 17a.41.41 0 01-.19.05.43.43 0 01-.19 0l-7.5-3.7 7.7-.62 5.77 1.07zm-6-2.14L3 12.23v-1.05l14-6.67v6.41a.24.24 0 01-.07.17.2.2 0 01-.16.08l-6.25.49z",
    fill: primaryFill
  }));
};
export const SyntexRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/SyntexRegularIcon({}), 'SyntexRegular');
const TableLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M17 10.41a4.98 4.98 0 00-4 0V8h4v2.41z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.42 13a4.98 4.98 0 00-.42 2v2H8v-4h2.42z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 11c-.38.29-.71.62-1 1H8V8h4v3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 8v4H3V8h4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 13H3v1.5A2.5 2.5 0 005.5 17H7v-4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17 7h-4V3h1.5A2.5 2.5 0 0117 5.5V7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 7V3H8v4h4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 7V3H5.5A2.5 2.5 0 003 5.5V7h4z",
    fill: primaryFill
  }));
};
export const TableLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TableLoopFilledIcon({}), 'TableLoopFilled');
const TaskListLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M5.85 3.65c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 11.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 5.25c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 018 5.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 10.25c0-.41.34-.75.75-.75h8.5a.75.75 0 01.5 1.32A4.98 4.98 0 0012 11H8.75a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.03 14.5H8.75a.75.75 0 000 1.5H10v-1c0-.17.01-.34.03-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5.85 9.15c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5.85 14.85a.5.5 0 00-.7-.7L3.5 15.79l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2z",
    fill: primaryFill
  }));
};
export const TaskListLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TaskListLtrLoopFilledIcon({}), 'TaskListLtrLoopFilled');
const TeamsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10 9h5.57A2.43 2.43 0 0118 11.43v4.07a2.5 2.5 0 01-5 0v-4.07A2.43 2.43 0 0010.57 9H10z",
    fill: "url(#paint0_radial_79314_10653)"
  }), React.createElement("path", {
    d: "M10 9h5.57A2.43 2.43 0 0118 11.43v4.07a2.5 2.5 0 01-5 0v-4.07A2.43 2.43 0 0010.57 9H10z",
    fill: "url(#paint1_linear_79314_10653)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M4 9.43A2.43 2.43 0 016.43 7h4.14A2.43 2.43 0 0113 9.43v6.07a2.5 2.5 0 002.5 2.5H8.17A4.17 4.17 0 014 13.83v-4.4z",
    fill: "url(#paint2_radial_79314_10653)"
  }), React.createElement("path", {
    d: "M4 9.43A2.43 2.43 0 016.43 7h4.14A2.43 2.43 0 0113 9.43v6.07a2.5 2.5 0 002.5 2.5H8.17A4.17 4.17 0 014 13.83v-4.4z",
    fill: "url(#paint3_linear_79314_10653)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M4 9.43A2.43 2.43 0 016.43 7h4.14A2.43 2.43 0 0113 9.43v6.07a2.5 2.5 0 002.5 2.5H8.17A4.17 4.17 0 014 13.83v-4.4z",
    fill: "url(#paint4_radial_79314_10653)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M15 8a2 2 0 100-4 2 2 0 000 4z",
    fill: "url(#paint5_radial_79314_10653)"
  }), React.createElement("path", {
    d: "M15 8a2 2 0 100-4 2 2 0 000 4z",
    fill: "url(#paint6_radial_79314_10653)",
    fillOpacity: 0.56
  }), React.createElement("path", {
    d: "M15 8a2 2 0 100-4 2 2 0 000 4z",
    fill: "url(#paint7_linear_79314_10653)",
    fillOpacity: 0.4
  }), React.createElement("path", {
    d: "M8.5 6a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "url(#paint8_radial_79314_10653)"
  }), React.createElement("path", {
    d: "M8.5 6a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "url(#paint9_radial_79314_10653)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M8.5 6a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "url(#paint10_linear_79314_10653)",
    fillOpacity: 0.5
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint11_radial_79314_10653)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint12_radial_79314_10653)",
    fillOpacity: 0.7
  }), React.createElement("path", {
    d: "M8.4 9.92H7.08V14H5.93V9.92H4.6V9h3.82v.92z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(36.4 0 0 34.125 18.53 11.13)"
  }, React.createElement("stop", {
    stopColor: "#A386FF"
  }), React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6B5BEA"
  }), React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3F2FBC"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.39062 13.9333 -13.3528 5.625 4.36 6.27)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#85C2FF"
  }), React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7588FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#6459FE"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.36586 8.08858 -7.75155 -3.5122 12.63 6.63)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#BD96FF"
  }), React.createElement("stop", {
    offset: 0.69,
    stopColor: "#BD96FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -4.6664 4.6664 0 15 5.43)"
  }, React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6868F7"
  }), React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3923B1"
  })), React.createElement("radialGradient", {
    id: "paint6_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 1.03 17.7) scale(5.70676)"
  }, React.createElement("stop", {
    offset: 0.17,
    stopColor: "#A1D3FF"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#A1D3FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint8_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-90 5.64 -2.86) scale(5.74108)"
  }, React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8282FF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#3923B1"
  })), React.createElement("radialGradient", {
    id: "paint9_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(46.91 1.04 7.58) scale(5.02383)"
  }, React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A1D3FF"
  }), React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A1D3FF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint11_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#688EFF"
  }), React.createElement("stop", {
    offset: 0.95,
    stopColor: "#230F94"
  })), React.createElement("radialGradient", {
    id: "paint12_radial_79314_10653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 -3.1 9.6) scale(6.87288)"
  }, React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6965F6",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8FFF"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_79314_10653",
    x1: 18,
    y1: 12.42,
    x2: 11.63,
    y2: 12.42,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3C2CB8",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#10008F"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79314_10653",
    x1: 9.57,
    y1: 7,
    x2: 9.57,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6864F6",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5149DE"
  })), React.createElement("linearGradient", {
    id: "paint7_linear_79314_10653",
    x1: 14.05,
    y1: 7.21,
    x2: 19.14,
    y2: 2.68,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9FA2FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E3ACFD"
  })), React.createElement("linearGradient", {
    id: "paint10_linear_79314_10653",
    x1: 7.31,
    y1: 5.01,
    x2: 13.67,
    y2: -0.64,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9FA2FF",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E3ACFD"
  }))));
};
export const TeamsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeamsColorIcon({}), 'TeamsColor');
const TeamsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.5 7A2.5 2.5 0 0114 9.5v7c0 .56.19 1.08.5 1.5h-3.25c-1.04 0-2-.38-2.74-1H9a3 3 0 003-3V9c0-.77-.3-1.47-.77-2h.27zM16 9a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0v-7c0-.17-.01-.34-.04-.5H16zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zM4.6 9.92h1.33V14h1.14V9.92H8.4V9H4.59v.92zM15 3a2 2 0 110 4 2 2 0 010-4zM8.5 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: primaryFill
  }));
};
export const TeamsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeamsFilledIcon({}), 'TeamsFilled');
const TeamsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.5 7a2.5 2.5 0 012.45 2h2.55a2.5 2.5 0 012.5 2.5V15a3 3 0 01-3 3H8.25c-1.52 0-2.85-.8-3.6-2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h6.5zm.24 1.02A2 2 0 0111 9v5a2 2 0 01-2 2H5.9c.6.62 1.43 1 2.35 1h4.52a2.98 2.98 0 01-.77-2V9.5a1.5 1.5 0 00-1.26-1.48zM13 15a2 2 0 104 0v-3.5c0-.83-.67-1.5-1.5-1.5H13v5zM4.6 9.92h1.33V14h1.14V9.92H8.4V9H4.59v.92zM15 4a2 2 0 110 4 2 2 0 010-4zm0 1a1 1 0 100 2 1 1 0 000-2zM8.5 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm0 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};
export const TeamsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/TeamsRegularIcon({}), 'TeamsRegular');
const TextBulletListLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M4.5 5A1.25 1.25 0 112 5a1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.75 4.25a.75.75 0 000 1.5h9.5a.75.75 0 000-1.5h-9.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 10c0-.41.34-.75.75-.75h9.5a.75.75 0 010 1.5h-.07a4.98 4.98 0 00-4.36 0H7.75A.75.75 0 017 10z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.1 14.25H7.75a.75.75 0 000 1.5H10v-.5c0-.34.04-.68.1-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3.25 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4.5 15A1.25 1.25 0 112 15a1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }));
};
export const TextBulletListLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextBulletListLtrLoopFilledIcon({}), 'TextBulletListLtrLoopFilled');
const TextNumberListLtrLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M4.61 1.01A.5.5 0 015 1.5v4a.5.5 0 01-1 0V2.92c-.22.2-.48.38-.78.53a.5.5 0 01-.44-.9 2.96 2.96 0 001.2-1.15l.07-.12A.5.5 0 014.61 1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 4.75c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 018 4.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 9.75c0-.41.34-.75.75-.75h7.5a.75.75 0 01.5 1.31 4.99 4.99 0 00-3.93.19H8.75A.75.75 0 018 9.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.1 14H8.75a.75.75 0 000 1.5H10V15c0-.34.04-.68.1-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2.65 8.35a.5.5 0 010-.7v-.01h.01a1.36 1.36 0 01.12-.11A2.5 2.5 0 014.32 7c.38 0 .79.1 1.11.35C5.78 7.6 6 8 6 8.5c0 .55-.24.93-.57 1.2a4.2 4.2 0 01-.96.56c-.3.16-.54.3-.7.47a.93.93 0 00-.18.27H5.5a.5.5 0 110 1H3a.5.5 0 01-.5-.5c0-.62.2-1.08.52-1.44a3.32 3.32 0 011.15-.77c.27-.13.47-.23.62-.35A.5.5 0 005 8.5c0-.18-.07-.28-.16-.35A.93.93 0 004.3 8a1.5 1.5 0 00-.95.35h-.01c-.2.2-.5.2-.7 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M4.25 15a.5.5 0 100 1c.34 0 .53.1.63.18.1.09.13.2.13.3-.01.2-.19.52-.76.52-.41 0-.63-.1-.72-.17a.42.42 0 01-.1-.07.5.5 0 00-.88.46v.01l.02.02a.8.8 0 00.1.15c.07.08.17.17.3.27.28.18.7.33 1.28.33 1.03 0 1.73-.67 1.76-1.48.01-.37-.12-.74-.4-1.02.28-.28.41-.65.4-1.02-.03-.8-.73-1.48-1.76-1.48-.59 0-1 .15-1.28.33a1.4 1.4 0 00-.4.42l-.01.01v.01a.5.5 0 00.87.48.42.42 0 01.1-.08c.1-.07.3-.17.72-.17.57 0 .75.33.76.52 0 .1-.04.21-.13.3-.1.08-.29.18-.63.18zm-.82-.75l.01-.02v.02z",
    fill: primaryFill
  }));
};
export const TextNumberListLtrLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/TextNumberListLtrLoopFilledIcon({}), 'TextNumberListLtrLoopFilled');
const ToDoColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.37 6.98L1.32 9.03a1.04 1.04 0 000 1.5l3.66 3.55 3.55-3.55-3.55-3.55a1.17 1.17 0 00-1.61 0z",
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M17.68 5.47l-2.05-2.15a1.04 1.04 0 00-1.5 0l-2.8 2.8-3.55 3.66-2.8 2.8a1.04 1.04 0 000 1.5l2.05 2.05c.43.43 1.07.43 1.5 0l2.8-2.8 3.55-3.55 2.8-2.8c.43-.43.43-1.18 0-1.5z",
    fill: "url(#paint0_linear_72779_86)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_72779_86",
    x1: 11.1,
    y1: -0.73,
    x2: 0.93,
    y2: 9.81,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#62C4F6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#2A88E5"
  }))));
};
export const ToDoColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToDoColorIcon({}), 'ToDoColor');
const ToDoFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.08 14.6l2.1 2.1c.2.2.46.3.72.3a1 1 0 00.7-.3l2.1-2.1a1 1 0 00.08-.07L17.7 7.6a1 1 0 000-1.42L16.3 4.8a1 1 0 00-1.41 0L5.08 14.6zm2.82-4.22L5.8 8.29a1 1 0 00-1.4 0l-2.1 2.1a1 1 0 000 1.42l2.08 2.08 3.52-3.51z",
    fill: primaryFill
  }));
};
export const ToDoFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToDoFilledIcon({}), 'ToDoFilled');
const ToDoRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4.38 13.9l2.8 2.8c.2.2.46.3.72.3a1 1 0 00.7-.3l2.46-2.45L17.7 7.6a1 1 0 000-1.42l-2.1-2.1a1 1 0 00-1.42 0l-6.3 6.3-2.08-2.09a1 1 0 00-1.42 0l-2.1 2.1a1 1 0 000 1.42l2.1 2.08zM7.9 16l-2.1-2.1 9.1-9.11 2.1 2.1-9.1 9.1zm-2.81-2.81L3 11.09 5.1 9l2.09 2.1-2.1 2.1z",
    fill: primaryFill
  }));
};
export const ToDoRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ToDoRegularIcon({}), 'ToDoRegular');
const VisioColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 6h-6a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V7a1 1 0 00-1-1z",
    fill: "#2B7CD3"
  }), React.createElement("path", {
    d: "M10.29 2.3l-3 3a1 1 0 000 1.4l3 3a1 1 0 001.41 0l3-3a1 1 0 000-1.4l-3-3a1 1 0 00-1.41 0z",
    fill: "#41A5EE"
  }), React.createElement("path", {
    d: "M11 18a4 4 0 100-8 4 4 0 000 8z",
    fill: "#103F91"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M12 6H7c0 .25.1.51.29.7L10 9.41v.71A4 4 0 007.54 16H11a2 2 0 002-2V7a1 1 0 00-1-1V6z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 5H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: "#185ABD"
  }), React.createElement("path", {
    d: "M6.7 10.97c.17.5.27.81.3.95h.02c.03-.13.14-.47.33-1l1.34-3.9h1.23l-2.28 6H6.32l-2.25-6h1.27l1.35 3.96h.01z",
    fill: "#fff"
  }));
};
export const VisioColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisioColorIcon({}), 'VisioColor');
const VisioFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M10.29 2.3L8.58 4H11a2 2 0 012 2v2.4l1.7-1.7a1 1 0 000-1.4l-3-3a1 1 0 00-1.41 0zM11 18a4 4 0 01-3.47-2H11a2 2 0 002-2v-3.46A4 4 0 0111 18zm2.27-8.45l2.14-2.14a2 2 0 00.58-1.4H17a1 1 0 011 1v6a1 1 0 01-1 1h-1V14a5 5 0 00-2.73-4.45zM11 5H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1zm-4.3 5.97c.17.5.27.81.3.95h.02c.03-.13.14-.47.33-1l1.34-3.9h1.23l-2.28 6H6.32l-2.25-6h1.27l1.35 3.96h.01z",
    fill: primaryFill
  }));
};
export const VisioFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisioFilledIcon({}), 'VisioFilled');
const VisioRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 3l-1 1H8.57l1.7-1.7a1 1 0 011.42 0l3 3c.2.19.3.45.3.7h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a4 4 0 01-7.47 2h1.23A3 3 0 0014 14a3 3 0 00-1-2.23v-1.23A4 4 0 0114.87 13H17V7h-2.6L13 8.4V7l1-1L11 3zm0 2H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1zm-4.3 5.97c.17.5.27.81.3.95h.02c.03-.13.14-.47.33-1l1.34-3.9h1.23l-2.28 6H6.32l-2.25-6h1.27l1.35 3.96h.01z",
    fill: primaryFill
  }));
};
export const VisioRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisioRegularIcon({}), 'VisioRegular');
const VisualStudioColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.77 15.48l-2.94-1.64-.06-.03A1.5 1.5 0 012 12.5v-5c0-.56.31-1.06.77-1.31l.06-.03 2.94-1.64A1.5 1.5 0 005 5.83v8.34c0 .56.31 1.05.77 1.31z",
    fill: "url(#paint0_linear_82398_2624)"
  }), React.createElement("path", {
    d: "M17.08 4.45a1.5 1.5 0 00-1.78.48l-.02.03L14 6.66 11.5 10l-2.45 3.27-1.33 1.77-.02.03a1.5 1.5 0 01-1.87.44l-.06-.03-2.94-1.64a1.5 1.5 0 001.93-.52l.24-.37L6.92 10l2.13-3.27 2.19-3.38a1.5 1.5 0 011.84-.57l4 1.67z",
    fill: "url(#paint1_linear_82398_2624)"
  }), React.createElement("path", {
    d: "M17.08 4.45a1.5 1.5 0 00-1.78.48l-.02.03L14 6.66 11.5 10l-2.45 3.27-1.33 1.77-.02.03a1.5 1.5 0 01-1.87.44l-.06-.03-2.94-1.64a1.5 1.5 0 001.93-.52l.24-.37L6.92 10l2.13-3.27 2.19-3.38a1.5 1.5 0 011.84-.57l4 1.67z",
    fill: "url(#paint2_linear_82398_2624)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M17.08 15.55l-4 1.67a1.5 1.5 0 01-1.84-.57l-2.19-3.38L6.92 10 5 7.05l-.24-.37a1.5 1.5 0 00-1.93-.52l2.94-1.64.06-.03a1.5 1.5 0 011.87.44l.02.03 1.33 1.77L11.5 10l2.5 3.34 1.28 1.7.02.03a1.5 1.5 0 001.78.48z",
    fill: "url(#paint3_linear_82398_2624)"
  }), React.createElement("path", {
    d: "M17.08 15.55l-4 1.67a1.5 1.5 0 01-1.84-.57l-2.19-3.38L6.92 10 5 7.05l-.24-.37a1.5 1.5 0 00-1.93-.52l2.94-1.64.06-.03a1.5 1.5 0 011.87.44l.02.03 1.33 1.77L11.5 10l2.5 3.34 1.28 1.7.02.03a1.5 1.5 0 001.78.48z",
    fill: "url(#paint4_radial_82398_2624)"
  }), React.createElement("path", {
    d: "M18 5.83v8.34a1.5 1.5 0 01-.92 1.38l-4 1.67c.54-.23.92-.76.92-1.39V4.17a1.5 1.5 0 00-.92-1.39l4 1.67c.54.22.92.76.92 1.38z",
    fill: "url(#paint5_linear_82398_2624)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "paint0_linear_82398_2624",
    x1: 0.6,
    y1: 15.48,
    x2: 7.03,
    y2: 12.29,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.07,
    stopColor: "#85148A"
  }), React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7F21A9"
  }), React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5B2AB5"
  }), React.createElement("stop", {
    offset: 0.85,
    stopColor: "#4B20A0"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_82398_2624",
    x1: 12.34,
    y1: 2.17,
    x2: 5.49,
    y2: 16.6,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#4B20A0"
  }), React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6D37CD"
  }), React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7A41DC"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#CA59F7"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_82398_2624",
    x1: 10.87,
    y1: 8.92,
    x2: 5.93,
    y2: 12.46,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#30116E",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.16,
    stopColor: "#30116E",
    stopOpacity: 0.7
  }), React.createElement("stop", {
    offset: 0.71,
    stopColor: "#30116E"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#30116E",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint3_linear_82398_2624",
    x1: 4.79,
    y1: 4.33,
    x2: 12.29,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFBAC7"
  }), React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA71EF"
  }), React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CA59F7"
  }), React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#5750E2"
  })), React.createElement("linearGradient", {
    id: "paint5_linear_82398_2624",
    x1: 15.54,
    y1: 1.33,
    x2: 15.54,
    y2: 19.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#FFBAC7"
  }), React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EA71EF"
  }), React.createElement("stop", {
    offset: 0.68,
    stopColor: "#8B52F4"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5750E2"
  })), React.createElement("radialGradient", {
    id: "paint4_radial_82398_2624",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(13.5032 5.41666 -12.3409 30.7502 1.75 11.33)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8B52F4",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.98,
    stopColor: "#30116E"
  }))));
};
export const VisualStudioColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisualStudioColorIcon({}), 'VisualStudioColor');
const VisualStudioFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.21 13.81l-1.89-2.89-1.75 2.7c-.22.33-.52.57-.85.71l2.05 1.15.06.03a1.5 1.5 0 001.87-.44l.02-.03.69-.92-.2-.31zM3.73 6.93a.9.9 0 00-1.06-.39.92.92 0 00-.63.66c-.02.1-.04.2-.04.3v5c0 .1.02.2.04.3.09.36.36.58.63.66a.9.9 0 001.06-.39L5 11.12V8.88L3.73 6.93zM18 5.83v8.34a1.5 1.5 0 01-.92 1.38l-3.18 1.33-.82.34a1.44 1.44 0 01-1.37-.14l-.04-.01-.1-.07a1.45 1.45 0 01-.33-.35l-.59-.91-1.18-1.82-.42-.65L6.92 10l-.88-1.35v-.01L4.57 6.38a1.9 1.9 0 00-.86-.71l2.06-1.15.06-.03a1.5 1.5 0 011.87.44l.02.03 1.33 1.77L11.5 10l.96 1.29.54.72 1 1.33V6.66L13 8l-.88 1.17-2.49-3.33 1.68-2.57v-.01a1.27 1.27 0 01.25-.25c.25-.22.58-.34.94-.34.2 0 .4.04.58.11l.8.33 3.2 1.34c.54.22.92.76.92 1.38zm-6.69-2.56L9.63 5.84l1.61-2.49a.5.5 0 01.07-.08z",
    fill: primaryFill
  }));
};
export const VisualStudioFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisualStudioFilledIcon({}), 'VisualStudioFilled');
const VisualStudioRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.08 4.45l-.06-.02-3.94-1.65a1.5 1.5 0 00-1.84.57L9.05 6.73 7.72 4.96l-.02-.03a1.5 1.5 0 00-1.87-.44l-.06.03-2.94 1.64-.06.03A1.5 1.5 0 002 7.5v5c0 .56.31 1.06.77 1.31l.06.03 2.94 1.64.06.03a1.5 1.5 0 001.87-.44l.02-.03 1.33-1.77 2.19 3.38a1.5 1.5 0 001.84.57l3.94-1.65.06-.02c.54-.22.92-.76.92-1.38V5.83a1.5 1.5 0 00-.92-1.38zM13 12l-1.5-2L13 8v4zM9.89 7.27l2.19-3.37a.48.48 0 01.42-.23.5.5 0 01.19.03.5.5 0 01.31.47v2.16l-2.12 2.84-1.19-1.59.2-.31zM6.92 10L5 12.95v-5.9L6.92 10zM4 13.35l-.72-.4-.03-.02A.5.5 0 013 12.5v-5c0-.18.1-.35.22-.42l.1-.05.68-.38v6.7zm4.25-.68l-1.33 1.77-.03.04a.5.5 0 01-.39.19.6.6 0 01-.22-.05l-.02-.01-.86-.48c.07-.08.14-.17.2-.27l.24-.36 1.68-2.58.95 1.46-.22.29zm4.25 3.66a.5.5 0 01-.42-.22l-2.19-3.39-.2-.31-.58-.89L8.12 10l-.36-.55-.24-.37-1.68-2.57-.24-.38a2.56 2.56 0 00-.2-.26l.82-.46.06-.03a.6.6 0 01.22-.05c.16 0 .31.07.39.18l.01.03.02.02 1.33 1.77.22.29.64.85L10.25 10l.45.6.18.23L13 13.67v2.16c0 .23-.14.39-.28.46l-.03.01a.63.63 0 01-.19.03zm2.5-1l-.57.24-.43.18V4.25l.43.18.57.24.38.16 1.32.55c.18.07.3.25.3.45v8.34a.5.5 0 01-.31.46l-1.3.54-.39.16z",
    fill: primaryFill
  }));
};
export const VisualStudioRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisualStudioRegularIcon({}), 'VisualStudioRegular');
const VisualStudioCodeColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 17,
    height: 16
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7 2.05a1 1 0 01.44.1l3.3 1.58a1 1 0 01.56.9v10.74a1 1 0 01-.57.9l-3.29 1.59a1 1 0 01-1.14-.2l-6.3-5.75L3.95 14a.67.67 0 01-.85-.04l-.88-.8a.67.67 0 010-.99L4.6 10 2.22 7.83a.67.67 0 010-.99l.88-.8c.24-.21.6-.23.85-.04L6.7 8.1 13 2.34a1 1 0 01.7-.3zm.3 4.32L9.22 10 14 13.63V6.37z",
    fill: "#fff"
  })), React.createElement("g", {
    mask: "url(#a)"
  }, React.createElement("path", {
    d: "M17.43 3.73l-3.3-1.58a1 1 0 00-1.13.19L2.22 12.17a.67.67 0 000 .99l.88.8c.24.21.6.23.85.04l12.99-9.86a.66.66 0 011.06.53v-.04a1 1 0 00-.57-.9z",
    fill: "#0065A9"
  }), React.createElement("g", {
    filter: "url(#filter0_d_74230_2753)"
  }, React.createElement("path", {
    d: "M17.43 16.27l-3.3 1.59a1 1 0 01-1.13-.2L2.22 7.83a.67.67 0 010-.99l.88-.8c.24-.21.6-.23.85-.04l12.99 9.86a.66.66 0 001.06-.53v.04a1 1 0 01-.57.9z",
    fill: "#007ACC"
  })), React.createElement("g", {
    filter: "url(#filter1_d_74230_2753)"
  }, React.createElement("path", {
    d: "M14.14 17.86a1 1 0 01-1.14-.2c.37.37 1 .11 1-.41V2.75a.59.59 0 00-1-.41 1 1 0 011.14-.2l3.3 1.59a1 1 0 01.56.9v10.74a1 1 0 01-.57.9l-3.29 1.59z",
    fill: "#1F9CF0"
  })), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7 2.05a1 1 0 01.44.1l3.3 1.58a1 1 0 01.56.9v10.74a1 1 0 01-.57.9l-3.29 1.59a1 1 0 01-1.14-.2l-6.3-5.75L3.95 14a.67.67 0 01-.85-.04l-.88-.8a.67.67 0 010-.99L4.6 10 2.22 7.83a.67.67 0 010-.99l.88-.8c.24-.21.6-.23.85-.04L6.7 8.1 13 2.34a1 1 0 01.7-.3zm.3 4.32L9.22 10 14 13.63V6.37z",
    fill: "url(#paint0_linear_74230_2753)",
    opacity: 0.25
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "filter0_d_74230_2753",
    x: 0.54,
    y: 4.41,
    width: 18.91,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
    stdDeviation: 0.73
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74230_2753"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74230_2753",
    result: "shape"
  })), React.createElement("filter", {
    id: "filter1_d_74230_2753",
    x: 11.55,
    y: 0.59,
    width: 7.91,
    height: 18.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
    stdDeviation: 0.73
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74230_2753"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74230_2753",
    result: "shape"
  })), React.createElement("linearGradient", {
    id: "paint0_linear_74230_2753",
    x1: 10,
    y1: 2.05,
    x2: 10,
    y2: 17.95,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))));
};
export const VisualStudioCodeColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisualStudioCodeColorIcon({}), 'VisualStudioCodeColor');
const VisualStudioCodeFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3.1 6.04l-.88.8a.67.67 0 000 .99l6.5 5.93 3.71 3.38c.15.14.31.09.37.06.06-.02.2-.1.2-.31v-4.02L3.95 6a.67.67 0 00-.85.04zm9.7-3.24a.33.33 0 00-.37.06L7.45 7.4l2.6 1.97L13 7.13V3.11c0-.2-.14-.29-.2-.31zm4.63.93l-3.29-1.59a.98.98 0 00-.62-.06c.3.25.48.62.48 1.03v13.78c0 .42-.18.79-.5 1.04.21.04.44.02.64-.07l3.3-1.59a1 1 0 00.56-.9V4.63a1 1 0 00-.57-.9zM2.22 12.17a.67.67 0 000 .99l.88.8c.24.21.6.23.85.04l1.94-1.47-2.03-1.85-1.64 1.5z",
    fill: primaryFill
  }));
};
export const VisualStudioCodeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisualStudioCodeFilledIcon({}), 'VisualStudioCodeFilled');
const VisualStudioCodeRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.99 4.53a.98.98 0 00-.56-.8l-3.29-1.59a1.1 1.1 0 00-.43-.09.98.98 0 00-.61.21.4.4 0 00-.1.08L6.7 8.09 3.95 6a.66.66 0 00-.4-.13.7.7 0 00-.45.17l-.88.8a.67.67 0 000 .99L4.6 10l-2.38 2.17a.67.67 0 000 .99l.88.8a.7.7 0 00.45.17c.14 0 .28-.04.4-.13l2.75-2.09 6.3 5.75a.4.4 0 00.1.08c.18.14.39.21.61.21.14 0 .29-.03.43-.09l3.29-1.59a.98.98 0 00.56-.8l.01-.1V4.63l-.01-.1zm-4.28-1.48l.29.14v1.93L8.39 9.37l-.88-.67 6.2-5.65zM14 13.63L9.22 10 14 6.37v7.26zm-10.43-.6l-.41-.37 2.18-1.99.61.56-2.38 1.8zm10.11 3.89L7.51 11.3l-.75-.69-.68-.61-.74-.67-2.18-1.99.41-.37 2.38 1.8.8.62.81.61.83.63L14 14.88v1.89l-.32.15zm1.32-.59V3.67l1.57.75.43.21v10.74l-.43.21-1.57.75z",
    fill: primaryFill
  }));
};
export const VisualStudioCodeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VisualStudioCodeRegularIcon({}), 'VisualStudioCodeRegular');
const VivaColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.53 7.97a3.5 3.5 0 104.94-4.94 3.5 3.5 0 00-4.94 4.94z",
    fill: "#62D0E0"
  }), React.createElement("path", {
    d: "M14 15.99l3.86-4.58c.19-.23.2-.56-.02-.78a5.08 5.08 0 00-7.78.38L6 16c2.24 2.68 5.76 2.68 8 0z",
    fill: "#2B256F"
  }), React.createElement("path", {
    d: "M6 15.99L2.14 11.4a.57.57 0 01.02-.78 5.08 5.08 0 017.78.38L14 16c-2.24 2.68-5.76 2.68-8 0z",
    fill: "#385DC2"
  }));
};
export const VivaColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaColorIcon({}), 'VivaColor');
const VivaFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.47 7.97a3.5 3.5 0 11-4.94-4.94 3.5 3.5 0 014.94 4.94zM2.14 11.41L6 15.99c2.24 2.68 5.76 2.68 8 0L9.94 11a5.08 5.08 0 00-7.78-.38.57.57 0 00-.02.78zm8.57-1.03l3.95 4.83 3.2-3.8c.19-.23.2-.56-.02-.78a5.03 5.03 0 00-7.15-.27l.02.01v.01z",
    fill: primaryFill
  }));
};
export const VivaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaFilledIcon({}), 'VivaFilled');
const VivaRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.47 7.97a3.5 3.5 0 11-4.94-4.94 3.5 3.5 0 014.94 4.94zm-4.24-.7a2.5 2.5 0 103.54-3.54 2.5 2.5 0 00-3.54 3.54zM2.14 11.4a.57.57 0 01.02-.78 5.08 5.08 0 017.78.38l.06.08.06-.08a5.08 5.08 0 017.78-.38c.21.22.2.55.02.78L14 15.99c-2.24 2.68-5.76 2.68-8 0L2.14 11.4zm4.63 3.94A4.22 4.22 0 0010 17c.9 0 1.84-.34 2.66-1.07l-3.5-4.28c-1.66-2-4.18-2.17-6-.59l3.6 4.29zm6.59-.15l3.48-4.14c-1.82-1.58-4.34-1.4-6 .6l-.2.22 2.72 3.32z",
    fill: primaryFill
  }));
};
export const VivaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaRegularIcon({}), 'VivaRegular');
const VivaAmplifyColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.33 14.33a3.67 3.67 0 11-7.33 0 3.67 3.67 0 017.33 0z",
    fill: "#561E60"
  }), React.createElement("path", {
    d: "M5.38 6.65l-2.97 6a2.33 2.33 0 014.16.27l1.84 3.71A2.42 2.42 0 0010.58 18h5.25l-1.09-.46L9.46 7.31a3.12 3.12 0 00-4.08-.66z",
    fill: "#CB6BDF"
  }), React.createElement("path", {
    d: "M12.7 3.8l4.2 8.35c.3.58.84 1.77.84 1.77.15.4.25.85.26 1.33v.33c0 1.34-.99 2.42-2.2 2.42a2.2 2.2 0 01-1.96-1.3L9.5 8.1A2.82 2.82 0 007 6.5c-.76 0-1.45.3-1.95.8L6.8 3.8a3.33 3.33 0 015.92 0z",
    fill: "#894497"
  }));
};
export const VivaAmplifyColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaAmplifyColorIcon({}), 'VivaAmplifyColor');
const VivaAmplifyFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6.5 6c-.33 0-.6.02-.84.07l1.11-2.25.02-.03a3.33 3.33 0 015.92 0l4.2 8.36c.3.58.83 1.77.83 1.77.15.4.25.85.26 1.33v.33c0 1.34-.99 2.42-2.2 2.42a2.2 2.2 0 01-1.96-1.3L9.99 9.1C9.29 7.69 8.44 6 6.5 6zM4 11c-.28 0-.57.06-.85.16l1.73-3.51C5.27 7.18 5.73 7 6.5 7c.44 0 1.12.22 1.52.71.4.5.73 1.14 1.08 1.83l3.84 7.6c.15.32.35.6.58.86h-2.94c-.96 0-1.78-.56-2.18-1.37l-1.83-3.7C5.87 11.64 5 11 4 11zm-2 3.33c0-.4.07-.79.19-1.15C2.5 12.5 3 12 4 12c.49 0 1.09.29 1.68 1.39l1.83 3.68c.05.11.11.22.18.32A3.67 3.67 0 012 14.33z",
    fill: primaryFill
  }));
};
export const VivaAmplifyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaAmplifyFilledIcon({}), 'VivaAmplifyFilled');
const VivaAmplifyRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17.3 12.97c-.13-.3-.28-.6-.4-.82l-4.2-8.36a3.33 3.33 0 00-5.9 0L4.84 7.71l-2.39 4.83-.08.18a3.67 3.67 0 006.07 4c.4.76 1.21 1.28 2.13 1.28h4.63c1.83 0 2.82-1.29 2.79-2.8-.01-.42-.1-.86-.26-1.28l-.43-.95zM13.46 17h-2.87c-.55 0-1.04-.32-1.27-.8l-1.4-3.1C7.48 12.04 6.52 11 5 11c-.24 0-.47.02-.7.08L5.8 8.02 5.83 8v-.01c.45-.77.91-.98 1.54-.98.64 0 1.29.58 1.8 1.53l3.54 7.1.07.15c.2.4.4.84.67 1.22zm-5.48-1.33a2.67 2.67 0 11-4.3-3.1c.43-.4.81-.57 1.33-.57.97 0 1.65.66 2 1.5l.97 2.17zm8.84-1.37c.12.32.18.63.19.92 0 .54-.16.97-.43 1.27-.26.28-.7.51-1.36.51-.35 0-.58-.13-.83-.43a3.39 3.39 0 01-.34-.52l-.36-.72-.07-.14-3.55-7.12v-.01a6 6 0 00-.56-.85c-.16-.21-.34-.4-.53-.56-.28-.24-.6-.44-.97-.55-.2-.07-.4-.1-.63-.1-.19 0-.38.01-.58.05l.9-1.8a2.33 2.33 0 014.13 0L16 12.59v.02a30.56 30.56 0 01.73 1.52l.06.14.01.03zM2.38 12.72l.08-.18z",
    fill: primaryFill
  }));
};
export const VivaAmplifyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaAmplifyRegularIcon({}), 'VivaAmplifyRegular');
const VivaConnectionsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 10a4 4 0 014-4h6a2 2 0 110 4H8a2 2 0 100 4h6a4 4 0 01-4 4H6a4 4 0 01-4-4v-4z",
    fill: "#0766B6"
  }), React.createElement("path", {
    d: "M18 10a4 4 0 01-4 4H8a2 2 0 110-4h4a2 2 0 100-4H6a4 4 0 014-4h4a4 4 0 014 4v4z",
    fill: "#63CFF3"
  }));
};
export const VivaConnectionsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaConnectionsColorIcon({}), 'VivaConnectionsColor');
const VivaConnectionsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10a4 4 0 01-4 4H7.5c-.77 0-1.5-.73-1.5-1.75s.73-1.75 1.5-1.75h5c1.43 0 2.5-1.29 2.5-2.75S13.93 5 12.5 5H6.13A4 4 0 0110 2h4a4 4 0 014 4v4zM6 6a4 4 0 00-4 4v4a4 4 0 004 4h4a4 4 0 003.87-3H7.5C6.07 15 5 13.71 5 12.25S6.07 9.5 7.5 9.5h5c.77 0 1.5-.73 1.5-1.75S13.27 6 12.5 6H6z",
    fill: primaryFill
  }));
};
export const VivaConnectionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaConnectionsFilledIcon({}), 'VivaConnectionsFilled');
const VivaConnectionsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M13.87 15H14a4 4 0 004-4V6a4 4 0 00-4-4h-4a4 4 0 00-4 4 4 4 0 00-4 4v4a4 4 0 004 4h4a4 4 0 003.87-3zM3 10a3 3 0 013-3h5.5a1.5 1.5 0 010 3h-3a2.5 2.5 0 100 5h4.33A3 3 0 0110 17H6a3 3 0 01-3-3v-4zm11 4H8.5a1.5 1.5 0 010-3h3a2.5 2.5 0 100-5H7a3 3 0 013-3h4a3 3 0 013 3v5a3 3 0 01-3 3z",
    fill: primaryFill
  }));
};
export const VivaConnectionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaConnectionsRegularIcon({}), 'VivaConnectionsRegular');
const VivaEngageColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 2a4 4 0 014 4v5H2V6a4 4 0 014-4z",
    fill: "#0472D8"
  }), React.createElement("path", {
    d: "M14 2a4 4 0 00-4 4v5h8V6a4 4 0 00-4-4z",
    fill: "#2596FF"
  }), React.createElement("path", {
    d: "M14 9a4 4 0 10-8 0 4 4 0 008 0z",
    fill: "#56C5FF"
  }), React.createElement("path", {
    d: "M18 6v-.16C17.88 8.4 15.36 10 13 10a4 4 0 100 8c3.29 0 5-2.67 5-5.75V6z",
    fill: "#0472D8"
  }), React.createElement("path", {
    d: "M2 12.25C2 15.33 3.71 18 7 18a4 4 0 000-8c-2.36 0-4.88-1.61-5-4.16v6.41z",
    fill: "#0C4497"
  }));
};
export const VivaEngageColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaEngageColorIcon({}), 'VivaEngageColor');
const VivaEngageFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 2a4 4 0 00-3.48 2.03 5 5 0 014.46 4.58 5.82 5.82 0 002.31-1.32l.71-.7V6a4 4 0 00-4-4zM2 12.25C2 15.33 3.71 18 7 18a4 4 0 000-8 7.4 7.4 0 01-5-2v4.25zm8.78 5.02c.64.42 1.4.67 2.22.67 3.29 0 5-2.67 5-5.75V8a7.58 7.58 0 01-5 1.94c-.85 0-1.64.26-2.28.72a4.98 4.98 0 01.06 6.61zM6 2a4 4 0 013.48 2.03 5 5 0 00-4.47 4.63A6.13 6.13 0 012.7 7.28L2 6.6V6a4 4 0 014-4zm0 6.91a4 4 0 018-.06c-.35.06-.68.09-1 .09-1.14 0-2.2.38-3.04 1.03A4.98 4.98 0 007 9c-.33 0-.66-.03-1-.09z",
    fill: primaryFill
  }));
};
export const VivaEngageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaEngageFilledIcon({}), 'VivaEngageFilled');
const VivaEngageRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.48 4.03a5.06 5.06 0 011.04 0A4 4 0 0118 6v6.25c-.07 1.99-1 5.75-5 5.75-1.2 0-2.27-.52-3-1.35A4 4 0 017 18c-4 0-4.93-3.76-5-5.75V6a4 4 0 017.48-1.97zm-1.04.22A3 3 0 003 6v1.68c.52.76 1.22 1.4 2.02 1.82a5 5 0 013.41-5.25zM6.1 9.9c.3.06.6.1.9.1 1.2 0 2.27.52 3 1.35A3.99 3.99 0 0113 10c.3 0 .6-.04.9-.1A4.01 4.01 0 0010 5a4 4 0 00-3.9 4.9zm8.88-.4c.8-.41 1.5-1.06 2.02-1.82V6a3 3 0 00-5.44-1.75 5 5 0 013.42 5.25zM13 17a3.4 3.4 0 003.12-1.66 6.6 6.6 0 00.88-3.12V9.23A5.7 5.7 0 0113 11a3 3 0 00-2.42 1.22 3.98 3.98 0 010 3.56A3 3 0 0013 17zM3 12.1v.12c.03.89.26 2.13.88 3.12A3.4 3.4 0 007 17a3 3 0 100-6 5.7 5.7 0 01-4-1.77v2.88z",
    fill: primaryFill
  }));
};
export const VivaEngageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaEngageRegularIcon({}), 'VivaEngageRegular');
const VivaGlintColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M7.73 12.2a3.99 3.99 0 004.27-.8l3.18-2.87a1.62 1.62 0 012.6.27 3.74 3.74 0 01-1.06 4.11L12 17.1a3.24 3.24 0 01-5.5-2.35c0-1.03.48-1.95 1.23-2.55z",
    fill: "#6343BF"
  }), React.createElement("path", {
    d: "M7.06 12.35l2.2-2.11c1-.97 1.58-2.21 1.71-3.5l.23-.23a2.5 2.5 0 014.07-.77l1.68 1.62a4.47 4.47 0 01.63.87 3.86 3.86 0 01.42 1.93v-.03a1.63 1.63 0 00-2.82-1.1L12 11.9a3.99 3.99 0 01-4.94.44z",
    fill: "#B05EF3"
  }), React.createElement("path", {
    d: "M18 10.17v0z",
    fill: "#B05EF3"
  }), React.createElement("path", {
    d: "M9.9 2.22a.74.74 0 00-1.04-.02L3.25 7.45l-.11.1h-.01a3.74 3.74 0 00.15 5.51l3.91 3.7a3.24 3.24 0 01.35-4.4l2.22-2.13a5.65 5.65 0 00.14-8z",
    fill: "#CE8BED"
  }));
};
export const VivaGlintColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGlintColorIcon({}), 'VivaGlintColor');
const VivaGlintFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.42 8.5c.19-.35.43-.67.71-.94v-.01l.12-.1L8.86 2.2a.74.74 0 011.06.05c.71.74 1.08 1.9 1.08 3.13 0 1.62-.63 3.33-1.74 4.4L7.04 11.9A3.72 3.72 0 006 14.5c0 .27.02.73.12 1.27l-2.97-2.83a3.74 3.74 0 01-.73-4.43zM12 17.1c-.58.56-1.38.9-2.25.9a2.45 2.45 0 01-2.5-1.83A5.62 5.62 0 017 14.5c0-.32.06-.65.17-.95a4.98 4.98 0 005.5-.9l1.6-1.44c.76-.7 1.59-1.21 2.44-1.21.58 0 1.29.47 1.29 1.03 0 .76-.76 1.38-1.28 1.88L12 17.1zm6-7.6c-.32-.31-.85-.5-1.3-.5-1.23 0-2.3.73-3.1 1.47L12 11.9a3.99 3.99 0 01-4.32.77l.05-.04 2.23-2.14a7.24 7.24 0 002.04-5 2.49 2.49 0 013.27.24l1.68 1.62c.55.6.92 1.33 1.05 2.14z",
    fill: primaryFill
  }));
};
export const VivaGlintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGlintFilledIcon({}), 'VivaGlintFilled');
const VivaGlintRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11.47 5.61a3.34 3.34 0 012.03-.6c1.03 0 1.58.53 2.03.99l1.42 1.36A3.74 3.74 0 0118 10c.01 1.13-.5 2.22-1.29 2.91l-4.72 4.19A3.24 3.24 0 017.4 17l-2.03-1.96-2.1-1.99a3.74 3.74 0 01-.13-5.5l.12-.1L8.86 2.2a.74.74 0 011.04.02 5.62 5.62 0 011.57 3.4zM3.92 8.2l-.1.09a2.74 2.74 0 00.11 4.02l2.1 2a5.46 5.46 0 01-.03-.62 3.2 3.2 0 011.16-2.34L9.07 9.5a4.63 4.63 0 00.29-6.4L3.92 8.19zm4.21 3.6a3 3 0 003.18-.6l2.7-2.41A2.85 2.85 0 0116.2 8l-1.37-1.3c-.43-.44-.73-.7-1.32-.7-.75 0-1.49.2-2.08 1.11a5.62 5.62 0 01-1.66 3.11L8.13 11.8zM17 10c0-.01 0 .01 0 0 0-.39-.19-.73-.5-.89A1.11 1.11 0 0016 9c-.47 0-1 .18-1.3.5L12 11.9a3.99 3.99 0 01-4.6.65c-.22.29-.4.66-.4 1.13 0 .46.06.86.17 1.2.17.55.47.99.91 1.4.5.46 1.05.72 1.65.72.6 0 1.16-.24 1.56-.63h.02l4.73-4.21c.57-.5.96-1.32.96-2.16z",
    fill: primaryFill
  }));
};
export const VivaGlintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGlintRegularIcon({}), 'VivaGlintRegular');
const VivaGoalsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 2h-.75A4.25 4.25 0 0012 6.22V10a5 5 0 01-10 .25 8 8 0 0016-.13V3a1 1 0 00-1-1z",
    fill: "#00554C"
  }), React.createElement("path", {
    d: "M9 8.75a4.25 4.25 0 013.33-4.15c-.2.5-.33 1.05-.33 1.62V10a5 5 0 01-10 .25v.09-.84a3.5 3.5 0 107 0v-.75z",
    fill: "#068576"
  }), React.createElement("circle", {
    cx: 5.5,
    cy: 9.5,
    r: 3.5,
    fill: "#40DCC9"
  }));
};
export const VivaGoalsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGoalsColorIcon({}), 'VivaGoalsColor');
const VivaGoalsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M18 10.12V3a1 1 0 00-1-1h-.75A4.25 4.25 0 0012 6.22V10a5 5 0 01-7.59 4.28c-.5-.28-1.11-.7-1.86-1.36A8 8 0 0018 10.12zm-7-3.9c0-.35.04-.68.1-1A6.32 6.32 0 009 9.75v.75a3.5 3.5 0 01-2.78 3.42A4.02 4.02 0 0011 10V6.22zm-3.18.66c.22.2.41.41.58.66-.26.73-.4 1.5-.4 2.21v.75A2.5 2.5 0 015.6 13h-.1a3.5 3.5 0 112.32-6.12z",
    fill: primaryFill
  }));
};
export const VivaGoalsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGoalsFilledIcon({}), 'VivaGoalsFilled');
const VivaGoalsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M6 6a4 4 0 00-4 4v.11A7.96 7.96 0 0010 18a7.99 7.99 0 008-7.88V3a1 1 0 00-1-1h-.75a4.25 4.25 0 00-3.92 2.6 4.26 4.26 0 00-3.16 2.96A4 4 0 006 6zm6 4.28a5 5 0 01-7.5 4.05c-.23-.3-.44-.61-.63-.94A4 4 0 0010 10V8.75c0-1.36.84-2.53 2.03-3.01l-.03.48v4.06zM9 10a3 3 0 11-6 0 3 3 0 016 0zm.75 7a6.96 6.96 0 01-3.42-1.04A6 6 0 0013 10V6.23A3.25 3.25 0 0116.25 3H17V10.11A7 7 0 019.75 17zM12 10z",
    fill: primaryFill
  }));
};
export const VivaGoalsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaGoalsRegularIcon({}), 'VivaGoalsRegular');
const VivaInsightsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.96 10.01A3.52 3.52 0 005.5 6a3.5 3.5 0 102.74 5.68l.01-.02 1.34-1.65h-.63z",
    fill: "#1D3179"
  }), React.createElement("circle", {
    cx: 10.5,
    cy: 6.5,
    r: 4.5,
    fill: "#6CA2FF"
  }), React.createElement("path", {
    d: "M2.9 11.84l4.44 4.94.11.12.05.05a3.49 3.49 0 005.03-.03l4.57-5.08a3.5 3.5 0 10-5.42-4.42l-3.43 4.24-.06.08a3.5 3.5 0 01-5.3.1z",
    fill: "#3B5DB0"
  }));
};
export const VivaInsightsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaInsightsColorIcon({}), 'VivaInsightsColor');
const VivaInsightsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.75 5a4.5 4.5 0 00-8.68.7 4.53 4.53 0 002 4.6l2.83-3.5A4.5 4.5 0 0114.75 5zm.48 1.08a3.51 3.51 0 00-3.54 1.34l-3.43 4.24-.73.85a3.5 3.5 0 01-2.9 1.26l2.72 3 .1.13.05.05a3.5 3.5 0 005.03-.02l4.57-5.09a3.51 3.51 0 00-1.87-5.76zM3.16 12.12a2.49 2.49 0 003.6-.24l.68-.8a5.5 5.5 0 01-2.42-5.05A3.5 3.5 0 003 11.93l.17.2z",
    fill: primaryFill
  }));
};
export const VivaInsightsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaInsightsFilledIcon({}), 'VivaInsightsFilled');
const VivaInsightsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.98 6.03a4.5 4.5 0 00-8.96 0l-.3-.02L5.5 6a3.5 3.5 0 00-2.51 5.94l4.36 4.84.1.12.05.05a3.5 3.5 0 005.03-.02l4.57-5.09a3.51 3.51 0 00-2.12-5.8zm-1.01.01a3.5 3.5 0 00-2.28 1.38L9.68 9.9a3.5 3.5 0 114.29-3.86zM5.28 13l-1.56-1.74A2.5 2.5 0 015.5 7l.24.01.3.05A4.5 4.5 0 009 10.74l-.74.92-.07.08A3.56 3.56 0 015.5 13h-.22zm2.8 3.12l-1.93-2.16a4.42 4.42 0 002.8-1.57l.08-.09 3.45-4.26.01-.01A2.5 2.5 0 0117 9.5a2.5 2.5 0 01-.64 1.67l-4.56 5.07a2.5 2.5 0 01-3.57.03l-.02-.03-.12-.13z",
    fill: primaryFill
  }));
};
export const VivaInsightsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaInsightsRegularIcon({}), 'VivaInsightsRegular');
const VivaLearningColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 18v-.05A2.5 2.5 0 008.5 13h-2A1.5 1.5 0 015 11.5V6a3 3 0 00-3 3v6a3 3 0 003 3h4z",
    fill: "#003951"
  }), React.createElement("path", {
    d: "M11 6v9.5a2.5 2.5 0 01-2 2.45V18h6a3 3 0 003-3V9a3 3 0 00-3-3h-4z",
    fill: "#117898"
  }), React.createElement("path", {
    d: "M11 15.5v-10a3.5 3.5 0 10-7 0v6c0 .83.67 1.5 1.5 1.5h3a2.5 2.5 0 012.5 2.5z",
    fill: "#63D8E1"
  }));
};
export const VivaLearningColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaLearningColorIcon({}), 'VivaLearningColor');
const VivaLearningFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 6h-4v9.5c0 .98-.4 1.86-1.05 2.5H15a3 3 0 003-3V9a3 3 0 00-3-3zM7.5 18a2.5 2.5 0 100-5h-2A1.5 1.5 0 014 11.5V6.17A3 3 0 002 9v6a3 3 0 003 3h2.5zM10 4.5v8.55A3.49 3.49 0 007.5 12h-2a.5.5 0 01-.5-.5v-7a2.5 2.5 0 115 0z",
    fill: primaryFill
  }));
};
export const VivaLearningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaLearningFilledIcon({}), 'VivaLearningFilled');
const VivaLearningRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 6.17A3 3 0 002 9v6a3 3 0 003 3h10a3 3 0 003-3V9a3 3 0 00-3-3h-4v-.5a3.5 3.5 0 10-7 0v.67zM10 15a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 011-1.73v4.23A1.5 1.5 0 005.5 13H8a2 2 0 012 2zm1-8h4a2 2 0 012 2v6a2 2 0 01-2 2h-4.76a3 3 0 00.76-2V7zm-1 5.76A2.99 2.99 0 008 12H5.5a.5.5 0 01-.5-.5v-6a2.5 2.5 0 115 0v7.26z",
    fill: primaryFill
  }));
};
export const VivaLearningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaLearningRegularIcon({}), 'VivaLearningRegular');
const VivaPulseColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M5.73 10.04l4.62-4.57A2 2 0 009 2a3 3 0 00-2.17.93C5.28 4.38 3.73 5.8 2.23 7.3c-.3.31-.3.8 0 1.11a5.2 5.2 0 003.5 1.62z",
    fill: "#0A828A"
  }), React.createElement("path", {
    d: "M6.78 17.01a3 3 0 004.43.01l5.88-5.86.07-.07v-.01A2.99 2.99 0 0015 6a3 3 0 00-1.1.21 3 3 0 01-.92 3.04l-5.3 5.25A2 2 0 008.91 18 3 3 0 016.78 17z",
    fill: "#0A5768"
  }), React.createElement("path", {
    d: "M9 2c.8 0 1.52.3 2.05.81l2.04 2.02.22.26a2.99 2.99 0 01-.33 4.16l-5.3 5.25A2 2 0 008.91 18 3 3 0 016.78 17l-2.06-2.06-.02-.03a2.99 2.99 0 01.14-4l5.51-5.45A2 2 0 009.01 2z",
    fill: "#18D3DA"
  }));
};
export const VivaPulseColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaPulseColorIcon({}), 'VivaPulseColor');
const VivaPulseFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 2a3 3 0 00-2.17.93C5.28 4.38 3.73 5.8 2.23 7.3c-.3.31-.3.8 0 1.11a4.24 4.24 0 003.12 1.23l5.16-4.97c.3-.28.49-.68.49-1.11C11 2.45 9.96 2 9 2zM7.01 16.44c0-.45.2-.85.5-1.13h.02l6.3-6.13A3.63 3.63 0 0014.95 6a3 3 0 012.21 5.08l-.07.08-5.88 5.86A3 3 0 019 18c-.96 0-1.99-.45-1.99-1.56zm-1 .05L4.6 15.05l-.01-.01a2.49 2.49 0 01.12-3.34l.07-.07L11.2 5.4a2.5 2.5 0 00.8-1.9l1.22 1.24.21.24c.36.43.57.98.57 1.59 0 .73-.32 1.34-.87 1.9l-6.29 6.1a2.5 2.5 0 00-.83 1.92z",
    fill: primaryFill
  }));
};
export const VivaPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaPulseFilledIcon({}), 'VivaPulseFilled');
const VivaPulseRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.38 8.57c.71.71 1.58 1.16 2.49 1.36l-.52.5a2.99 2.99 0 00-.14 4l.02.03 2.55 2.55a3 3 0 004.43.01l5.88-5.86.07-.07v-.01A2.99 2.99 0 0015 6a3 3 0 00-1.1.21 3 3 0 00-.59-1.12l-.22-.26-2.03-2.02h-.01l-.02-.02A2.99 2.99 0 009 2H9a3 3 0 00-2.17.93l-2.7 2.52a2.9 2.9 0 00-.33.3L2.23 7.3c-.3.31-.3.8 0 1.11l.15.15zm11.6-1.3a2 2 0 012.45 3.11v.01l-.02.02-.02.03-5.9 5.9h-.01a2 2 0 01-3.37-.68c.1-.77.73-1.44 1.07-1.73l4.8-4.68a3 3 0 001-1.98zM9 3c.4 0 .78.12 1.1.32.65.6.2 1.4-.2 1.77L5.8 9.04a3.98 3.98 0 01-2.71-1.17L4.5 6.45a2.16 2.16 0 01.23-.2l.05-.03 2.75-2.58.02-.02A2 2 0 019 3zm2.36 1.52l1 1 .2.22a1.99 1.99 0 01-.24 2.76l-.02.02-4.8 4.68c-.25.22-.65.61-.96 1.13-.12.2-.23.45-.32.71L4.98 13.8a1.99 1.99 0 01.1-2.68l.04-.04 5.46-5.26c.3-.28.64-.73.78-1.28v-.02z",
    fill: primaryFill
  }));
};
export const VivaPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaPulseRegularIcon({}), 'VivaPulseRegular');
const VivaSalesColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.73 2.73A2.5 2.5 0 002 4.5v9a2.5 2.5 0 004.27 1.77l9-9A2.5 2.5 0 0013.5 2h-9a2.5 2.5 0 00-1.77.73z",
    fill: "#02865E"
  }), React.createElement("path", {
    d: "M12.5 18a5.5 5.5 0 100-11 5.5 5.5 0 000 11z",
    fill: "#044A31"
  }), React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 004.5 7h4a2.5 2.5 0 011.77 4.27l-4 4A2.5 2.5 0 012 13.5v-9z",
    fill: "#61D8AC"
  }));
};
export const VivaSalesColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaSalesColorIcon({}), 'VivaSalesColor');
const VivaSalesFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2.73 6.26A2.5 2.5 0 012 4.5v9a2.5 2.5 0 004.27 1.77l4-4A2.5 2.5 0 008.49 7H4.5a2.5 2.5 0 01-1.77-.74zm8.39.91a5.51 5.51 0 11-3.39 8.07l3.25-3.25a3.5 3.5 0 00.14-4.82zM5.25 2C4.01 2 3 3 3 4.25v.25C3 5.33 3.67 6 4.5 6h4c.63 0 1.2.16 1.69.42a6.48 6.48 0 014.84.09l.24-.24A2.5 2.5 0 0013.5 2H5.25z",
    fill: primaryFill
  }));
};
export const VivaSalesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaSalesFilledIcon({}), 'VivaSalesFilled');
const VivaSalesRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M16.24 6.47A2.62 2.62 0 0014.38 2h-9.6A2.79 2.79 0 002 4.79v9.6c0 2.33 2.82 3.5 4.47 1.84l1.17-1.16a5.5 5.5 0 107.43-7.43l1.17-1.17zm-7.85 7.85l2.85-2.85c.98-.98.96-2.4.29-3.36a4.5 4.5 0 11-3.14 6.21zm2.26-7C10.3 7.12 9.86 7 9.38 7H5.01c-1.1 0-2-.9-2-2v-.21C3 3.79 3.8 3 4.78 3h9.6a1.62 1.62 0 011.14 2.77l-1.46 1.46a5.5 5.5 0 00-3.42.09zm-.12 3.45l-4.76 4.76A1.62 1.62 0 013 14.38V7.23A3 3 0 005.01 8h4.37a1.62 1.62 0 011.15 2.77z",
    fill: primaryFill
  }));
};
export const VivaSalesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaSalesRegularIcon({}), 'VivaSalesRegular');
const VivaTopicsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 5,
    fill: "#B26BFF"
  }), React.createElement("path", {
    d: "M13.9 8L11 11l.52 4.14A4 4 0 1013.9 8z",
    fill: "#7655AE"
  }), React.createElement("path", {
    d: "M4.32 8.78L11 11l.52 4.13a5 5 0 11-7.2-6.35z",
    fill: "#3C2B5E"
  }));
};
export const VivaTopicsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaTopicsColorIcon({}), 'VivaTopicsColor');
const VivaTopicsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14.38 8.02l-2.86 3.16.45 4.27a4 4 0 102.4-7.43zm-3.36 7.95l-.48-4.58-6.71-2.25a5 5 0 107.2 6.83zM4.14 8.19A5 5 0 1114 6.94l-3.15 3.5-6.7-2.25z",
    fill: primaryFill
  }));
};
export const VivaTopicsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaTopicsFilledIcon({}), 'VivaTopicsFilled');
const VivaTopicsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M14 8h-.1a5 5 0 10-9.58.77 5 5 0 107.2 6.37A4 4 0 1014 8zm-.52 1.01l.44-.01H14a3 3 0 11-1.86 5.36l-.31-.25-.3-2.94 1.95-2.16zm-2.64 5.24l-.22.46a4 4 0 11-5.76-5.1L5 9.54l5.54 1.85.3 2.87zm2.08-6.45l-.09.43-1.98 2.2-5.53-1.85-.06-.16a4 4 0 117.66-.62z",
    fill: primaryFill
  }));
};
export const VivaTopicsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/VivaTopicsRegularIcon({}), 'VivaTopicsRegular');
const VoteLoopFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M11 15a4 4 0 114 4h-2.2a3 3 0 001.2-2.4h1a1.6 1.6 0 10-1.6-1.6v1.6A2.4 2.4 0 0111 19v-4z",
    fill: "#8230FF"
  }), React.createElement("path", {
    d: "M12.23 9h1.27a.5.5 0 010 1h-7a.5.5 0 010-1h.76a1 1 0 01-.13-1.17l2.5-4.33A1 1 0 0111 3.13l2.6 1.5A1 1 0 0113.96 6l-1.73 3zm.87-3.5L10.5 4 8 8.33 9.16 9h1.92l2.02-3.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13.96 8l.58-1a1 1 0 01.76.4l2.5 3.33a1 1 0 01.12.2 4.98 4.98 0 00-1.83-.81L14.5 8h-.54z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 11H3.25L5.5 8h.4a1 1 0 01.08-.17L6.46 7H5.5a1 1 0 00-.8.4l-2.5 3.33a1 1 0 00-.2.6V16a1 1 0 001 1h7v-2a5 5 0 012-4z",
    fill: primaryFill
  }));
};
export const VoteLoopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/VoteLoopFilledIcon({}), 'VoteLoopFilled');
const WalletColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3H12a2 2 0 012 2v1a2 2 0 01-2 2H4.5A2.5 2.5 0 012 5.5z",
    fill: "url(#paint0_linear_64947_5606)"
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3H12a2 2 0 012 2v1a2 2 0 01-2 2H4.5A2.5 2.5 0 012 5.5z",
    fill: "url(#paint1_radial_64947_5606)"
  }), React.createElement("path", {
    d: "M3.73 8.58c-.47-.8-.2-1.83.61-2.3l8.76-5.05c.8-.47 1.84-.2 2.3.61l3.37 5.84c.47.8.2 1.84-.61 2.3L9.4 15.04c-.8.47-1.84.19-2.3-.62L3.73 8.58z",
    fill: "url(#paint2_linear_64947_5606)"
  }), React.createElement("path", {
    d: "M3.73 8.58c-.47-.8-.2-1.83.61-2.3l8.76-5.05c.8-.47 1.84-.2 2.3.61l3.37 5.84c.47.8.2 1.84-.61 2.3L9.4 15.04c-.8.47-1.84.19-2.3-.62L3.73 8.58z",
    fill: "url(#paint3_radial_64947_5606)"
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 004.5 8H16a2 2 0 012 2v6a2 2 0 01-2 2H6a4 4 0 01-4-4V5.5z",
    fill: "url(#paint4_linear_64947_5606)"
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 004.5 8H16a2 2 0 012 2v6a2 2 0 01-2 2H6a4 4 0 01-4-4V5.5z",
    fill: "url(#paint5_radial_64947_5606)"
  }), React.createElement("path", {
    d: "M12 11.56c0-.3.25-.56.56-.56h1.88c.3 0 .56.25.56.56v1.88c0 .3-.25.56-.56.56h-1.88a.56.56 0 01-.56-.56v-1.88z",
    fill: "#1A43BC"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_64947_5606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-14.2012 0 0 -5.4375 16.2 5.5)"
  }, React.createElement("stop", {
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), React.createElement("radialGradient", {
    id: "paint3_radial_64947_5606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.5 .1426 -.02494 2.53619 3.5 8.5)"
  }, React.createElement("stop", {
    offset: 0.45,
    stopColor: "#B91CBF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#B91CBF",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_64947_5606",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-8.47486 2.67016 -3.16054 -10.03128 18.55 11)"
  }, React.createElement("stop", {
    stopColor: "#AD7DFF"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#AD7DFF",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_64947_5606",
    x1: 15.63,
    y1: 5.5,
    x2: 2,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2253CE"
  }), React.createElement("stop", {
    offset: 0.75,
    stopColor: "#004099"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#003580"
  })), React.createElement("linearGradient", {
    id: "paint2_linear_64947_5606",
    x1: 16.2,
    y1: 1,
    x2: 5.69,
    y2: 7.13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#EF91F3"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E656EB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#C543FE"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_64947_5606",
    x1: 18.26,
    y1: 12.87,
    x2: 1.9,
    y2: 12.87,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#2764E7"
  }), React.createElement("stop", {
    offset: 0.72,
    stopColor: "#367AF2"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0091EB"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33B1FF"
  }))));
};
export const WalletColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/WalletColorIcon({}), 'WalletColor');
const WhiteboardColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7z",
    fill: "url(#paint0_linear_80424_30713)"
  }), React.createElement("path", {
    d: "M2 7a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V7z",
    fill: "url(#paint1_radial_80424_30713)",
    fillOpacity: 0.3
  }), React.createElement("path", {
    d: "M11.43 10.13c-.15-.12-.27 0-.27 0-.56.48-1.24.58-1.78.41a1.73 1.73 0 01-.68-.48c-.17-.19-1.1-1.37-1.47-1.7a2.53 2.53 0 00-1.35-.67 2.3 2.3 0 00-1.44.26c-.42.24-.74.61-.9 1.02 0 0-.06.13.08.24.12.1.25-.02.25-.02a1.88 1.88 0 011.78-.4c.26.08.47.25.68.47.17.2 1.1 1.37 1.47 1.71.35.33.84.6 1.35.66a2.3 2.3 0 001.44-.26c.42-.24.74-.6.9-1.02 0 0 .06-.13-.06-.23v.01z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M12.23 9.57l-.6.46c-.11.1-.3-.03-.27-.17l.16-.74.71.45z",
    fill: "#1E2021"
  }), React.createElement("path", {
    d: "M11.72 7.86l-.02.05-.17.72-.16.66c-.01.06 0 .12.05.14l.57.36s.1.02.15-.02l.53-.42.58-.46.03-.03-.5-.84-1.06-.15z",
    fill: "#CCC"
  }), React.createElement("path", {
    d: "M13.3 8.83l3.68-5.78c.03-.05.02-.12-.04-.18a5 5 0 00-1.34-.86.15.15 0 00-.18.04l-3.68 5.78-.02.03 1.56 1 .02-.04v.01z",
    fill: "#333"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint1_radial_80424_30713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4 -4.5 1.27284 1.13141 13.5 8.5)"
  }, React.createElement("stop", null), React.createElement("stop", {
    stopColor: "#010408",
    stopOpacity: 0.97
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#1C83E8",
    stopOpacity: 0
  })), React.createElement("linearGradient", {
    id: "paint0_linear_80424_30713",
    x1: 15.99,
    y1: 20.37,
    x2: 7.16,
    y2: 5.08,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.1,
    stopColor: "#30E5D0"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#0C34FB"
  }))));
};
export const WhiteboardColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/WhiteboardColorIcon({}), 'WhiteboardColor');
const WordColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M4 13.89L10 6l7 5.13v5.31c0 .86-.7 1.56-1.56 1.56H6.67A2.67 2.67 0 014 15.33V13.9z",
    fill: "url(#paint0_radial_79314_10612)"
  }), React.createElement("path", {
    d: "M4 9.04c0-1.1.9-2 2-2h9.67L17 6v4.94c0 .86-.7 1.56-1.56 1.56H6.5A2.5 2.5 0 004 15V9.04z",
    fill: "url(#paint1_linear_79314_10612)"
  }), React.createElement("path", {
    d: "M4 9.04c0-1.1.9-2 2-2h9.67L17 6v4.94c0 .86-.7 1.56-1.56 1.56H6.5A2.5 2.5 0 004 15V9.04z",
    fill: "url(#paint2_radial_79314_10612)",
    fillOpacity: 0.6
  }), React.createElement("path", {
    d: "M4 9.04c0-1.1.9-2 2-2h9.67L17 6v4.94c0 .86-.7 1.56-1.56 1.56H6.5A2.5 2.5 0 004 15V9.04z",
    fill: "url(#paint3_linear_79314_10612)",
    fillOpacity: 0.07
  }), React.createElement("path", {
    d: "M4 4.67C4 3.19 5.2 2 6.67 2h8.77C16.3 2 17 2.7 17 3.56v2.38c0 .86-.7 1.56-1.56 1.56H6.5A2.5 2.5 0 004 10V4.67z",
    fill: "url(#paint4_linear_79314_10612)"
  }), React.createElement("path", {
    d: "M4 4.67C4 3.19 5.2 2 6.67 2h8.77C16.3 2 17 2.7 17 3.56v2.38c0 .86-.7 1.56-1.56 1.56H6.5A2.5 2.5 0 004 10V4.67z",
    fill: "url(#paint5_radial_79314_10612)",
    fillOpacity: 0.8
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint6_radial_79314_10612)"
  }), React.createElement("path", {
    d: "M2 9c0-1.1.9-2 2-2h5a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9z",
    fill: "url(#paint7_radial_79314_10612)",
    fillOpacity: 0.65
  }), React.createElement("path", {
    d: "M9.5 9l-1.08 5H7.14l-.64-3-.67 3h-1.3L3.5 9h1.06l.64 3.3.63-3.3h1.3l.67 3.3.62-3.3H9.5z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "paint0_radial_79314_10612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-16.98 89.45 -40.14) scale(21.8267)"
  }, React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1657F4"
  }), React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0036C4"
  })), React.createElement("radialGradient", {
    id: "paint2_radial_79314_10612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.26653 7.22368 -7.625 -8.77882 17.5 7.78)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D471FF"
  }), React.createElement("stop", {
    offset: 0.83,
    stopColor: "#509DF5",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint5_radial_79314_10612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-14.25 3.7978 -3.81828 -14.1736 17.63 3.12)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E4A7FE"
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E4A7FE",
    stopOpacity: 0
  })), React.createElement("radialGradient", {
    id: "paint6_radial_79314_10612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -7.45 5.91) scale(12.7279)"
  }, React.createElement("stop", {
    offset: 0.08,
    stopColor: "#367AF2"
  }), React.createElement("stop", {
    offset: 0.87,
    stopColor: "#001A8F"
  })), React.createElement("radialGradient", {
    id: "paint7_radial_79314_10612",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6.9 -6.9 0 6.5 12.4)"
  }, React.createElement("stop", {
    offset: 0.59,
    stopColor: "#2763E5",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.97,
    stopColor: "#58AAFE"
  })), React.createElement("linearGradient", {
    id: "paint1_linear_79314_10612",
    x1: 4,
    y1: 10.5,
    x2: 13.96,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#66C0FF"
  }), React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0094F0"
  })), React.createElement("linearGradient", {
    id: "paint3_linear_79314_10612",
    x1: 10.5,
    y1: 10.5,
    x2: 10.5,
    y2: 7.07,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#4F006F",
    stopOpacity: 0
  }), React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4F006F",
    stopOpacity: 0.44
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#4F006F"
  })), React.createElement("linearGradient", {
    id: "paint4_linear_79314_10612",
    x1: 4,
    y1: 6,
    x2: 17,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#9DEAFF"
  }), React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3BD5FF"
  }))));
};
export const WordColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/WordColorIcon({}), 'WordColor');
const WordFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M17 16a2 2 0 01-2 2H7a3 3 0 01-2.23-1H9a3 3 0 003-3v-1h3c.77 0 1.47-.3 2-.77V16zM9 7a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h5zm-.58 2l-.62 3.3L7.14 9h-1.3l-.64 3.3L4.56 9H3.5l1.04 5h1.3l.66-3 .64 3h1.28L9.5 9H8.42zM17 10a2 2 0 01-2 2h-3V9c0-.77-.3-1.47-.77-2H15c.77 0 1.47-.3 2-.77V10zm-2-8a2 2 0 110 4H4V5a3 3 0 013-3h8z",
    fill: primaryFill
  }));
};
export const WordFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/WordFilledIcon({}), 'WordFilled');
const WordRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M15 2a2 2 0 012 2v12a2 2 0 01-2 2H7a3 3 0 01-2.83-2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2V5a3 3 0 013-3h8zM8.42 9l-.62 3.3L7.14 9h-1.3l-.64 3.3L4.56 9H3.5l1.04 5h1.3l.66-3 .64 3h1.28L9.5 9H8.42zM16 7.73c-.3.17-.64.27-1 .27h-4.27c.17.3.27.64.27 1v3h4a1 1 0 001-1V7.73zM5.27 16c.35.6.99 1 1.73 1h8a1 1 0 001-1v-3.27c-.3.17-.64.27-1 .27h-4v1a2 2 0 01-2 2H5.27zM15 7a1 1 0 001-1V4a1 1 0 00-1-1H7a2 2 0 00-2 2v2h10z",
    fill: primaryFill
  }));
};
export const WordRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/WordRegularIcon({}), 'WordRegular');
const WorkplaceAnalyticsColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 11c0-1.1.9-2 2-2h3v8H5a2 2 0 01-2-2v-4z",
    fill: "#036C70"
  }), React.createElement("path", {
    d: "M12 5h3a2 2 0 012 2v8a2 2 0 01-2 2h-3V5z",
    fill: "#37C6D0"
  }), React.createElement("path", {
    d: "M7 5c0-1.1.9-2 2-2h2a2 2 0 012 2v12H7V5z",
    fill: "#1A9BA1"
  }), React.createElement("path", {
    d: "M3 15c0 1.1.9 2 2 2h2v-2.74c-.82.45-1.79.74-3 .74H3z",
    fill: "#0E4F51"
  }), React.createElement("path", {
    d: "M13 17V8.74A6.01 6.01 0 0116 8h1v7a2 2 0 01-1.95 2H13z",
    fill: "#1A9BA1"
  }), React.createElement("path", {
    d: "M7 17v-2.74c1.21-.67 2.1-1.72 3-2.76.9-1.04 1.79-2.09 3-2.76V17H7z",
    fill: "#036C70"
  }));
};
export const WorkplaceAnalyticsColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/WorkplaceAnalyticsColorIcon({}), 'WorkplaceAnalyticsColor');
const WorkplaceAnalyticsFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9.75 3C8.78 3 8 3.78 8 4.75v7.66a19.1 19.1 0 001.62-1.74l.03-.03c.7-.82 1.43-1.67 2.35-2.35V4.75C12 3.78 11.22 3 10.25 3h-.5zM12 9.59a19.1 19.1 0 00-1.62 1.74l-.03.03c-.7.82-1.43 1.67-2.35 2.35V17h4V9.59zm-5 3.59V9H5a2 2 0 00-2 2v3h1c1.23 0 2.19-.31 3-.82zM3 15c0 1.1.9 2 2 2h2v-2.68c-.83.42-1.8.68-3 .68H3zm10-6.18c.81-.5 1.77-.82 3-.82h1v7a2 2 0 01-2 2h-2V8.82zM17 7h-1c-1.2 0-2.17.26-3 .68V5h2a2 2 0 012 2z",
    fill: primaryFill
  }));
};
export const WorkplaceAnalyticsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/WorkplaceAnalyticsFilledIcon({}), 'WorkplaceAnalyticsFilled');
const WorkplaceAnalyticsRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M9 3a2 2 0 00-2 2v4H5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2-2H9zm7 4c-1.2 0-2.17.26-3 .68V6h2a1 1 0 011 1zm-4 1.3c-.92.67-1.65 1.52-2.35 2.34l-.03.03A19.1 19.1 0 018 12.41V5a1 1 0 011-1h2a1 1 0 011 1v3.3zm-4 5.4c.92-.67 1.65-1.52 2.35-2.34l.03-.03A19.1 19.1 0 0112 9.59V16H8v-2.3zm-1-.52c-.81.5-1.77.82-3 .82v-3a1 1 0 011-1h2v3.18zM4 15c1.2 0 2.17-.26 3-.68V16H5a1 1 0 01-1-1zm9-6.18c.81-.5 1.77-.82 3-.82v7a1 1 0 01-1 1h-2V8.82z",
    fill: primaryFill
  }));
};
export const WorkplaceAnalyticsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/WorkplaceAnalyticsRegularIcon({}), 'WorkplaceAnalyticsRegular');
const YammerColorIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M8.99 8.82c-.06-.21-.13-.46-.21-.66a4.94 4.94 0 00-.93-1.4.18.18 0 01-.01-.08.19.19 0 01.06-.15l4.36-4.41a.43.43 0 01.62 0c1.3 1.4 2.22 3.1 2.7 4.94l-3.41 2.59-3.18-.83z",
    fill: "#28A8EA"
  }), React.createElement("path", {
    d: "M17.64 6.99a.42.42 0 00-.56-.31L8.99 8.82a4.76 4.76 0 010 2.4l3 1.8 3.58-.08 1.54.4a.42.42 0 00.52-.3c.48-1.97.48-4.03 0-6l.01-.05z",
    fill: "#0F78D4"
  }), React.createElement("path", {
    d: "M8.99 11.2c-.06.21-.13.46-.21.66-.22.5-.51.96-.88 1.36a.22.22 0 000 .3l4.36 4.35a.42.42 0 00.62 0c1.3-1.4 2.22-3.1 2.7-4.94L8.99 11.2z",
    fill: "#0358A7"
  }), React.createElement("path", {
    opacity: 0.5,
    d: "M13 14V7a1 1 0 00-1-1H8.38l-.49.49a.21.21 0 000 .26 4.88 4.88 0 011.1 4.47c-.06.21-.13.46-.21.66-.22.5-.51.96-.88 1.36a.22.22 0 000 .3l2.48 2.48H11A2 2 0 0013 14z",
    fill: "#000"
  }), React.createElement("path", {
    d: "M11 5H3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: "#0078D4"
  }), React.createElement("path", {
    d: "M6.53 9.54c.06.12.1.25.14.38.03-.13.07-.25.13-.37l1.28-2.39a.58.58 0 01.5-.34.56.56 0 01.5.88L7.3 10.75a.68.68 0 00-.07.28v1.55a.56.56 0 01-.56.56h-.11a.56.56 0 01-.56-.56v-1.53a.52.52 0 00-.07-.23L4.21 7.69a.56.56 0 01.48-.87h.11a.58.58 0 01.5.3l1.23 2.42z",
    fill: "#fff"
  }));
};
export const YammerColor = /*#__PURE__*/wrapIcon( /*#__PURE__*/YammerColorIcon({}), 'YammerColor');
const YammerFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 2.15a.5.5 0 00-.7 0L10.29 4H11a2 2 0 012 2v.54l2.2-.6c-.7-1.8-1.7-3.15-2.35-3.8zm-.7 15.7L10.29 16H11a2 2 0 002-2v-.54l2.2.6c-.7 1.8-1.7 3.15-2.35 3.8a.5.5 0 01-.7 0zm.85-5.42V7.57l3.87-1.05a.5.5 0 01.6.32l.03.08c.18.54.5 1.48.5 3.08a11.29 11.29 0 01-.38 2.84c-.03.1-.06.19-.1.26a.9.9 0 01-.17.25.5.5 0 01-.48.13L13 12.43zM2 6a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V6zm7.28 1.82a.83.83 0 000-.78.82.82 0 00-1.42 0L6.67 9.28 5.52 7.1a.8.8 0 00-.73-.5h-.1a.78.78 0 00-.7.4.79.79 0 000 .8l1.76 3.15c.02.05.02.1 0 .15v1.47a.81.81 0 00.81.8h.15a.81.81 0 00.81-.8v-1.54a.32.32 0 010-.16l1.76-3.05z",
    fill: primaryFill
  }));
};
export const YammerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/YammerFilledIcon({}), 'YammerFilled');
const YammerRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M12.85 2.15a.5.5 0 00-.7 0L9.29 5H3a1 1 0 00-1 1v8a1 1 0 001 1h6.3l2.85 2.85c.2.2.5.2.7 0 .75-.75 2-2.46 2.68-4.73l1.34.36a.5.5 0 00.48-.13.9.9 0 00.17-.25 5.93 5.93 0 00.28-.97c.11-.56.2-1.3.2-2.13 0-1.6-.32-2.54-.5-3.08l-.03-.08a.5.5 0 00-.6-.32l-1.34.36a11.95 11.95 0 00-2.68-4.73zM10.71 15H11a1 1 0 001-1v-1.85l2.57.7a11.41 11.41 0 01-2.09 3.93L10.71 15zM12 11.12V8.88l4.67-1.27c.16.5.33 1.26.33 2.39a10.28 10.28 0 01-.29 2.4L12 11.12zm0-3.27V6a1 1 0 00-1-1h-.3l1.78-1.78c.67.79 1.56 2.18 2.09 3.93l-2.57.7zm-2.72-.03l-1.76 3.05a.32.32 0 000 .16v1.54a.81.81 0 01-.8.8h-.16a.81.81 0 01-.8-.8V11.1a.24.24 0 000-.15L3.98 7.8A.79.79 0 014 7a.78.78 0 01.7-.4h.1a.8.8 0 01.73.49l1.15 2.18 1.2-2.24a.82.82 0 011.41 0 .83.83 0 010 .78z",
    fill: primaryFill
  }));
};
export const YammerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/YammerRegularIcon({}), 'YammerRegular');
const YourPhoneFilledIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10V8a2 2 0 00-2-2H3V4.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10 15h7.5a.5.5 0 000-1H10v1z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM5 15a.5.5 0 000 1h1a.5.5 0 000-1H5z",
    fill: "#242424"
  }));
};
export const YourPhoneFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/YourPhoneFilledIcon({}), 'YourPhoneFilled');
const YourPhoneRegularIcon = iconProps => {
  const {
    className,
    primaryFill
  } = iconProps;
  return React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H10v-1h5.5a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5V6H3V4.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10 15h7.5a.5.5 0 000-1H10v1z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M5 15a.5.5 0 000 1h1a.5.5 0 000-1H5z",
    fill: "#242424"
  }), React.createElement("path", {
    d: "M2 8.5C2 7.67 2.67 7 3.5 7h4C8.33 7 9 7.67 9 8.5v8c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 16.5v-8zM3.5 8a.5.5 0 00-.5.5v8c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-8a.5.5 0 00-.5-.5h-4z",
    fill: "#242424"
  }));
};
export const YourPhoneRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/YourPhoneRegularIcon({}), 'YourPhoneRegular');